import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  es: {
    translation: {
      testReminder: {
        title: "Enviar recordatorio si no responde",
        enabledHint: "Si el candidato no completa el test, se le enviará un recordatorio automático",
        disabledHint: "No se enviará ningún recordatorio",
        daysAfterSent: "Días después del envío",
        daysAfterSentHelp: "Se cuenta desde que sale el correo (1 a 30)",
        repeat: "Insistir si sigue sin responder",
        repeatEveryDays: "Cada cuántos días",
        maxReminders: "Máximo de recordatorios",
        maxRemindersHelp: "Hasta 5",
        stopNote: "Los recordatorios se detienen apenas el candidato comienza el test.",
        urlCopiedAndMarked: "URL copiada — el test quedó marcado como enviado",
        sendReminderNow: "Enviar recordatorio ahora",
        reminderSent: "Recordatorio enviado al candidato",
        reminderError: "No se pudo enviar el recordatorio",
        indicatorNext: "Recordatorio a {{days}} · aprox. {{date}}",
        indicatorProgress: "Recordatorios: {{sent}} de {{max}} · próximo aprox. {{date}}",
        day: "día",
        days: "días",
        indicatorDone: "Recordatorios: {{sent}} de {{max}} enviados",
      },
      project: "Proyecto",
      organization: "Organización",
      language: "Idioma",
      create: "Crear",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      cancel: "Cancelar",
      saving: "Guardando...",
      yes: "Sí",
      no: "No",
      name: "Nombre",
      email: "Email",
      password: "Contraseña",
      role: "Rol",
      actions: "Acciones",
      generalApiError: "Error al procesar la solicitud",
      noWayBack: "Esta acción no se puede deshacer",
      showing: "Mostrando",
      of: "de",
      lastModified: "Última modificación",
      lastUpdated: "Última actualización",
      show: "Ver",
      validationErrors: "Errores de validación",
      description: "Descripción",
      noDescription: "Sin Descripción",
      title: "Título",
      content: "Contenido",
      quantity: "Cantidad",
      generating: "Generando...",
      suggestWithAI: "Sugerir con IA",
      question: "Pregunta",
      close: "Cerrar",
      fullName: "Nombre Completo",
      applicantNames: "Nombres",
      applicantFirstLastName: "Apellido paterno",
      applicantSecondLastName: "Apellido materno",
      fullNameComposedHint: "Se arma automáticamente desde nombres y apellidos; en registros antiguos se conserva hasta completarlos",
      phone: "Teléfono",
      uniqueIdentifier: "Identificador Único",
      createdAt: "Creado",
      industry: "Industria",
      clone: "Clonar",
      pdfUploading: "Subiendo PDF...",
      maxFileSize: "El archivo es demasiado grande. Máximo 10MB.",
      processing: "Procesando...",
      step: "Paso",
      dragOver: "Arrastra archivos aquí",
      select: "Seleccionar",
      selected: "Seleccionado",
      downloadFile: "Descargar Archivo",
      deleteFile: "Eliminar Archivo",
      uploadedFile: "Archivo subido",
      uploadFilePending: "Archivo cargado",
      optionalContext: "Contexto Adicional (Opcional)",
      optionalContextPlaceholder:
        "Agrega aquí más información para este paso...",
      markNotApply: "No lo tengo / No Aplica",
      unmarkNotApply: "Desmarcar No Aplica",
      dateNotAvailable: "Fecha no disponible",
      report: "Reporte",
      noStatus: "Sin estado",
      createdBy: "Creado por",
      unknown: "Desconocido",
      notAvailable: "No disponible",
      position: "Cargo",
      file: "Archivo",
      sending: "Enviando...",
      downloadWord: "Descargar Word",
      statusWord: "Estado",
      created: "creado",
      completeRequiredFields: "Por favor completa todos los campos requeridos",
      processingError: "Error en el procesamiento",
      retrying: "Reintentando",
      summary: "Resumen",
      retry: "Reintentar",
      processedAt: "Procesado el",
      active: "Activa",
      inactive: "Inactiva",
      back: "Anterior",
      goBack: "Volver",
      next: "Siguiente",
      evaluation: "Evaluación",
      nextSteps: "Próximos pasos",
      basicInfo: "Información Básica",
      timeLimit: "Tiempo límite",
      minutes: "minutos",
      total: "Total",
      noEmail: "Sin email",
      competency: "Competencia",
      preview: "Vista previa",
      update: "Actualizar",
      updating: "Actualizando...",
      capability: "Competencia",
      previous: "Anterior",
      all: "Todos",
      user: "Usuario",
      admin: "Administrador",
      note: "Nota",
      important: "Importante",
      reprocess: "Reprocesar",
      remove: "Quitar",
      industries: [
        "Acuicultura",
        "Administración Pública",
        "Agricultura",
        "Alimentos y Bebidas",
        "Automotriz",
        "Banca y Servicios Financieros",
        "Comercio Mayorista",
        "Construcción",
        "Consultoría",
        "Deporte",
        "Educación",
        "Energía",
        "Entretenimiento",
        "Ferretería",
        "Finanzas",
        "Forestal",
        "Ganadería",
        "Gobierno",
        "Inmobiliario",
        "Logística y Transporte",
        "Manufactura",
        "Marketing",
        "Medios de Comunicación",
        "Minería",
        "Pesca",
        "Publicidad",
        "Recursos Humanos",
        "Retail",
        "Salud",
        "Seguros",
        "Servicios Profesionales",
        "Tecnología de la Información (TI)",
        "Telecomunicaciones",
        "Transporte",
        "Turismo y Hotelería",
        "Vitivinicultura",
      ],
      status: {
        error: "Error",
        fallido: "Fallido",
        completado: "Completado",
        procesando: "Procesando",
        procesando_gpt: "Procesando con GPT",
        generando: "Generando",
        subiendo: "Subiendo",
        subiendo_archivos: "Subiendo archivos",
        iniciando_procesamiento_gpt: "Iniciando procesamiento con GPT",
        extrayendo_contenido: "Extrayendo Contenido",
        analizando_contenido: "Analizando Contenido",
        generando_html: "Generando HTML",
        generando_word: "Generando Word",
        completado: "Completado",
      },
      organizations: {
        title: "Organizaciones",
        organizationSelect: "Selecciona o edita una organización",
        organizationSelectUser: "Seleccionar organización",
        organizationCreate:
          "Tu lista de organizaciones está vacía, presiona el botón con el símbolo + para crear una organización",
        organizationCreateUser:
          "Tu lista de organizaciones está vacía, contacta a un administrador para más información",
        organizationLoading: "Cargando organizaciones",
        loadError: "Error al cargar organizaciones",
        totalProjects: "Total Proyectos",
        organizationCreateSuccess: "Organización creada exitosamente",
        organizationCreateError: "Error al crear organización",
        organizationEditSuccess: "Organización editada exitosamente",
        organizationEditError: "Error al editar organización",
        organizationDeleteSuccess: "Organización eliminada exitosamente",
        organizationDeleteError: "Error al eliminar organización",
        organizationDeleteConfirm:
          "¿Estás seguro de que quieres eliminar la organización",
        organizationDeleteLoading: "Eliminando...",
        organizationNew: "Nueva Organización",
        organizationEdit: "Editar Organización",
        organizationName: "Nombre de la Organización",
        // Módulos ATS y Hunting por organización (super-admin, 2026-10-26)
        modules: {
          ats: "Módulo ATS",
          atsHelper: "Muestra el modo ATS a los usuarios de esta organización.",
          hunting: "Módulo Hunting",
          huntingHelper: "Muestra el modo Hunting. Para buscar y obtener contactos además necesita el sistema de puntos con Hunting entre sus módulos (Gestionar puntos).",
          saveError: "No se pudieron guardar los módulos ATS y Hunting",
        },
        points: {
          enableSwitch: "Activar sistema de puntos",
          pointsToLoad: "Puntos a cargar",
          modulesTitle: "Módulos disponibles",
          manageAction: "Gestionar puntos",
          manageTitle: "Gestionar Puntos",
          currentUsage: "Uso actual",
          currentLimit: "Límite",
          available: "Disponibles",
          unlimited: "Ilimitado",
          // Puntos ilimitados (super-admin, 2026-10-29)
          unlimitedSwitch: "Puntos ilimitados",
          unlimitedSwitchHelper: "No se bloquea por saldo y el consumo se sigue registrando. Siguen aplicando solo los módulos marcados.",
          unlimitedHelper: "Con puntos ilimitados no se cargan puntos",
          unlimitedOffHelper: "Al quitar ilimitado, la organización quedará con estos puntos disponibles (0 si lo dejas vacío)",
          huntingUnlimitedWarning: "Con puntos ilimitados, Hunting no tiene tope: cada email y teléfono obtenido consume créditos de Apollo.",
          willActivate: "Esta organización no tiene el sistema de puntos activo. Al guardar se activará con plan escala.",
          assignSuccess: "Puntos asignados exitosamente",
          assignError: "Error al asignar puntos",
          services: {
            psycholaborEvaluations: "Evaluaciones Psicolaborales",
            assessments: "Assessments",
            comparisons: "Comparaciones",
            discTest: "Tests DISC",
            reasoningTest: "Tests de Capacidades",
            cvFiltering: "Filtrado de CVs",
            cvSummary: "Resumen de CV",
            salesAssessment: "Sales Assessment",
            interview: "Entrevistas",
            interviewQuestions: "Preguntas de entrevista",
            hunting: "Hunting",
            backgroundCheck: "Verificación de antecedentes",
          },
        },
        settingsTitle: "Configuración de la Organización",
        settingsSaveSuccess: "Configuración guardada correctamente",
        settingsSaveError: "Error al guardar la configuración",
        settingsLoadError: "Error al cargar la configuración",
        settingsDescription: "Descripción",
        settingsWebsite: "Sitio web",
        settingsPhone: "Teléfono",
        settingsContactEmail: "Email de contacto",
        settingsCurrency: "Moneda",
        organizationCountry: "País de operación",
        settingsIndustry: "Industria",
        settingsAddress: "Dirección",
      },
      projects: {
        title: "Proyectos",
        currentOrganization: "Organización actual",
        projectSelect: "Selecciona o edita un proyecto",
        projectSelectUser: "Seleccionar proyecto",
        projectCreate:
          "Tu lista de proyectos está vacía, presiona el botón con el símbolo + para crear un proyecto",
        projectCreateUser:
          "Tu lista de proyectos está vacía, contacta a un administrador para más información",
        projectLoading: "Cargando proyectos",
        noProjects: "No se han encontrado proyectos",
        loadError: "Error al cargar proyectos",
        projectCreateSuccess: "Proyecto creado exitosamente",
        projectCreateError: "Error al crear proyecto",
        projectEditSuccess: "Proyecto editado exitosamente",
        projectEditError: "Error al editar proyecto",
        projectDelete: "Eliminar Proyecto",
        projectDeleteSuccess: "Proyecto eliminado exitosamente",
        projectDeleteError: "Error al eliminar proyecto",
        projectDeleteConfirm:
          "¿Estás seguro de que quieres eliminar el proyecto",
        projectDeleteLoading: "Eliminando...",
        projectNew: "Nuevo Proyecto",
        projectEdit: "Editar Proyecto",
        projectName: "Nombre del Proyecto",
        usageLimitReached: "Límite de Proyectos Alcanzado",
        usageLimitMessage: "Ha alcanzado el límite máximo de proyectos...",
        currentUsage: "Uso actual",
        projects: "proyectos",
        remainingProjects: "Proyectos restantes",
        unlimited: "ilimitado",
        checkingUsageLimits: "Verificando límites de uso...",
      },
      myOrganization: {
        "title": "Mi Organización",
        "configuring": "Configurando organización...",
        "configurationError": "Error de configuración",
        "noOrganizations": "No tienes organizaciones asignadas. Contacta al administrador.",
        "loadError": "Error al cargar las organizaciones. Intenta nuevamente.",
        "loadErrorAlert": "Error al cargar las organizaciones",
        "unauthorizedAccess": "Acceso no autorizado",
        "autoSelectedOrganization": "Se seleccionó automáticamente la organización: {{organizationName}}",
        "couldNotLoadOrganizations": "No se pudieron cargar las organizaciones"
      },
      topBar: {
        title: "Opciones de Cuenta",
        changeOrganization: "Cambiar Organización",
        changeProject: "Cambiar Proyecto",
        logout: "Cerrar Sesión",
        modeEvaluations: "Evaluaciones",
      },
      users: {
        title: "Usuarios",
        subTitle: "Administración de usuarios",
        userLoading: "Cargando usuarios...",
        loadError: "Error al cargar usuarios/organizaciones",
        changePassword: "Cambiar contraseña",
        changeOrganizations: "Cambiar organizaciones",
        generalEdit: "Editar datos generales",
        erpRole: "Rol ERP",
        erpRoleHelper: "Da acceso al módulo ERP según la matriz de accesos: BP y Back Office ven todas las secciones; KAM solo cotizaciones; Compras espera sus módulos (próximo ciclo).",
        erpRoleNone: "Sin rol ERP",
        erpRoles: { admin: "Admin ERP", bp: "BP", back_office: "Back Office", kam: "KAM", compras: "Compras", comercial: "Comercial (obsoleto)" },
        noEditAllowed: "Sin permisos para editar",
        deleteUser: "Eliminar usuario",
        userCreateSuccess: "Usuario creado correctamente",
        userCreateSuccess: "Usuario editado correctamente",
        userCreate: "Crear nuevo usuario",
        userEdit: "Editar usuario",
        userDelete: "Eliminar usuario",
        userDeleteConfirm: "¿Estás seguro que deseas eliminar al usuario",
        projectsOf: "Proyectos de",
        assignOrganizationProjectsSuccess:
          "Organizaciones y/o proyectos asignados correctamente",
        assignOrganizationProjectsError:
          "Error al asignar organizaciones y/o proyectos",
        userOrganizationEdit: "Editar organizaciones de",
        userPasswordSuccess: "Contraseña actualizada correctamente",
        userPasswordError: "Error al actualizar la contraseña",
        userPasswordTitle: "Cambiar la contraseña de",
        newPassword: "Nueva contraseña",
        currentPassword: "Contraseña actual",
        currentPasswordRequired: "Debes ingresar tu contraseña actual",
        wrongCurrentPassword: "La contraseña actual es incorrecta",
        passwordPolicy: "Mínimo 6 caracteres y al menos un número",
        organizationUsers: "Usuarios de la Organización",
        userDeleteSuccess: "Usuario eliminado correctamente",
        "noProjects": "Sin proyectos",
        "changeProjects": "Cambiar proyectos",
        "assignProjects": "Asignar Proyectos",
        "projectsLoadError": "Error al cargar proyectos",
        "assignProjectsSuccess": "Proyectos asignados correctamente",
        "assignProjectsError": "Error al asignar proyectos",
        "noProjectsInOrganization": "No hay proyectos disponibles en esta organización",
        "selectProjects": "Selecciona los proyectos para este usuario",
        "selectedProjects": "Proyectos seleccionados",
        "usageLimitReached": "Límite de Usuarios Alcanzado",
        "usageLimitMessage": "Ha alcanzado el límite máximo de usuarios para su organización. Para continuar utilizando este servicio, póngase en contacto con su administrador para revisar su plan actual o aumentar los límites de uso.",
        "currentUsage": "Uso actual",
        "users": "usuarios",
        "remainingUsers": "Usuarios restantes",
        "unlimited": "ilimitado",
        "checkingUsageLimits": "Verificando límites de uso...",
        "assignProjects": "Asignar Proyectos",
        "selectProjects": "Selecciona los proyectos para este usuario",
        "selectedProjects": "Proyectos seleccionados",
        "noProjectsInOrganization": "No hay proyectos disponibles en esta organización",
        "projectsLoadError": "Error al cargar proyectos",
      },
      drawer: {
        dashboard: "Dashboard",
        configuration: "Configuración",
        capabilities: "Competencias",
        positions: "Cargos",
        applicants: "Postulantes",
        reports: "Evaluación Psicolaboral",
        reportComparison: "Comparación Evaluaciones",
        evaluations: "Assessment",
        assessment2: "Assessment 2", // Assessment 2 (PLAN_ASSESSMENT2.md)
        disc: "Test DISC",
        reasoningTests: "Tests de Capacidades",
        personalHabilities: "Test Habilidades Personales",
        cvFiltering: "Filtrado de CV",
        salesAssessment: "Assessment de Ventas",
        massiveRecruitment: "Reclutamiento Masivo",
        trialUpgradeTooltip: "Disponible en planes de pago",
      },
      capabilities: {
        noPermissionToEdit: "No tienes permisos para editar esta competencia",
        noPermissionToDelete: "No tienes permisos para eliminar esta competencia",
        loadError: "Error al cargar las competencias",
        capabilityDeleteSuccess: "Capacidad eliminada satisfactoriamente",
        capabilityDeleteError: "Error al eliminar capacidad",
        title: "Gestión de Competencias",
        search: "Buscar Competencias...",
        clearSearch: "Limpiar Búsqueda",
        newCapability: "Nueva Competencia",
        editCapability: "Editar Competencia",
        showCapability: "Mostrar Competencia",
        capabilities: "competencias",
        noCapabilities: "No hay competencias registradas",
        noCapabilitiesFound: "No se encontraron competencias que coincidan con",
        texts: "Casos",
        text: "caso(s)",
        deleteTitle: "Confirmar eliminación",
        deleteConfirm: "¿Estás seguro de que quieres eliminar la competencia",
        generatedQuestions:
          "Se generaron {{count}} pregunta(s) sugeridas por IA",
        generatedQuestionsError: "Error generando preguntas",
        nameError: "El nombre de la competencia es obligatorio",
        descriptionError: "La descripción de la competencia es obligatoria",
        textError: "La competencia debe tener al menos un caso",
        textTitleError: "El título del caso {{index}} es obligatorio",
        textContentError: "El contenido del caso {{index}} es obligatorio",
        textQuestionError:
          "El caso {{index}} debe tener al menos una pregunta",
        textQuestionTextError:
          "La pregunta {{questionIndex}} del caso {{textIndex}} es obligatoria",
        atLeastOneTextError: "Debe tener al menos un caso",
        atLeastOneQuestionError: "Cada caso debe tener al menos una pregunta",
        capabilityCreated: "Competencia creada exitosamente",
        capabilityUpdated: "Competencia actualizada exitosamente",
        capabilitySaveError: "Error al guardar la competencia",
        textsAndQuestions: "Casos y Preguntas",
        addQuestion: "Agregar Pregunta",
        addText: "Agregar Caso",
        descriptionHelper: "Describe qué evalúa esta competencia",
        questions: "Preguntas",
        caseStudyHelper: "Describe el caso de estudio o situación para evaluar",
        tabCapabilities: "Competencias",
        tabCaseStudies: "Casos de estudio",
        linkedCaseStudies: "Casos de estudio vinculados",
        linkedCaseStudiesHelper: "Elige casos del catálogo y define las preguntas de esta competencia para cada uno.",
        noCaseStudiesInCatalog: "No hay casos de estudio en el catálogo. Créalos en la pestaña \"Casos de estudio\" antes de vincularlos.",
        caso: "Caso",
        selectCaseStudy: "Caso de estudio",
        linkCaseStudy: "Vincular caso de estudio",
        casoSelectError: "Debes elegir un caso de estudio en la fila {{index}}",
        casoDuplicatedError: "El caso de estudio de la fila {{index}} ya está vinculado en otra fila",
      },
      caseStudies: {
        intro: "Catálogo de casos de estudio. Un caso se vincula a una o varias competencias desde la competencia, y en un assessment el candidato lo lee una sola vez.",
        newCaseStudy: "Nuevo Caso de Estudio",
        editCaseStudy: "Editar Caso de Estudio",
        showCaseStudy: "Mostrar Caso de Estudio",
        search: "Buscar Casos de Estudio...",
        none: "No hay casos de estudio registrados",
        noneFound: "No se encontraron casos de estudio que coincidan con",
        loadError: "Error al cargar los casos de estudio",
        saveError: "Error al guardar el caso de estudio",
        created: "Caso de estudio creado exitosamente",
        updated: "Caso de estudio actualizado exitosamente",
        titleError: "El título del caso de estudio es obligatorio",
        contentError: "El contenido del caso de estudio es obligatorio",
        readingTimeError: "El tiempo de lectura debe estar entre {{min}} y {{max}} minutos",
        readingTime: "Tiempo de lectura (min)",
        readingTimeHelper: "Por defecto para los assessments; ajustable en cada uno ({{min}}–{{max}} min)",
        contentHelper: "Describe la situación o escenario. Las preguntas se definen en cada competencia.",
        showInactive: "Mostrar inactivos",
        inactive: "Inactivo",
        deactivate: "Inactivar",
        activate: "Reactivar",
        deactivateTitle: "Inactivar caso de estudio",
        deactivateConfirm: "¿Quieres inactivar el caso de estudio",
        deactivateHint: "No se elimina: deja de aparecer para vincular o para nuevos assessments. Los assessments existentes no se ven afectados. Puedes reactivarlo después.",
        deactivated: "Caso de estudio inactivado",
        activated: "Caso de estudio reactivado",
        deactivateError: "Error al inactivar el caso de estudio",
        noPermissionToEdit: "No tienes permisos para modificar este caso de estudio",
      },
      applicants: {
        data: "Datos del postulante",
        noApplicantsMatchFilters: "No se encontraron postulantes con los filtros aplicados",
        clearFilters: "Borrar Filtros",
        cvWillDeleteOnSave: "El CV se eliminará al guardar",
        cvMarkedForDeletion: "CV marcado para eliminar",
        cv: "Curriculum Vitae",
        cvSelectedWillUploadOnSave: "Archivo seleccionado. Se subirá al guardar.",
        cvSummaryWillDelete: "Este postulante tiene un resumen IA de su CV. Al reemplazar el CV, el resumen se eliminará.",
        cvSummaryKeep: "Mantener el resumen IA de todas formas",
        cvWillUploadOnSave: "Se subirá al guardar",
        applicantSavedButCvFailed: "Postulante guardado, pero hubo un error al subir el CV",
        invalidCvFormat: "Solo se permiten archivos PDF, DOC o DOCX",
        positions: "Cargos",
        selectPositions: "Selecciona los cargos",
        cvTitle: "Curriculum Vitae",
        cvLoaded: "CV cargado",
        cvView: "Ver",
        cvDelete: "Eliminar",
        cvNotLoaded: "Este postulante no tiene CV cargado.",
        cvDragAndDrop: "Arrastra y suelta el CV aquí",
        cvClickToSelect: "o haz clic para seleccionar un archivo",
        cvFormats: "Formatos: PDF, DOC, DOCX (máx. 10MB)",
        cvSaveFirstNote: "Nota: primero guarda el postulante para poder subir el CV.",
        cvSaveFirstWarning: "Primero guarda el postulante para poder subir el CV",
        cvInvalidFormat: "Solo se permiten archivos PDF, DOC o DOCX",
        cvSizeExceeded: "El archivo no debe superar los 10MB",
        cvUploadSuccess: "CV subido exitosamente",
        cvUploadError: "Error al subir el CV",
        cvDeleteSuccess: "CV eliminado exitosamente",
        cvDeleteError: "Error al eliminar el CV",
        deleteCv: "Eliminar",
        importWithHiringRoom: "Importar con HiringRoom",
        viewCv: "Ver CV",
        hiringRoomBadge: "HiringRoom",
        gender: "Género",
        genderMale: "Masculino",
        genderFemale: "Femenino",
        genderOther: "Otros",
        genderPreferNotToSay: "Prefiero no decirlo",
        country: "País",
        profession: "Profesión",
        currentPosition: "Cargo Actual",
        loadError: "Error al cargar los postulantes",
        deleteSuccess: "Postulante eliminado exitosamente",
        deleteError: "Error al eliminar postulante",
        title: "Postulantes",
        subTitle: "Gestiona los postulantes del sistema",
        newApplicant: "Nuevo Postulante",
        emailAlreadyExists: "Ya existe un postulante con este correo electrónico en este proyecto",
        rutAlreadyExists: "Ya existe un postulante con este RUT en el proyecto: {{name}}",
        searchPlaceholder:
          "Buscar por nombre, email, teléfono o identificador...",
        noApplicantsFound: "No se encontraron postulantes que coincidan con",
        noApplicants: "No hay postulantes registrados",
        applicantDeleteConfirm:
          "¿Estás seguro de que quiere eliminar al postulante",
        deleteTitle: "Confirmar eliminación",
        validateNameExist: "El nombre complejo es obligatorio",
        validateNameLength:
          "El nombre completo debe tener al menos 2 caracteres",
        validateEmailExist: "El email es obligatorio",
        validateEmailFormat: "El email no tiene un formato válido",
        applicantCreated: "Postulante creado exitosamente",
        applicantUpdated: "Postulante actualizado exitosamente",
        applicantSaveError: "Error al guardar postulante",
        newApplicant: "Nuevo Postulante",
        editApplicant: "Editar Postulante",
        showApplicant: "Ver Postulante",
        emailNotEditable: "El email no se puede modificar",
        validEmail: "Ingresa un email válido",
        // Ficha sin correo (PLAN_IMPORTACION_COMPUTRABAJO, fase 0)
        noEmailChip: "Sin correo",
        pendingEmailTooltip: "Correo pendiente: {{email}} (está en otra ficha del proyecto)",
        noEmailHelper: "Esta ficha no tiene correo. Si escribes uno que ninguna otra ficha del proyecto use, se le asigna al guardar; si lo dejas vacío, se guarda el resto.",
        noEmailHelperPending: "Esta ficha no tiene correo (correo pendiente: {{email}}). Si escribes uno que ninguna otra ficha del proyecto use, se le asigna al guardar; si lo dejas vacío, se guarda el resto.",
        noEmailView: "Sin correo. Correo pendiente: {{email}}",
        emailInOtherApplicant: "El correo {{email}} ya está en la ficha de {{name}}. Escribe otro o déjalo vacío.",
        emailAssignedValidated: "Correo asignado. {{count}} postulación(es) por validar pasaron a su etapa.",
        uniqueIdentifierHelper:
          "Ingresa un identificador único (puede ser RUT, DNI, pasaporte, etc.)",
        bulkUpload: "Carga Masiva",

        bulk: {
          title: "Carga Masiva de Postulantes",
          confirmData: "Confirmar Datos",
          result: "Resultado",
          instructions: "Instrucciones:",
          requiredColumns: "Columnas obligatorias:",
          requiredColumnsDesc: "nombres, apellido_paterno y email",
          optionalColumns: "Columnas opcionales:",
          optionalColumnsDesc: "apellido_materno, telefono, rut/dni, genero, pais, profesion y cargo_actual",
          limit: "Límite:",
          limitDesc: "Máximo 3500 registros por archivo",
          onlyAllowedColumns: "Solo se permiten estas columnas",
          downloadTemplate: "Descargar Plantilla de Ejemplo",
          invalidFileType: "Por favor selecciona un archivo Excel válido (.xls o .xlsx)",
          dragOrClick: "Haz clic o arrastra un archivo Excel aquí",
          supportedFormats: "Formatos soportados: .xlsx, .xls",
          processingFile: "Procesando archivo...",
          columnsIdentified: "Columnas identificadas correctamente:",
          columnsInFile: "Columnas en el archivo:",
          totalRows: "Total de filas en el archivo:",
          validRows: "Registros válidos a cargar:",
          rowsOmitted: "filas serán omitidas por no tener nombres, apellido paterno o email",
          preview: "Vista previa (primeros 5 registros):",
          andMore: "... y",
          moreRecords: "registros más",
          uploadingToSystem: "Cargando postulantes al sistema...",
          uploadSummary: "Resumen de la carga:",
          totalLabel: "Total:",
          createdLabel: "Creados:",
          failedLabel: "Fallidos:",
          successfullyCreated: "Postulantes creados exitosamente",
          withErrors: "Postulantes con error",
          errorLabel: "Error:",
          emailLabel: "Email:",
          more: "más",
          cancel: "Cancelar",
          processFile: "Procesar Archivo",
          goBack: "Volver",
          confirmAndLoad: "Confirmar y Cargar",
          applicants: "Postulantes",
          selectFile: "Por favor selecciona un archivo",
          bulkUploadError: "Error al procesar la carga masiva",
          uploadCompleted: "Carga completada:",
          created: "creados",
          failed: "fallidos",
          emptyFile: "El archivo Excel está vacío",
          invalidColumns: "El archivo contiene columnas no permitidas:",
          onlyAllowed: "Solo se permiten: nombres, apellido_paterno, apellido_materno, email, telefono, rut/dni, genero, pais, profesion, cargo_actual",
          missingNameColumn: "El archivo debe contener las columnas \"nombres\" y \"apellido_paterno\". Si tu archivo es del formato anterior (una sola columna \"nombre\" con todo junto), descarga la plantilla nueva: los apellidos ahora van separados.",
          missingEmailColumn: "El archivo debe contener la columna \"email\"",
          noValidRecords: "No se encontraron registros válidos. Asegúrate de que las filas tengan nombres, apellido paterno y email.",
          exceedsLimit: "El archivo contiene",
          validRecords: "registros válidos, pero el límite es 3500.",
          processingError: "Error al procesar el archivo Excel:",
          readError: "Error al leer el archivo",
          noName: "Sin nombre",
          columnLabels: {
            name: "Nombre",
            names: "Nombres",
            firstLastName: "Apellido paterno",
            secondLastName: "Apellido materno",
            email: "Email",
            phone: "Teléfono",
            rut: "Identificador",
            gender: "Género",
            country: "País",
            profession: "Profesión",
            currentPosition: "Cargo Actual",
          },
        },
      },
      positions: {
        offeredSalary: "Salario Ofrecido",
        offeredSalaryPlaceholder: "Ej: $1.500.000 - $2.000.000",
        offeredSalaryHelper: "Rango salarial o monto específico para este cargo",
        notAvailable: "N/A",
        copySuffix: "- Copia",
        importFromHiringRoom: "Importar con HiringRoom",
        hiringRoomBadge: "HiringRoom",
        atsBadge: "ATS",
        loadError: "Error al cargar los cargos",
        deleteSuccess: "Cargo eliminado exitosamente",
        deleteError: "Error al eliminar cargo",
        title: "Gestión de Cargos",
        searchPlaceholder: "Buscar cargos...",
        newPosition: "Nuevo Cargo",
        noPositionsFound: "No se encontraron cargos que coincidan con",
        noPositions: "No hay cargos registrados",
        deleteTitle: "Confirmar eliminación",
        deleteConfirm: "¿Estás seguro de que quieres eliminar el cargo",
        completeNameAndIndustry:
          "Necesitas completar el nombre y la industria antes de generar la descripción",
        generateDescriptionSuccess: "Descripción generada exitosamente con IA",
        generateDescriptionError: "Error al generar descripción con IA",
        processingPDF: "Procesando PDF con IA...",
        processPDFSuccess: "PDF procesado exitosamente por IA",
        processPDFError: "No se pudo procesar el PDF",
        selectValidPDF: "Por favor selecciona un archivo PDF válido",
        validateNameExist: "El nombre del cargo es obligatorio",
        validateIndustryExist: "La industria es obligatoria",
        validateDescription: "La descripción es obligatoria",
        positionCreated: "Cargo creado exitosamente",
        positionUpdated: "Cargo actualizado exitosamente",
        positionSaveError: "Error al guardar cargo",
        newPosition: "Nuevo Cargo",
        editPosition: "Editar Cargo",
        showPosition: "Ver Cargo",
        positionNamePlaceholder: "ej: Desarrollador Fullstack",
        positionIndustryPlaceholder: "ej: Tecnología",
        positionDescriptionPlaceholder:
          "Describe las responsabilidades y requisitos de este cargo...",
        positionDescriptionDragOver:
          "¡Suelta el archivo PDF aquí para extraer su contenido!",
        positionDescriptionHelper: "Descripción obligatoria del cargo",
        positionDescriptionHelperDragOver:
          "Arrastra un archivo PDF para extraer automáticamente su contenido",
        "hierarchy": "Jerarquía",
        "hierarchyPlaceholder": "Ej: Analista, Coordinador, Gerente...",
        "mission": "Misión: Propósito fundamental del cargo",
        "missionPlaceholder": "Describe el propósito fundamental y la misión del cargo...",
        "missionDragOver": "Suelta aquí el archivo PDF para extraer la información",
        "missionHelper": "También puedes arrastrar un PDF aquí para extraer la información automáticamente",
        "missionHelperDragOver": "Arrastra y suelta un PDF aquí para extraer automáticamente la información",
        "responsibilities": "Principales responsabilidades",
        "responsibilitiesPlaceholder": "Describe las principales responsabilidades del cargo...",
        "responsibilitiesHelper": "Responsabilidades genéricas comunes al cargo, sin distinción a la unidad de pertenencia del cargo",
        "profile": "Perfil General",
        "profilePlaceholder": "Describe el perfil general requerido...",
        "profileHelper": "Profesión y experiencia laboral mínima requeridas",
        "excludingKnowledge": "Conocimientos excluyentes",
        "excludingKnowledgePlaceholder": "Lista los conocimientos indispensables...",
        "desirableKnowledge": "Conocimientos deseables",
        "desirableKnowledgePlaceholder": "Lista los conocimientos que serían un plus...",
        "defaultCompetencies": "Competencias predeterminadas",
        "defaultCompetenciesHelper": "Se precargan al enviar un Test DISC en modo completo o al configurar un Assessment para este cargo. En cada envío se pueden agregar o quitar sin modificar el cargo.",
        "validateMission": "La misión/propósito fundamental del cargo es requerida",
        "hierarchy": "Jerarquía",
        "mission": "Misión",
        "downloadTemplate": "Descargar Plantilla",
        "loadTemplate": "Cargar Plantilla",
        "selectValidDocx": "Por favor selecciona un archivo DOCX válido",
        "templateProcessedSuccess": "Plantilla procesada correctamente",
        "templateProcessError": "Error procesando la plantilla",
        "missionDragOver": "Suelta aquí el archivo DOCX para extraer la información",
        "missionHelperDragOver": "Arrastra y suelta una plantilla DOCX aquí para extraer automáticamente la información",
        selectValidWord: "Por favor selecciona un archivo Word válido (.doc o .docx)",
      },
      reports: {
        narrative: {
          title: "Narrativa del entregable",
          description: "Define cómo debe redactar GPT el análisis de este paso. Si lo dejas vacío, se usará la instrucción por defecto del sistema. Esta configuración se aplica a todas las evaluaciones futuras del proyecto.",
          label: "Instrucciones de narrativa",
          placeholder: "Ej: Usa un tono formal y directo. Destaca las fortalezas antes que las debilidades. Evita tecnicismos. Prioriza evidencia concreta sobre el cargo objetivo...",
          helperEmpty: "Sin instrucciones configuradas: GPT usará la narrativa por defecto del sistema para este paso.",
          helperEmptyWithSaved: "Estás eliminando la narrativa guardada. Al guardar, GPT volverá a usar la narrativa por defecto del sistema.",
          helperUnsaved: "Tienes cambios sin guardar. Guarda para que surtan efecto.",
          save: "Guardar narrativa",
          saving: "Guardando...",
          saveSuccess: "Narrativa guardada exitosamente",
          saveError: "Error al guardar la narrativa",
          errorTooShort: "La narrativa debe tener al menos {{min}} caracteres.",
          errorTooLong: "La narrativa no puede superar los {{max}} caracteres.",
          errorForbiddenChars: "La narrativa contiene caracteres no permitidos ({ } [ ] \\). Por favor, corrígela.",
          errorInvalidContent: "El contenido no es una instrucción narrativa válida",
          stepScope: {
            step0: "Esta narrativa aplica al análisis del CV: perfil general, trayectoria y fortalezas del candidato.",
            step2: "Esta narrativa aplica al análisis del test conductual DISC.",
            step3: "Esta narrativa aplica al análisis de la evaluación de razonamiento.",
            step4: "Esta narrativa aplica al análisis de la entrevista y áreas de desarrollo.",
          },
        },
        applicant: {
          applicantData: "Datos del Candidato",
          applicantNamePlaceholder: "Ingresa el nombre del cantidato...",
          applicantNoMatch: "No se encontraron coincidencias",
          applicantEmailPlaceholder: "Ingre el email del candidato...",
          selectedApplicant: "Candidato seleccionado",
        },
        dynamicSteps: {
          stepTitle: "Paso Extra",
          stepDescription: "Descripción personalizada del paso",
          stepGptInstructions:
            "Instrucciones específicas para GPT sobre cómo procesar este contenido",
          title: "Pasos Adicionales",
          subTitle:
            "Agrega hasta {{max}} pasos personalizados con instrucciones específicas para GPT",
          addStep: "Agregar Paso",
          deleteStep: "Eliminar Paso",
          gptInstructions: "Instrucciones para GPT",
          noAdditionalSteps: "No hay pasos adicionales",
          config: "Configurar Paso Dinámico",
          dynamicStepInstructionPlaceholder:
            "Describe específicamente qué debe hacer GPT con el contenido de este paso...",
          dynamicStepInstructionHelper:
            "Estas instrucciones le dirán a GPT cómo procesar y analizar el contenido de este paso",
          instruction: "Haz clic sobre el engranaje para configurar este paso adicional indicando a la IA cómo debe procesar el archivo que subirás. Puedes usar este paso para cargar información como referencias laborales, evaluaciones de desempeño u otros documentos relevantes."
        },
        reportList: {
          loadError: "No se pudieron cargar los evaluaciones. Intenta nuevamente.",
          title: "Evaluaciones Psicolaborales",
          newReport: "Crear nuevo reporte",
          updateList: "Actualizar lista",
          loadingReports: "Cargando Evaluaciones...",
          noReports: "No hay evaluaciones disponibles",
          applicantName: "Nombre postulante",
        },
        steps: {
          step1: {
            title: "Paso 1: CV del Candidato/a",
            description:
              "Ingresa los datos del candidato y carga su curriculum vitae",
            title: "Paso 1: CV del Candidato/a",
            recommendation: "Recomendación:",
            recommendationText: "Sube el CV en formato Word (.doc o .docx) para una mejor lectura automática. Si usas PDF, asegúrate de que sea el archivo original, no una imagen escaneada.",
            cvAvailable: "CV Disponible",
            cvAvailableMessage: "El candidato seleccionado tiene un CV cargado en el sistema.",
            candidateLabel: "Candidato:",
            loadAutomatically: "Cargar Automáticamente",
            checkingCv: "Verificando CV del candidato...",
            cvLoadedSuccess: "CV del candidato cargado automáticamente",
            cvLoadError: "Error al cargar el CV del candidato",
          },
          step2: {
            title: "Paso 2: Perfil del Cargo",
            description:
              "Selecciona el cargo correspondiente al proceso de selección desde los cargos configurados en el sistema",
          },
          step3: {
            title: "Paso 3: Test Conductual",
            description: "Carga el test conductual del candidato/a",
          },
          step4: {
            title: "Paso 4: Test de capacidades",
            description:
              "Carga el informe de test de capacidades del cantidado/a",
          },
          step5: {
            title: "Paso 5: Entrevista Técnica / Evaluación Conductual",
            description:
              "Carga el informe de la entrevista técnica y/o evaluación conductual",
            recommendation: "Recomendación:",
            recommendationText: "Sube la entrevista en Word o PDF original. Idealmente, usa la transcripción exportada desde el software de videollamada (Zoom, Meet, etc.) para asegurar una mejor lectura automática."
          },
        },
        layout: {
          fileOrUrlNotAvailable:
            "El archivo no está disponible o la URL es inválida",
          wordNotAvailable:
            "El documento Word aún no está disponible. Por favor, espera unos segundos e intenta nuevamente.",
          emailAndNameRequired:
            "El email y nombre del candidato son requeridos",
          uploadingFiles: "subiendo archivos",
          uploadingFilesCount: "subiendo archivos ({{count}})",
          uploadFilesSuccess: "archivos subidos satisfactoriamente",
          selectPosition:
            "Selecciona el cargo correspondiente a este proceso de selección",
          positionsNotFound: "No se encontraron cargos",
          selectedPosition: "Cargo seleccionado",
          positionDescription: "Descripción del cargo",
          stepsFlow: "Flujo de pasos para generar evaluación psicolaboral",
          reportTitle: "Generación de Informe",
          reportSubTitle:
            "Una vez completados todos los pasos, podrás generar el informe final con IA",
          generateReport: "Generar Informe Final",
          retryProccesing: "Reintentar procesamiento",
          startProcessing: "Iniciar procesamiento",
          reportGeneratedSuccess: "¡Informe generado correctamente!",
          showHtmlReport: "Ver informe HTML",
          uploadedPlural: "Subidos",
          usageLimitReached: "Límite de Evaluaciones Psycholabor Alcanzado",
          usageLimitMessage: "Ha alcanzado el límite máximo de evaluaciones psicolaborales. Para continuar utilizando este servicio, póngase en contacto con su administrador para revisar su plan actual o aumentar los límites de uso.",
          currentUsage: "Uso actual",
          evaluations: "evaluaciones",
          remainingEvaluations: "Evaluaciones restantes",
          unlimited: "ilimitado",
          checkingUsageLimits: "Verificando límites de uso...",
          reasoningTestsAvailableCount: "Tests de Capacidades Disponibles ({{count}})",
          reasoningTestsFoundMessage: "Se encontraron tests de capacidades completados para este candidato.",
          reasoningTestCompleted: "Completado:",
          reasoningTestDateNotAvailable: "Fecha no disponible",
          loadAllReasoningTests: "Cargar Todos",
          searchingReasoningTests: "Buscando tests de capacidades disponibles...",
          reasoningTestTypes: {
            wordAssociation: "Asociación de Palabras",
            logicalProcess: "Proceso Lógico",
            numericalReasoning: "Razonamiento Numérico",
            socialContext: "Contexto Social",
            logicalAbstract: "Razonamiento Lógico Abstracto",
            integrityTest: "Integridad Laboral",
            emotionalIntelligence: "Inteligencia Emocional"
          },
        },
        usageLimitExceeded: "Has alcanzado tu límite de evaluaciones ({{currentUsage}}/{{limit}}). Actualiza tu plan para continuar.",
        validationError: "Error de validación. Verifica los datos ingresados.",
        unexpectedError: "Error inesperado al crear el reporte. Intenta nuevamente.",
      },
      psycholabor: {
        title: "Evaluaciones Psicolaborales",
        subTitle: "Crea y gestiona evaluaciones psicolaborales completas",
        create: "Crear",
        dashboard: "Dashboard",
        dashboardTitle: "Estado de Evaluaciones Psicolaborales",
        dashboardSubTitle: "Visualiza y filtra todas las evaluaciones psicolaborales del proyecto",
        reportId: "ID Evaluación",
        totalReports: "Total de evaluaciones: {{count}}",
      },
      comparisonDashboard: {
        create: "Crear",
        dashboard: "Dashboard",
        noHistoryFound: "No hay comparaciones realizadas aún",
        noHistoryFoundDesc: "Inicia tu primera comparación desde la pestaña 'Crear'",
        totalComparisons: "Total: {{count}} comparaciones",
        viewResults: "Ver resultados",
        viewResultsDisabled: "La comparación aún no está completada",
        refresh: "Actualizar",
        statusPendiente: "Pendiente",
        statusCancelado: "Cancelado",
        reportsLoadError: "Error al cargar evaluaciones",
        noName: "Sin nombre",
        noPosition: "Cargo no especificado",
        selectReportForApplicant:
          "Primero selecciona un reporte para este postulante",
        comparisonStarted: "Comparación iniciada exitosamente",
        comparisonCreateError: "Error al crear la comparación",
        newComparison: "Nueva Comparación",
        comparisonResults: "Resultados de Comparación",
        title: "Dashboard de Comparación de Postulantes",
        subTitle:
          "Compara postulantes que han postulado a una misma posición usando métricas específicas",
        config: "Configuración",
        results: "Resultados",
        targetPosition: "Cargo Objetivo",
        selectPosition:
          "Selecciona el cargo para el cual quieres encontrar los mejores postulantes",
        noPositionsFound: "No se encontraron cargos",
        comparisonMode: "Modo de Comparación",
        "1vsAll": "1 vs Todos",
        "1vsAllDescription":
          "Compara un candidato ideal contra todos los demás",
        allVsAll: "Todos vs Todos",
        allVsAllDescription:
          "Compara todos los postulantes para encontrar el mejor",
        applicants: "Postulantes",
        applicantsWithReports:
          "Postulantes con informes completados. Selecciona al menos 2 para comparar",
        applicantsLoading: "Cargando postulantes...",
        noApplicantsWithReports:
          "No se encontraron postulantes con evaluaciones completados",
        selectReportForComparison:
          "Selecciona el reporte a usar para la comparación",
        selectPositionToContinue: "Selecciona un cargo objetivo para continuar",
        availableApplicants: "Postulantes disponibles",
        selectedReports: "Evaluaciones seleccionadas",
        idealApplicant: "Postulante ideal",
        starting: "Iniciando...",
        start: "Iniciar Comparación",
        processingComparison: "Procesando comparación...",
        processingText: "El análisis de postulantes está en progreso",
        comparisonError: "Error en la comparación",
        startingProcess: "Iniciando proceso de comparación",
        firstPlace: "Primer Lugar",
        secondPlace: "Segundo Lugar",
        thirdPlace: "Tercer Lugar",
        noResultsAvailable: "No hay resultados disponibles para descargar",
        applicantsAnalized: "Postulantes analizados",
        idealApplicantReference: "Candidato ideal de referencia",
        applicantsRanking: "Ranking de Postulantes",
        afinity: "Afinidad",
        keyStrengths: "Fortalezas clave para el cargo",
        analisis: "Análisis de ajuste",
        generalRecommendation: "Recomendación General",
        downloadResults: "Descargar Resultados",
        requirements: {
          title: "Para iniciar la comparación necesitas",
          reqOne: "Seleccionar un cargo objetivo",
          reqTwo: "Seleccionar al menos 2 postulantes",
          reqThree: "Elegir un modo de comparación",
          reqFour: "Marcar un candidato ideal",
        },
        "searchApplicantPlaceholder": "Buscar postulante por nombre...",
        "showOnlyTargetPosition": "Solo cargo objetivo",
        "showingResults": "Mostrando",
        "of": "de",
        "filteredBy": "Filtrado por",
        "onlyTargetPosition": "Solo cargo objetivo",
        "noApplicantsWithFilters": "No se encontraron postulantes con los filtros aplicados",
        usageLimitReached: "Límite de Comparaciones Alcanzado",
        usageLimitMessage: "Ha alcanzado el límite máximo de comparaciones para su organización. Para continuar utilizando este servicio, póngase en contacto con su administrador para revisar su plan actual o aumentar los límites de uso.",
        currentUsage: "Uso actual",
        comparisons: "comparaciones",
        remainingComparisons: "Comparaciones restantes",
        unlimited: "ilimitado",
        checkingUsageLimits: "Verificando límites de uso...",
        points: "puntos",
        remaining: "Puntos restantes"
      },
      // Assessment 2 (PLAN_ASSESSMENT2.md): módulo aparte, sin psicolaboral
      assessment2: {
        title: "Assessment 2",
        subTitle: "Assessment de competencias para cualquier postulante, sin evaluación psicolaboral",
        noApplicants: "No hay postulantes en este proyecto. Crea postulantes para agregarlos al assessment.",
        processing: "Procesando…",
        processingTooltip: "La evaluación con IA y los reportes se están generando en segundo plano. Esta lista se actualiza sola.",
        processingError: "Error al procesar",
        processingErrorTooltip: "La evaluación automática falló. Puedes reprocesarla.",
        reprocessQueued: "Reproceso encolado. El resultado aparecerá en unos minutos.",
      },
      evaluations: {
        // Modo simple / completo (PLAN_UNIFICACION_ASSESSMENT.md)
        modeTitle: "Modalidad del assessment",
        modeComplete: "Assessment completo",
        modeCompleteDescription: "Solo postulantes con informe psicolaboral. Incluye el ajuste al cargo (Nine Box) y considera DISC y razonamiento.",
        modeSimple: "Assessment simple",
        modeSimpleDescription: "Cualquier postulante del proyecto, sin informe psicolaboral. La evaluación considera solo las respuestas del assessment.",
        modeChipComplete: "Completo",
        modeChipSimple: "Simple",
        modeColumn: "Modalidad",
        modeFilterAll: "Todas",
        noEvaluationsForMode: "No hay assessments con modalidad {{mode}}.",
        noApplicantsSimple: "No hay postulantes en este proyecto. Crea postulantes para agregarlos al assessment.",
        // Un caso, varias competencias (PLAN_CASOS_ESTUDIO.md)
        legacyCase: "formato anterior",
        caseAlreadyInAssessment: "ya en este assessment",
        duplicatedCapability: "Competencia repetida",
        duplicatedCapabilityError: "Una competencia se mide una sola vez por assessment: hay competencias repetidas.",
        caseStudyRequiredError: "Cada competencia debe tener un caso de estudio seleccionado.",
        assessmentCaseStudies: "Casos de estudio del assessment",
        assessmentCaseStudiesHelper: "El candidato lee cada caso una sola vez y luego responde, de corrido, las preguntas de todas las competencias asociadas. El tiempo de lectura es por caso.",
        caseStudiesCount: "{{count}} caso(s) de estudio",
        sharedCaseHint: "caso compartido con otras competencias",
        expandAll: "Expandir todo",
        collapseAll: "Colapsar todo",
        noApplicantsWithReport: "No hay postulantes con evaluación psicolaboral completada. Los candidatos deben tener un informe psicolaboral para ser agregados a la evaluación.",
        points: "puntos",
        title: "Gestión de assessments",
        subTitle:
          "Configura y administra los assessments de competencias para tus procesos de selección.",
        loadError: "Error al cargar los assessments",
        loadErrorSingle: "Error al cargar el assessment",
        createSuccess: "Assessment creado exitosamente",
        deleteSuccess: "Assessment eliminado exitosamente",
        deleteError: "Error al eliminar assessment",
        myEvaluations: "Mis Assessments",
        newEvaluation: "Nuevo Assessment",
        searchPlaceholder:
          "Buscar assessments por título, cargo o descripción...",
        noEvaluationsFound: "No se encontraron assessments que coincidan con",
        noEvaluations:
          "No hay assessments registrados. Crea tu primer assessment usando el botón 'Nuevo Assessment'.",
        showDashboard: "Ver Dashboard",
        enterEvaluation: "Entrar al assessment",
        deleteConfirm: "Confirmar Eliminación",
        deleteConfirmText: "¿Estás seguro de que deseas eliminar el assessment",
        pleaseSelectPosition: "Por favor selecciona un cargo para continuar",
        pleaseFillTitle: "Por favor completa el título del assessment",
        pleaseSelectCapability: "Por favor selecciona al menos una competencia",
        percentageError: "La suma de los porcentajes debe ser exactamente 100%",
        pleaseSelectApplicant: "Por favor selecciona al menos un candidato",
        unknownStep: "Paso desconocido",
        configurationTitle: "Configuración de Formulario de Assessment",
        configurationSubTitle:
          "Configura el proceso de assessment paso a paso para optimizar la selección de postulantes.",
        configurationStepOneSubTitle:
          "Selecciona el cargo y define los detalles básicos del assessment.",
        configurationStepOneFormTitle: "Configuración del Assessment",
        configurationStepOneFormSubTitle:
          "Define los detalles principales del assessment para",
        configurationStepOneFormTitleLabel: "Título del assessment",
        configurationStepOneFormTitlePlaceholder: "Assessment",
        configurationStepOneFormTitleHelper: "Título del assessment",
        configurationStepOneFormDescriptionLabel: "Descripción (opcional)",
        configurationStepOneFormDescriptionPlaceholder:
          "Descripción (opcional)",
        configurationStepOneFormDescriptionHelper: "Descripción (opcional)",
        configurationStepOneFormTimeLabel: "Tiempo límite (minutos)",
        configurationStepOneFormTimeHelper: "Entre 5 y 500 minutos",
        configurationStepOneFormTimeInfo:
          "Los postulantes tendrán {{timeLimit}} minutos para completar el assessment",
        selectPosition: "Seleccionar este cargo",
        createEvaluation: "Crear Assessment",
        evaluationCreateSuccess: "¡Assessment creado exitosamente!",
        evaluationCreateSucesssInfo:
          "El assessment ha sido configurado y está listo para ser enviado a los postulantes.",
        evaluationId: "ID del assessment",
        evaluationCreateError: "Error al crear el assessment",
        evaluationReady: "Tu assessment está listo. Ahora puedes:",
        evaluationReadyPointOne:
          "Enviar invitaciones a los postulantes seleccionados",
        evaluationReadyPointTwo:
          "Monitorear el progreso desde el panel de assessments",
        evaluationReadyPointThree:
          "Revisar los resultados cuando los postulantes completen el assessment",
        evaluationCreateConfirm: "Confirmación y Creación del Assessment",
        evaluationCreateReview:
          "Revisa la configuración antes de crear el assessment.",
        evaluationSummary: "Resumen del Assessment",
        applicantNotFound: "Postulante no encontrado",
        applicantAlreadyAdded: "Este postulante ya ha sido agregado",
        applicantAddedSuccessfully: "Postulante agregado exitosamente",
        applicantDeleted: "Postulante eliminado",
        applicantManagement: "Gestión de postulantes",
        applicantManagementSubTitle:
          "Agrega los postulantes a los que deseas enviar el assessment de competencias para el cargo de",
        currentConfiguration: "Configuración actual",
        configuredCapabilities: "Competencia configuradas",
        totalPercentage: "Porcentaje total",
        addNewApplicant: "Agregar Nuevo Postulante",
        selectApplicant: "Seleccionar postulante",
        addApplicant: "Agregar Postulante",
        allApplicantsAdded:
          "Todos los postulantes disponibles ya han sido agregados.",
        noApplicantsAvailable:
          "No hay postulantes disponibles. Agrega postulantes desde la sección de Postulantes.",
        totalApplicantsAdded: "Total de postulantes agregados",
        readyToContinue: "Listo para continuar ✓",
        addAtleastOneApplicant: "Agrega al menos un postulante",
        noTitle: "Sin título",
        stepTwoTitle: "Definición de Competencias y Contexto del Assessment",
        stepTwoSubTitle:
          "Define las competencias, casos de estudio y preguntas específicas que se evaluarán para cada candidato.",
        selectCapability: "Seleccionar competencia",
        evaluationWeigth: "Peso en el assessment (%)",
        selectCaseStudy: "Seleccionar caso de estudio",
        noContent: "Sin cantenido",
        selectQuestion: "Seleccionar pregunta",
        selectedQuestion: "Pregunta seleccionada",
        noCapability: "Sin competencia",
        selectedCase: "Caso seleccionado",
        addNewCapability: "Agregar Nueva Competencia",
        noCapabilitiesAvailable:
          "No hay competencias disponibles. Crea competencias desde la sección de Competencias para poder configurar el assessment.",
        finalConfigurationSummary: "Resumen Final de la Configuración",
        totalWeigthsAsigned: "Total de pesos asignados",
        configurationComplete: "Configuración completa",
        configurationIncomplete: "Configuración incompleta",
        weigthWarning:
          "La suma de los porcentajes debe ser exactamente 100% para continuar",
        left: "Faltan",
        forAssignment: "por asignar",
        youHave: "Tienes",
        surplusAssigned: "de más asignado",
        evaluationSteps: [
          "Seleccionar Cargo y Configurar Assessment",
          "Definición de Competencias",
          "Gestión de postulantes",
          "Confirmación y Creación",
        ],
        maxQuestionsPerCompetency: "Máximo 5 preguntas por competencia",
        minQuestionsPerCompetency: "Mínimo 3 preguntas por competencia",
        questionsConfigurationTitle: "📝 Configuración de Preguntas por Competencia",
        questionsConfigurationDescription: "• Mínimo: 3 preguntas por competencia\n• Máximo: 5 preguntas por competencia\n• Las preguntas seleccionadas se presentarán secuencialmente al candidato",
        selectMinimumQuestions: "Selecciona al menos {{minimum}} preguntas para esta competencia. Actualmente tienes {{current}} seleccionadas.",
        noQuestionsAvailable: "No hay preguntas disponibles para el caso de estudio seleccionado.",
        questionNumber: "Pregunta {{number}}",
        selectedQuestions: "Preguntas Seleccionadas ({{count}})",
        questionsCount: "{{count}} preguntas",
        questionsCountMinimum: "{{count}} preguntas (mín. {{minimum}})",
        totalQuestions: "Total Preguntas",
        questionsConfigurationRequired: "📝 Configuración de Preguntas Requerida",
        competencyNumber: "Competencia {{number}}",
        noQuestionsSelected: "No tiene preguntas seleccionadas",
        insufficientQuestions: "Solo tiene {{count}} pregunta{{count, plural, one {} other {s}}} (mínimo {{minimum}})",
        excessQuestions: "Tiene {{count}} preguntas (máximo {{maximum}})",
        caseStudy: "Caso de estudio",
        viewQuestions: "Ver preguntas",
        noQuestionsConfigured: "No hay preguntas configuradas para esta competencia",
        createNewEvaluation: "Crear Nuevo Assessment",
        backToStep1: "Volver al Paso 1",
        resetToStep1Success: "Configuración reiniciada exitosamente. Puedes crear un nuevo assessment.",
        "emailNotifications": "Notificaciones por Email",
        "sendEmailsToCandidate": "Enviar emails automáticamente a los candidatos",
        "emailsWillBeSentAutomatically": "Los emails se enviarán automáticamente después de crear el assessment",
        "emailsWillNotBeSent": "Los emails NO se enviarán. Deberás enviarlos manualmente desde la vista de assessments",
        "emailWillInclude": "El email incluirá el enlace directo para que los candidatos puedan acceder a su assessment.",
        "creatingAndSendingEmails": "Creando assessment y enviando emails...",
        "creatingEvaluation": "Creando assessment...",
        "evaluationCreateSuccessWithEmails": "Assessment creado exitosamente y emails enviados a los candidatos.",
        "evaluationCreateSuccessInfo": "Assessment creado exitosamente. Los candidatos aún no han sido invitados: puedes enviar las invitaciones desde el panel de assessments.",
        "evaluationReadyWithEmails": "Tu assessment ha sido creado y los candidatos han recibido sus invitaciones por email.",
        "emailsSentToCandidates": "Los emails han sido enviados a todos los candidatos",
        "candidatesCanStartEvaluation": "Los candidatos pueden comenzar su assessment inmediatamente",
        "monitorProgressInEvaluationView": "Puedes monitorear el progreso desde la vista de assessments",
        "readingTime": "Tiempo lectura (min)",
        "questionTime": "Tiempo preguntas (min)",
        "timeRangeHelper": "5-60 minutos",
        "cannotExceed100": "No puede exceder 100%",
        "unspecified": "Sin especificar",
        "candidate": "Candidato",
        "reading": "Lectura",
        "questions": "Preguntas",
        "minutes": "min",
        "totalTime": "Tiempo total",
        "insufficientAssessments": "No tienes suficientes assessments disponibles para enviar a todos los candidatos",
      },
      evaluationAlert: {
        "checkingAssessments": "Verificando assessments disponibles...",
        "warning": "Advertencia",
        "limitsCouldNotBeVerified": "Los límites no pudieron verificarse correctamente.",
        "dismissAlert": "Descartar alerta",
        "insufficientAssessments": "Assessments insuficientes",
        "assessmentsStatus": "Estado de assessments",
        "insufficientMessage": "Assessments insuficientes: tienes {{available}} disponibles pero necesitas {{needed}} para enviar a todos los candidatos pendientes.",
        "unlimitedMessage": "Tienes assessments ilimitados disponibles.",
        "availableAndPending": "Assessments disponibles: {{available}}. Candidatos pendientes: {{pending}}.",
        "remainingMessage": "Tienes {{remaining}} assessments restantes de {{limit}} totales.",
        "availableCompact": "{{count}} assessments disponibles",
        "pendingCompact": "{{count}} pendientes",
        "currentUsage": "Uso actual: {{current}} / {{limit}}",
        "usedChip": "{{count}} usados",
        "availableChip": "{{count}} disponibles",
        "pendingCandidatesChip": "{{count}} candidatos pendientes",
        "unlimitedChip": "Assessments ilimitados",
      },
      evaluationResponses: {
        downloadPdf: 'Descargar PDF',
        downloadWord: 'Descargar Word',
        noResultsAvailable: 'No hay resultados disponibles',
        candidate: 'Candidato',
        position: 'Cargo',
        completedDate: 'Fecha Completado',
        talentMap: 'Mapa de Talentos (Matriz NineBox)',
        confidenceIndex: 'Índice de Confiabilidad',
        assessmentResults: 'Resultados del Assessment',
        scoreAssessment: 'Score Assessment',
        scorePsycholabor: 'Score Evaluación Psicolaboral',

        // Competencias
        evaluatedCompetencies: 'Competencias Evaluadas',
        questionsEvaluated: 'pregunta(s) evaluada(s)',
        questionsAnswered: '{{answered}} de {{total}} pregunta(s) respondida(s)',
        reprocessTitle: 'Reprocesar assessment',
        reprocessConfirm: 'Se volverá a evaluar el assessment de {{name}} con IA y se regenerarán el PDF y el Word. Esto reemplaza el score, la conclusión y el plan de desarrollo actuales, y puede tardar varios minutos. ¿Continuar?',
        reprocessSuccess: 'Assessment reprocesado correctamente.',
        // Procesamiento en cola (PLAN_UNIFICACION_ASSESSMENT.md)
        reprocessQueued: 'Reproceso encolado. El resultado aparecerá en unos minutos.',
        processing: 'Procesando…',
        processingTooltip: 'La evaluación con IA y los reportes se están generando en segundo plano. Esta lista se actualiza sola.',
        processingError: 'Error al procesar',
        processingErrorTooltip: 'La evaluación automática falló. Puedes reprocesarla.',
        // Informe de Potencial (PLAN_UNIFICACION_ASSESSMENT.md §7); los textos del informe vienen del backend
        potentialReportLoading: 'Cargando el informe del assessment…',
        potentialReportError: 'No se pudo cargar el informe del assessment.',
        potentialReportDownloadError: 'No se pudo descargar el informe del assessment. Intenta nuevamente.',
        reprocessError: 'Error al reprocesar el assessment. Intenta nuevamente.',
        strengthsForPosition: 'Fortalezas para el Cargo',
        improvementAreas: 'Áreas de Mejora',
        noCompetenciesAvailable: 'No hay competencias evaluadas disponibles',
        noCompetency: 'Sin competencia',

        // NineBox
        nineBoxPosition: 'Posición en Matriz NineBox',
        xAxisAssessment: 'Eje X (Assessment):',
        yAxisJobFit: 'Eje Y (Job Fit):',
        quadrantMeaning: 'Significado del Cuadrante',
        positioningReasons: 'Razones del Posicionamiento',
        elementsAndOpportunities: 'Elementos a Considerar y Oportunidades',
        expectations6to12: 'Expectativas (6-12 meses)',
        unclassified: 'Sin Clasificar',

        // NineBox Labels
        nineBoxLabels: {
          'high-high': 'Alto Potencial - Alto Desempeño',
          'high-medium': 'Alto Potencial - Desempeño Medio',
          'high-low': 'Alto Potencial - Desarrollo Requerido',
          'medium-high': 'Profesional Clave de Alto Rendimiento',
          'medium-medium': 'Desempeño Sólido',
          'medium-low': 'Diamante en Bruto',
          'low-high': 'Contribuidor Efectivo',
          'low-medium': 'En Desarrollo',
          'low-low': 'Requiere Atención Inmediata'
        },

        // Plan de Desarrollo
        developmentPlan90180360: 'Plan de Desarrollo (90/180/360 días)',
        first90Days: 'Primeros 90 días',
        next90Days: 'Siguientes 90 días (91-180)',
        thirdPeriod: 'Tercer período (181-360)',
        objectives: 'Objetivos:',
        actions: 'Acciones:',
        indicators: 'Indicadores:',

        // Conclusión
        integratedConclusion: 'Conclusión Integrada',
        generalPerformanceView: 'Visión General del Desempeño',
        discConnection: 'Conexión con Estilo de Trabajo (DISC)',
        cognitiveCapabilities: 'Capacidades Cognitivas',
        developmentOpportunities: 'Oportunidades de Desarrollo',
        profileSynthesis: 'Síntesis del Perfil',
        positionImplications: 'Implicaciones para el Cargo',
        noConclusionAvailable: 'No hay conclusión integrada disponible',
        assessmentResults: 'Resultados del Assessment',
        export: {
          title: "Reporte de Evaluación",
          date: "Fecha",
          executiveSummary: "Resumen Ejecutivo",
          totalCandidates: "Total de Candidatos",
          completedCandidates: "Candidatos Completados",
          averageScore: "Puntuación Promedio",
          bestCompetency: "Mejor Competencia",
          worstCompetency: "Competencia a Mejorar",
          candidateRanking: "Ranking de Candidatos",
          competencyAnalysis: "Análisis por Competencias",
          average: "promedio",
          analysis: "Análisis",
          overallScore: "Puntuación General",
          timeSpent: "Tiempo Empleado",
          minutes: "minutos",
          unknownCompetency: "Desconocida",
          strengths: "Fortalezas",
          noOutstandingSkills:
            "No se identificaron competencias destacadas (≥75%)",
          improvementAreas: "Áreas de Mejora",
          allSkillsAdequate:
            "Todas las competencias evaluadas están en nivel adecuado",
          developmentPlan: "Plan de Desarrollo",
          toImproveIn: "Para mejorar en",
          generalRecommendations: "Recomendaciones generales",
          conclusion: "Conclusión",
          conclusions: "Conclusiones",
          filename: "Reporte",
          description: "Reporte de evaluación generado automáticamente",
          error:
            "Error al generar el reporte Word. Por favor, inténtalo de nuevo.",

          developmentPlans: {
            reinforceFundamentals:
              "Reforzar conceptos fundamentales de la posición.",
            participateInTraining:
              "Participar en entrenamientos específicos por competencia.",
            requestDetailedFeedback:
              "Solicitar feedback detallado para mejorar el desempeño.",
            focusOnWeakSkills:
              "Enfocarse en las competencias con menor puntuación.",
            practiceCaseStudies:
              "Practicar casos de estudio similares a los evaluados.",
            seekMentorship: "Buscar mentoría en áreas de oportunidad.",
            maintainCurrentLevel: "Mantener el nivel actual de competencias.",
            shareKnowledge: "Compartir conocimientos con otros candidatos.",
            exploreAdvancedAreas: "Explorar áreas de especialización avanzada.",
          },

          conclusionTemplate: {
            profile:
              "{{name}} tiene un perfil con una puntuación general de {{score}}%.",
            standOut: "Destaca especialmente en {{competency}} ({{score}}%).",
            improvement:
              "Con el plan de desarrollo propuesto, puede mejorar en {{competency}} y alcanzar su máximo potencial.",
          },

          finalConclusions: {
            evaluated:
              "Se evaluaron {{total}} candidatos para la posición de {{position}}.",
            averageScore:
              "El promedio general de puntuación fue de {{average}}%.",
            bestPerformance:
              "La competencia con mejor desempeño fue {{competency}}.",
            recommendation:
              "Se recomienda reforzar la competencia de {{competency}} en futuros entrenamientos.",
          },
          startingBackendExport: "Iniciando exportación Word desde backend...",
          missingProjectData: "Error: Faltan datos del proyecto",
          downloadSuccessful: "Documento Word descargado exitosamente",
          backendExportError: "Error exportando Word desde backend:",
          incompleteData: "Datos incompletos para generar el documento",
          serverError: "Error interno del servidor",
          connectionError: "Error de conexión con el servidor",
        },
        loadError: "Error al cargar las respuestas",
        dataUpdated: "Datos actualizados",
        statusPending: "Pendiente",
        statusOpened: "Abierta",
        statusStarted: "Iniciada",
        statusCompleted: "Completada",
        statusProcessing: "Procesando",
        statusExpired: "Expirada",
        title: "Respuestas de Evaluación",
        answered: "Respondida",
        notAnswered: "Sin responder",
        noName: "Postulante sin nombre",
        noPosition: "Sin posición",
        loadingEvaluationData: "Cargando datos de evaluación...",
        backToEvaluations: "Volver a Evaluaciones",
        evaluations: "Evaluaciones",
        comparativeDashboard: "Dashboard Comparativo",
        exportWord: "Exportar Word",
        totalApplicants: "Total Postulantes",
        applicantsBreakdown:
          "{{qualified}} calificados, {{unqualified}} sin calificar, {{inProgress}} en progreso",
        averageScore: "Puntuación Promedio",
        bestCompetency: "Mejor Competencia",
        competencyToImprove: "Competencia a Mejorar",
        averageWithValue: "{{value}}% promedio",
        noAnalysisDataAvailable:
          "No hay datos de análisis disponibles para este postulante.",
        applicantId: "ID del postulante",
        unknownCompetency: "Desconocida",
        strengths: "Fortalezas",
        improvementAreas: "Áreas de mejora",
        personalizedDevelopmentPlan: "Plan de desarrollo personalizado",
        conclusion: "Conclusión",
        excellent: "Excelente",
        noOutstandingStrengths:
          "No se identificaron fortalezas destacadas en las competencias evaluadas.",
        allSkillsAdequateLevel:
          "Todas las competencias evaluadas están en un nivel adecuado.",
        noDevelopmentPlanAvailable:
          "No hay plan de desarrollo específico disponible.",
        toImproveInCompetency: "Para mejorar en {{competency}}",
        generalRecommendations: "Recomendaciones generales",
        conclusionFallback: {
          profile:
            "{{name}} tiene un perfil con una puntuación general de {{score}}%.",
          standOut: "Destaca especialmente en {{competency}} ({{score}}%).",
          canImprove:
            "Con el plan de desarrollo propuesto, puede mejorar en {{competency}} y alcanzar su máximo potencial.",
        },
        statusCompleted: "Completada",
        statusProcessing: "Procesando",
        statusInProgress: "En progreso",
        statusExpired: "Expirada",
        statusPending: "Pendiente",
        statusSent: "Enviada",
        statusUnknown: "Desconocido",
        tabAllApplicants: "Todos los postulantes",
        tabComparative: "Comparativa",
        tabBySkills: "Por competencias",
        searchApplicant: "Buscar postulante...",
        applicantsFound: "{{count}} postulantes encontrados",
        applicant: "Postulante",
        status: "Estado",
        progress: "Progreso",
        score: "Puntuación",
        time: "Tiempo",
        date: "Fecha",
        total: "Total",
        questionsProgress: "{{completed}}/{{total}} preguntas",
        notAvailable: "N/A",
        selectApplicants: "Seleccionar Postulantes",
        selectApplicantsDescription:
          "Elige los postulantes que deseas comparar",
        competenciesToCompare: "Competencias a comparar",
        comparativeAnalysis: "Análisis Comparativo",
        comparativeAnalysisDescription:
          "Comparación detallada de los postulantes seleccionados y recomendaciones personalizadas",
        comparativeChart: "Gráfico Comparativo",
        analysisByApplicant: "Análisis por Postulante",
        comparingInfo:
          "Comparando {{applicants}} postulantes en {{competencies}} competencias seleccionadas",
        selectAtLeastTwoApplicants:
          "Selecciona al menos 2 postulantes para mostrar la comparación gráfica.",
        selectApplicantsForChart:
          "Selecciona postulantes para mostrar el gráfico comparativo.",
        selectApplicantsForAnalysis:
          "Selecciona postulantes para mostrar el análisis comparativo.",
        analysisBySkills: "Análisis por Competencias",
        analysisBySkillsDescription:
          "Visualiza el rendimiento de cada postulante en las competencias evaluadas y recomendaciones personalizadas.",
        generalAverages: "Promedios Generales",
        averagesWillShow:
          "Los promedios se mostrarán cuando haya evaluaciones calificadas.",
        applicantRanking: "Ranking de Postulantes",
        applicantRankingDescription:
          "Ordenados por puntuación total de mayor a menor",
        detailedTableWillShow:
          "La tabla detallada se mostrará cuando haya postulantes con evaluaciones calificadas.",
        analysisAndDevelopmentPlan: "Análisis y Plan de Desarrollo",
        personalizedRecommendations:
          "Recomendaciones personalizadas para cada postulante",
        applicantDeletedSuccessfully:
          "Postulante y sus respuestas eliminados exitosamente",
        errorDeletingApplicant: "Error al eliminar postulante",
        errorLoadingInitialData: "Error al cargar los datos iniciales",
        evaluationGeneratedSuccessfully:
          "Evaluación generada exitosamente con {{questionsCount}} preguntas usando las competencias definidas. ID: {{responseId}}",
        evaluationCreatedButErrorUpdatingApplicant:
          "Evaluación creada pero error al actualizar estado del postulante",
        errorCreatingEvaluation: "Error al crear la evaluación",
        errorGeneratingEvaluation: "Error al generar evaluación",
        evaluationsGeneratedSuccessfully:
          "Evaluaciones generadas exitosamente para {{count}} postulantes",
        evaluationsFailed: "{{count}} evaluaciones fallaron al generarse",
        errorGeneratingEvaluations: "Error al generar evaluaciones",
        statusLabels: {
          pending: "Pendiente",
          sent: "Enviado",
          opened: "Abierta",
          started: "Iniciada",
          completed: "Completada",
          expired: "Expirada",
        },
        statusTooltips: {
          pending: "En espera de generar el link de evaluación",
          sent: "Link de evaluación generado y disponible para el postulante",
          opened: "El postulante ha visitado el link de la evaluación",
          started:
            "El postulante comenzó a responder las preguntas de la evaluación",
          completed:
            "El postulante finalizó todas las preguntas de la evaluación",
          expired: "La evaluación expiró por límite de tiempo sin completarse",
          unknown: "Estado desconocido",
        },
        evaluationNotFound: "Evaluación no encontrada",
        goBack: "Volver",
        evaluations: "Evaluaciones",
        viewDashboard: "Ver Dashboard",
        evaluationInformation: "Información de la Evaluación",
        title: "Título",
        description: "Descripción",
        position: "Posición",
        competencies: "Competencias",
        timeLimit: "Tiempo límite",
        minutes: "minutos",
        addApplicants: "Agregar Postulantes",
        noApplicantsAvailable:
          "No hay postulantes disponibles para agregar. Todos los postulantes del proyecto ya están incluidos en esta evaluación.",
        selectApplicant: "Seleccionar postulante",
        add: "Agregar",
        applicantsCount: "Postulantes ({{count}})",
        generateEvaluationsForAllPending:
          "Generar Evaluaciones para Todos los Pendientes",
        noApplicantsAdded: "No hay postulantes agregados",
        addApplicantsToStart:
          "Agrega postulantes a esta evaluación para comenzar el proceso de selección.",
        name: "Nombre",
        email: "Email",
        status: "Estado",
        evaluationGenerated: "Evaluación generada",
        lastActivity: "Última actividad",
        actions: "Acciones",
        generateEvaluation: "Generar evaluación",
        copyEvaluationUrl: "Copiar URL de evaluación",
        deleteApplicant: "Eliminar postulante",
        confirmDeletion: "Confirmar Eliminación",
        deleteConfirmationMessage:
          "¿Estás seguro de que deseas eliminar al postulante {{name}}?",
        noName: "Sin nombre",
        thisAction: "Esta acción",
        deleteActionRemove: "Eliminará al postulante de esta evaluación",
        deleteActionPermanent:
          "Borrará permanentemente todas sus respuestas de evaluación",
        deleteActionUndoable: "No se puede deshacer",
        applicant: "Postulante",
        noEmail: "Sin email",
        cancel: "Cancelar",
        yesDelete: "Sí, Eliminar",
        tabTalentMap: "Mapa de Talentos",

        talentMap: {
          title: "Mapa de Talentos",
          description: "Análisis visual del potencial y desempeño de los candidatos evaluados",
          noDataAvailable: "No hay datos disponibles para mostrar la matriz de talento",

          totalCandidates: "Total Candidatos",
          highPerformers: "Alto Rendimiento",
          needsDevelopment: "Necesitan Desarrollo",
          averagePerformance: "Rendimiento Promedio",

          performance: "Desempeño",
          profile: "Ajuste Perfil",
          performanceAxis: "Desempeño (%)",
          profileAxis: "Ajuste Perfil (%)",


          matrixTitle: "Mapa de Talentos - Desempeño vs Ajuste al Perfil del Cargo",
          candidates: "Candidatos",
          legend: "Leyenda",

          starPerformer: "Estrella Consistente",
          starPerformerDesc: "Ideal para sucesión y planes de liderazgo. Alto impacto organizacional.",

          highPerformer: "Profesional más que Altamente Calificado",
          highPerformerDesc: "Aún no brilla del todo, pero tiene futuro. Necesita desarrollo o mentoring.",

          keyContributor: "Trabajador Clave de Alto Rendimiento",
          keyContributorDesc: "Cumple, pero con bajo margen de crecimiento.",

          emergingTalent: "Futura Estrella",
          emergingTalentDesc: "Excelente en su rol actual, quizá no para escalar.",

          coreProfessional: "Profesional Sólido",
          coreProfessionalDesc: "Podría mejorar con capacitación o cambio de rol.",

          highPotential: "Profesional Altamente Calificado",
          highPotentialDesc: "Requiere apoyo, feedback o reubicación.",

          inconsistentPerformer: "Un Diamante en Bruto",
          inconsistentPerformerDesc: "Muy valioso en su puesto actual, no se proyecta a cargos superiores.",

          developmentNeeded: "Trabajador de Rendimiento Inconsistente",
          developmentNeededDesc: "Mantiene estabilidad, pero sin ambición de más.",

          underPerformer: "Trabajador de Rendimiento Bajo",
          underPerformerDesc: "Requiere intervención inmediata. Posible desvinculación o reubicación.",

          unclassified: "Sin Clasificar",

          candidatesSummary: "Resumen de Candidatos",
          candidate: "Candidato",
          classification: "Clasificación"
        },
        resendEmail: "Reenviar correo de invitación",
        emailResentSuccessfully: "Correo de invitación reenviado exitosamente",
        errorResendingEmail: "Error al reenviar el correo de invitación",
        applicantNotFound: "Candidato no encontrado",
      },
      publicEvaluations: {
        // Un caso, varias competencias (PLAN_CASOS_ESTUDIO.md)
        caseStudyOf: "Caso de estudio {{current}} de {{total}}",
        caseStudyCompetenciesHint: "Lee el caso una sola vez: a continuación responderás las preguntas de {{count}} competencia(s) sobre esta situación.",
        competencyOfCase: "competencia {{current}} de {{total}} de este caso",
        activityMonitoringDisclaimer: "Durante este test se monitoreará tu actividad para garantizar la integridad del proceso. Esto incluye la detección de cambios de pestaña, copiar/pegar, capturas de pantalla y otras acciones sospechosas.",
        evaluationAlreadyCompleted: "Esta evaluación ya ha sido completada.",
        evaluationExpiredNotAvailable:
          "Esta evaluación ha expirado y ya no está disponible.",
        timeToCompleteExpired:
          "El tiempo para completar esta evaluación ha expirado.",
        timeUpSavingAnswers:
          "El tiempo se ha agotado. Guardando todas las respuestas y completando automáticamente...",
        evaluationCompletedAutomatically:
          "Evaluación completada automáticamente por agotamiento de tiempo.",
        errorCompletingAutomatically:
          "Error al completar la evaluación automáticamente.",
        errorSavingAnswersAutomatically:
          "Error al guardar las respuestas automáticamente.",
        answerSavedSuccessfully: "Respuesta guardada correctamente",
        errorSavingAnswer: "Error al guardar la respuesta. Intenta nuevamente.",
        emptyAnswer: "Respuesta vacía",
        errorSavingAllAnswers:
          "Error al guardar todas las respuestas: {{message}}",
        errorCompletingEvaluation: "Error al completar la evaluación",
        errorCompletingEvaluationTryAgain:
          "Error al completar la evaluación. Intenta nuevamente.",
        noQuestionsFound: "No se encontraron preguntas para esta evaluación.",
        evaluationExpired: "Evaluación Expirada",
        timeToCompleteHasExpired:
          "El tiempo para completar esta evaluación ha expirado.",
        contactAdministratorIfError:
          "Si crees que esto es un error, contacta al administrador de la evaluación.",
        questionProgress: "Pregunta {{current}} de {{total}}",
        answeredCount: "{{answered}}/{{total}} respondidas",
        fiveMinutesWarning:
          "⚠️ Quedan menos de 5 minutos para completar la evaluación.",
        lastMinuteWarning:
          "🚨 ¡Último minuto! La evaluación se cerrará automáticamente cuando se agote el tiempo.",
        caseStudy: "Caso de Estudio",
        readCaseStudyCarefully:
          "Lee cuidadosamente este caso de estudio antes de responder la pregunta siguiente.",
        aboutThisCompetency: "Sobre esta competencia",
        evaluationExpiredPlaceholder: "Evaluación expirada",
        writeAnswerPlaceholder: "Escribe tu respuesta aquí...",
        previous: "Anterior",
        finishEvaluation: "Finalizar Evaluación",
        next: "Siguiente",
        finishConfirmationQuestion:
          "¿Estás seguro de que deseas finalizar la evaluación?",
        finishConfirmationWarning:
          "Una vez finalizada, no podrás modificar tus respuestas.",
        ensureAllQuestionsAnswered:
          "Asegúrate de haber respondido todas las preguntas antes de finalizar.",
        cancel: "Cancelar",
        finishing: "Finalizando...",
        confirm: "Confirmar",
        evaluationAlreadyCompleted: "Esta evaluación ya ha sido completada.",
        evaluationExpiredNotAvailable:
          "Esta evaluación ha expirado y ya no está disponible.",
        errorStartingEvaluation: "Error al iniciar la evaluación",
        errorLoadingEvaluation: "Error al cargar la evaluación",
        invalidEmail: "Email no válido",
        pleaseEnterEmail: "Por favor ingresa tu email",
        noAccessToEvaluation: "No tienes acceso a esta evaluación",
        evaluationNotFound: "Evaluación no encontrada",
        noAccessWithProvidedEmail:
          "No tienes acceso a esta evaluación con el email proporcionado",
        errorValidatingAccess: "Error al validar acceso",
        errorValidatingAccessTryAgain:
          "Error al validar acceso. Intenta nuevamente.",
        evaluationAccess: "Acceso a Evaluación",
        enterEmailToAccess: "Ingresa tu email para acceder a tu evaluación",
        email: "Email",
        emailPlaceholder: "ejemplo@correo.com",
        enterRegisteredEmail: "Ingresa tu email registrado",
        validating: "Validando...",
        accessEvaluation: "Acceder a Evaluación",
        evaluationCompleted: "¡Evaluación Completada!",
        evaluationCompletedDescription:
          "Has completado exitosamente la evaluación. Tus respuestas han sido guardadas.",
        thanksForTimeMessage:
          "Gracias por tu tiempo. Los resultados serán revisados y te contactaremos pronto.",
        evaluationExpired: "Evaluación Expirada",
        timeToCompleteHasExpired:
          "El tiempo para completar esta evaluación ha expirado.",
        contactAdministratorIfError:
          "Si crees que esto es un error, contacta al administrador de la evaluación.",
        error: "Error",
        evaluationNotFoundTitle: "Evaluación No Encontrada",
        accessDenied: "Acceso Denegado",
        timeFinishedContactAdmin:
          "El tiempo para completar esta evaluación ha finalizado. Si crees que esto es un error, contacta al administrador.",
        tryAgain: "Intentar Nuevamente",

        competenciesLabel: "{{count}} competencias",
        estimatedTimeLabel: "Tiempo estimado: {{time}}",
        evaluationStructure: "Estructura de la Evaluación",
        evaluationStructureDescription: "La evaluación está organizada por competencias. Cada competencia tiene dos fases: lectura del caso de estudio y respuesta a las preguntas.",
        evaluationStructureDescriptionGrouped: "La evaluación está organizada por casos de estudio. Leerás cada caso una sola vez y luego responderás, una tras otra, las preguntas de las competencias asociadas a ese caso.",
        caseStudyAndCompetencies: "Caso de estudio / Competencias",
        caseStudyGroupHint: "Se lee una vez · {{count}} competencia(s)",
        competency: "Competencia",
        reading: "Lectura",
        totalTime: "Tiempo Total",
        timeWillStartPerPhase: "El tiempo comenzará a correr en cada fase",
        continueToQuestions: "Continuar a las Preguntas",
        continueToNextCompetency: "Continuar a la Siguiente Competencia",
        questionNumber: "Pregunta {{number}}",
        questions: "Preguntas",
        total: "Total",

        timeFormat: {
          minutes: "{{minutes}} minutos",
          hoursAndMinutes: "{{hours}} {{hoursLabel}} y {{minutes}} minutos",
          hoursOnly: "{{hours}} {{hoursLabel}}",
          hour: "hora",
          hours: "horas"
        },
        defaultApplicantName: "Postulante",
        defaultEvaluationTitle: "Evaluación de Competencias",
        helloApplicant: "Hola, {{name}}",
        evaluationInformation: "Información de la Evaluación",
        timeLabel: "Tiempo: {{time}}",
        questionsLabel: "{{count}} pregunta(s)",
        importantInstructions: "Instrucciones Importantes",
        instructions: {
          readCarefully: "Lee cada pregunta cuidadosamente antes de responder",
          readCarefullyDesc:
            "Tómate tu tiempo para entender lo que se te pregunta",
          answerHonestly: "Responde de manera honesta y completa",
          answerHonestlyDesc:
            "No hay respuestas correctas o incorrectas, queremos conocer tu perspectiva",
          timeLimit: "Tienes {{time}} para completar toda la evaluación",
          timeLimitDesc:
            "El tiempo se cuenta desde que presiones 'Comenzar Evaluación'",
          navigateBetween: "Puedes navegar entre preguntas",
          navigateBetweenDesc:
            "Puedes volver a preguntas anteriores para revisar o modificar tus respuestas",
          saveProgress: "Guarda tu progreso regularmente",
          saveProgressDesc:
            "Tus respuestas se guardan automáticamente, pero asegúrate de completar todas las preguntas",

          competencyBased: "Evaluación por competencias",
          competencyBasedDesc: "La evaluación está dividida en competencias específicas que evaluarán diferentes aspectos de tu perfil profesional.",
          readingPhase: "Fase de lectura del caso de estudio",
          readingPhaseDesc: "Primero leerás un caso de estudio o contexto para cada competencia. Tendrás tiempo limitado para esta fase.",
          readingPhaseGroupedDesc: "Primero leerás un caso de estudio, una sola vez, con tiempo limitado. El caso no volverá a mostrarse mientras respondes.",
          questionPhase: "Fase de preguntas",
          questionPhaseDesc: "Después responderás todas las preguntas de esa competencia en una sola página con tiempo limitado.",
          noGoingBack: "Sin posibilidad de retroceso",
          noGoingBackDesc: "Una vez que avances de la lectura a las preguntas, o de una competencia a otra, no podrás volver atrás.",
          noGoingBackGroupedDesc: "Una vez que avances de la lectura a las preguntas, de una competencia a otra o de un caso al siguiente, no podrás volver atrás.",
          timeBackup: "Tiempo máximo absoluto: {{time}}",
          timeBackupDesc: "Si cierras la ventana y vuelves más tarde, este es el tiempo máximo total disponible.",
        },
        importantAboutTime: "⚠️ Importante sobre el tiempo",
        timeWillStart:
          'El tiempo comenzará a contar cuando presiones "Comenzar Evaluación".',
        recommendations: {
          stableConnection:
            "• Asegúrate de tener una conexión estable a internet",
          quietPlace:
            "• Encuentra un lugar tranquilo donde puedas concentrarte",
          paperAndPen:
            "• Ten a mano papel y lápiz por si necesitas tomar notas",
          dontCloseWindow:
            "• No cierres esta ventana del navegador hasta completar la evaluación",
          exactTime:
            "• Una vez iniciada, tendrás exactamente {{time}} para completar todas las preguntas",

          estimatedTime: "Tiempo estimado total: {{time}}",
          maxTime: "Tiempo máximo absoluto: {{time}}",
        },
        whenReady:
          "Cuando estés listo/a, presiona el botón para comenzar tu evaluación.",
        starting: "Iniciando...",
        startEvaluation: "Comenzar Evaluación",
        competency: "Competencia",
        of: "de",
        readInstructions: "Lee cuidadosamente el caso de estudio. Tienes {{minutes}} minutos para esta fase.",
        answered: "respondidas",
        question: "Pregunta",
        writePlaceholder: "Escribe tu respuesta aquí...",
        nextCompetency: "Siguiente Competencia",
        confirmFinish: "¿Estás seguro de que deseas finalizar la evaluación?",
        noReturn: "No podrás volver a acceder después de finalizar.",
        completingEvaluation: "Completando Evaluación",
        processingResponses: "Estamos procesando sus respuestas y generando el informe final.",
        operationTime: "Esta operación puede tomar varios minutos.",
        doNotClose: "Por favor, no cierre esta ventana ni navegue hacia otra página.",
        cancel: "Cancel",
        confirm: "Confirm",
      },
      configuration: {
        title: "Configuración de Documentos Word",
        description:
          "Configure encabezados y pies de página para los documentos Word generados por el sistema. Puede usar texto personalizado o logos, y elegir la posición de cada elemento.",
        header: "Encabezado",
        footer: "Pie de página",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        contentType: "Tipo de contenido",
        logo: "Logo",
        text: "Texto",
        position: "Posición",
        left: "Izquierda",
        center: "Centro",
        right: "Derecha",
        customText: "Texto personalizado",
        dragDropImage: "Arrastra una imagen aquí o haz clic para seleccionar",
        imageFormats: "PNG, JPG, JPEG (máx. 2MB)",
        uploading: "Subiendo",
        save: "Guardar Configuración",
        saving: "Guardando...",
        downloadExample: "Descargar Ejemplo",
        generating: "Generando...",
        tabs: {
          word: "Word",
          hiringRoom: "HiringRoom",
          companyContext: "Empresa / Equipo",
          narratives: "Narrativas",
          customUrl: "URL personalizada",
        },
        customUrl: {
          title: "URL personalizada para candidatos",
          description: "Personaliza el subdominio con el que tus candidatos reciben los links por correo: los tests (DISC, razonamiento, habilidades, ventas) y las solicitudes de documentos usarán {slug}.amandahr.ai en vez de app.amandahr.ai.",
          sharedNote: "Este subdominio es compartido con la web de empleos del ATS: si lo cambias aquí, la URL de la web de empleos también cambia (y viceversa).",
          slugLabel: "Subdominio (slug)",
          slugHint: "Solo minúsculas, números y guiones. Ej: grafton",
          previewLabel: "Así se verán los links que reciba el candidato:",
          noSlugNote: "Sin subdominio configurado, los links siguen usando app.amandahr.ai.",
          changeWarning: "Vas a cambiar el subdominio: la URL actual ({{old}}.amandahr.ai) dejará de mostrar tu web de empleos y los próximos correos usarán el nuevo. Los links ya enviados seguirán funcionando.",
          slugRequiredBoard: "Tu web de empleos está habilitada: el subdominio no puede quedar vacío. Deshabilítala primero en Configuración ATS si quieres quitarlo.",
          slugTaken: "Ese subdominio ya está en uso por otra organización",
          checking: "Verificando disponibilidad...",
          saveSuccess: "URL personalizada guardada",
          saveError: "No se pudo guardar la URL personalizada",
          loadError: "No se pudo cargar la configuración",
          save: "Guardar",
        },
        sections: {
          header: "encabezado",
          footer: "pie de página",
        },
        logoAlt: "Logo de {{section}}",
        exampleFileName: "ejemplo-configuracion-{{timestamp}}.docx",
        validation: {
          textRequired: "El texto es requerido cuando está habilitado",
          logoRequired: "El logo es requerido cuando está habilitado",
        },
        messages: {
          loadingConfig: "Cargando configuración...",
          saveSuccess: "Configuración guardada exitosamente",
          saveError: "No se puede guardar: organización o proyecto no disponibles",
          cannotSave: "No se puede guardar: organización o proyecto no disponibles",
          saveErrorResponse: "Error al guardar configuración",
          saveErrorWithMessage: "Error al guardar configuración: {{message}}",
          saveErrorGeneral: "Error al guardar la configuración",
          downloadSuccess: "Archivo descargado exitosamente",
          downloadError: "Error al descargar ejemplo",
          uploadError: "Error al subir imagen",
          uploadErrorWithMessage: "Error al subir imagen: {{message}}",
          logoSizeError: "La imagen no puede superar los 2MB",
          logoFormatError: "Solo se permiten archivos PNG, JPG y JPEG",
          headerUploadSuccess: "Imagen del encabezado subida exitosamente",
          footerUploadSuccess: "Imagen del pie de página subida exitosamente",
        },
      },
      dashboard: {
        title: "Dashboard de Métricas",
        refresh: "Actualizar",
        loading: "Cargando...",
        selectProject: "Selecciona un proyecto para ver las métricas",
        loadError: "Error al cargar las métricas del dashboard",
        metrics: {
          totalUsers: "Usuarios Registrados",
          totalReports: "Evaluaciones Realizadas",
          totalApplicants: "Candidatos Registrados",
          totalPositions: "Cargos Registrados",
          totalEvaluations: "Assessments",
          totalComparisons: "Comparaciones Hechas"
        },
        tables: {
          topUsersTitle: "Usuarios que han hecho más evaluaciones",
          topPositionsTitle: "Cargos con Más Evaluaciones",
          position: "Cargo",
          name: "Nombre",
          email: "Email",
          reportsCount: "Cantidad de Evaluaciones",
          positionName: "Nombre del Cargo",
          industry: "Industria",
          noUsersData: "No hay datos de usuarios con evaluaciones",
          noPositionsData: "No hay evaluaciones con cargos asignados",
          unknownUser: "Usuario sin nombre",
          noEmail: "Sin email",
          unknownPosition: "Cargo desconocido",
          noIndustry: "No especificada"
        },
        "filters": {
          "title": "Filtros de fecha (evaluaciones y comparaciones)",
          "startDate": "Fecha inicio",
          "endDate": "Fecha fin",
          "applyFilters": "Aplicar filtros",
          "lastSevenDays": "Últimos 7 días",
          "showingDataFrom": "Mostrando datos desde {{startDate}} hasta {{endDate}}",
          "dateRange": "({{startDate}} - {{endDate}})"
        }
      },
      home: {
        welcome: "¡Bienvenido de vuelta, {{name}}!",
        subtitle: "Gestiona tus procesos de selección y toma decisiones basadas en datos",
        essentialConfig: "Configuración Esencial",
        prerequisite: "Prerequisito",
        noPositionsAlert: "No hay cargos creados. Los cargos son necesarios para utilizar los servicios de Evaluación Psicolaboral, Assessment Center y Comparación de Candidatos.",
        positionManagement: "Gestión de cargos",
        managePositionDesc: "Administra los perfiles de cargo para tus evaluaciones psicolaborales, evaluaciones y assessments",
        createPositionDesc: "Configura los perfiles de cargo necesarios para crear evaluaciones psicolaborales, evaluaciones y assessments",
        currentPositions: "Cargos actuales",
        managePositions: "Gestionar Cargos",
        adminOnlyPositions: "Solo los usuarios administradores pueden crear y gestionar cargos",
        requiredForServices: "Requerido para todos los servicios",
        candidateManagement: "Gestión de candidatos",
        manageCandidateDesc: "Administra los candidatos registrados para tus assessments",
        createCandidateDesc: "Registra candidatos para assessments. Se crean automáticamente en evaluaciones psicolaborales",
        currentApplicants: "Candidatos",
        manageCandidates: "Gestionar Candidatos",
        requiredForAssessments: "Requerido para assessments",
        availableCapabilities: "Competencias disponibles",
        viewCapabilityDesc: "Revisa las competencias predefinidas disponibles para tus assessments",
        currentCapabilities: "Competencias",
        viewCapabilities: "Ver Competencias",
        mainServices: "Servicios Principales",
        integratedReport: "Evaluación Psicolaboral",
        integratedReportDesc: "Evalúa un candidato específico paso a paso con tests psicológicos",
        prerequisites: "Prerequisitos",
        positionsCreated: "Cargos creados",
        candidateAutoCreated: "El candidato se crea automáticamente si no existe",
        createReport: "Crear Evaluación",
        assessmentCenter: "Assessment Center",
        assessmentCenterDesc: "Evalúa las competencias específicas de un candidato y analiza su compatibilidad con los requisitos del cargo. Integra información del reporte psicológico cuando esté disponible",
        applicantsRegistered: "Postulantes registrados",
        capabilitiesDefined: "Competencias definidas",
        createAssessment: "Crear Assessment",
        reportComparisonCandidates: "Comparación de Evaluaciones / Candidatos",
        reportComparisonDesc: "Realiza comparaciones entre candidatos para identificar cuál presenta mayor afinidad con el perfil de un cargo específico, basándose en sus evaluaciones psicolaborales",
        twoOrMoreReports: "2 o más evaluaciones psicolaborales",
        compareReports: "Comparar Evaluaciones",
        configAndManagement: "Configuración y Gestión",
        configuration: "Configuración",
        configurationDesc: "Configura encabezados y pie de páginas para los documentos Word de descarga",
        goToConfiguration: "Ir a Configuración",
        dashboard: "Dashboard",
        dashboardDesc: "Visualiza métricas generales, usuarios más activos, cargos con más evaluaciones y estadísticas del proyecto",
        goToDashboard: "Ver Dashboard",
        retrying: "Reintentando...",
        retry: "Reintentar",
        trialBanner: {
          title: "Estás usando tu cuenta de prueba — 5 puntos disponibles",
          description: "Tienes acceso a Test de Razonamiento, Test DISC, Evaluación Psicolaboral y Filtrado de CV. Los puntos no se recargan una vez agotados.",
          upgrade: "¿Te interesa continuar con un plan completo? Contáctanos a",
        },
      },
      subscription: {
        title: "Suscripción",
        currentPlan: "Plan Actual",
        availablePlans: "Planes Disponibles",
        features: "Características incluidas",
        price: "Precio",
        monthly: "mensual",
        yearly: "anual",
        free: "Gratis",
        upgrade: "Actualizar",
        downgrade: "Cambiar a Gratis",
        currentPlanBadge: "Plan Actual",
        recommended: "Recomendado",
        comingSoon: "Próximamente",
        subscriptionNote: "La lógica de suscripción y pagos se implementará en una próxima versión. Por ahora puedes ver los planes disponibles.",
        planChangeWarning: "Al cambiar de plan, los cambios se aplicarán inmediatamente y afectarán los límites de uso de tu organización.",
        unlimited: "Ilimitado",
        perMonth: "por mes",
        organization: "Organización",
        currentSubscription: "Suscripción Actual",
        billingCycle: "Ciclo de Facturación",
        nextBilling: "Próxima Facturación",
        planFeatures: "Características del Plan",
        upgradePlan: "Actualiza tu plan para acceder a más funcionalidades",
        manageBilling: "Gestionar Facturación",

        // Nuevas claves agregadas
        freePlan: {
          title: "Plan Gratuito",
          current: "Actual",
          description: "Actualmente estás usando el plan gratuito. Actualiza para acceder a más funcionalidades."
        },
        availablePlansDescription: "Elige el plan que mejor se adapte a tus necesidades.",
        availablePlansSuspendedDescription: "Tu suscripción está suspendida. Reactiva tu plan actual o espera a que expire para cambiar.",

        paymentHistory: {
          title: "Historial de Pagos",
          description: "Los cambios de suscripción pueden tardar unos minutos en reflejarse completamente. Si acabas de realizar un pago, usa el botón \"Actualizar\" para verificar el estado.",
          headers: {
            date: "Fecha",
            concept: "Concepto",
            amount: "Monto",
            status: "Estado",
            method: "Método"
          },
          planConcept: "Plan {{plan}}",
          payment: "Pago",
          expected: "Esperado"
        },
        billingCycleMonthly: "Mensual",
        billingCycleYearly: "Anual",
        savingsUpTo8: "Ahorra hasta 10%",
        equivalencePerMonth: "(Equivale a ${{amount}} por mes)",

        plans: {
          starter: {
            name: "Starter",
            description: "Perfecto para probar el producto"
          },
          crece: {
            name: "Crece",
            description: "Para equipos pequeños que empiezan a crecer"
          },
          avanza: {
            name: "Avanza",
            description: "Para equipos que necesitan más funcionalidades"
          },
          escala: {
            name: "Escala",
            description: "Para equipos grandes con necesidades avanzadas"
          },
          empresa: {
            name: "Empresa",
            description: "Para empresas con necesidades ilimitadas"
          },
          features: {
            evaluations: {
              singular: "{{count}} Evaluación psicolaboral por mes",
              plural: "{{count}} Evaluaciones psicolaborales por mes",
              yearly: "{{count}} Evaluaciones psicolaborales por año",
              unlimited: "Evaluaciones ilimitadas"
            },
            users: {
              singular: "{{count}} Usuario",
              plural: "{{count}} Usuarios",
              unlimited: "Usuarios ilimitados"
            },
            projects: {
              singular: "{{count}} Proyecto",
              plural: "{{count}} Proyectos",
              unlimited: "Proyectos ilimitados"
            },
            assessments: {
              singular: "{{count}} Assessment",
              plural: "{{count}} Assessments",
              yearly: "{{count}} Assessments por año",
              unlimited: "Assessments ilimitados"
            },
            comparisons: {
              singular: "{{count}} Comparación",
              plural: "{{count}} Comparaciones",
              yearly: "{{count}} Comparaciones por año",
              unlimited: "Comparaciones ilimitadas"
            }
          }
        },
        fields: {
          startDate: "Fecha de inicio",
          nextBilling: "Próximo cobro",
          limitsReset: "Reinicio de límites",
          currentPeriodEnd: "Fin del período actual",
          notApplicable: "No aplica"
        },
        status: {
          active: "Activa",
          suspended: "Suspendida",
          expired: "Expirada",
          pending: "Pendiente",
          completed: "Completado",
          failed: "Fallido",
          cancelled: "Cancelado"
        },
        actions: {
          update: "Actualizar",
          updating: "Actualizando...",
          processing: "Procesando...",
          select: "Seleccionar",
          confirmUpgrade: "Confirmar Upgrade",
          downgradeNotAvailable: "Downgrade no disponible",
          notAvailable: "No disponible",
          cancel: "Cancelar",
          suspendButton: "Suspender Suscripción",
          suspendReason: "Usuario solicitó suspensión",
          reactivateButton: "Reactivar Suscripción",
          reactivateReason: "Usuario reactivó suscripción"
        },
        alerts: {
          suspended: "Tu suscripción está suspendida pero mantienes acceso hasta el fin del período actual ({{endDate}}). Puedes reactivarla en cualquier momento.",
          recentPayment: "Detectamos un pago reciente para el plan {{plan}}. Los datos de tu suscripción se actualizarán automáticamente en unos minutos."
        },
        messages: {
          paymentProcessed: "Pago completado exitosamente. Actualizando datos...",
          paymentCancelled: "Pago cancelado",
          popupClosed: "Popup cerrado. Verificando estado del pago...",
          suspended: "Suscripción suspendida, puede que el cambio tome un momento en verse reflejado",
          reactivated: "Suscripción reactivada exitosamente, puede que el cambio tome un momento en verse reflejado"
        },
        errors: {
          loadingData: "Error al cargar datos de suscripción",
          createSubscription: "Error al crear suscripción",
          processSubscription: "Error al procesar la suscripción",
          upgrade: "Error al procesar el upgrade",
          suspend: "Error al suspender suscripción",
          processSuspension: "Error al procesar la suspensión",
          reactivate: "Error al reactivar suscripción",
          processReactivation: "Error al procesar la reactivación"
        },
        tooltips: {
          downgrade: "Para hacer downgrade, primero suspende tu plan actual y espera a que expire"
        },
        modals: {
          confirmTitle: "Confirmar Acción",
          suspendTitle: "Suspender Suscripción",
          suspendDescription: "Al suspender tu suscripción",
          suspendPointAccess: "Mantienes acceso hasta {{endDate}}",
          suspendPointNoBilling: "No se realizarán más cobros automáticos",
          suspendPointReactivate: "Puedes reactivar en cualquier momento antes del {{endDate}}",
          suspendPointCancellation: "Después de esa fecha, se cancelará definitivamente",
          suspendConfirmation: "¿Estás seguro de que quieres suspender tu suscripción?",
          upgradeTitle: "Confirmar Upgrade de Plan",
          upgradeDescription: "Estás upgradeando de {{currentPlan}} a {{targetPlan}}",
          upgradeConfirm: "Al confirmar este upgrade",
          upgradePointCancel: "Se cancelará tu suscripción actual inmediatamente",
          upgradePointCharge: "Se cobrará ${{amount}} USD completos por el nuevo plan",
          upgradePointLimitsReset: "Tus límites de uso se reiniciarán al nuevo plan",
          upgradePointBillingDate: "La fecha de facturación comenzará desde hoy",
          upgradeWarning: "Importante: No recuperarás el tiempo restante de tu plan actual."
        },
        enterprise: {
          title: "¿Necesitas un plan empresarial?",
          description: "Para organizaciones con necesidades específicas o volúmenes altos",
          contactButton: "Contactar: dgalaz@grafton.cl"
        },
        terms: {
          title: "Términos y Condiciones",
          description: "Antes de proceder con la suscripción, debes aceptar nuestros términos y condiciones.",
          planSelected: "Plan seleccionado",
          billingCycle: "Ciclo de facturación",
          agreement: "He leído y acepto los",
          termsAndConditions: "términos y condiciones",
          continue: "Continuar",
          mustAccept: "Debes aceptar los términos y condiciones para continuar"
        },

        contactEmail: "Contactar a",
        customPricing: "Precio Personalizado",
        user: "usuario",
        users: "usuarios",
        project: "proyecto",
        projects: "proyectos",
        points: "puntos"
      },
      login: {
        title: "Iniciar Sesión",
        subtitle: "Accede a tu cuenta para gestionar evaluaciones y proyectos",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          signIn: "Iniciar Sesión",
          signingIn: "Iniciando Sesión..."
        },
        register: {
          question: "¿No tienes una cuenta?",
          button: "Crear Cuenta",
          subtitle: "Regístrate para comenzar a usar AmandaHR"
        },
        passwordReset: {
          link: "¿Olvidaste tu contraseña?",
          title: "Recuperar Contraseña",
          subtitle: "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
          form: {
            email: "Correo Electrónico",
            sendButton: "Enviar Enlace",
            sending: "Enviando...",
            backToLogin: "Volver al Inicio de Sesión"
          },
          success: "Si el correo está registrado, recibirás un enlace para restablecer tu contraseña. Revisa tu bandeja de entrada (y el spam).",
          error: {
            userNotFound: "No se encontró una cuenta con este correo electrónico.",
            invalidEmail: "El formato del correo electrónico no es válido.",
            generic: "Error al enviar el correo de recuperación. Intenta nuevamente."
          }
        },
        sessionExpired: "Tu sesión expiró. Por favor, vuelve a iniciar sesión.",
        loading: "Iniciando sesión...",
        error: {
          generic: "Error al iniciar sesión. Verifica tus credenciales e intenta nuevamente."
        }
      },
      resetPassword: {
        title: "Crear nueva contraseña",
        subtitle: "Define la nueva contraseña de tu cuenta",
        newPassword: "Nueva contraseña",
        confirmPassword: "Confirmar contraseña",
        policy: "Mínimo 6 caracteres y al menos un número",
        mismatch: "Las contraseñas no coinciden",
        submit: "Guardar contraseña",
        submitting: "Guardando...",
        success: "Tu contraseña fue actualizada correctamente. Ya puedes iniciar sesión.",
        goLogin: "Ir a iniciar sesión",
        invalid: "El enlace no es válido. Solicita uno nuevo desde la pantalla de inicio de sesión.",
        expired: "El enlace expiró (dura 60 minutos). Solicita uno nuevo desde la pantalla de inicio de sesión.",
        used: "Este enlace ya fue utilizado. Si necesitas cambiar tu contraseña otra vez, solicita un nuevo enlace.",
        requestNew: "Ir a solicitar un nuevo enlace",
        error: "Error al actualizar la contraseña. Intenta nuevamente."
      },
      register: {
        header: {
          title: "Únete a Amanda HR",
          subtitle: "Revoluciona tu proceso de selección con IA"
        },
        form: {
          title: "Crea tu cuenta gratuita",
          fields: {
            name: "Nombre completo",
            email: "Email",
            password: "Contraseña",
            passwordHelper: "Mínimo 6 caracteres",
            confirmPassword: "Confirmar contraseña"
          },
          buttons: {
            hasAccount: "¿Ya tienes cuenta? Inicia sesión",
            creating: "Creando cuenta...",
            createAccount: "Crear cuenta gratuita"
          }
        },
        freeAccount: {
          title: "¿Qué incluye tu cuenta gratuita?",
          features: {
            evaluations: "1 Evaluación psicológica por mes",
            userProject: "1 Usuario y 1 Proyecto",
            basicAccess: "Acceso completo a las funcionalidades básicas",
            upgrade: "Podrás actualizar tu plan en cualquier momento"
          }
        },
        validation: {
          nameRequired: "El nombre es requerido",
          emailRequired: "El email es requerido",
          passwordRequired: "La contraseña es requerida",
          passwordMismatch: "Las contraseñas no coinciden",
          passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
          privacyRequired: "Debes aceptar la política de privacidad para continuar"
        },
        success: {
          message: "Registro exitoso. Inicia sesión con tus credenciales."
        },
        error: {
          generic: "Error al registrar usuario"
        },
        loading: {
          message: "Creando tu cuenta..."
        },
        privacy: {
          agreement: "He leído y acepto la",
          privacyPolicy: "política de privacidad"
        },
      },
      disc: {
        sendEmailOnCreate: "Enviar email al postulante",
        sendEmailOnCreateEnabled: "Se enviará el link del test por email automáticamente al crear",
        sendEmailOnCreateDisabled: "El test se creará sin enviar email, puedes enviarlo luego desde el dashboard",
        testCreatedSuccess: "Test creado exitosamente. Puedes enviar el email desde el dashboard.",
        createTest: "Crear test",
        individualTests: "Tests Individuales",
        testsCompared: "Tests Comparados",
        tests: "tests",
        viewReport: "Ver Reporte",
        deleteComparison: "Eliminar Comparación",
        deleteComparisonTitle: "Eliminar Comparación",
        deleteComparisonConfirm: "¿Estás seguro de que deseas eliminar esta comparación?",
        type: "Tipo",
        statusProcessing: "Procesando",
        statusEvaluated: "Evaluado",
        statusProcessing_error: "Error al Procesar",
        processTest: "Procesar",
        processing: "Procesando...",
        retryProcess: "Reintentar",
        copyTestUrl: "Copiar URL del Test",
        urlCopied: "URL copiada al portapapeles",
        urlCopyError: "Error al copiar URL",
        processTestSuccess: "Test encolado para procesamiento",
        processTestError: "Error al procesar el test",
        errorDetails: "Detalles del error",
        title: "Gestión de Test DISC",
        subTitle: "Configura y administra los test DISC para evaluar perfiles de comportamiento de tus postulantes.",
        configuration: "Crear",
        dashboard: "Dashboard",
        comparisons: "Comparaciones",
        reanalyze: "Reanálisis",
        configurationTitle: "Crear Nuevo Test DISC",
        configurationSubTitle: "Configura los parámetros del test DISC para tus postulantes",
        testMode: "Modalidad del Test",
        simpleMode: "Modo Simple",
        simpleModeDescription: "El postulante solo responde el test DISC",
        completeMode: "Modo Completo",
        completeModeDescription: "Test DISC con contexto adicional del cargo y competencias",
        selectApplicant: "Seleccionar Postulante",
        selectPosition: "Seleccionar Cargo",
        optional: "(Opcional)",
        currentPosition: "Puesto Actual del Postulante",
        currentPositionPlaceholder: "Ej: Analista de Marketing",
        selectCompetencies: "Seleccionar Competencias a Medir",
        competenciesDescription: "Selecciona las competencias que quieres evaluar en base a las respuestas del test",
        sendTest: "Enviar Test",
        cancel: "Cancelar",
        testSentSuccess: "Test DISC enviado exitosamente",
        testSentError: "Error al enviar el test DISC",
        pleaseSelectApplicant: "Por favor selecciona un postulante",
        dashboardTitle: "Estado de Tests DISC",
        dashboardSubTitle: "Visualiza el progreso y resultados de los tests enviados",
        applicantName: "Postulante",
        position: "Cargo",
        status: "Estado",
        sentDate: "Fecha de Envío",
        completedDate: "Fecha de Completado",
        actions: "Acciones",
        viewResult: "Ver Resultado",
        resendTest: "Reenviar Test",
        statusPending: "Pendiente",
        statusCompleted: "Completado",
        statusProcessing: "Procesando",
        statusSent: "Enviado",
        noTestsFound: "No se encontraron tests DISC",
        noTestsMessage: "Crea tu primer test DISC desde la pestaña de Configuración",
        loadError: "Error al cargar los tests DISC",
        notAvailable: "No disponible",

        // Textos públicos
        emailVerification: "Verificación de Email",
        enterEmailToAccess: "Ingresa tu email para acceder al test DISC",
        enterEmail: "Ingresa tu email",
        accessTest: "Acceder al Test",
        invalidEmail: "Email inválido",
        pleaseEnterEmail: "Por favor ingresa tu email",
        testNotFound: "Test no encontrado",
        testExpired: "Test Expirado",
        testExpiredMessage: "Este test ha expirado. Por favor contacta al administrador.",
        // Cierre automatico al agotarse el cronometro: las respuestas que
        // alcanzo a dar ya se enviaron, el test no queda como "iniciado".
        timeUpTitle: "Se acabó el tiempo",
        timeUpMessage: "El tiempo disponible para responder el test terminó. Enviamos automáticamente las respuestas que alcanzaste a marcar, así que no necesitas hacer nada más. Si crees que hubo un problema, contacta a la persona que te envió el test.",
        timeUpSubmitFailedMessage: "El tiempo disponible para responder el test terminó, pero no pudimos registrar tus respuestas. Por favor contacta a la persona que te envió el test.",
        accessDenied: "Acceso denegado. El email no coincide con el test.",
        errorTitle: "Error",
        genericError: "Ocurrió un error. Por favor intenta nuevamente.",
        errorStartingTest: "Error al iniciar el test",

        // Instrucciones
        extendedDiscModel: "Insight DISC by Amanda",
        modelDescription: "La evolución inteligente del modelo DISC",
        modelHistory: "Este test no busca medir tu valor ni calificarte. Su objetivo es comprender tu manera natural de pensar, comunicarte y trabajar. Responde de forma espontánea: no hay respuestas buenas o malas. Cada perfil es único y valioso, y conocerlo nos permite identificar los entornos donde puedes desplegar mejor tu talento.",

        // Estilos DISC
        dominance: "Dominancia",
        dominanceDescription: "Personas directas, decididas, orientadas a resultados, competitivas",
        influence: "Influencia",
        influenceDescription: "Personas sociables, optimistas, comunicativas, entusiastas",
        steadiness: "Estabilidad",
        steadinessDescription: "Personas pacientes, leales, colaborativas, confiables",
        conscientiousness: "Conciencia",
        conscientiousnessDescription: "Personas analíticas, precisas, sistemáticas, detallistas",

        // Instrucciones del test
        instructionText: "Selecciona una opción de cada columna para cada característica",
        testInstructions: "Instrucciones del Test",
        instruction1: "El test consta de 24 preguntas con 4 opciones cada una",
        instruction2: "Para cada pregunta, selecciona la opción que MÁS te describe (M)",
        instruction3: "También selecciona la opción que MENOS te describe (L)",
        instruction4: "Responde de forma instintiva y honesta, no hay respuestas correctas o incorrectas",
        instruction5: "El test toma aproximadamente 20 minutos en completarse",

        starting: "Iniciando...",
        startTest: "Comenzar Test",

        // Navegación del test
        page: "Página",
        of: "de",
        completed: "completado",
        selectOptions: "Selecciona tus opciones",
        mostDescribesMe: "MÁS me describe",
        leastDescribesMe: "MENOS me describe",
        previous: "Anterior",
        next: "Siguiente",
        completeTest: "Completar Test",
        completing: "Completando...",

        // Validaciones
        cannotSelectSameOption: "No puedes seleccionar la misma opción en ambas columnas",
        mustSelectBothOptions: "Debes seleccionar una opción en cada columna (MÁS y MENOS)",
        errorCompletingTest: "Error al completar el test. Por favor intenta nuevamente.",

        // Completado
        testCompletedTitle: "¡Test Completado!",
        testCompletedMessage: "Has completado exitosamente el test DISC. Los resultados serán enviados al evaluador.",
        thankYou: "Gracias por tu tiempo",

        refresh: "Actualizar",
        reportTitle: "Reporte DISC",
        discResults: "Resultados DISC",
        insufficientResponses: "No hay respuestas suficientes para calcular.",
        downloadPdf: "Descargar PDF",
        statusStarted: "Iniciado",
        statusExpired: "Expirado",
        // Test cerrado con menos de las 24 paginas: el perfil sale de un set
        // parcial, asi que no se puede procesar ni comparar.
        statusInvalid: "Inválido",
        answeredPagesLabel: "{{answered}} de {{total}} respondidas",

        reliabilityAnalysis: "Análisis de Confiabilidad",
        completed: "Completado",
        state: "Estado",
        primaryStyle: "Estilo Primario",

        // Estados de validez (para getValidityChipConfig)
        highReliability: "Alta confiabilidad",
        acceptableReliability: "Confiabilidad aceptable",
        questionableReliability: "Confiabilidad cuestionable",
        lowReliability: "Baja confiabilidad",
        compromisedValidity: "Validez comprometida",

        // Estilos DISC
        dominance: "Dominancia",
        influence: "Influencia",
        steadiness: "Estabilidad",
        conscientiousness: "Cumplimiento",

        naturalProfile: "Perfil Natural",
        adaptedProfile: "Perfil Adaptado",
        flexibilityZone: "Zona de Flexibilidad",
        characteristics: "Características",
        strengths: "Fortalezas",
        motivators: "Motivadores",
        demotivators: "Desmotivadores",
        developmentAreas: "Áreas de Desarrollo",
        thingsThatTryToAvoid: "Cosas que Trata de Evitar",
        noContent: "Sin contenido.",
        overuseUnderuseAnalysis: "Análisis de Sobreuso y Subuso",
        detailedAnalysis: "Análisis Detallado:",
        teamRole: "Rol en el Equipo",
        practicalExamples: "Ejemplos Prácticos:",
        emotionalInterpretationTitle: "Interpretación Emocional y Proporcionalidad del Perfil",
        generalEmotionalAnalysis: "Análisis Emocional General",
        dominantTraits: "Rasgos Dominantes",
        dominantTraitsDescription: "Estos rasgos definen el estilo conductual principal y son los más visibles en el día a día.",
        nonDominantTraits: "Rasgos No Dominantes",
        nonDominantTraitsDescription: "Presentes pero con menor énfasis natural; pueden desarrollarse según necesidades del rol.",
        adaptationAnalysis: "Análisis de Adaptación (Natural vs Adaptado)",
        adaptationPatternDescription: "La persona muestra un patrón mixto de adaptación, intensificando algunos rasgos mientras suprime otros. Esto sugiere un ajuste consciente al entorno laboral.",
        natural: "Natural:",
        adapted: "Adaptado:",
        noInformation: "Sin información",
        overuseUnderuseConsiderations: "Consideraciones sobre Sobreuso y Subuso de Rasgos",
        overuseRisk: "Riesgo de Sobreuso:",
        overuseRiskDescription: "puede volverse contraproducente si se intensifica en exceso.",
        underuseRisk: "Riesgo de Subuso:",
        underuseRiskDescription: "podría expresarse por debajo de lo que el entorno requiere.",
        balancedUse: "Uso Balanceado:",
        balancedUseDescription: "expresión en nivel adecuado.",
        practicalExample: "Ejemplo práctico:",
        developmentPlan90Days: "Plan de Desarrollo 90 Días",
        howToLeverageThem: "Cómo Aprovecharlas:",
        concreteTip: "TIP CONCRETO:",
        whyItMatters: "¿Por qué importa?",
        dominant: "Dominante",
        deleteTest: "Eliminar Test",
        deleteTestTitle: "Confirmar Eliminación",
        deleteTestConfirm: "¿Estás seguro que deseas eliminar el test DISC de",
        testDeletedSuccess: "Test DISC eliminado exitosamente",
        testDeletedError: "Error al eliminar el test DISC",
        testResentSuccess: "Test reenviado exitosamente",
        testResentError: "Error al reenviar el test",
        refresh: "Actualizar",
        evaluatedTestsNotice: "Solo se mostrarán tests DISC que hayan completado su proceso de evaluación. Se considerará el test más reciente de cada candidato.",
        reanalyzeTitle: "Reanalizar Test DISC",
        reanalyzeDescription: "Selecciona un test completado y especifica nuevos parámetros (cargo y/o competencias) para generar un nuevo análisis",
        reanalyzeNote: "Nota:",
        reanalyzeNoteText: "El reanálisis creará un nuevo test con los mismos resultados DISC pero con el contexto (cargo y/o competencias) que especifiques. El test original no se modificará.",
        selectApplicantPlaceholder: "Selecciona un postulante",
        reanalyzeWarning: "Importante:",
        reanalyzeWarningText: "Si solo envías el cargo, se eliminarán las competencias. Si solo envías competencias, se eliminará el cargo.",
        reanalyzeValidation: "Debes proporcionar al menos un cargo o competencias para reanalizar",
        reanalyzeSuccess: "Test reenviado a reanálisis exitosamente. Nuevo test ID: {{testId}}",
        reanalyzing: "Reanalizando...",
        reanalyzeButton: "Reanalizar Test DISC",
        selectApplicantToStart: "Selecciona un postulante para comenzar el reanálisis",
        noCompletedTestsForReanalysis: "No hay tests DISC evaluados disponibles para reanalizar",
        discComparisons: {
          title: "Comparaciones de Test DISC",
          subTitle: "Analiza y compara perfiles DISC para identificar compatibilidades y fortalezas del equipo",

          // Tipos de análisis
          analysisType: "Tipo de Análisis",
          selectAnalysisType: "Selecciona el tipo de análisis que deseas realizar",

          // Opción 1: Comparar Candidatos
          compareCandidates: "Comparar Candidatos",
          compareCandidatesTitle: "Comparar Candidatos",
          compareCandidatesDescription: "Rankear candidatos para un cargo. Compara múltiples candidatos y obtén un ranking basado en el ajuste al cargo. Analiza qué aporta cada candidato al equipo.",

          // Opción 2: Candidato vs Jefe
          candidateVsBoss: "Candidato vs Jefe",
          candidateVsBossTitle: "Candidato vs Jefe",
          candidateVsBossDescription: "Analiza la complementariedad entre candidatos y su futuro jefe. Identifica sinergias y posibles conflictos.",

          // Opción 3: Análisis de Equipos
          teamAnalysis: "Análisis de Equipos",
          teamAnalysisTitle: "Análisis de Equipos Establecidos",
          teamAnalysisDescription: "Analiza equipos establecidos para identificar fortalezas, gaps y estrategias para maximizar su rendimiento.",

          // Configuración general
          results: "Resultados",
          selectPosition: "Seleccionar Cargo",
          selectPositionDescription: "Selecciona el cargo objetivo para el análisis",
          positionRequired: "El cargo es obligatorio para este análisis",
          noPositionsFound: "No se encontraron cargos",

          // Contexto de equipo (para Análisis de Equipos)
          teamContext: "Contexto del Equipo",
          teamContextDescription: "Información sobre el equipo (opcional)",
          teamName: "Nombre del Equipo",
          teamNamePlaceholder: "Ej: Equipo de Operaciones - Laboratorio Dental",
          teamDescription: "Descripción",
          teamDescriptionPlaceholder: "Equipo responsable de la gestión diaria de operaciones del laboratorio, incluyendo coordinación de producción, control de calidad y atención a clientes.",
          teamObjectives: "Objetivos",
          teamObjectivesPlaceholder: "Optimizar tiempos de producción, mantener estándares de calidad, mejorar comunicación con clientes y técnicos.",

          // Selección de personas
          teamMembers: "Miembros del Equipo",
          selectMembers: "Selecciona los miembros del equipo",
          candidates: "Candidatos",
          selectCandidates: "Selecciona los candidatos a comparar",
          boss: "Jefe/Referencia",
          selectBoss: "Marca quién es el jefe o referencia",

          // Tests DISC
          discTestsAvailable: "Tests DISC Disponibles",
          noDiscTestsFound: "No se encontraron tests DISC completados",
          loadingTests: "Cargando tests DISC...",
          testsLoadError: "Error al cargar los tests DISC",
          selectedTests: "Tests seleccionados",
          selectMinimum: "Selecciona al menos {{count}} tests DISC",

          // Información de tests
          testCompleted: "Test completado",
          testDate: "Fecha del test",
          discProfile: "Perfil DISC",
          naturalProfile: "Perfil Natural",
          adaptedProfile: "Perfil Adaptado",

          // Búsqueda y filtros
          searchApplicant: "Buscar por nombre...",
          filterByPosition: "Filtrar por cargo",
          showOnlySelectedPosition: "Solo tests del cargo seleccionado",
          showingResults: "Mostrando",
          of: "de",
          results: "resultados",

          // Requisitos para iniciar
          requirements: {
            title: "Para iniciar el análisis necesitas",
            selectAnalysisType: "Seleccionar un tipo de análisis",
            selectPosition: "Seleccionar un cargo (para opciones 1 y 2)",
            fillTeamContext: "Completar contexto del equipo (para opción 3)",
            selectMinTests: "Seleccionar al menos 2 tests DISC",
            selectBoss: "Marcar quién es el jefe (para opción 2)",
          },

          // Acciones
          startAnalysis: "Iniciar Análisis",
          starting: "Iniciando...",
          analyzing: "Analizando perfiles DISC...",
          processingAnalysis: "Procesamiento en curso",
          processingText: "El análisis de perfiles DISC está en progreso. Esto puede tomar unos momentos.",

          // Resultados
          analysisResults: "Resultados del Análisis",
          candidateRanking: "Ranking de Candidatos",
          compatibilityAnalysis: "Análisis de Compatibilidad",
          teamStrengths: "Fortalezas del Equipo",
          teamGaps: "Gaps Identificados",
          recommendations: "Recomendaciones",
          discProfileComparison: "Comparación de Perfiles DISC",

          // Errores
          analysisError: "Error en el análisis",
          analysisCreateError: "Error al crear el análisis",
          analysisStarted: "Análisis iniciado exitosamente",

          // Estados
          statusPending: "Pendiente",
          statusProcessing: "Procesando",
          statusCompleted: "Completado",
          statusProcessing: "Procesando",
          statusError: "Error",

          // Acciones de resultado
          newAnalysis: "Nuevo Análisis",
          downloadResults: "Descargar Resultados",
          viewDetails: "Ver Detalles",

          // Límites de uso
          usageLimitReached: "Límite de Análisis DISC Alcanzado",
          usageLimitMessage: "Ha alcanzado el límite máximo de análisis DISC para su organización. Para continuar utilizando este servicio, póngase en contacto con su administrador para revisar su plan actual o aumentar los límites de uso.",
          currentUsage: "Uso actual",
          analyses: "análisis",
          remainingAnalyses: "Análisis restantes",
          unlimited: "ilimitado",
          checkingUsageLimits: "Verificando límites de uso...",
          teamContextRequired: "El contexto del equipo es obligatorio",
          bossLabel: "Jefe",
          markAsBoss: "Marcar como Jefe",
          noPosition: "Sin cargo",
          teamNameRequired: "El nombre del equipo es requerido",
          teamDescriptionRequired: "La descripción es requerida",
          teamObjectivesRequired: "Los objetivos son requeridos",

          processing: "Procesando Análisis DISC",
          processingDescription: "Estamos analizando los perfiles DISC con inteligencia artificial. Esto puede tomar algunos minutos.",
          lastUpdate: "Última actualización",
          processingError: "Error al procesar el análisis",
          unknownError: "Error desconocido al procesar la comparación",
          retryStarted: "Reintento iniciado exitosamente",
          retryError: "Error al reintentar el análisis",

          naturalProfile: "Perfil DISC Natural",
          candidatesRanking: "Ranking de Candidatos",
          analysisBasedOnCompetencies: "Análisis generado por IA basado en competencias y descriptor del cargo",

          fitAnalysis: "Análisis de Fit",
          teamContribution: "Aporte al Equipo",

          bossDataNotFound: "No se encontraron los datos del jefe/supervisor",
          noResultsAvailable: "No hay resultados disponibles",

          complementarityAnalysis: "Complementariedad en Contexto",
          workDynamics: "Dinámicas de Trabajo",
          synergiesAndTensions: "Sinergias y Tensiones",

          composition: "Composición del Equipo",
          collectiveStrengths: "Fortalezas Colectivas",
          gaps: "Gaps y Áreas de Oportunidad",
          currentDynamics: "Dinámicas Actuales",
          roleRecommendations: "Recomendaciones de Roles",
          managementStrategies: "Estrategias de Gestión",
          actionPlan: "Plan de Acción",
          actionPlan306090: "Plan de Acción 30 / 60 / 90 Días",
          days30: "30 Días",
          days60: "60 Días",
          days90: "90 Días",
          inSummary: "En síntesis",
          teamAnalysisTitle: "Análisis de Equipo",

          unknownAnalysisType: "Tipo de análisis desconocido",
          competenciesTitle: "Competencias",
          competenciesOptional: "(Opcional)",
          competenciesDescription: "Selecciona competencias específicas para enfocar el análisis DISC",
          selectCompetencies: "Seleccionar Competencias",
          searchCompetencies: "Buscar competencias...",
          noCompetenciesFound: "No se encontraron competencias",
          competenciesSelected: "competencia(s) seleccionada(s)",
          competenciesLabel: "Competencias:",
          summary: "Resumen",
          positionInfo: "Información del Cargo",
          positionDescription: "Descripción",
          evaluatedCompetencies: "Competencias evaluadas",
          downloadPDF: "Descargar PDF",
          teamContext: "Contexto del Equipo",
          teamDescription: "Descripción",
          teamObjectives: "Objetivos",
          configuration: "Configuración",
          teamDiscMap: "Mapa DISC del Equipo",
          teamMembersLegend: "Miembros del Equipo:",
          natural: "Natural",
          adapted: "Adaptado",
          teamMapLegendHint: "El punto marca el estilo natural y la flecha apunta al estilo adaptado (círculo con el número).",
          reprocessTitle: "Reprocesar análisis",
          reprocessConfirm: "Se volverá a generar el análisis con IA y se reemplazarán el resultado y el PDF actuales. No descuenta puntos.",
          reprocessStarted: "Reprocesamiento iniciado. El análisis se actualizará en unos minutos.",
          reprocessError: "No se pudo iniciar el reprocesamiento.",
          downloadGroupMapsPDF: "Descargar mapas (PDF)",
          groupMapsPdfPending: "El PDF de los mapas se genera al procesar el análisis. Los análisis anteriores lo tendrán al reprocesarlos.",
        },
        bulkSend: {
          selectApplicants: "Seleccionar Postulantes",
          selectionMethod: "Método de Selección",
          uploadExcel: "Cargar Excel",
          selectManually: "Seleccionar Manualmente",
          searchApplicants: "Buscar postulantes por nombre o email...",
          selectAll: "Seleccionar Todos",
          deselectAll: "Deseleccionar Todos",
          applicantsSelected: "{{count}} postulante(s) seleccionado(s)",
          noApplicantsFound: "No se encontraron postulantes con los filtros aplicados",
          individualSend: "Envío Individual",
          bulkSend: "Envío Masivo",
          title: "Envío Masivo de Tests DISC",
          subtitle: "Sube un archivo Excel con emails de candidatos para enviar tests DISC de forma masiva",

          instructions: {
            title: "Instrucciones:",
            step1: "El archivo Excel debe tener una columna llamada \"email\"",
            step2: "Solo se enviarán tests a candidatos que ya existan en el sistema",
            step3: "Puedes descargar una plantilla de ejemplo",
            downloadTemplate: "Descargar Plantilla",
          },

          configuration: {
            title: "Configuración del Test",
            subtitle: "Selecciona el modo y parámetros opcionales que se aplicarán a todos los candidatos",
          },

          fileUpload: {
            title: "Cargar Archivo Excel",
            dragOrClick: "Click o arrastra un archivo Excel aquí",
            supportedFormats: "Formatos soportados: .xlsx, .xls",
            processing: "Procesando archivo...",
            invalidFileType: "Por favor selecciona un archivo Excel válido (.xls o .xlsx)",
            emptyFile: "El archivo Excel está vacío",
            noEmailColumn: "No se encontraron emails. Asegúrate de que haya una columna \"email\"",
            readError: "Error al leer el archivo",
            processError: "Error al procesar el archivo:",
          },

          preview: {
            summary: "Resumen del archivo:",
            totalEmails: "Total de emails:",
            candidatesFound: "Candidatos encontrados:",
            emailsNotFound: "Emails no encontrados:",
            candidatesList: "Candidatos que recibirán los tests:",
            name: "Nombre",
            email: "Email",
            andMore: "... y",
            moreRecords: "más",
            notFoundEmails: "Emails no encontrados:",
          },

          progress: {
            title: "Estado del envío:",
            progressLabel: "Progreso:",
            processed: "Procesados:",
            successful: "Exitosos:",
            failed: "Fallidos:",
          },

          actions: {
            cancel: "Cancelar",
            sending: "Enviando...",
            sendTo: "Enviar a",
            candidates: "Candidatos",
          },

          messages: {
            loadValidCandidates: "Por favor carga un archivo con candidatos válidos",
            bulkStarted: "Envío masivo iniciado:",
            errorStartingBulk: "Error al iniciar envío masivo",
            sendCompleted: "Envío completado:",
            successful: "exitosos",
            failed: "fallidos",
            bulkFailed: "El envío masivo falló",
          },

          insufficientPoints: "Puntos insuficientes",
          insufficientPointsMessage: "Has seleccionado {{selected}} candidatos pero solo tienes {{available}} puntos disponibles.",
          sufficientPoints: "Tienes suficientes puntos para enviar {{selected}} tests ({{available}} disponibles)",
        },

        usageCheck: {
          checkingLimits: "Verificando límites disponibles...",
          serviceNotAvailable: "Test DISC no disponible en tu plan",
          limitReached: "Límite de tests DISC alcanzado",
          pointsAvailable: "Puntos disponibles: {{points}}"
        },

        positionAffinity: "Afinidad con el Cargo",
        affinityPercentage: "Porcentaje de Afinidad",
        affinityAnalysis: "Análisis de Afinidad",
        highAffinity: "Alta Afinidad",
        moderateAffinity: "Afinidad Moderada",
        lowAffinity: "Baja Afinidad",
        competenciesAffinity: "Afinidad con Competencias",
        createdBy: "Creado por",
      },
      reasoningTests: {
        sendEmailOnCreate: "Enviar email al postulante",
        sendEmailOnCreateEnabled: "Se enviará el link del test por email automáticamente al crear",
        sendEmailOnCreateDisabled: "Los tests se crearán sin enviar email, puedes enviarlo luego desde el dashboard",
        testsCreatedSuccess: "{{count}} test(s) creado(s) exitosamente. Puedes enviar el email desde el dashboard.",
        createTests: "Crear tests",
        activityMonitoringDisclaimer: "Durante este test se monitoreará tu actividad para garantizar la integridad del proceso. Esto incluye la detección de cambios de pestaña, copiar/pegar, capturas de pantalla y otras acciones sospechosas.",
        totalTime: 'Tiempo Total',
        confidenceIndex: 'Índice de Confiabilidad',
        confidenceHigh: 'Alta Confiabilidad',
        confidenceMedium: 'Confiabilidad Moderada',
        confidenceLow: 'Confiabilidad Baja',
        confidenceVeryLow: 'Confiabilidad Muy Baja',
        statusProcessing: "Procesando",
        statusEvaluated: "Evaluado",
        statusProcessing_error: "Error al Procesar",
        processTest: "Procesar",
        processing: "Procesando...",
        retryProcess: "Reintentar",
        copyTestUrl: "Copiar URL del Test",
        urlCopied: "URL copiada al portapapeles",
        urlCopyError: "Error al copiar URL",
        processTestSuccess: "Test encolado para procesamiento",
        processTestError: "Error al procesar el test",
        errorDetails: "Detalles del error",
        createdBy: "Creado por",
        // Layout
        title: "Tests de Capacidades",
        subTitle: "Configura y gestiona tests de capacidades para evaluar habilidades cognitivas de tus postulantes",
        configuration: "Crear",
        dashboard: "Dashboard",

        // Configuration
        configurationTitle: "Crear Nuevos Tests de Capacidades",
        configurationSubTitle: "Selecciona el postulante y los tests que deseas enviar",
        selectApplicant: "Seleccionar Postulante",
        searchApplicant: "Buscar postulante...",
        selectTests: "Seleccionar Tests",
        selectTestsDescription: "Selecciona uno o más tests para enviar al postulante",

        // Test Types
        wordAssociation: "Asociación de Palabras",
        wordAssociationDescription: "Evalúa creatividad y patrones de pensamiento asociativo",
        logicalProcess: "Proceso Lógico",
        logicalProcessDescription: "Evalúa razonamiento lógico y capacidad de análisis secuencial",
        numericalReasoning: "Razonamiento Numérico",
        numericalReasoningDescription: "Evalúa habilidades numéricas y comprensión matemática",

        // Form
        selectedTests: "Tests seleccionados",
        sendTests: "Enviar Tests",
        sending: "Enviando...",
        cancel: "Cancelar",

        // Validations
        pleaseSelectApplicantAndTests: "Por favor selecciona un postulante y al menos un test",
        pleaseSelectAtLeastOneTest: "Por favor selecciona al menos un test para enviar",

        // Messages
        allTestsSentSuccess: "{{count}} test(s) enviado(s) exitosamente",
        testsCreatedAndEmailSent: "{{count}} test(s) creados y enviados en un solo email",
        someTestsSentSuccess: "{{success}} test(s) enviado(s), {{failed}} fallaron",
        allTestsFailed: "Error al enviar todos los tests",
        testSentError: "Error al enviar tests de capacidades",
        loadApplicantsError: "Error al cargar postulantes",
        testResentSuccess: "Test reenviado exitosamente",
        testResentError: "Error al reenviar test",
        viewResultNotImplemented: "La visualización de resultados estará disponible próximamente",

        // Dashboard
        dashboardTitle: "Estado de Tests de Capacidades",
        dashboardSubTitle: "Visualiza el progreso y resultados de los tests enviados",
        allTests: "Todos los Tests",
        refresh: "Actualizar",

        // Table
        applicantName: "Postulante",
        testType: "Tipo de Test",
        status: "Estado",
        sentDate: "Fecha de Envío",
        completedDate: "Fecha de Completado",
        actions: "Acciones",
        notAvailable: "No disponible",

        // Status
        statusPending: "Pendiente",
        statusSent: "Enviado",
        statusStarted: "Iniciado",
        statusCompleted: "Completado",
        statusProcessing: "Procesando",
        statusExpired: "Expirado",

        // Actions
        viewResult: "Ver Resultado",
        resendTest: "Reenviar Test",

        // Empty states
        noTestsFound: "No se encontraron tests de capacidades",
        noTestsMessage: "Crea tu primer test desde la pestaña de Configuración",
        loadError: "Error al cargar tests de capacidades",

        // TESTS
        questionProgress: "Pregunta {{current}} de {{total}}",
        skipQuestion: "Saltar pregunta",
        next: "Siguiente",
        finish: "Finalizar",
        savingProgress: "Guardando progreso...",
        instructions: "Instrucciones",
        welcomeMessage: "¡Bienvenido {{name}}!",
        startTest: "Comenzar Test",
        starting: "Iniciando...",

        // Word Association
        wordAssociation16Questions: "El test consta de 16 preguntas",
        wordAssociation10Minutes: "Tienes 10 minutos para completarlo",
        wordAssociationPairs: "Cada pregunta muestra un par de palabras relacionadas",
        wordAssociationSimilar: "Debes seleccionar el par que tiene una relación similar",
        wordAssociationNoPrevious: "No puedes volver a preguntas anteriores",
        wordAssociationCanSkip: "Puedes dejar preguntas sin responder",

        // Numeric Reasoning
        numericalReasoning42Series: "Hay 42 series de números",
        numericalReasoningNext2: "Debes identificar el patrón y escribir los siguientes 2 números",
        numericalReasoningPractice: "Las primeras 4 series son de práctica para familiarizarte",

        logicalProcess6Problems: "Hay 6 problemas lógicos",
        logicalProcessMultipleQuestions: "Cada problema tiene varias preguntas",
        logicalProcessReadCarefully: "Lee cuidadosamente cada enunciado",
        timeRemaining: "Tiempo restante",
        lessThanOneMinute: "¡Menos de 1 minuto!",
        invalidTestType: "Tipo de test inválido",
        accessDenied: "Acceso denegado",
        testNotFound: "Test no encontrado",
        loadError: "Error al cargar el test",

        // Public access
        emailVerification: "Verificación de Email",
        enterEmailToAccess: "Ingresa tu email para acceder al test",
        enterEmail: "Ingresa tu email",
        accessTest: "Acceder al Test",
        invalidEmail: "Email inválido",
        errorTitle: "Error",
        genericError: "Ocurrió un error. Por favor intenta nuevamente.",
        testExpired: "Test Expirado",
        testExpiredMessage: "Este test ha expirado. Por favor contacta al administrador.",
        errorStartingTest: "Error al iniciar el test",
        errorCompletingTest: "Error al completar el test",
        testCompletedTitle: "Test Completado",
        testCompletedMessage: "Gracias por completar el test. Tus resultados han sido guardados.",
        // Cierre automatico al agotarse el cronometro
        timeUpTitle: "Se acabó el tiempo",
        timeUpMessage: "El tiempo disponible para responder el test terminó. Enviamos automáticamente las respuestas que alcanzaste a marcar, así que no necesitas hacer nada más.",
        timeUpSubmitFailedMessage: "El tiempo disponible para responder el test terminó, pero no pudimos registrar tus respuestas. Por favor contacta a la persona que te envió el test.",
        pleaseCompleteAllFields: "Por favor completa ambos campos",
        itIsKnownThat: "Se sabe que...",
        questions: "Preguntas",
        selectAnOption: "Selecciona una opción",
        similarRelationTo: "¿Qué par de palabras tiene una relación similar a:",

        // Navegación de páginas
        questionNumber: "Pregunta {{number}}",
        pageProgress: "Página {{current}} de {{total}}",
        questionsInPage: "Preguntas {{start}}-{{end}} de {{total}}",
        previous: "Anterior",
        next: "Siguiente",
        nextPage: "Siguiente Página",
        finish: "Finalizar",
        skipQuestion: "Omitir",

        // Estados
        timeExpired: "¡Tiempo agotado! El test se completará automáticamente.",
        savingProgress: "Guardando progreso...",
        pleaseCompleteAllFields: "Por favor completa todos los campos",

        resultsTitle: "Resultados del Test",
        correctAnswers: "Respuestas correctas",
        timeUsed: "Tiempo utilizado",
        answersDetail: "Detalle de respuestas",
        yourAnswer: "Respuesta",
        correctAnswer: "Respuesta correcta",
        incorrect: "Incorrecta",
        noResults: "No hay resultados disponibles",
        insufficientResponses: "No hay respuestas suficientes",
        unknownTestType: "Tipo de test desconocido",
        of: "de",
        correct: "Correctas",
        question: "Pregunta",
        emptyAnswer: "Sin respuesta",
        score: "Puntuación",
        totalTime: "Tiempo Total",
        technicalDetails: "Tabla Detalles Técnicos",
        metric: "Métrica",
        value: "Valor",
        correctTotal: "Correcto (total)",
        correctResponded: "Correcto (Respondido)",
        questionsAnswered: "Preguntas respondidas",
        answeredPercent: "Respondidos %",
        realTime: "Tiempo real",
        performanceInterpretation: "Interpretación del Desempeño",
        notAnswered: "No respondida",
        downloadReport: 'Descargar PDF',

        socialContext: "Contexto Social",
        socialContextDescription: "Evalúa la capacidad de ordenar eventos en secuencia cronológica",
        socialContext20Questions: "El test consta de 20 preguntas",
        socialContext10Minutes: "Tienes 10 minutos para completarlo",
        socialContextOrderImages: "Cada pregunta muestra 4 imágenes que debes ordenar cronológicamente",
        socialContextDragDrop: "Arrastra las imágenes para ordenarlas de la primera (1º) a la última (4º)",
        socialContextChronological: "El orden debe ser cronológico según la secuencia de los eventos",
        socialContextCanSkip: "Puedes omitir preguntas si no estás seguro",
        orderImagesChronologically: "Ordena las imágenes cronológicamente",
        dragToOrderInstructions: "Arrastra las imágenes para ordenarlas de la primera (1º) a la última (4º) según el orden cronológico de los eventos.",
        currentOrder: "Orden actual:",
        checkOrder: 'Verificar orden',
        correctOrderIs: 'El orden correcto es',
        correctOrderDescriptions: {
          a: "se levanta",
          b: "desayuna",
          c: "camina al trabajo",
          d: "trabaja"
        },

        logicalAbstract: "Razonamiento Lógico Abstracto",
        logicalAbstractDescription: "Evalúa capacidad de identificar relaciones lógicas entre conceptos y pensamiento categórico",
        logicalAbstract30Questions: "El test contiene 30 preguntas sobre relaciones lógicas entre conceptos",
        logicalAbstract10Minutes: "Tienes 10 minutos para completar el test",
        logicalAbstractAnalyzeConcepts: "Cada pregunta presenta tres conceptos que debes analizar",
        logicalAbstractIdentifyRelation: "Debes identificar la relación correcta entre ellos (A, B, C, D o E)",
        logicalAbstractNoPenalty: "No hay penalización por respuestas incorrectas",
        logicalAbstractCanSkip: "Puedes saltar preguntas y volver después",

        integrityTest: "Integridad Laboral",
        integrityTestDescription: "Evalúa honestidad, ética y actitudes hacia normas organizacionales",
        integrityTest45Questions: "El test contiene 45 preguntas sobre integridad y ética laboral",
        integrityTest15Minutes: "Tienes 15 minutos para completar el test",
        integrityTestHonestAnswers: "Responde con honestidad, no hay respuestas correctas o incorrectas",
        integrityTestConfidential: "Tus respuestas son confidenciales",
        integrityTestNoReturn: "No puedes volver a preguntas anteriores",
        integrityTestCanSkip: "Puedes saltar preguntas si lo deseas",
        integrityIGI: "Índice General de Integridad (IGI)",
        integrityRiskLevel: "Nivel de Riesgo",
        integrityHighRisk: "Alto Riesgo",
        integrityMediumRisk: "Riesgo Medio",
        integrityLowRisk: "Bajo Riesgo",
        integrityValidResponses: "Validez de Respuestas",
        integrityValid: "Válidas",
        integrityQuestionable: "Cuestionables",

        emotionalIntelligence: "Inteligencia Emocional",
        emotionalIntelligenceDescription: "Evalúa capacidad de reconocer y gestionar emociones propias y ajenas",
        emotionalIntelligence48Questions: "El test consta de 48 afirmaciones",
        emotionalIntelligence10Minutes: "Tiempo estimado: 10 minutos",
        emotionalIntelligenceLikertScale: "Responde según una escala Likert de 5 opciones (Nada de acuerdo - Totalmente de acuerdo)",
        emotionalIntelligenceHonestAnswers: "Responde con sinceridad según cómo actúas habitualmente, no cómo te gustaría actuar",
        emotionalIntelligenceNoReturn: "No podrás volver atrás una vez que avances",
        emotionalCIE: "Coeficiente de Inteligencia Emocional (CIE)",
        emotionalLevel: "Nivel",
        emotionalHigh: "Alto",
        emotionalMedium: "Medio",
        emotionalLow: "Bajo",
        emotionalDimensions: "Puntajes por Dimensión",

        deleteTest: "Eliminar Test",
        deleteTestTitle: "Confirmar Eliminación",
        deleteTestConfirm: "¿Estás seguro que deseas eliminar el test de capacicades de",
        testDeletedSuccess: "Test de capacidades eliminado exitosamente",
        testDeletedError: "Error al eliminar el test de capacidades",
        refresh: "Actualizar",

        goToExamples: 'Ir a Ejemplos',
        practiceExamples: 'Ejemplos de Práctica',
        practiceExamplesDescription: 'Estos son ejemplos para que te familiarices con el formato del test. No cuentan para tu puntaje.',
        example: 'Ejemplo',
        firstNumber: 'Primer número',
        secondNumber: 'Segundo número',
        correct: '¡CORRECTO!',
        incorrect: 'INCORRECTO',
        correctAnswerIs: 'La respuesta correcta es',
        readyToStart: 'Cuando estés listo/a, presiona el botón para iniciar el test real.',
        practiceExamplesInstruction: 'Antes de iniciar el test, se te presentarán ejemplos de práctica para familiarizarte con el formato. Estos no se contabilizan en tu puntaje ni activan el cronómetro.',
        selectSimilarPair: 'Selecciona el par que tenga una relación similar',

        bulkSend: {
          selectApplicants: "Seleccionar Postulantes",
          selectionMethod: "Método de Selección",
          uploadExcel: "Cargar Excel",
          selectManually: "Seleccionar Manualmente",
          searchApplicants: "Buscar postulantes por nombre o email...",
          selectAll: "Seleccionar Todos",
          deselectAll: "Deseleccionar Todos",
          applicantsSelected: "{{count}} postulante(s) seleccionado(s)",
          noApplicantsFound: "No se encontraron postulantes con los filtros aplicados",
          individualSend: "Envío Individual",
          bulkSend: "Envío Masivo",
          title: "Envío Masivo de Tests de Capacidades",
          subtitle: "Sube un archivo Excel con emails de candidatos para enviar tests de capacidades de forma masiva",

          instructions: {
            title: "Instrucciones:",
            step1: "El archivo Excel debe tener una columna llamada \"email\"",
            step2: "Solo se enviarán tests a candidatos que ya existan en el sistema",
            step3: "Puedes descargar una plantilla de ejemplo",
            downloadTemplate: "Descargar Plantilla"
          },

          fileUpload: {
            title: "Cargar Archivo Excel",
            dragOrClick: "Click o arrastra un archivo Excel aquí",
            supportedFormats: "Formatos soportados: .xlsx, .xls",
            processing: "Procesando archivo...",
            invalidFileType: "Por favor selecciona un archivo Excel válido (.xls o .xlsx)",
            emptyFile: "El archivo Excel está vacío",
            noEmailColumn: "No se encontraron emails. Asegúrate de que haya una columna \"email\"",
            readError: "Error al leer el archivo",
            processError: "Error al procesar el archivo:"
          },

          preview: {
            summary: "Resumen del archivo:",
            totalEmails: "Total de emails:",
            candidatesFound: "Candidatos encontrados:",
            emailsNotFound: "Emails no encontrados:",
            candidatesList: "Candidatos que recibirán los tests:",
            name: "Nombre",
            email: "Email",
            andMore: "... y",
            moreRecords: "más",
            notFoundEmails: "Emails no encontrados:"
          },

          selectTestsTitle: "Seleccionar Tests a Enviar",
          selectedTests: "Tests seleccionados:",

          progress: {
            title: "Estado del envío:",
            progressLabel: "Progreso:",
            processed: "Procesados:",
            successful: "Exitosos:",
            failed: "Fallidos:"
          },

          actions: {
            cancel: "Cancelar",
            sending: "Enviando...",
            sendTo: "Enviar a",
            candidates: "Candidatos"
          },

          messages: {
            loadValidCandidates: "Por favor carga un archivo con candidatos válidos y selecciona al menos un test",
            bulkStarted: "Envío masivo iniciado:",
            errorStartingBulk: "Error al iniciar envío masivo",
            sendCompleted: "Envío completado:",
            successful: "exitosos",
            failed: "fallidos",
            bulkFailed: "El envío masivo falló"
          },

          insufficientPoints: "Puntos insuficientes",
          insufficientPointsMessage: "Has seleccionado {{selected}} candidatos pero solo tienes {{available}} puntos disponibles.",
          sufficientPoints: "Tienes suficientes puntos para enviar {{selected}} tests ({{available}} disponibles)",
          insufficientPointsMessageBulk: "Necesitas {{total}} puntos ({{candidates}} candidatos × {{tests}} tests) pero solo tienes {{available}} disponibles.",
          sufficientPointsBulk: "Tienes suficientes puntos para {{total}} tests ({{candidates}} candidatos × {{tests}} tests). {{available}} puntos disponibles.",
          sufficientPointsBulkUnlimited: "Tienes suficientes puntos para {{total}} tests ({{candidates}} candidatos × {{tests}} tests) (ilimitado)."
        },

        usageCheck: {
          checkingLimits: "Verificando límites disponibles...",
          serviceNotAvailable: "Tests de razonamiento no disponibles en tu plan",
          limitReached: "Límite de tests de razonamiento alcanzado",
          pointsAvailable: "Puntos disponibles: {{points}}",
          insufficientPoints: "Puntos insuficientes",
          insufficientPointsMessage: "Has seleccionado {{selected}} tests pero solo tienes {{available}} puntos disponibles.",
          sufficientPoints: "Tienes suficientes puntos para {{selected}} tests ({{available}} disponibles)"
        },
      },
      personalHabilitiesTests: {
        sendEmailOnCreate: "Enviar email al postulante",
        sendEmailOnCreateEnabled: "Se enviará el link del test por email automáticamente al crear",
        sendEmailOnCreateDisabled: "Los tests se crearán sin enviar email, puedes enviarlo luego desde el dashboard",
        testsCreatedSuccess: "{{count}} test(s) creado(s) exitosamente. Puedes enviar el email desde el dashboard.",
        createTests: "Crear tests",
        activityMonitoringDisclaimer: "Durante este test se monitoreará tu actividad para garantizar la integridad del proceso. Esto incluye la detección de cambios de pestaña, copiar/pegar, capturas de pantalla y otras acciones sospechosas.",
        totalTime: 'Tiempo Total',
        confidenceIndex: 'Índice de Confiabilidad',
        confidenceHigh: 'Alta Confiabilidad',
        confidenceMedium: 'Confiabilidad Moderada',
        confidenceLow: 'Confiabilidad Baja',
        confidenceVeryLow: 'Confiabilidad Muy Baja',
        statusProcessing: "Procesando",
        statusEvaluated: "Evaluado",
        statusProcessing_error: "Error al Procesar",
        processTest: "Procesar",
        processing: "Procesando...",
        retryProcess: "Reintentar",
        copyTestUrl: "Copiar URL del Test",
        urlCopied: "URL copiada al portapapeles",
        urlCopyError: "Error al copiar URL",
        processTestSuccess: "Test encolado para procesamiento",
        processTestError: "Error al procesar el test",
        errorDetails: "Detalles del error",
        createdBy: "Creado por",
        // Layout
        title: "Tests de Habilidades Personales",
        subTitle: "Configura y gestiona tests de habilidades personales para evaluar a tus postulantes",
        configuration: "Crear",
        dashboard: "Dashboard",

        // Configuration
        configurationTitle: "Crear Nuevos Tests de Habilidades Personales",
        configurationSubTitle: "Selecciona el postulante y los tests que deseas enviar",
        selectApplicant: "Seleccionar Postulante",
        searchApplicant: "Buscar postulante...",
        selectTests: "Seleccionar Tests",
        selectTestsDescription: "Selecciona uno o más tests para enviar al postulante",

        // Form
        selectedTests: "Tests seleccionados",
        sendTests: "Enviar Tests",
        sending: "Enviando...",
        cancel: "Cancelar",

        // Validations
        pleaseSelectApplicantAndTests: "Por favor selecciona un postulante y al menos un test",
        pleaseSelectAtLeastOneTest: "Por favor selecciona al menos un test para enviar",

        // Messages
        allTestsSentSuccess: "{{count}} test(s) enviado(s) exitosamente",
        testsCreatedAndEmailSent: "{{count}} test(s) creados y enviados en un solo email",
        someTestsSentSuccess: "{{success}} test(s) enviado(s), {{failed}} fallaron",
        allTestsFailed: "Error al enviar todos los tests",
        testSentError: "Error al enviar tests de habilidades personales",
        loadApplicantsError: "Error al cargar postulantes",
        testResentSuccess: "Test reenviado exitosamente",
        testResentError: "Error al reenviar test",
        viewResultNotImplemented: "La visualización de resultados estará disponible próximamente",

        // Dashboard
        dashboardTitle: "Estado de Tests de Habilidades Personales",
        dashboardSubTitle: "Visualiza el progreso y resultados de los tests enviados",
        allTests: "Todos los Tests",
        refresh: "Actualizar",

        // Table
        applicantName: "Postulante",
        testType: "Tipo de Test",
        status: "Estado",
        sentDate: "Fecha de Envío",
        completedDate: "Fecha de Completado",
        actions: "Acciones",
        notAvailable: "No disponible",

        // Status
        statusPending: "Pendiente",
        statusSent: "Enviado",
        statusStarted: "Iniciado",
        statusCompleted: "Completado",
        statusProcessing: "Procesando",
        statusExpired: "Expirado",

        // Actions
        viewResult: "Ver Resultado",
        resendTest: "Reenviar Test",

        // Empty states
        noTestsFound: "No se encontraron tests de habilidades personales",
        noTestsMessage: "Crea tu primer test desde la pestaña de Configuración",
        loadError: "Error al cargar tests de habilidades personales",

        // TESTS
        questionProgress: "Pregunta {{current}} de {{total}}",
        skipQuestion: "Saltar pregunta",
        next: "Siguiente",
        finish: "Finalizar",
        savingProgress: "Guardando progreso...",
        instructions: "Instrucciones",
        welcomeMessage: "¡Bienvenido {{name}}!",
        startTest: "Comenzar Test",
        starting: "Iniciando...",

        timeRemaining: "Tiempo restante",
        lessThanOneMinute: "¡Menos de 1 minuto!",
        invalidTestType: "Tipo de test inválido",
        accessDenied: "Acceso denegado",
        testNotFound: "Test no encontrado",
        loadError: "Error al cargar el test",

        resultsTitle: "Resultados del Test",
        correctAnswers: "Respuestas correctas",
        timeUsed: "Tiempo utilizado",
        answersDetail: "Detalle de respuestas",
        yourAnswer: "Respuesta",
        correctAnswer: "Respuesta correcta",
        incorrect: "Incorrecta",
        noResults: "No hay resultados disponibles",
        insufficientResponses: "No hay respuestas suficientes",
        unknownTestType: "Tipo de test desconocido",
        of: "de",
        correct: "Correctas",
        question: "Pregunta",
        emptyAnswer: "Sin respuesta",
        score: "Puntuación",
        totalTime: "Tiempo Total",
        technicalDetails: "Tabla Detalles Técnicos",
        metric: "Métrica",
        value: "Valor",
        correctTotal: "Correcto (total)",
        correctResponded: "Correcto (Respondido)",
        questionsAnswered: "Preguntas respondidas",
        answeredPercent: "Respondidos %",
        realTime: "Tiempo real",
        performanceInterpretation: "Interpretación del Desempeño",
        notAnswered: "No respondida",
        downloadReport: 'Descargar PDF',

        integrityTest: "Integridad Laboral",
        integrityTestDescription: "Evalúa honestidad, ética y actitudes hacia normas organizacionales",
        integrityTest45Questions: "El test contiene 45 preguntas sobre integridad y ética laboral",
        integrityTest15Minutes: "Tienes 15 minutos para completar el test",
        integrityTestHonestAnswers: "Responde con honestidad, no hay respuestas correctas o incorrectas",
        integrityTestConfidential: "Tus respuestas son confidenciales",
        integrityTestNoReturn: "No puedes volver a preguntas anteriores",
        integrityTestCanSkip: "Puedes saltar preguntas si lo deseas",
        integrityIGI: "Índice General de Integridad (IGI)",
        integrityRiskLevel: "Nivel de Riesgo",
        integrityHighRisk: "Alto Riesgo",
        integrityMediumRisk: "Riesgo Medio",
        integrityLowRisk: "Bajo Riesgo",
        integrityValidResponses: "Validez de Respuestas",
        integrityValid: "Válidas",
        integrityQuestionable: "Cuestionables",

        emotionalIntelligence: "Inteligencia Emocional",
        emotionalIntelligenceDescription: "Evalúa capacidad de reconocer y gestionar emociones propias y ajenas",
        emotionalIntelligence48Questions: "El test consta de 48 afirmaciones",
        emotionalIntelligence10Minutes: "Tiempo estimado: 10 minutos",
        emotionalIntelligenceLikertScale: "Responde según una escala Likert de 5 opciones (Nada de acuerdo - Totalmente de acuerdo)",
        emotionalIntelligenceHonestAnswers: "Responde con sinceridad según cómo actúas habitualmente, no cómo te gustaría actuar",
        emotionalIntelligenceNoReturn: "No podrás volver atrás una vez que avances",
        emotionalCIE: "Coeficiente de Inteligencia Emocional (CIE)",
        emotionalLevel: "Nivel",
        emotionalHigh: "Alto",
        emotionalMedium: "Medio",
        emotionalLow: "Bajo",
        emotionalDimensions: "Puntajes por Dimensión",

        deleteTest: "Eliminar Test",
        deleteTestTitle: "Confirmar Eliminación",
        deleteTestConfirm: "¿Estás seguro que deseas eliminar el test de habilidades personales de",
        testDeletedSuccess: "Test de habilidades personales eliminado exitosamente",
        testDeletedError: "Error al eliminar el test de habilidades personales",
        refresh: "Actualizar",

        goToExamples: 'Ir a Ejemplos',
        practiceExamples: 'Ejemplos de Práctica',
        practiceExamplesDescription: 'Estos son ejemplos para que te familiarices con el formato del test. No cuentan para tu puntaje.',
        example: 'Ejemplo',
        firstNumber: 'Primer número',
        secondNumber: 'Segundo número',
        correct: '¡CORRECTO!',
        incorrect: 'INCORRECTO',
        correctAnswerIs: 'La respuesta correcta es',
        readyToStart: 'Cuando estés listo/a, presiona el botón para iniciar el test real.',
        practiceExamplesInstruction: 'Antes de iniciar el test, se te presentarán ejemplos de práctica para familiarizarte con el formato. Estos no se contabilizan en tu puntaje ni activan el cronómetro.',
        selectSimilarPair: 'Selecciona el par que tenga una relación similar',

        bulkSend: {
          selectApplicants: "Seleccionar Postulantes",
          selectionMethod: "Método de Selección",
          uploadExcel: "Cargar Excel",
          selectManually: "Seleccionar Manualmente",
          searchApplicants: "Buscar postulantes por nombre o email...",
          selectAll: "Seleccionar Todos",
          deselectAll: "Deseleccionar Todos",
          applicantsSelected: "{{count}} postulante(s) seleccionado(s)",
          noApplicantsFound: "No se encontraron postulantes con los filtros aplicados",
          individualSend: "Envío Individual",
          bulkSend: "Envío Masivo",
          title: "Envío Masivo de Tests de Habilidades Personales",
          subtitle: "Sube un archivo Excel con emails de candidatos para enviar tests de habilidades personales de forma masiva",

          instructions: {
            title: "Instrucciones:",
            step1: "El archivo Excel debe tener una columna llamada \"email\"",
            step2: "Solo se enviarán tests a candidatos que ya existan en el sistema",
            step3: "Puedes descargar una plantilla de ejemplo",
            downloadTemplate: "Descargar Plantilla"
          },

          fileUpload: {
            title: "Cargar Archivo Excel",
            dragOrClick: "Click o arrastra un archivo Excel aquí",
            supportedFormats: "Formatos soportados: .xlsx, .xls",
            processing: "Procesando archivo...",
            invalidFileType: "Por favor selecciona un archivo Excel válido (.xls o .xlsx)",
            emptyFile: "El archivo Excel está vacío",
            noEmailColumn: "No se encontraron emails. Asegúrate de que haya una columna \"email\"",
            readError: "Error al leer el archivo",
            processError: "Error al procesar el archivo:"
          },

          preview: {
            summary: "Resumen del archivo:",
            totalEmails: "Total de emails:",
            candidatesFound: "Candidatos encontrados:",
            emailsNotFound: "Emails no encontrados:",
            candidatesList: "Candidatos que recibirán los tests:",
            name: "Nombre",
            email: "Email",
            andMore: "... y",
            moreRecords: "más",
            notFoundEmails: "Emails no encontrados:"
          },

          selectTestsTitle: "Seleccionar Tests a Enviar",
          selectedTests: "Tests seleccionados:",

          progress: {
            title: "Estado del envío:",
            progressLabel: "Progreso:",
            processed: "Procesados:",
            successful: "Exitosos:",
            failed: "Fallidos:"
          },

          actions: {
            cancel: "Cancelar",
            sending: "Enviando...",
            sendTo: "Enviar a",
            candidates: "Candidatos"
          },

          messages: {
            loadValidCandidates: "Por favor carga un archivo con candidatos válidos y selecciona al menos un test",
            bulkStarted: "Envío masivo iniciado:",
            errorStartingBulk: "Error al iniciar envío masivo",
            sendCompleted: "Envío completado:",
            successful: "exitosos",
            failed: "fallidos",
            bulkFailed: "El envío masivo falló"
          },

          insufficientPoints: "Puntos insuficientes",
          insufficientPointsMessage: "Has seleccionado {{selected}} candidatos pero solo tienes {{available}} puntos disponibles.",
          sufficientPoints: "Tienes suficientes puntos para enviar {{selected}} tests ({{available}} disponibles)",
          insufficientPointsMessageBulk: "Necesitas {{total}} puntos ({{candidates}} candidatos × {{tests}} tests) pero solo tienes {{available}} disponibles.",
          sufficientPointsBulk: "Tienes suficientes puntos para {{total}} tests ({{candidates}} candidatos × {{tests}} tests). {{available}} puntos disponibles.",
          sufficientPointsBulkUnlimited: "Tienes suficientes puntos para {{total}} tests ({{candidates}} candidatos × {{tests}} tests) (ilimitado)."
        },

        usageCheck: {
          checkingLimits: "Verificando límites disponibles...",
          serviceNotAvailable: "Tests de razonamiento no disponibles en tu plan",
          limitReached: "Límite de tests de razonamiento alcanzado",
          pointsAvailable: "Puntos disponibles: {{points}}",
          insufficientPoints: "Puntos insuficientes",
          insufficientPointsMessage: "Has seleccionado {{selected}} tests pero solo tienes {{available}} puntos disponibles.",
          sufficientPoints: "Tienes suficientes puntos para {{selected}} tests ({{available}} disponibles)"
        },
      },
      usageFAB: {
        title: "Uso de Puntos",
        used: "Usados",
        limit: "Límite",
        remaining: "Disponibles",
        unlimited: "Ilimitado",
        unlimitedShort: "∞",
        pointsAvailableLabel: "Puntos Disponibles"
      },
      hiringRoomConfig: {
        title: "Integración con HiringRoom",
        subtitle: "Configura las credenciales para conectarte con la API de HiringRoom",
        connected: "Conectado",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        email: "Email",
        password: "Contraseña",
        clientIdTooltip: "Identificador único de cliente proporcionado por HiringRoom para autenticar tu aplicación",
        clientSecretTooltip: "Clave secreta proporcionada por HiringRoom para validar la identidad de tu aplicación",
        emailTooltip: "Correo electrónico que utilizas para iniciar sesión en la plataforma HiringRoom",
        passwordTooltip: "Contraseña asociada a tu cuenta de HiringRoom",
        saving: "Guardando...",
        saveConfig: "Guardar Configuración",
        testing: "Probando...",
        testConnection: "Probar Conexión",
        testBeforeSave: "Debes probar la conexión exitosamente antes de guardar la configuración",
        connectionSuccess: "Conexión exitosa con HiringRoom",
        connectionError: "Error al conectar con HiringRoom. Verifica tus credenciales.",
        cannotSave: "No se puede guardar: organización o proyecto no disponibles",
        saveSuccess: "Configuración de HiringRoom guardada exitosamente",
        saveError: "Error al guardar configuración",
        saveErrorGeneral: "Error al guardar la configuración de HiringRoom",
        testSuccess: "¡Conexión exitosa con HiringRoom!",
        testError: "Error al conectar",
        invalidCredentials: "Credenciales inválidas",
        testErrorGeneral: "Error al probar la conexión con HiringRoom",
      },
      hiringRoomImport: {
        title: "Importar Postulantes desde HiringRoom",
        applicantsFound: "postulantes encontrados",
        searchByDates: "Búsqueda por Fechas",
        searchByData: "Búsqueda por Datos",
        dateFrom: "Fecha desde",
        dateTo: "Fecha hasta",
        search: "Buscar",
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Email",
        position: "Cargo",
        phone: "Teléfono",
        applicationDate: "Fecha Postulación",
        status: "Estado",
        notAvailable: "N/A",
        imported: "Importado",
        new: "Nuevo",
        searchToSeeApplicants: "Realiza una búsqueda para ver postulantes",
        noApplicantsFound: "No se encontraron postulantes con los filtros aplicados",
        pageOfPages: "Página {{current}} de {{total}}",
        selectAll: "Seleccionar todas",
        deselectAll: "Deseleccionar todas",
        applicantsSelected: "{{count}} postulante(s) seleccionado(s) para importar",
        alreadyImported: "Este postulante ya fue importado",
        cancel: "Cancelar",
        importing: "Importando...",
        importSelected: "Importar {{count}} seleccionado(s)",
        selectAtLeastOne: "Debes seleccionar al menos un postulante",
        importSuccess: "Se importaron {{count}} postulantes exitosamente",
        importErrors: "{{count}} postulantes no pudieron ser importados",
        loadError: "Error al cargar postulantes",
        loadErrorDetail: "Error al cargar postulantes de HiringRoom",
        importError: "Error al importar postulantes",
        importErrorDetail: "Error al importar postulantes de HiringRoom",
      },
      hiringRoomVacanciesImport: {
        title: "Importar Cargos desde HiringRoom",
        vacanciesAvailable: "cargos disponibles",
        name: "Nombre",
        area: "Área",
        hierarchy: "Jerarquía",
        creationDate: "Fecha de creación",
        status: "Estado",
        notAvailable: "N/A",
        imported: "Importado",
        noVacanciesAvailable: "No hay cargos disponibles en HiringRoom",
        pageOfPages: "Página {{current}} de {{total}}",
        selectAll: "Seleccionar todos",
        deselectAll: "Deseleccionar todos",
        vacanciesSelected: "{{count}} cargo(s) seleccionado(s) para importar",
        alreadyImported: "Este cargo ya fue importado",
        cancel: "Cancelar",
        importing: "Importando...",
        importSelected: "Importar {{count}} seleccionado(s)",
        selectAtLeastOne: "Debes seleccionar al menos un cargo",
        importSuccess: "Se importaron {{count}} cargos exitosamente",
        importErrors: "{{count}} cargos no pudieron ser importados",
        loadError: "Error al cargar cargos",
        loadErrorDetail: "Error al cargar cargos de HiringRoom",
        importError: "Error al importar cargos",
        importErrorDetail: "Error al importar cargos de HiringRoom",
      },
      cvFiltering: {
        downloadPdf: "Descargar PDF",
        costEstimate: 'Costo estimado',
        pointsLabel: 'puntos',
        pointsPerApplicant: 'puntos por postulante',
        applicantsLabel: 'postulantes',
        serviceNotAvailable: 'El servicio de Filtrado de CV no está disponible en tu plan actual',
        unlimitedPoints: 'Puntos ilimitados',
        pointsAvailable: 'Puntos disponibles',
        insufficientPoints: 'Puntos insuficientes',
        youHave: 'Tienes',
        need: 'necesitas',
        totalCost: 'Costo total',
        remainingAfterProcess: 'Puntos restantes después del proceso',
        title: 'Filtrado de CV',
        subTitle: 'Analiza y compara candidatos mediante IA',
        createProcess: 'Crear Proceso',
        dashboard: 'Dashboard',
        selectPosition: 'Seleccionar Cargo',
        addApplicants: 'Agregar Postulantes',
        selectedApplicants: 'Postulantes Seleccionados',
        uploadCv: 'Subir CV',
        replaceCv: 'Reemplazar CV',
        noCv: 'Sin CV',
        currentPosition: 'Cargo actual',
        summary: 'Resumen',
        processing: 'Procesando...',
        completed: 'Completado',
        failed: 'Fallido',
        viewDetails: 'Ver Detalles',
        ranking: 'Ranking de Candidatos',
        score: 'Puntuación',
        strengths: 'Fortalezas',
        weaknesses: 'Áreas de Mejora',
        recommendation: 'Recomendación',
        dashboardTitle: 'Procesos de Filtrado de CV',
        dashboardSubtitle: 'Gestiona y revisa los procesos de filtrado de candidatos',
        noProcesses: 'No hay procesos de filtrado creados. Crea uno desde la pestaña "Crear Proceso".',
        tableTitle: 'Título',
        tablePosition: 'Cargo',
        tableApplicants: 'Postulantes',
        tableStatus: 'Estado',
        tableDate: 'Fecha',
        statusPending: 'Pendiente',
        statusProcessing: 'Procesando',
        statusCompleted: 'Completado',
        statusFailed: 'Fallido',
        viewResults: 'Ver resultados',
        reprocess: 'Reprocesar',
        retry: 'Reintentar',
        reprocessError: 'Error al reprocesar. Intenta nuevamente.',
        scoringWeights: 'Configuración de Ponderación',
        scoringWeightsDescription: 'Define el peso de cada componente en el score final. Deben sumar 100%.',
        cvWeight: 'Peso CV',
        answersWeight: 'Peso Respuestas',
        weightsError: 'Los pesos deben sumar 100%',
        weight: 'Peso',
        position: 'Cargo',
        totalApplicants: 'Total Postulantes',
        processed: 'Procesados',
        averageScore: 'Promedio Score',
        candidateRanking: 'Ranking de Candidatos',
        noResults: 'No hay resultados para mostrar',
        detailedScores: 'Scores Detallados',
        cv: 'CV',
        answers: 'Respuestas',
        strengths: 'Fortalezas',
        areasForImprovement: 'Áreas de Mejora',
        cvAnalysis: 'Análisis del CV',
        answersAnalysis: 'Análisis de Respuestas',
        scoreJustification: 'Justificación del Score',
        observations: 'Observaciones',
        finalRecommendation: 'Recomendación Final',
        step1: 'Selección de Cargo y Postulantes',
        step2: 'Resumen y Procesamiento',
        mustSelectPosition: 'Debes seleccionar un cargo',
        mustAddApplicant: 'Debes agregar al menos un postulante',
        createProcessError: 'Error al crear proceso de filtrado',
        startProcessingError: 'Error al iniciar procesamiento',
        processingError: 'Error al procesar',
        selectPosition: 'Seleccionar Cargo',
        position: 'Cargo',
        searchPosition: 'Buscar cargo...',
        addApplicants: 'Agregar Postulantes',
        applicant: 'Postulante',
        searchApplicant: 'Buscar postulante...',
        currentPosition: 'Cargo actual',
        noCv: 'Sin CV',
        positions: 'Cargos',
        selectedApplicants: 'Postulantes Seleccionados',
        cvLoaded: 'CV cargado',
        selectedPosition: 'Cargo Seleccionado',
        name: 'Nombre',
        industry: 'Industria',
        hierarchy: 'Jerarquía',
        description: 'Descripción',
        applicantsToAnalyze: 'Postulantes a Analizar',
        successTitle: 'Proceso de filtrado creado exitosamente',
        successMessage1: 'El análisis de CVs se está procesando en segundo plano. Puedes ver los resultados en el',
        successMessage2: 'una vez que el proceso esté completado.',
        dashboard: 'Dashboard',
        redirectingMessage: 'Redirigiendo al dashboard en unos segundos...',
        errorTitle: 'Error al crear el proceso',
        errorMessage: 'Ocurrió un error al intentar crear el proceso de filtrado. Por favor, intenta nuevamente.',
        creatingProcess: 'Creando proceso de filtrado...',
        takeFewSeconds: 'Esto tomará solo unos segundos',
        back: 'Atrás',
        creating: 'Creando...',
        processing: 'Procesando...',
        processCvs: 'Procesar CVs',
        next: 'Siguiente',
        uploadCv: 'Subir CV',
        uploadCvMessage1: 'El postulante',
        uploadCvMessage2: 'no tiene CV cargado. Puedes subir un CV ahora o continuar sin él.',
        uploading: 'Subiendo...',
        selectCv: 'Seleccionar CV',
        continueWithoutCv: 'Continuar sin CV',
        invalidFileFormat: 'Formato de archivo no válido. Solo se permiten PDF, DOC y DOCX.',
        uploadCvError: 'Error al subir CV',
        replaceCvError: 'Error al reemplazar CV',
        filteringPrefix: 'Filtrado',
        processDescription: 'Proceso de filtrado de CV para el cargo',
        deleteTitle: 'Eliminar Proceso de Filtrado',
        deleteConfirm: '¿Estás seguro de que deseas eliminar el proceso',
        deleteSuccess: 'Proceso eliminado exitosamente',
        deleteError: 'Error al eliminar el proceso',
      },
      salesAssessment: {
        sendEmailOnCreate: "Enviar email al postulante",
        sendEmailOnCreateEnabled: "Se enviará el link del assessment por email automáticamente al crear",
        sendEmailOnCreateDisabled: "El assessment se creará sin enviar email, puedes enviarlo luego desde el dashboard",
        testCreatedSuccess: "Assessment creado exitosamente. Puedes enviar el email desde el dashboard.",
        createTest: "Crear assessment",
        createTest: "Crear Test de Ventas",
        selectApplicantDescription: "Seleccione el postulante para enviar el test de evaluación de ventas. Opcionalmente puede seleccionar un cargo para ordenar los postulantes.",
        selectPosition: "Seleccionar Cargo (Opcional)",
        selectApplicant: "Seleccionar Postulante ({{count}} disponibles)",
        applicantsSorted: "Postulantes ordenados: primero los del cargo seleccionado",
        selectApplicantToSend: "Seleccione un postulante para enviar el test",
        positionLabel: "Cargo:",
        industryLabel: "Industria:",
        descriptionLabel: "Descripción:",
        noIndustry: "Sin industria",
        notSpecified: "No especificada",
        cancel: "Cancelar",
        sendTest: "Enviar Test",
        sending: "Enviando...",
        mustSelectApplicant: "Debe seleccionar un postulante",
        testSentSuccess: "Test de ventas enviado exitosamente",
        testSentError: "Error al enviar el test de ventas",
        dashboard: {
          individualTests: 'Tests Individuales',
          comparisons: 'Comparaciones',
          statuses: {
            pending: 'Pendiente',
            sent: 'Enviado',
            started: 'Iniciado',
            completed: 'Completado',
            processing: 'Procesando',
            evaluated: 'Evaluado',
            processing_error: 'Error',
            expired: 'Expirado',
          },
          // Botones y acciones
          refresh: "Actualizar",
          searchApplicant: "Buscar postulante...",

          // Headers de tabla
          applicant: "Postulante",
          position: "Cargo",
          createdBy: "Creado por",
          status: "Estado",
          sentDate: "Fecha Envío",
          completedDate: "Fecha Completado",
          actions: "Acciones",

          // Valores por defecto
          notSpecified: "No especificado",
          notAvailable: "No disponible",

          // Tooltips de acciones
          processTest: "Procesar Test",
          viewReport: "Ver Reporte",
          processing: "Procesando...",
          reprocess: "Reprocesar",
          retry: "Error de procesamiento - Reintentar",
          copyUrl: "Copiar URL del Test",
          resendTest: "Reenviar Test",
          deleteTest: "Eliminar Test",

          // Mensajes de éxito
          testProcessing: "Test en procesamiento",
          testResentSuccess: "Test reenviado exitosamente",
          urlCopied: "URL copiada al portapapeles",
          urlCopyError: "Error al copiar la URL",
          testDeletedSuccess: "Test eliminado exitosamente",

          // Mensajes de error
          errorProcessing: "Error al procesar el test",
          errorResending: "Error al reenviar el test",
          errorDeleting: "Error al eliminar el test",
          errorLoading: "Error al cargar los tests de ventas",

          // Estados vacíos
          noTestsFound: "No se encontraron tests de ventas",
          createFirstTest: "Crea tu primer test desde la pestaña Crear",

          // Modal de eliminación
          deleteDialogTitle: "Eliminar Test de Ventas",
          deleteConfirmation: "¿Estás seguro de que deseas eliminar el test de",
          deleteWarning: "Esta acción no se puede deshacer.",
          cancel: "Cancelar",
          delete: "Eliminar",
        },
        layout: {
          title: "Evaluación de Ventas",
          subtitle: "Evalúa las habilidades de ventas de tus postulantes",
          createTab: "Crear",
          dashboardTab: "Dashboard",
          comparisonsTab: 'Comparaciones',
        },
        report: {
          // Alertas
          noDataAvailable: "No hay datos disponibles para mostrar",
          analysisNotAvailable: "El análisis aún no está disponible",
          assessmentCompleted: "Assessment Completado",

          // Secciones principales
          executiveSummary: "Resumen Ejecutivo Comercial",
          currentSalesProfile: "Perfil Comercial Actual",
          competenciesEvaluation: "Evaluación de Competencias Comerciales",
          predominantRole: "Rol Comercial Predominante",
          roleIndustryFit: "Ajuste al Rol e Industria",
          aspectsToManage: "Aspectos a Gestionar para Maximizar Efectividad",
          developmentPriorities: "Prioridades de Desarrollo Comercial",
          actionPlan: "Plan de Acción 30 / 60 / 90 Días",
          finalRecommendations: "Recomendaciones Finales",

          // Resumen Ejecutivo
          effectivenessLevel: "Nivel de Efectividad",
          sellerType: "Tipo de Vendedor",
          optimalContexts: "Contextos Óptimos",

          // Perfil Comercial
          salesProcess: "Proceso de Ventas",
          customerInteraction: "Interacción con Clientes",
          decisionMaking: "Toma de Decisiones",
          closingProgress: "Avance al Cierre",

          // Rol Comercial
          mainRole: "Rol Principal",
          secondary: "Secundario:",
          optimalSaleType: "Tipo de Venta Óptima",

          // Ajuste
          fitLevel: "Nivel de Ajuste:",

          // Aspectos a Gestionar
          importance: "Importancia:",
          context: "Contexto:",

          // Prioridades
          priority: "Prioridad",
          impact: "Impacto:",

          // Plan de Acción
          days30: "30 Días",
          days60: "60 Días",
          days90: "90 Días",

          // Recomendaciones Finales
          synthesis: "Síntesis",
          practicalAdvice: "Consejos Prácticos",

          // Glosario de roles de venta
          rolesGlossary: {
            title: "¿Qué representan los roles de venta?",
            intro: "Los roles permiten identificar el tipo de escenario comercial en el que una persona puede desenvolverse con mayor naturalidad. Consideran aspectos como la complejidad de la solución, conocimiento previo del cliente, duración del ciclo de venta, cantidad de tomadores de decisión y nivel de relación requerido para concretar el negocio.",
            roleColumn: "Rol de venta",
            definitionColumn: "Definición",
            mainTag: "Principal",
            secondaryTag: "Secundario",
            groups: {
              transactional: "Venta directa / transaccional",
              opportunity: "Venta de desarrollo de oportunidad",
              consultative: "Venta consultiva / estratégica",
            },
            roles: {
              distributor: {
                name: "Distribuidor",
                definition: "Se desempeña en ventas directas, simples y transaccionales, donde el cliente conoce lo que necesita y puede decidir rápidamente. El foco está en facilitar la compra, responder con agilidad y concretar eficientemente la operación.",
              },
              provider: {
                name: "Proveedor",
                definition: "Se enfoca en atender una necesidad ya conocida por el cliente, ofreciendo una solución clara y fácil de comparar. La venta suele ser ágil, pero el valor está en entregar confianza, buen servicio y generar nuevas oportunidades a partir de la relación existente.",
              },
              revealer: {
                name: "Revelador",
                definition: "Detecta oportunidades en clientes que aún no reconocen claramente una necesidad, pero donde la solución es relativamente sencilla de comprender. Su fortaleza está en hacer visible el problema, conectar rápidamente la necesidad con una solución y facilitar la decisión de compra.",
              },
              creator: {
                name: "Creador",
                definition: "Se orienta a generar una necesidad o despertar interés en clientes que inicialmente no estaban buscando la solución. Requiere iniciativa, capacidad de captar atención y convertir rápidamente una oportunidad en una venta, manteniendo posteriormente la relación comercial.",
              },
              pioneer: {
                name: "Pionero",
                definition: "Se mueve en ventas donde tanto la solución como la decisión de compra pueden ser nuevas y complejas para el cliente. Requiere capacidad para explicar, persuadir y acompañar un proceso comercial más largo, generalmente hasta lograr el cierre.",
              },
              innovator: {
                name: "Innovador",
                definition: "Introduce soluciones nuevas o poco conocidas que el cliente todavía no necesariamente sabe que necesita. Su desafío es abrir mercado, educar, generar una visión de valor y movilizar decisiones complejas que pueden involucrar a varias personas dentro de la organización.",
              },
              consultant: {
                name: "Consultor",
                definition: "Aborda ventas complejas y de alto involucramiento, donde el cliente reconoce su necesidad pero requiere apoyo para determinar cuál es la mejor solución. El vendedor debe diagnosticar, hacer buenas preguntas, construir una propuesta de valor y conducir a distintos tomadores de decisión hacia el cierre.",
              },
              partner: {
                name: "Partner",
                definition: "Actúa como un socio comercial del cliente frente a decisiones relevantes o de mayor complejidad. Necesita comprender profundamente el negocio, relacionarse con distintos interlocutores y construir confianza para sostener una relación de largo plazo.",
              },
            },
          },
        },
        reportModal: {
          title: "Resultados Sales Assessment",
          noDataAvailable: "No hay datos disponibles para mostrar",
          downloadPDF: "Descargar PDF",
          close: "Cerrar",
          fileNamePrefix: "reporte-sales-assessment-",
          defaultFileName: "resultado",
          downloadWord: 'Descargar Word',
        },
        public: {
          invalidEmail: "Email inválido",
          enterEmail: "Por favor ingresa tu email",
          emailVerification: "Verificación de Email",
          emailVerificationDescription: "Ingresa tu email para acceder al test de evaluación de ventas",
          enterEmailLabel: "Ingresa tu email",
          verifying: "Verificando...",
          accessTest: "Acceder al Test",
          testTitle: "Test de Evaluación de Ventas",
          instructions: "Instrucciones:",
          instruction1: "El test consiste en una serie de afirmaciones sobre comportamientos de ventas",
          instruction2: "Para cada pregunta, se presentarán dos opciones (A y B)",
          instruction3: "Selecciona la opción que mejor te describe cuando estás vendiendo",
          instruction4: "No hay respuestas correctas o incorrectas",
          instruction5: "Responde de manera honesta y espontánea",
          starting: "Iniciando...",
          startTest: "Comenzar Test",
          testCompleted: "¡Test Completado!",
          testCompletedDescription: "Gracias por completar el test de evaluación de ventas. Tus respuestas han sido guardadas exitosamente.",
        // Cierre automatico al agotarse el cronometro
        timeUpTitle: "Se acabó el tiempo",
        timeUpMessage: "El tiempo disponible para responder el test terminó. Enviamos automáticamente las respuestas que alcanzaste a marcar, así que no necesitas hacer nada más.",
        timeUpSubmitFailedMessage: "El tiempo disponible para responder el test terminó, pero no pudimos registrar tus respuestas. Por favor contacta a la persona que te envió el test.",
          testExpiredTitle: "Test Expirado",
          testExpiredMessage: "Este test ha expirado. Por favor contacta al administrador.",
          error: "Error",
          genericError: "Ha ocurrido un error. Por favor intenta nuevamente.",
          tryAgain: "Volver a intentar",
          testNotFound: "Test no encontrado",
          accessDenied: "Acceso denegado. El email no coincide con el test",
          testExpired: "Este test ha expirado",
          emailValidationError: "Error al validar el email",
          startTestError: "Error al iniciar el test",
          invalidTestStatus: "Estado del test no válido",
          selectAnswer: "Por favor selecciona una respuesta",
          completeTestError: "Error al completar el test",
          questionProgress: "Pregunta {{current}} de {{total}}",
          optionLabel: "Opción {{option}}",
          previous: "Anterior",
          completing: "Completando...",
          completeTest: "Completar Test",
          next: "Siguiente",
          completingEvaluation: "Completando Evaluación",
          processingResponses: "Procesando tus respuestas...",
          doNotCloseWindow: "Por favor no cierres esta ventana.",
          timeRemaining: "Tiempo restante",
        },
        comparison: {
          // Setup
          selectPosition: 'Cargo de referencia',
          selectPositionDescription: 'Cargo de referencia para el análisis (opcional)',
          positionPlaceholder: 'Buscar cargo...',
          noPositionsFound: 'No se encontraron cargos',
          selectedPosition: 'Cargo seleccionado',
          noPosition: 'Sin cargo',
          evaluatedTests: 'Postulantes evaluados',
          searchApplicant: 'Buscar postulante...',
          onlyEvaluatedNotice: 'Solo se muestran assessments con estado "evaluado"',
          loadingTests: 'Cargando postulantes...',
          noEvaluatedTests: 'No hay assessments evaluados disponibles',
          selectedPersons: 'Personas seleccionadas',
          persons: 'personas',
          position: 'Cargo',
          requirements: 'Requisitos',
          requirementMinTests: 'Mínimo 2 postulantes seleccionados',
          startComparison: 'Iniciar Análisis',
          creating: 'Creando...',
          selectAtLeastTwo: 'Selecciona al menos 2 postulantes para comparar',
          evaluatedAt: 'Evaluado el',
          testsLoadError: 'Error al cargar los postulantes',
          createError: 'Error al crear la comparación',
          createdSuccess: 'Comparación creada exitosamente',

          // Resultados - tabla
          resultsTitle: 'Resultados de Comparación',
          tabCompetencies: 'Tabla de Competencias',
          tabRecommendations: 'Análisis GPT',
          competency: 'Competencia',
          legendHighest: 'Mayor puntaje',
          legendMiddle: 'Nivel medio',
          legendLowest: 'Menor puntaje',

          // Resultados - GPT
          competenciesToDevelop: 'competencias a desarrollar',
          objective: 'Objetivo de mejora',
          actions: 'Acciones recomendadas',
          noRecommendations: 'No hay recomendaciones disponibles',

          // Estados
          processing: 'Procesando análisis...',
          processingDescription: 'El análisis GPT puede tomar unos segundos. Esta pantalla se actualizará automáticamente.',
          processingError: 'Error al procesar el análisis',
          unknownError: 'Error desconocido al procesar la comparación',
          fetchError: 'Error al obtener la comparación',

          // Dashboard historial
          noComparisons: 'No hay comparaciones aún',
          noComparisonsDescription: 'Crea tu primera comparación desde la pestaña Comparaciones',
          loadError: 'Error al cargar las comparaciones',
          status: 'Estado',
          createdBy: 'Creado por',
          deleteTitle: 'Eliminar comparación',
          deleteConfirm: '¿Estás seguro de que deseas eliminar esta comparación?',

          statusCompleted: 'Completado',
          statusProcessing: 'Procesando',
          statusPending: 'Pendiente',
          statusError: 'Error',
          tabDevelopment: 'Plan de Desarrollo',
          developmentSubtitle: 'Estas son las 3 competencias con menor puntaje para cada persona, junto con recomendaciones prácticas para su desarrollo.',
        },
        usageCheck: {
          checkingLimits: "Verificando límites disponibles...",
          serviceNotAvailable: "Sales Assessment no disponible en tu plan",
          limitReached: "Límite de puntos alcanzado para Sales Assessment",
          pointsAvailable: "Puntos disponibles: {{points}}",
        },
      },
      massiveRecruitment: {
        title: "Reclutamiento Masivo",
        subTitle: "Gestiona procesos de contratación masiva de personal",
        loadError: "Error al cargar los procesos de reclutamiento",
        deleteSuccess: "Proceso eliminado exitosamente",
        deleteError: "Error al eliminar el proceso",
        deleteTitle: "Confirmar eliminación",
        deleteConfirm: "¿Estás seguro de que quieres eliminar el proceso",

        tabs: {
          list: "Mis Procesos",
          new: "Nuevo Proceso",
        },

        estados: {
          borrador: "Borrador",
          activo: "Activo",
          pausado: "Pausado",
          cerrado: "Cerrado",
          cubierto: "Cubierto",
          cancelado: "Cancelado",
        },

        list: {
          title: "Procesos de Reclutamiento Masivo",
          searchPlaceholder: "Buscar procesos...",
          newProcess: "Nuevo Proceso",
          empty: "No hay procesos de reclutamiento masivo registrados",
          noResults: "No se encontraron procesos que coincidan con la búsqueda",
          vacantes: "Contratadas / Requeridas",
          estado: "Estado",
          prioridad: "Prioridad",
          fechaInicio: "Inicio búsqueda",
          fechaCierre: "Cierre búsqueda",
        },

        form: {
          updateSuccess: "Proceso actualizado exitosamente",
          editTitle: "Editar proceso",
          applicantsHelperEdit: "Aquí puedes agregar nuevos postulantes al proceso. Los ya existentes se mantienen.",
          title: "Crear Proceso de Reclutamiento Masivo",
          createSuccess: "Proceso creado exitosamente",
          validationError: "Por favor corrige los errores antes de guardar",

          tabs: {
            general: "General",
            logistics: "Logística",
            publication: "Publicación",
            budget: "Presupuesto",
            stages: "Etapas",
            applicants: "Postulantes",
          },

          errors: {
            nombre: "El nombre del proceso es obligatorio",
            position: "Debes seleccionar un cargo",
            vacantes: "La cantidad de vacantes debe ser mayor a 0",
          },

          // Pestaña General
          nombre: "Nombre del proceso",
          nombreHelper: "Identificador interno del proceso de reclutamiento",
          nombrePlaceholder: "Ej: Proceso Operarios Planta Norte Q1 2025",
          descripcion: "Descripción del proceso",
          descripcionPlaceholder: "Describe el contexto, objetivo o particularidades de este proceso...",
          position: "Cargo a cubrir",
          vacantesRequeridas: "Vacantes requeridas",
          prioridad: "Prioridad",
          prioridades: {
            alta: "Alta",
            media: "Media",
            baja: "Baja",
          },
          estado: "Estado inicial",
          estadoHelper: "Puedes publicar el proceso como activo o dejarlo en borrador",

          // Pestaña Logística
          modalidad: "Modalidad de trabajo",
          modalidades: {
            presencial: "Presencial",
            remoto: "Remoto",
            "híbrido": "Híbrido",
          },
          ubicacion: "Ubicación",
          pais: "País",
          ciudad: "Ciudad",
          comuna: "Comuna",
          direccion: "Dirección",
          tipoContrato: "Tipo de contrato",
          tiposContrato: {
            indefinido: "Indefinido",
            plazo_fijo: "Plazo fijo",
            proyecto: "Por proyecto",
            honorarios: "Honorarios",
          },
          jornada: "Jornada",
          jornadas: {
            "full-time": "Full-time",
            "part-time": "Part-time",
            turno: "Turno",
          },
          condicionesLaborales: "Condiciones laborales",
          horario: "Horario",
          comunaLugarTrabajo: "Comuna lugar de trabajo",
          tieneAcercamiento: "Acercamiento incluido",
          tieneAlmuerzo: "Almuerzo incluido",

          // Pestaña Publicación
          aceptaExtranjeros: "Acepta postulantes extranjeros",
          canalesPublicacion: "Canales de publicación",
          canales: {
            portales_empleo: "Portales de empleo",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            referidos: "Referidos",
            whatsapp: "WhatsApp",
            otro: "Otro",
          },
          fechaInicio: "Fecha inicio búsqueda",
          fechaCierre: "Fecha cierre búsqueda",

          // Pestaña Presupuesto
          moneda: "Moneda",
          presupuestoTotal: "Presupuesto total",
          salarioPorPersona: "Salario por persona",

          // Pestaña Etapas
          stagesHelper: "Activa o desactiva las etapas del proceso según tus necesidades. El orden se mantiene fijo.",

          // Pestaña Postulantes
          applicantsHelper: "Los postulantes son opcionales al crear el proceso. Puedes agregarlos más tarde desde la vista de detalle.",
          selectApplicants: "Buscar y agregar postulantes",
          searchApplicants: "Escribe para buscar...",
          applicantsSelected: "postulante(s) seleccionado(s)",
        },

        view: {
          filtrarPorEtapa: "Filtrar por etapa",
          todasLasEtapas: "Todas las etapas",
          resultados: "resultado(s)",
          noResultadosFiltro: "No hay postulantes en esta etapa",
          pais: "País",
          etapaActual: "Etapa actual",
          cambiarEtapa: "Cambiar etapa",
          etapaUpdated: "Etapa actualizada",
          avanzar: "Avanzar",
          avanzarA: "Avanzar a",
          ultimaEtapa: "Última etapa",
          sinEtapa: "Sin etapa",
          changeStatus: "Cambiar estado",
          statusUpdated: "Estado actualizado",
          vacantes: "Vacantes contratadas",
          completado: "completado",
          postulantes: "Postulantes en proceso",
          fechas: "Fechas",
          presupuesto: "Presupuesto",
          modalidad: "Modalidad",
          etapas: "Pipeline de etapas",
          noEtapas: "No hay etapas activas configuradas",
          postulantesTitle: "Postulantes",
          searchApplicant: "Agregar postulante",
          searchApplicantPlaceholder: "Buscar por nombre o email...",
          addApplicant: "Agregar",
          applicantAdded: "Postulante agregado al proceso",
          applicantRemoved: "Postulante removido del proceso",
          noApplicants: "Aún no hay postulantes en este proceso",
          removeApplicant: "Quitar postulante",
          removeApplicantTitle: "Confirmar",
          removeApplicantConfirm: "¿Quitar a",
          removeApplicantNote: "El postulante solo se quita del proceso, no se elimina del sistema.",
          currentPosition: "Cargo actual",
        }
      },
      registerTrial: {
        header: {
          title: "Prueba Amanda HR gratis",
          subtitle: "Explora las funcionalidades más potentes con 5 puntos de bienvenida"
        },
        form: {
          title: "Crea tu cuenta de prueba",
          buttons: {
            createAccount: "Comenzar prueba gratuita"
          }
        },
        trialAccount: {
          pointsBanner: "5 puntos para usar en estos módulos:",
          title: "¿Qué incluye tu cuenta de prueba?",
          features: {
            points: "5 puntos de bienvenida para usar en los módulos disponibles",
            noRenewal: "Los puntos no se renuevan — son para explorar la plataforma",
            upgrade: "Puedes contratar un plan pago en cualquier momento"
          },
          services: {
            reasoningTest: "Test de Razonamiento",
            discTest: "Test DISC",
            psycholabor: "Evaluación Psicolaboral",
            cvFiltering: "Filtrado de CV"
          }
        },
        success: {
          message: "Cuenta de prueba creada. Inicia sesión con tus credenciales."
        }
      },
      interviews: {
        title: 'Entrevistas',
        inviteBotTitle: 'Invitar bot a una reunión',
        upload: {
          title: 'Subir transcripción/informe',
          hint: 'Acepta .txt, .pdf, .doc o .docx. Queda como entrevista completada.',
          chooseFile: 'Elegir archivo',
          dateLabel: 'Fecha de la entrevista (opcional)',
          submit: 'Subir',
          uploading: 'Subiendo...',
          success: 'Transcripción subida correctamente',
          error: 'Error al subir la transcripción',
          fileRequired: 'Selecciona un archivo',
          manualBadge: 'Subida',
        },
        meetingUrlLabel: 'URL de la reunión (Meet, Zoom, Teams)',
        meetingUrlHelper: 'El bot se unirá inmediatamente a la reunión',
        meetingUrlRequired: 'La URL de la reunión es requerida',
        inviting: 'Invitando...',
        inviteBot: 'Invitar bot',
        botInvitedSuccess: 'Bot invitado exitosamente a la reunión',
        inviteBotError: 'Error al invitar al bot',
        refresh: 'Actualizar',
        noInterviews: 'No hay entrevistas registradas para este postulante.',
        detectedParticipants: 'Participantes detectados:',
        assignRoles: 'Asignar roles',
        whoIsInterviewee: '¿Quién es el entrevistado?',
        selectIntervieweeRequired: 'Debes seleccionar al entrevistado',
        confirm: 'Confirmar',
        assignedSuccess: 'Participantes asignados exitosamente',
        assignError: 'Error al asignar participantes',
        viewTranscript: 'Ver transcripción',
        processingError: 'Error procesando la entrevista',
        viewInterviews: 'Ver entrevistas',
        modalTitle: 'Entrevistas — {{name}}',
        status: {
          pending: 'Bot en reunión',
          pendingAssignment: 'Asignar participantes',
          completed: 'Completada',
          error: 'Error',
        },
        pointsCost: 'Cada entrevista cuesta {{cost}} puntos. Tienes {{remaining}} puntos disponibles.',
        pointsCostUnlimited: 'Cada entrevista cuesta {{cost}} puntos. Tienes puntos ilimitados.',
        noPoints: 'No tienes puntos suficientes para registrar una entrevista.',
        serviceNotAvailable: 'El módulo de Entrevistas no está habilitado para tu organización. Un super-admin puede activarlo en Organizaciones → Puntos y módulos.',
      },
      branding: {
        changeLogo: "Cambiar logo",
        logoUpdated: "Logo actualizado",
        uploadError: "No se pudo subir el logo",
        invalidImage: "El archivo debe ser una imagen",
        orgLogo: "Logo de la organización",
        projectLogo: "Logo del proyecto",
      },
      erp: {
        tooltips: {
          client: {
            industry: "Actividad económica del cliente (giro tributario).",
            serviceType: "Tipo de servicio contratado: Servicios Transitorios, Outsourcing o ambos.",
            frameworkContract: "Acuerdo marco firmado entre Grafton y el cliente. Si aún no está firmado, el servicio puede iniciar igual y queda registrado como pendiente, para control.",
            usesPurchaseOrder: "El cliente exige orden de compra para aceptar y pagar facturas: la cotización y la facturación deben referenciarla.",
            allowsFactoring: "El cliente autoriza ceder sus facturas a factoring (financiamiento). Si no autoriza, condiciona el tratamiento posterior de la facturación.",
            kam: "Key Account Manager: ejecutivo a cargo de la relación comercial con el cliente.",
            businessPartner: "Business Partner responsable de la operación: gestiona el acuerdo y las cotizaciones, y valida las fichas.",
            requesterSection: "Persona del cliente que solicita el servicio en el día a día (nombre, cargo y contacto).",
            contactsSection: "A quién se envían las facturas y con quién se gestiona el pago a proveedores.",
            assessmentSection: "Verificaciones previas a operar con el cliente: DICOM, evaluación comercial interna y carpeta tributaria.",
            dicomChecked: "Se consultó el boletín comercial (DICOM) del cliente.",
            taxFolderReviewed: "Se revisó la carpeta tributaria (SII) del cliente.",
            commercialEvaluation: "Resultado o nota de la evaluación comercial interna.",
            auxiliaryRut: "RUT sin dígito verificador, derivado automáticamente. Es la llave que vincula al cliente con el sistema de remuneraciones por centro de costo.",
            reviewBp: "Deja registro (quién y cuándo) de que el Business Partner revisó que el cliente quedó correctamente creado.",
          },
          agreement: {
            margins: "Lo que Grafton cobra por el servicio. Puede diferir por tipo de servicio; el fee es porcentual (% sobre el subtotal) o fijo ($ pactado).",
            serviceType: "Modalidad de la cotización a la que aplica este margen (una vez cada una).",
            adminExpense: "Monto fijo pactado con el cliente que se suma al precio del servicio.",
            assistanceCost: "Costo adicional de asistencia, cuando el acuerdo lo contempla.",
            paymentTermDays: "Plazo de pago de las facturas, en días (ej: 30).",
            paymentDay: "Día fijo del mes en que el cliente ejecuta pagos (opcional).",
            usesPurchaseOrder: "El cliente exige orden de compra para aceptar y pagar facturas.",
            // Fase 4 del cotizador OUT/EST (2026-10-13)
            scope: "Un acuerdo de un centro de costo reemplaza al de todo el cliente en las cotizaciones de ese centro de costo (ej: margen o provisiones distintas por faena).",
            operationalExpenses: "Monto mensual que se suma a los costos de la cotización. Si no está activo, la cotización no lleva gastos operacionales.",
            marginMinimum: "Margen mínimo por cotización: si el margen calculado queda bajo este monto, se cobra el mínimo.",
            formulaProvisions: "Provisiones que calcula la cotización con los haberes del período. Por defecto, aviso previo e indemnización van en OUT (contrato indefinido) y no en EST; el reemplazo de vacaciones no va.",
            fixedProvisions: "Montos mensuales fijos que se suman a los costos (EPP, uniforme, aguinaldo, seguro…). Van completos en el mes de ingreso parcial, salvo que se marquen como proporcionales.",
          },
          costCenter: {
            code: "Código asignado por finanzas: vincula el ERP con remuneraciones y contabilidad.",
          },
          jobTitle: {
            name: "Cargo del catálogo para cotizar (nombre estándar del puesto). No es la vacante del ATS.",
          },
          parameters: {
            monthly: "UF y UTM del período: de ellas dependen los topes imponibles y los tramos del impuesto único.",
            normative: "Cambian por reajuste o modificación normativa: sueldo mínimo, tasas de salud y mutualidad, IVA.",
            legal: "Fijos por definición legal: factor de provisión de vacaciones, porcentaje y tope de gratificación.",
            period: "Formato AAAA-MM (ej: 2026-09).",
            partialMonth: "Aplica a las cotizaciones con ingreso a mitad de mes. Apagado = topes mensuales, como la planilla de remuneraciones. Enciéndelo si Talana proporciona los topes en el primer mes. Se copia al completar el período siguiente.",
          },
          causes: {
            renewable: "La causal admite renovar el contrato dentro de su límite legal de días.",
            code: "Código corto de la causal (ej: OBRA).",
          },
          quotation: {
            serviceMode: "Servicios Transitorios y Outsourcing tienen estructuras de costo distintas; el margen del acuerdo puede diferir por modalidad.",
            jobTitle: "Si el cargo no existe en el catálogo, créalo aquí mismo.",
            gratificationType: "Cómo se paga la gratificación legal: mensual (Art. 50: 25% con tope) o anual (Art. 47). Revisar antes de guardar.",
            vacationProvision: "Provisiona 1,75 días de vacaciones por mes sobre el total imponible (minuta OUT/EST). Puedes fijar un monto mensual; en un mes parcial va proporcional. Apagar solo si el servicio no provisiona.",
            mealAllowance: "Asignación no imponible de colación.",
            transportAllowance: "Asignación no imponible de movilización.",
            teleworkAllowance: "Asignación no imponible por teletrabajo (Ley 21.220): compensa gastos como internet y electricidad. Mismo tratamiento que la colación.",
            taxableBonuses: "Bonos que suman a la base imponible: afectan cotizaciones previsionales e impuesto.",
            otherAllowances: "Otras asignaciones pactadas con el cliente (habitualmente no imponibles).",
            additionalProvisions: "Provisiones extra que solicita el cliente: se suman al costo del servicio y se traspasan al precio final.",
          },
          employee: {
            visaRequired: "Trabajador extranjero: requiere visa vigente; el tipo y su vencimiento quedan en la ficha.",
            submit: "Marca la ficha como completa y la deja lista para la validación operativa.",
            validate: "El BP revisa la ficha contra los antecedentes adjuntos y completa horario, turno y condiciones de pago.",
            toContract: "Genera el contrato desde la ficha validada: causal, fechas y control de días legales.",
            hiringCause: "Cada causal tiene un límite legal de días acumulables por trabajador; el saldo aparece abajo.",
          },
          contract: {
            causeDays: "Días consumidos / límite legal de la causal, acumulando todos los contratos del trabajador en la organización.",
          },
          export: {
            reExport: "Vuelve a marcar como exportado después de revisar los cambios, cerrando el reproceso.",
          },
        },

        export: {
          menu: "Exportación",
          title: "Exportación a remuneraciones",
          subtitle: "Selecciona los contratos pendientes y envíalos a Talana: por cada uno se crea o actualiza la persona y se crea el contrato, con resultado por registro. El Excel de carga queda como respaldo (descargar y marcar a mano). Las fichas ingresadas después del corte quedan para el reproceso siguiente.",
          tabs: {
            pending: "Pendientes",
            modified: "Modificados post-export",
          },
          loadError: "Error al cargar la exportación",
          noPending: "No hay contratos pendientes de exportar",
          noModified: "No hay contratos modificados después del export",
          downloadSelected: "Descargar Excel ({{count}})",
          markSelected: "Marcar como exportados ({{count}})",
          markSuccess: "{{count}} contrato(s) marcados como exportados",
          markError: "Error al marcar los contratos",
          downloadError: "Error al generar el Excel",
          changesCount: "Cambios",
          viewChanges: "Ver cambios",
          reExport: "Re-exportar",
          changesTitle: "Cambios post-export",
          changeSource: "Origen",
          talana: {
            sendSelected: "Enviar a Talana ({{count}})",
            sendHint: "Crea o actualiza la persona y crea el contrato en Talana. Corre en segundo plano; el resultado por contrato aparece abajo.",
            markHint: "Solo para el respaldo por Excel: marca como exportado sin llamar a Talana.",
            started: "Envío iniciado: {{count}} contrato(s). El resultado aparece a medida que Talana responde.",
            startError: "No se pudo iniciar el envío a Talana",
            alreadyRunning: "Ya hay un envío a Talana en curso",
            finished: "Envío terminado: {{ok}} ok, {{failed}} con error de {{total}}",
            jobTitle: "Último envío a Talana",
            running: "En curso {{done}}/{{total}}",
            summary: "{{ok}} ok · {{failed}} con error · {{total}} en total",
            stopped: "Detenido por {{code}}",
            state: "Estado",
            detail: "Detalle",
            sentAt: "Enviado",
            sentBy: "Por",
            retry: "Reenviar",
            resend: "Reenviar a Talana",
            itemStatus: { pending: "Pendiente", running: "Enviando…", ok: "En Talana", failed: "Error", skipped: "Omitido" },
            steps: { validate: "Validando datos", jobTitle: "Asegurando cargo", persona: "Persona", contrato: "Contrato", mark: "Marcando", documents: "Documentos", done: "Listo" },
            // Documentos de la persona → Talana (PLAN_DOCUMENTOS_TALANA, 2026-10-22)
            docs: {
              title: "Documentos para Talana",
              titlePerson: "Enviar documentos a Talana — {{name}}",
              intro: "Elige qué documentos de cada persona van con su contrato. Se suben a su carpeta en Talana después del contrato; si alguno falla, el contrato igual queda enviado.",
              introDocuments: "Documentos de la persona (ficha, ATS y contrato firmado) y su estado en Talana. Los que ya están en Talana no se vuelven a enviar.",
              loading: "Cargando documentos…",
              loadError: "No se pudieron cargar los documentos",
              empty: "Esta persona no tiene documentos en Amanda",
              recordNotFound: "No se encontró la ficha de esta persona: el contrato se envía sin documentos.",
              contractsCount: "{{count}} contratos en este envío",
              source: { record: "Ficha", ats: "ATS", contract: "Contrato" },
              signedContract: "Contrato firmado",
              signedContractFrom: "Contrato firmado (inicio {{date}})",
              category: "Categoría en Talana",
              categoryRequired: "Elige o escribe una categoría",
              visible: "Visible",
              visibleHint: "Visible para el trabajador en la app y el portal de Talana («Mis documentos»)",
              notSendable: {
                format: "Talana solo acepta PDF o fotos (JPG, PNG, WebP): conviértelo a PDF y vuelve a subirlo.",
                external: "El archivo no está guardado en Amanda: no se puede enviar.",
              },
              imageNote: "Foto: se envía convertida a PDF",
              status: { queued: "En cola", sending: "Enviando…", sent: "En Talana · {{date}}", failed: "Error en Talana" },
              linkedHint: "Asociado al contrato en Talana",
              uploadType: "Tipo de documento",
              upload: "Subir documento",
              uploadHint: "Se guarda en la ficha de la persona y queda marcado para enviar",
              uploadSuccess: "Documento subido a la ficha",
              uploadError: "No se pudo subir el documento",
              sendWithDocs: "Enviar {{contracts}} contrato(s) con {{docs}} documento(s)",
              sendContracts: "Enviar {{contracts}} contrato(s)",
              sendWithoutDocs: "Enviar sin documentos",
              sendDocuments: "Enviar {{count}} documento(s) a Talana",
              sendStarted: "Enviando {{count}} documento(s) a Talana…",
              nothingToSend: "No había documentos nuevos para enviar (ya estaban en Talana o en curso)",
              someIgnored: "{{count}} documento(s) no se enviaron: ya estaban en Talana, en curso o no se pueden enviar",
              notInTalana: "La persona aún no está en Talana: envía primero su contrato desde Exportación",
              alreadyRunning: "Ya hay un envío de documentos en curso para esta persona",
              invalid: "Revisa las categorías de los documentos marcados",
              sendError: "No se pudieron enviar los documentos",
              close: "Cerrar",
              started: "Envío iniciado: {{count}} contrato(s) con {{docs}} documento(s). El resultado aparece a medida que Talana responde.",
              finished: "Documentos: {{sent}} enviados, {{failed}} con error.",
              summary: "Documentos: {{sent}} enviados · {{failed}} con error · {{skipped}} omitidos",
              progress: "Documentos {{done}}/{{total}}…",
              pendingCount: "{{count}} documento(s) por enviar",
              retry: "Reintentar documentos",
            },
          },
        },
        traceability: {
          title: "Trazabilidad por trabajador",
          subtitle: "Busca por RUT y recorre la cadena completa: cliente → cotización → ficha → contrato (en ambos sentidos, con links directos).",
          placeholder: "RUT del trabajador (ej: 12345678-9)",
          search: "Buscar",
          empty: "Sin contratos para este RUT en la organización",
          error: "Error al buscar la trazabilidad",
        },

        employees: {
          title: "Fichas",
          new: "Nueva ficha",
          createTitle: "Crear ficha de colaborador",
          createSubtitle: "La ficha cuelga de una cotización (spec 3.5). Los documentos se adjuntan después, en el detalle.",
          searchPlaceholder: "Buscar por nombre o RUT...",
          loadError: "Error al cargar las fichas",
          empty: "No hay fichas en este estado",
          noQuotations: "No hay cotizaciones disponibles: crea una cotización antes de crear fichas.",
          createSuccess: "Ficha creada correctamente",
          saveSuccess: "Ficha guardada",
          saveError: "Error al guardar la ficha",
          submitSuccess: "Ficha enviada a validación",
          validateSuccess: "Ficha validada",
          deleteRecord: "Eliminar ficha",
          deleteConfirmTitle: "Eliminar ficha",
          deleteConfirmText: "La ficha y sus documentos adjuntos se eliminarán definitivamente. Esta acción no se puede deshacer.",
          deleteSuccess: "Ficha eliminada",
          deleteError: "No se pudo eliminar la ficha",
          deleteHasContract: "La ficha tiene un contrato asociado y no puede eliminarse.",
          recordIncomplete: "Faltan campos requeridos para validar la ficha — revisa el checklist.",
          rutInProgressConfirm: "Ya existe una ficha en curso para este RUT ({{name}}) en otra cotización. Recontratar es válido — el control de causales suma los días por RUT. ¿Crear la ficha igual?",
          rutInProgressTitle: "RUT con ficha en curso",
          rutInProgressCreate: "Crear igual",
          rutDuplicateQuotation: "Ya existe una ficha en curso con este RUT para esta misma cotización ({{name}}). Usa esa ficha en vez de crear otra.",
          sourceAts: "Desde ATS",
          sourceManual: "Manual",
          tabs: { all: "Todas" },
          status: {
            draft: "Borrador",
            submitted: "Por validar",
            validated: "Validada",
            contracted: "Contratada",
          },
          table: {
            name: "Nombre",
            rut: "RUT",
            source: "Origen",
          },
          form: {
            quotation: "Cotización",
            sectionPersonal: "Datos personales",
            sectionVisa: "Visa",
            sectionEmployment: "Condiciones operativas",
            names: "Nombres",
            firstLastName: "Apellido paterno",
            secondLastName: "Apellido materno",
            rut: "RUT",
            rutHelper: "Requerido para el control de causales del contrato.",
            birthDate: "Fecha de nacimiento",
            country: "País",
            address: "Dirección",
            phone: "Teléfono",
            email: "Correo",
            gender: "Sexo",
            genderOptions: { male: "Masculino", female: "Femenino", other: "Otro" },
            maritalStatus: "Estado civil",
            maritalOptions: { single: "Soltero(a)", married: "Casado(a)", civil_union: "Conviviente civil", divorced: "Divorciado(a)", widowed: "Viudo(a)" },
            street: "Calle",
            streetNumber: "Número",
            apartment: "Depto.",
            commune: "Comuna",
            city: "Ciudad",
            sectionPrevision: "Previsión",
            pensionFund: "AFP",
            healthSystem: "Sistema de salud",
            healthOptions: { fonasa: "Fonasa", isapre: "Isapre", none: "Sin previsión" },
            healthProvider: "Salud (Fonasa / Isapre)",
            countryHelper: "Nacionalidad según catálogo de países de Talana",
            cityFilteredHint: "Solo ciudades de la misma región que la comuna",
            healthPlanValue: "Valor del plan",
            healthPlanUnit: "Unidad",
            healthPlanHelper: "Si supera el 7% legal, el exceso se descuenta del líquido.",
            isPensioner: "Es pensionado(a)",
            sectionPayment: "Datos de pago",
            paymentMethod: "Forma de pago",
            paymentMethods: { deposit: "Depósito en cuenta", vale_vista: "Vale vista", check: "Cheque", cash: "Efectivo" },
            bank: "Banco",
            accountType: "Tipo de cuenta",
            accountTypes: { corriente: "Cuenta corriente", vista: "Cuenta vista", rut: "Cuenta RUT", ahorro: "Cuenta de ahorro" },
            accountNumber: "Número de cuenta",
            visaRequired: "Requiere visa",
            visaType: "Tipo de visa",
            visaExpiresAt: "Vigencia de la visa",
          },
          employment: {
            startDate: "Fecha de ingreso",
            endDate: "Fecha de término",
            schedule: "Jornada (Talana)",
            scheduleHelper: "Jornada según catálogo de Talana",
            shift: "Horario / turnos (texto)",
            shiftHelper: "Distribución de la jornada tal como va en el contrato (Mi DT). Texto libre.",
            paymentConditions: "Condiciones de pago",
            contractType: "Tipo de contrato (Talana)",
            contractTypes: { fixed_term: "Plazo fijo", indefinite: "Indefinido", work_or_task: "Por obra o faena" },
            jobFunctions: "Funciones del cargo",
            workDays: "Días de jornada",
            weeklyHours: "Horas semanales",
            mealBreakMinutes: "Minutos de colación",
            mealBreakMinutesHelper: "Descanso de la jornada (contrato)",
            workplaceAddress: "Dirección lugar de trabajo",
            workplaceCommune: "Comuna lugar de trabajo",
            workplaceCity: "Ciudad lugar de trabajo",
            branch: "Sucursal (Talana)",
            branchHelper: "Sucursal según Talana (lugar donde presta servicios); escribe para buscar. Obligatoria para enviar a Talana.",
          },
          actions: {
            submit: "Enviar a validación",
            validate: "Validar ficha",
            toContract: "Pasar a contrato",
          },
          validateDialog: {
            title: "Validar ficha",
            subtitle: "Revisa que la información coincida con los antecedentes y completa las condiciones operativas (spec 3.6).",
            checklistSubtitle: "Requisitos para validar — los datos se completan en la ficha; aquí solo se revisa que esté todo.",
            missingHint: "Completa los campos marcados en rojo en la ficha y vuelve a intentarlo.",
            saveNote: "Al validar se guardan primero los cambios pendientes de la ficha.",
          },
          postExport: {
            title: "Ficha ya exportada",
            message: "Esta ficha ya fue exportada a remuneraciones: el cambio NO se propaga automáticamente y quedará registrado para el reproceso. ¿Continuar?",
            confirm: "Guardar igualmente",
          },
          docs: {
            title: "Documentos adjuntos",
            upload: "Subir documento",
            type: "Tipo de documento",
            empty: "Sin documentos adjuntos (cédula, certificados AFP/salud, visa...)",
            uploadSuccess: "Documento subido",
            uploadError: "Error al subir el documento",
            // Documentos en Talana (PLAN_DOCUMENTOS_TALANA §4.3, 2026-10-22)
            talana: {
              send: "Enviar pendientes a Talana",
              sendHint: "Envía a la carpeta de la persona en Talana los documentos que aún no están allá (ficha, ATS y contrato firmado)",
              alsoSend: "Enviar también a Talana",
              category: "Categoría en Talana",
              visible: "Visible para el trabajador",
              notSentChip: "No enviado",
              sending: "Enviando el documento a Talana…",
              notSent: "El documento quedó en la ficha, pero no se pudo enviar a Talana: usa «Enviar a Talana»",
              deleteKeepsTalana: "Eliminar de Amanda (en Talana el documento se mantiene)",
            },
            types: {
              id_card: "Cédula de identidad",
              pension_certificate: "Certificado AFP",
              health_certificate: "Certificado de salud",
              visa: "Visa",
              other: "Otro",
            },
          },
        },
        contracts: {
          title: "Contratos",
          subtitle: "El contrato se crea desde una ficha validada. Su identificador es la llave compartida con el sistema de remuneraciones.",
          createTitle: "Crear contrato",
          create: "Crear contrato",
          createSuccess: "Contrato creado correctamente",
          createdWithSub: "Contrato creado con la subcotización {{number}}",
          deleteContract: "Eliminar contrato",
          deleteConfirmText: "Solo puede eliminarse un contrato pendiente de exportar. Al eliminarlo, la ficha vuelve a Validada y la cotización deja de estar En uso si no tiene otros contratos. Esta acción no se puede deshacer.",
          deleteSuccess: "Contrato eliminado — la ficha volvió a Validada",
          deleteError: "No se pudo eliminar el contrato",
          deleteExported: "El contrato ya fue exportado a remuneraciones y no puede eliminarse.",
          deleteHasSignature: "El contrato está enviado a firma en Izydocs. Anula el envío antes de eliminarlo.",
          deleteSigned: "El contrato ya está firmado en Izydocs y no puede eliminarse.",
          saveError: "Error al guardar el contrato",
          loadError: "Error al cargar los contratos",
          empty: "Aún no hay contratos",
          noCauses: "No hay causales en el catálogo: créalas en Configuración ERP → Causales.",
          searchPlaceholder: "Buscar por trabajador, RUT o cliente...",
          table: {
            worker: "Trabajador",
            rut: "RUT",
            client: "Cliente",
            cause: "Causal",
            dates: "Vigencia",
            causeDays: "Días causal",
            exportStatus: "Export",
          },
          exportStatus: {
            pending: "Pendiente de exportar",
            exported: "Exportado",
            modified_after_export: "Modificado post-export",
          },
          openEnded: "indefinido",
          talana: {
            exported: "En Talana",
            failed: "Error Talana",
            tipExported: "Enviado a Talana ({{env}}): persona {{persona}} · contrato {{contrato}} · {{at}}",
            tipFailed: "El último envío a Talana falló en {{step}}: {{error}}. Se puede reenviar desde Exportación.",
            tipNone: "Aún no se ha enviado a Talana. Se envía desde Exportación → Enviar a Talana.",
          },
          form: {
            hiringCause: "Causal de contratación",
            contractTypeFromRecord: "Tipo de contrato según la ficha",
            contractTypeUnknown: "sin definir",
            indefiniteHint: "sin fecha de término ni causal EST",
            quotation: "Cotización de esta persona",
            quotationOption: "{{number}} · ingreso {{date}}",
            quotationUsed: "{{number}} · ya tiene contrato",
            quotationUsedBy: "{{number}} · contrato de {{person}}",
            quotationArchived: "{{number}} · archivada",
            quotationNew: "Nueva subcotización ({{number}}-N) con esta fecha de ingreso",
            quotationHint: "Si el contrato empieza en otra fecha, la cotización elegida pasa a esa fecha de ingreso y se recalcula su proporcional.",
            quotationNewHint: "Se crea una subcotización con la estructura de la cotización madre y la fecha de inicio del contrato. Su número viaja a Talana.",
            quotationLoadError: "No se pudieron cargar las cotizaciones de este cargo. Reintenta: sin elegir la cotización de la persona no se puede crear el contrato.",
            quotationRetry: "Reintentar",
            quotationLoading: "Cargando las cotizaciones del cargo…",
            quotationRequired: "Elige la cotización de esta persona para crear el contrato.",
            quotationTaken: "Esa cotización ya tiene contrato: elige otra o crea una subcotización.",
            quotationArchivedError: "La cotización elegida (o su madre) está archivada: reábrela o elige otra.",
            belowMinimum: "No se creó el contrato. {{reason}} Corrige el sueldo de la cotización (o elige otra fecha de ingreso).",
          },
          balance: {
            summary: "Días consumidos en esta causal: {{consumed}} de {{limit}} (saldo: {{available}})",
            warning: "El trabajador agota o excede los días legales de esta causal",
            consumed: "Días consumidos",
            limit: "Límite legal",
            available: "Saldo disponible",
            renewals: "Contratos previos (renovaciones)",
          },
          detail: {
            payrollKey: "Llave remuneraciones (uid)",
            causeTitle: "Control de causal",
            chainTitle: "Cadena trazable",
            chainNote: "Cliente → cotización → ficha → contrato. El uid del contrato identifica al trabajador en remuneraciones.",
            changeLogTitle: "Cambios post-export",
          },
          changeLog: {
            field: "Campo",
            oldValue: "Valor anterior",
            newValue: "Valor nuevo",
            changedAt: "Fecha",
          },
          // Contrato tipo en PDF (PLAN_ERP.md §15, fase B1, 2026-10-19)
          document: {
            title: "Documento del contrato",
            template: "Contrato tipo: {{name}}",
            download: "Ver contrato (PDF)",
            downloadHint: "Contrato con los datos de la ficha, la cotización y el contrato",
            noTemplate: "No hay un contrato tipo activo para {{mode}} · {{kind}}. Súbelo en Configuración ERP → Plantillas Word (PDF de Amanda).",
            missing: "Faltan datos que usa el contrato tipo: {{list}}. Complétalos en la ficha o en la cotización.",
            error: "No se pudo generar el contrato",
            stale: "La cotización se simuló desde el líquido con la versión anterior y el sueldo base quedó inflado. Vuelve a simular la cotización antes de emitir el contrato.",
            checkError: "No se pudo revisar el contrato tipo",
            unknownMode: "sin modalidad",
            unknownKind: "sin tipo de contrato",
          },
          // Firma con Izydocs (PLAN_ERP.md §15.4, fase B2, 2026-10-20)
          signature: {
            title: "Firma con Izydocs",
            send: "Enviar a firma",
            sendHint: "Crea el contrato en Izydocs desde el formato tipo y lo deja para firma",
            refresh: "Actualizar estado",
            cancel: "Anular envío",
            download: "Descargar firmado",
            format: "Formato: {{id}} · {{name}}",
            internalDocument: "N° interno: {{number}}",
            sentAt: "Enviado: {{date}}",
            lastCheckedAt: "Última consulta: {{date}}",
            providerStatus: "En Izydocs: {{status}}",
            completedAt: "Firmado: {{date}}",
            cancelledAt: "Anulado: {{date}}",
            notSent: "El contrato aún no se ha enviado a firma.",
            statuses: {
              sending: "Enviando",
              sent: "Pendiente de firma",
              signed_by_worker: "Firmado por la persona",
              completed: "Firmado",
              cancelled: "Anulado",
              failed: "Error al enviar",
            },
            failed: "Izydocs rechazó el envío: {{message}}",
            failedNotFound: "Izydocs no tiene este envío: el contrato no se creó. Puedes volver a enviarlo.",
            // Modo prueba, solo super-admin (2026-10-22)
            testMode: {
              label: "Modo prueba (solo super-admin)",
              hint: "Permite enviar aunque falten los datos del perfil en Izydocs. El envío es real.",
              dialogWarning: "Modo prueba: el envío es real. El contrato le llegará a {{name}} y al Business Partner en Izydocs. La nacionalidad, la fecha de nacimiento y la dirección saldrán en blanco si la persona no las tiene en su perfil de Izydocs.",
              chip: "Prueba",
              sent: "Contrato enviado a firma en modo prueba",
            },
            sendingHint: "El envío quedó a medias. Usa \"Actualizar estado\" para saber si llegó a Izydocs.",
            inProgressHint: "El envío está en curso. Espera unos minutos para consultar o anular.",
            dataChanged: "Estos datos cambiaron desde el envío: {{list}}. El contrato en Izydocs tiene los anteriores; si corresponde, anula el envío y vuelve a enviarlo.",
            dataChangedSigned: "Estos datos cambiaron después de la firma: {{list}}. El contrato firmado tiene los anteriores.",
            reasons: {
              notConfigured: "Izydocs no está configurado en el servidor (IZYDOCS_BASE_URL e IZYDOCS_API_KEY).",
              notWired: "La conexión con Izydocs está pendiente: falta {{list}}.",
              formatNotAvailable: "Por ahora la firma con Izydocs es solo para contratos EST.",
              stale: "La cotización se simuló desde el líquido con la versión anterior y el sueldo base quedó inflado. Vuelve a simular la cotización antes de enviar el contrato.",
              gratification: "El contrato de Izydocs trae escrita la gratificación legal mensual y esta cotización tiene otro tipo de gratificación.",
              missing: "Faltan datos para el contrato de Izydocs: {{list}}.",
              checkError: "No se pudo revisar si el contrato se puede enviar a firma.",
            },
            operations: {
              enrollment: "enrolar a la persona",
              status: "consultar el estado",
              cancellation: "anular el envío",
              profile: "cargar en el perfil de Izydocs los datos personales (nacionalidad, fecha de nacimiento y dirección)",
            },
            dialog: {
              title: "Enviar contrato a firma",
              intro: "Se creará el contrato en Izydocs con el formato {{id}} · {{name}} y estos datos:",
              person: "Persona: {{name}} · {{rut}} · {{email}}",
              personNote: "Izydocs completa el nombre, el RUT, la dirección y los demás datos personales desde la ficha.",
              tag: "Dato",
              value: "Valor",
              confirm: "Enviar",
              cancel: "Cancelar",
            },
            cancelDialog: {
              title: "Anular envío",
              body: "Se anulará el contrato en Izydocs. Después podrás volver a enviarlo.",
              confirm: "Anular",
              back: "Volver",
            },
            sent: "Contrato enviado a firma",
            refreshed: "Estado actualizado: {{status}}",
            cancelled: "Envío anulado",
            errors: {
              alreadySent: "El contrato ya tiene un envío activo.",
              notOpen: "El contrato no tiene un envío abierto.",
              inProgress: "El envío está en curso. Intenta de nuevo en unos minutos.",
              changed: "El envío cambió mientras se procesaba (otra acción u otro usuario). Revisa el estado actualizado.",
              uncertain: "Izydocs no confirmó el envío a tiempo y el contrato pudo haberse creado. Usa \"Actualizar estado\" en unos minutos antes de volver a enviarlo.",
              loadNotFound: "Izydocs no encuentra este envío. Revisa en Izydocs si se anuló o se eliminó.",
              testModeForbidden: "Solo un super-admin puede enviar en modo prueba.",
              izydocs: "Izydocs respondió con un error: {{message}}",
              fileNotAvailable: "El contrato firmado aún no está disponible.",
              fileNotSaved: "No se pudo guardar el contrato firmado. Intenta de nuevo.",
              generic: "No se pudo completar la acción",
            },
          },
          // Término del contrato y aviso de vencimiento (PLAN_ERP.md §15, 2026-10-19)
          termination: {
            title: "Término de contrato",
            column: "Término",
            activeOpenEnded: "Contrato vigente, sin fecha de vencimiento (indefinido).",
            endsOn: "Contrato vigente · vence el {{date}} (en {{count}} días).",
            endsOn_one: "Contrato vigente · vence el {{date}} (en {{count}} día).",
            endsToday: "Contrato vigente · vence hoy ({{date}}).",
            expiredWithoutTermination: "El contrato venció el {{date}} y no tiene término registrado.",
            register: "Registrar término",
            edit: "Editar término",
            remove: "Deshacer término",
            removeConfirm: "Se quita el término registrado y el contrato vuelve a quedar vigente. Un aviso ya impreso o entregado no se anula.",
            removeSuccess: "Término deshecho: el contrato vuelve a quedar vigente",
            removeError: "No se pudo deshacer el término",
            saveSuccess: "Término guardado",
            saveError: "No se pudo guardar el término",
            loadCausesError: "No se pudieron cargar las causales de término",
            cause: "Causal",
            terminationDate: "Fecha de término",
            letterDate: "Fecha de la carta",
            letterDateHelper: "Por defecto, la fecha de término",
            settlementAvailableFrom: "Finiquito disponible desde",
            settlementHelper: "Por defecto, {{days}} días corridos después del término (el finiquito va dentro de 10 días hábiles)",
            zeroPayment: "Finiquito sin pago ($0): usa la carta EST de finiquito $0",
            zeroPaymentShort: "Finiquito $0",
            yes: "Sí",
            notes: "Notas",
            registeredAt: "Registrado el {{date}}",
            updatedAt: "modificado el {{date}}",
            dateDiffersFromEnd: "El contrato vence el {{date}}: revisa la fecha de término.",
            downloadNotice: "Descargar aviso",
            downloadNoticeHint: "Aviso de vencimiento de plazo para imprimir y entregar a la persona",
            downloadNotices: "Descargar avisos ({{count}})",
            tooManyNotices: "Máximo {{max}} avisos por PDF: deja menos seleccionados.",
            noticeError: "No se pudo generar el aviso",
            noticeMissing: "Faltan datos para el aviso: {{reasons}}.",
            noticeMissingTitle: "Faltan datos para algunos avisos",
            noticeMissingIntro: "Estos contratos no tienen los datos que pide la carta. Complétalos en la ficha o en la cotización:",
            noticeDownloadReady: "Descargar los {{count}} completos",
            noticeDownloadReady_one: "Descargar el completo",
            selectForNotice: "Seleccionar para descargar su aviso",
            selectAllNotices: "Seleccionar los contratos con aviso de vencimiento (159-4)",
            chipExpired: "Vencido sin término",
            chipExpiresToday: "Vence hoy",
            chipExpiresIn: "Vence en {{count}} días",
            chipExpiresIn_one: "Vence mañana",
            filter: {
              label: "Vigencia",
              all: "Todos",
              expiring7: "Vencen en 7 días",
              expiring15: "Vencen en 15 días",
              expiring30: "Vencen en 30 días",
              expired: "Vencidos sin término",
              terminated: "Terminados",
            },
            missing: {
              termination: "no tiene término registrado",
              expirationCause: "su causal no es 159-4 (vencimiento del plazo)",
              workerName: "faltan los nombres o el apellido paterno en la ficha",
              workerRut: "falta el RUT",
              address: "falta la dirección (calle y número) en la ficha",
              commune: "falta la comuna en la ficha",
              legalEntity: "la cotización no tiene razón social (empleador)",
              serviceMode: "la cotización no tiene modalidad (EST / OUT)",
              contractStartDate: "el contrato no tiene fecha de inicio",
              contract: "no se encontró el contrato",
            },
            errors: {
              TERMINATION_CAUSE_NOT_FOUND: "La causal elegida no está en el catálogo.",
              EXPIRATION_REQUIRES_END_DATE: "Vencimiento del plazo (159-4) solo aplica a contratos con fecha de término.",
              TERMINATION_BEFORE_START: "La fecha de término es anterior al inicio del contrato.",
              LETTER_BEFORE_START: "La fecha de la carta es anterior al inicio del contrato.",
              SETTLEMENT_BEFORE_TERMINATION: "El finiquito no puede quedar disponible antes de la fecha de término.",
              ZERO_PAYMENT_NOT_APPLICABLE: "El finiquito de $0 solo aplica al aviso 159-4 de contratos EST.",
            },
          },
        },
        hiringCauses: {
          title: "Causales de contratación",
          subtitle: "Catálogo con límites legales de días por causal.",
          add: "Agregar causal",
          edit: "Editar causal",
          empty: "Aún no hay causales. El contrato requiere al menos una.",
          loadError: "Error al cargar las causales",
          saveSuccess: "Causal guardada",
          saveError: "Error al guardar la causal",
          duplicateCode: "Ya existe una causal con este código",
          table: {
            code: "Código",
            name: "Nombre",
            maxDays: "Días máx.",
            renewable: "Renovable",
          },
          form: {
            code: "Código",
            name: "Nombre de la causal",
            maxDays: "Límite legal de días",
            maxDaysHelper: "Vacío = sin límite parametrizado",
            renewable: "Admite renovación",
          },
        },
        atsBridge: {
          button: "Crear ficha ERP",
          create: "Crear ficha",
          pickQuotation: "Elige la cotización de la que colgará la ficha del colaborador:",
          created: "Ficha ERP creada con los datos del candidato",
          done: "Ficha ERP creada",
          alreadyLinked: "Esta contratación ya tiene una ficha ERP",
          error: "Error al crear la ficha ERP",
          loadError: "Error al cargar las cotizaciones",
          noQuotations: "No hay cotizaciones disponibles en el modo ERP",
        },

        quotations: {
          title: "Cotizaciones",
          new: "Nueva cotización",
          createTitle: "Crear cotización",
          editTitle: "Editar cotización {{number}}",
          searchPlaceholder: "Buscar por cliente, cargo o centro de costo...",
          loadError: "Error al cargar las cotizaciones",
          empty: "Aún no hay cotizaciones",
          allStatuses: "Todos los estados",
          table: {
            number: "N°",
            client: "Cliente",
            costCenter: "Centro de costo",
            jobTitle: "Cargo",
            serviceMode: "Modalidad",
            period: "Período",
            targetNet: "Líquido objetivo",
          },
          status: {
            draft: "Borrador",
            quoted: "Cotizada",
            in_use: "En uso",
            archived: "Archivada",
          },
          serviceMode: {
            temporary_services: "Servicios Transitorios",
            outsourcing: "Outsourcing",
          },
          steps: {
            step1: "Cliente y modalidad",
            step2: "Cargo y fechas",
            step3: "Estructura de renta",
            step4: "Simulación",
            step5: "Resumen",
          },
          form: {
            serviceMode: "Modalidad",
            legalEntity: "Razón social",
            legalEntityHelper: "Empleador del contrato en Talana; se sugiere según la modalidad",
            client: "Cliente",
            costCenter: "Centro de costo",
            noCostCenters: "Este cliente no tiene centros de costo activos",
            jobTitle: "Cargo",
            newJobTitle: "Crear cargo",
            startDate: "Fecha de inicio",
            endDate: "Fecha de término",
            endDateHint: "Como máximo, hasta fin de ese mes",
            entryDate: "Fecha de ingreso",
            entryDateHint: "Se calcula el mes completo (contrato) y el período; el mes de ingreso y el de término, proporcionales si no son completos",
            periodUntil: "Período hasta",
            periodUntilHint: "Por defecto, fin del mes de ingreso; puede abarcar varios meses",
            baseSalary: "Sueldo base",
            gratificationType: "Tipo de gratificación",
            vacationProvision: "Provisionar vacaciones",
            vacationProvisionAmount: "Monto mensual de vacaciones (opcional)",
            vacationProvisionAmountHint: "Vacío = automático: imponible / 30 × 1,75",
            mealAllowance: "Asignación de colación",
            transportAllowance: "Asignación de movilización",
            teleworkAllowance: "Asignación de teletrabajo",
            taxableBonuses: "Bonos imponibles",
            otherAllowances: "Otras asignaciones",
            additionalProvisions: "Provisiones adicionales",
            targetNetSalary: "Renta líquida objetivo",
            targetNetHelper: "La calculadora inversa ajusta el bruto hasta llegar exactamente a este líquido",
            calcModeBase: "Cotizar desde el sueldo base",
            calcModeTarget: "Cotizar desde la renta líquida objetivo",
            calcModeTargetHint: "Es la renta líquida MENSUAL: el motor calcula el sueldo base mensual que la produce. En un período parcial, ambos se proporcionan a los días.",
            itemName: "Nombre",
            itemAmount: "Monto",
            addItem: "Agregar",
          },
          gratification: {
            legal_monthly: "Legal mensual (Art. 50)",
            legal_annual: "Legal anual (Art. 47)",
            none: "Sin gratificación",
          },
          inheritance: {
            label: "Condiciones comerciales",
            manualShort: "Ingresadas manualmente",
          },
          // Condiciones comerciales editables en la cotización (fase 4 del cotizador OUT/EST, 2026-10-13)
          conditions: {
            title: "Condiciones comerciales",
            loading: "Consultando el acuerdo comercial…",
            fromCostCenter: "Heredadas del acuerdo del centro de costo {{costCenter}}. Puedes cambiarlas solo para esta cotización: lo cambiado queda marcado.",
            fromClient: "Heredadas del acuerdo de todo el cliente (el centro de costo no tiene acuerdo propio). Puedes cambiarlas solo para esta cotización: lo cambiado queda marcado.",
            manual: "Ni el cliente ni el centro de costo tienen acuerdo comercial: ingresa las condiciones; quedan registradas en la cotización.",
            keep: "Se mantienen las condiciones de la cotización y puedes cambiarlas. Si cambias la modalidad o el centro de costo, se vuelven a heredar del acuerdo vigente.",
            keepError: "No se pudo consultar el acuerdo comercial: se mantienen las condiciones de la cotización.",
            modified: "Modificado",
            modifiedCount: "{{count}} cambiada(s) respecto del acuerdo",
            reset: "Deshacer cambios",
            margin: "Margen",
            marginMinimum: "Margen mínimo ($)",
            marginMinimumHint: "Vacío = el de Configuración → Parámetros",
            operationalExpenses: "Gastos operacionales",
            operationalExpensesAmount: "Monto gastos operacionales",
            provisionsTitle: "Provisiones calculadas",
            formula: {
              notice: "Aviso previo",
              severance: "Indemnización por años de servicio",
              vacationReplacement: "Reemplazo de vacaciones",
            },
            formulaHint: {
              notice: "Total haberes del período / 12",
              severance: "Total haberes del período / 12",
              vacationReplacement: "(Total haberes + aportes del empleador) / 30 × 21 / 12",
            },
            fixedTitle: "Provisiones de monto fijo",
            fixedName: "Provisión",
            fixedAmount: "Monto mensual",
            fixedProrated: "Proporcional",
            fixedAdd: "Agregar provisión",
            fixedRemove: "Quitar provisión",
            summaryKeep: "Las de la cotización",
            summaryCostCenter: "Heredadas del acuerdo del centro de costo",
            summaryClient: "Heredadas del acuerdo del cliente",
            fromParametersHint: "Cotización anterior: vacío = el de Parámetros. Escribe un monto o apágalo para cambiarlo.",
            invalidAmount: "Monto no válido: usa solo números (ej: 12,5 o 5.000)",
            missingAmount: "Falta el monto",
          },
          simulate: "Simular",
          simulationOk: "Simulación calculada",
          simulationError: "Error al simular",
          simulationHint: "La simulación calcula la estructura completa: haberes, descuentos legales, líquido, costos de empresa, margen, IVA y total factura.",
          engineNotReady: "Motor de cálculo pendiente de parametrización (planilla de remuneraciones). La cotización puede guardarse igual y simularse cuando el motor esté disponible.",
          summary: {
            title: "Resumen de la cotización",
            note: "Al guardar, la cotización queda en estado Cotizada con las condiciones comerciales congeladas (los cambios futuros del acuerdo no la afectan).",
          },
          back: "Atrás",
          next: "Siguiente",
          saveQuotation: "Guardar cotización",
          createSuccess: "Cotización creada correctamente",
          saveError: "Error al guardar la cotización",
          duplicate: "Duplicar",
          duplicateTitle: "Duplicar cotización",
          duplicateHint: "La copia conserva cliente, cargo, estructura y condiciones; solo cambian las fechas (trabajador con distinta fecha de ingreso). El período puede abarcar varios meses.",
          periodInvalid: "El término no puede ser anterior a la fecha de ingreso.",
          duplicateSuccess: "Cotización duplicada",
          duplicateNoSimulation: "Cotización duplicada sin simular. {{reason}} Edítala para subir el sueldo.",
          duplicatedFrom: "Duplicada de",
          archive: "Archivar",
          unarchive: "Reabrir",
          document: "Documento",
          documentNeedsSimulation: "Simula la cotización antes de generar el documento",
          documentError: "No se pudo generar el documento de cotización",
          excel: "Excel",
          excelNeedsSimulation: "Simula la cotización antes de descargar el Excel",
          excelError: "No se pudo generar el Excel de la cotización",
          edit: "Editar",
          updateSuccess: "Cotización actualizada y simulada de nuevo",
          editNote: "Al guardar se sobrescribe la cotización (lo que se envió al cliente) y se vuelve a simular.",
          editClientLocked: "El cliente no se cambia al editar: para otro cliente, crea una cotización nueva.",
          agreementLoadError: "No se pudo cargar el acuerdo comercial del cliente. Recarga la página para reintentar.",
          editSubsWarning: "Subcotizaciones asociadas: {{count}}. No se actualizan automáticamente: después de guardar, usa \"Actualizar desde la madre\" en el detalle.",
          editSubHint: "En una subcotización solo cambia la fecha de ingreso; la estructura se edita en la cotización madre.",
          editBlocked: {
            contract: "No se puede editar: tiene un contrato asociado ({{person}}). Para cambiar las condiciones, duplícala.",
            contractNoName: "No se puede editar: tiene un contrato asociado. Para cambiar las condiciones, duplícala.",
            archived: "No se puede editar: está archivada. Reábrela primero.",
          },
          goToDetail: "Ir al detalle",
          family: {
            title: "Personas del cargo",
            hint: "Si entra más de una persona en este cargo, agrega una subcotización por persona ({{number}}-1, -2…) con su fecha de ingreso. La primera persona usa esta cotización.",
            add: "Agregar persona",
            addTitle: "Agregar persona",
            addHint: "Se crea una subcotización ({{number}}-N) con la estructura y las condiciones de la cotización madre y la fecha de ingreso que indiques. Su número viaja al contrato y a Talana.",
            addSuccess: "Subcotización {{number}} creada",
            addError: "No se pudo crear la subcotización",
            addBelowMinimum: "No se creó la subcotización. {{reason}} Sube el sueldo en la cotización madre (o duplícala si ya tiene contrato).",
            parentArchived: "La cotización madre está archivada: reábrela primero.",
            number: "N°",
            entryDate: "Ingreso",
            contract: "Contrato",
            noContract: "Sin contrato",
            withContract: "Con contrato",
            current: "esta",
            parent: "Madre",
            subOf: "Subcotización de {{number}}",
            outdated: "Desactualizada",
            outdatedTooltip: "La cotización madre cambió después de la última actualización de esta subcotización.",
            outdatedAlert: "La cotización madre cambió y {{count}} subcotización(es) sin contrato quedaron desactualizadas. No se actualizan solas: usa \"Actualizar desde la madre\".",
            sync: "Actualizar desde la madre",
            syncAll: "Actualizar todas desde la madre",
            syncSuccess: "Actualizadas desde la madre: {{list}}",
            syncNone: "No había subcotizaciones por actualizar",
            syncBelowMinimum: "No se actualizaron {{list}}: con la estructura de la madre, el sueldo base queda bajo el ingreso mínimo de su mes de ingreso. Actualizadas: {{count}}.",
            syncError: "No se pudo actualizar desde la madre",
            syncAllBlocked: "No hay subcotizaciones sin contrato desactualizadas.",
            syncBlocked: {
              contract: "No se puede actualizar: tiene un contrato asociado ({{person}}).",
              contractNoName: "No se puede actualizar: tiene un contrato asociado.",
              archived: "No se puede actualizar: está archivada.",
              upToDate: "Ya está igual a la cotización madre.",
            },
            loadError: "No se pudieron cargar las subcotizaciones de esta cotización.",
          },
          entryDialog: {
            title: "Cambiar fecha de ingreso",
            hint: "La estructura y las condiciones vienen de la cotización madre; aquí solo cambia la fecha de ingreso. Al guardar se vuelve a simular.",
            success: "Fecha de ingreso actualizada",
            belowMinimum: "No se cambió la fecha de ingreso. {{reason}} Sube el sueldo en la cotización madre.",
          },
          list: {
            showSubs: "Ver subcotizaciones ({{count}})",
            hideSubs: "Ocultar subcotizaciones",
          },
          detail: {
            salaryTitle: "Estructura de renta",
            snapshotTitle: "Condiciones comerciales (congeladas)",
            snapshotNote: "Copiadas del acuerdo comercial al cotizar, con los cambios hechos en la cotización. Editar el acuerdo no las modifica.",
            scopeCostCenter: "Acuerdo del centro de costo {{costCenter}}",
            scopeClient: "Acuerdo del cliente",
            fromParameters: "el de Parámetros",
            provisions: "Provisiones",
            prorated: "proporcional",
            simulationTitle: "Simulación",
          },
          sim: {
            netSalary: "Líquido a pagar",
            subtotal: "Subtotal",
            marginAmount: "Margen",
            invoiceTotal: "Total factura",
            summaryMonthlyAndPeriod: "Líquido mensual: {{net}} · Total factura mensual: {{monthly}} · Total del período ({{period}}): {{total}}",
          },
          noSimulation: "Sin simulación aún: presiona Simular para calcular la estructura completa.",
          parameterSetMissing: "Faltan los parámetros del período (UF, UTM y sueldo mínimo). Créalos o complétalos en Configuración → Parámetros y vuelve a simular.",
          // Ingreso mínimo (fase 1b del cotizador OUT/EST, 2026-10-13)
          minimumWage: {
            base: "El sueldo base mensual ({{base}}) es menor al ingreso mínimo ({{minimum}}) de los parámetros {{period}}.",
            fromNet: "La renta líquida objetivo ({{target}}) da un sueldo base mensual de {{base}}, menor al ingreso mínimo ({{minimum}}) de los parámetros {{period}}.",
            fixInWizard: "Corrígelo en el paso de estructura de renta.",
            fixInDetail: "Edita la cotización para subir el sueldo.",
            fixInParent: "Sube el sueldo en la cotización madre y actualiza desde ella.",
            fixByDuplicate: "Tiene contrato: duplícala para cambiar el sueldo.",
          },
          breakdown: {
            earnings: "HABERES",
            baseSalary: "Sueldo base",
            solvedFromTarget: "Calculado desde la renta líquida objetivo ({{target}}) con la calculadora inversa.",
            solvedFromTargetPartial: "Sueldo base mensual de {{base}}, calculado para una renta líquida mensual de {{target}}; los montos del período son proporcionales.",
            monthlyReference: "Mes completo (lo que va al contrato): sueldo base {{base}} · gratificación {{gratification}}",
            staleInverse: "Calculado con la versión anterior de la calculadora desde el líquido (en períodos parciales el sueldo base salía inflado). Presiona Simular para recalcular antes de exportar el contrato.",
            monthlyColumn: "Mes completo (contrato)",
            monthlyColumnHint: "Renta mensual: es la que va al contrato y a Talana.",
            partialColumn: "Proporcional {{period}}",
            partialColumnHint: "Puesta a disposición del mes de ingreso: {{days}} días.",
            noMonthly: "Simula de nuevo para ver también el mes completo junto al proporcional.",
            entryColumn: "Mes de ingreso",
            exitColumn: "Mes de término",
            segmentColumnHint: "Proporcional {{period}}: {{days}} días.",
            fullMonthsHint: "Renta mensual del contrato. Valor de cada mes completo × {{n}} ({{months}}).",
            fullMonthsReference: "Renta mensual del contrato. El período no tiene meses completos: es solo referencia y no suma al total.",
            totalColumn: "Total del período",
            totalColumnHint: "{{period}}: {{days}} días, suma de los meses del servicio.",
            multiPeriodNote: "Cada mes se calcula por separado con los parámetros del mes de ingreso; los gastos fijos y el margen mínimo se cobran en cada mes.",
            gratification: "Gratificación legal",
            bonus: "Bono imponible",
            totalTaxable: "Total imponible",
            allowance: "Asignación",
            totalEarnings: "Total haberes",
            deductions: "DESCUENTOS DEL TRABAJADOR",
            pension: "AFP",
            health: "Salud",
            unemploymentWorker: "Seguro cesantía trabajador",
            incomeTax: "Impuesto único",
            totalDeductions: "Total descuentos",
            employerCosts: "COSTOS DE EMPRESA",
            mutual: "Seguro accidentes del trabajo (IST)",
            disabilityInsurance: "Seguro invalidez y sobrevivencia (SIS)",
            unemploymentEmployer: "Seguro cesantía empleador",
            lifeExpectancy: "Seguro social expectativa de vida",
            individualCapitalization: "Aporte capitalización individual",
            protectedProfit: "FAPP - Rentabilidad protegida",
            vacationProvision: "Provisión de vacaciones",
            vacationAgreed: "(monto pactado)",
            noticeProvision: "Provisión aviso previo",
            severanceProvision: "Provisión indemnización por años de servicio",
            vacationReplacementProvision: "Provisión reemplazo de vacaciones",
            agreementProvision: "Provisión",
            operationalExpenses: "Gastos operacionales",
            provision: "Provisión adicional",
            adminExpense: "Gasto de administración (acuerdo)",
            assistanceCost: "Costo de asistencia (acuerdo)",
            totalCosts: "Total costos",
            netTotal: "Total neto",
            vat: "IVA",
            marginMinimumApplied: "Se aplicó el margen mínimo configurado.",
            footer: "Período de {{days}} días · parámetros del período {{period}}",
            parameterSetFallback: "Calculada con los parámetros de {{used}}, no con los del mes de ingreso ({{month}}). Si faltan, complétalos en Configuración → Parámetros; después vuelve a simular.",
          },
        },
        parameters: {
          title: "Parámetros de cálculo",
          subtitle: "Los períodos son los de Talana (catálogo Periodos, pestaña Talana). Aquí se completan los parámetros de cada uno: UF/UTM mensuales, valores normativos y factores legales. Un período referenciado por cotizaciones no se edita: se completa el siguiente.",
          add: "Completar parámetros",
          edit: "Editar parámetros",
          empty: "No hay períodos abiertos en Talana ni parámetros cargados. Sincroniza el catálogo Periodos en la pestaña Talana o activa \"Mostrar períodos cerrados\".",
          talana: {
            open: "Abierto en Talana",
            closed: "Cerrado en Talana",
            missing: "No existe en Talana",
            fill: "Completar parámetros",
            showClosed: "Mostrar períodos cerrados",
            notSynced: "El catálogo de períodos de Talana no está sincronizado. Ve a la pestaña Talana y sincroniza \"Periodos\" para poder completar parámetros.",
            notInTalana: "Ese período no existe en Talana. Sincroniza el catálogo Periodos e inténtalo de nuevo.",
            fetch: "Traer de Talana",
            fetching: "Consultando…",
            fetched: "{{count}} parámetros traídos de Talana. Revisa y guarda.",
            fetchError: "No se pudieron traer los parámetros desde Talana",
            paramsNotSynced: "Faltan los catálogos de remuneraciones de Talana (Variables, Comisiones AFP, Tramos de impuesto). Sincronízalos en la pestaña Talana.",
            fromTalana: "Talana · {{code}} · vigente desde {{desde}}",
            resolvedSummary: "{{count}} campos resueltos desde las vigencias de Talana a la fecha de inicio del período ({{brackets}} tramos de impuesto).",
            manualHint: "UF, UTM, IVA, margen mínimo, provisión de vacaciones, gratificación % y mutualidad no vienen de Talana: se mantienen los valores digitados.",
            warningNotFound: "sin vigencia que cubra el inicio del período (se mantiene el valor actual / default)",
            warningChanges: "cambia dentro del período; se usa el valor vigente el día 1",
            afpCommissions: "Obligatorio {{base}}% + comisión por AFP ({{count}} AFP; el motor usa la AFP del trabajador cuando se conoce)",
          },
          loadError: "Error al cargar los parámetros",
          invalidPeriod: "El período debe tener formato AAAA-MM",
          correction: {
            invalidated: "{{count}} cotización(es) perdieron su simulación y hay que volver a simularlas: {{list}}.",
            untouched: "{{count}} en uso o archivadas quedaron con la simulación anterior, revísalas: {{list}}.",
          },
          implausibleAmount: "{{field}}: \"{{value}}\" se entendió como un monto demasiado chico. Escríbelo sin separador o con punto de miles y coma decimal (553.553 o 41.057,2).",
          saveSuccess: "Parámetros guardados",
          saveError: "Error al guardar los parámetros",
          referencedError: "Este período ya fue usado por cotizaciones y no puede editarse; crea un período nuevo (un super-admin puede corregirlo)",
          duplicatePeriod: "Ya existe un set de parámetros para este período",
          table: { period: "Período", talana: "Talana" },
          sections: {
            monthly: "Mensuales (UF / UTM)",
            normative: "Normativos (reajustes)",
            legal: "Fijos legales",
            partialMonth: "Mes de ingreso parcial",
          },
          defaultsHint: "Las tasas se ingresan como porcentaje (ej: 7 = 7%; sirve coma o punto: 10,46). Los montos aceptan punto de miles y coma decimal (553.553 · 41.057,2). Los campos vacíos usan el valor por defecto del motor, tomado de la planilla de remuneraciones (00. MODELO ESTRUCTURA DE RENTA).",
          operationalExpensesMoved: "Los gastos operacionales se configuran en el acuerdo comercial del cliente o de su centro de costo (desde el 2026-10-13). El valor guardado en este período solo lo usan las cotizaciones anteriores.",
          fields: {
            uf: "UF",
            utm: "UTM",
            minimumWage: "Sueldo mínimo",
            pensionRate: "Tasa AFP referencia % (10 + comisión más alta; defecto 11,45)",
            sisRate: "Tasa SIS % (defecto 1,78)",
            unemploymentWorkerRate: "AFC trabajador, indefinido (OUT) % (defecto 0,6; EST no cotiza)",
            unemploymentEmployerRate: "AFC empleador, plazo fijo (EST) % (defecto 3)",
            unemploymentEmployerRateIndefinite: "AFC empleador, indefinido (OUT) % (defecto 2,4)",
            lifeExpectancyRate: "Expectativa de vida % (defecto 0,72)",
            individualCapitalizationRate: "Capitalización individual % (defecto 0,1)",
            protectedProfitRate: "FAPP % (defecto 0,9)",
            taxableCapUf: "Tope imponible UF (defecto 90)",
            unemploymentCapUf: "Tope cesantía UF (defecto 135.2)",
            operationalExpenses: "Gastos operacionales (defecto 10000)",
            marginMinimum: "Margen mínimo CLP (defecto 70000; si el acuerdo no trae otro)",
            healthRate: "Tasa salud % (defecto 7)",
            mutualRate: "Tasa mutualidad % (defecto 0,93 base; con recargo Grafton 2,29)",
            vatRate: "IVA % (defecto 19)",
            vacationProvisionFactor: "Factor provisión vacaciones",
            gratificationRate: "Gratificación % (defecto 25)",
            gratificationCap: "Tope gratificación (IMM)",
            prorateCaps: "Proporcionar los topes de AFP, salud y cesantía (90 / 135,2 UF) a los días del período",
            prorateGratificationCap: "Proporcionar el tope de gratificación a los días del período",
          },
        },

        admin: {
          moduleSwitch: "Módulo ERP",
          moduleSwitchHelper: "Habilita el modo ERP para esta organización (por ahora visible solo para super-admin)",
          saveError: "La organización se guardó, pero falló la actualización del módulo ERP",
        },
        home: {
          menu: "Inicio",
          welcome: "Bienvenido al módulo ERP",
          welcomeName: "Hola, {{name}}",
          subtitle: "Ciclo A: clientes, acuerdos comerciales y catálogo de cargos",
          metrics: {
            clients: "Clientes",
            activeClients: "Clientes activos",
            jobTitles: "Cargos en catálogo",
          },
          quickActions: {
            title: "Accesos rápidos",
            newClient: "Crear cliente",
            viewClients: "Ver clientes",
            newQuotation: "Crear cotización",
            viewQuotations: "Ver cotizaciones",
            configuration: "Configuración ERP",
          },
          underConstruction: "Tus módulos (órdenes de compra, proveedores, SOLPE, HES) llegan en un próximo ciclo del ERP. Por ahora no tienes secciones habilitadas.",
        },
        clients: {
          title: "Clientes",
          serviceTypes: {
            temporary_services: "Servicios Transitorios",
            outsourcing: "Outsourcing",
            mixed: "Ambos (Servicios Transitorios y Outsourcing)",
            legacy: "{{value}} (texto anterior)",
          },
          new: "Nuevo cliente",
          createTitle: "Crear cliente",
          createSubtitle: "Ficha del cliente — reemplaza la ficha Excel: todo se registra en la plataforma",
          searchPlaceholder: "Buscar por razón social o RUT...",
          loadError: "Error al cargar los clientes",
          empty: "Aún no hay clientes creados",
          table: {
            legalName: "Razón social",
            rut: "RUT",
            industry: "Giro",
            kam: "KAM",
            frameworkContract: "Contrato marco",
            talana: "Talana",
            status: "Estado",
          },
          status: { active: "Activo", inactive: "Inactivo" },
          framework: { signed: "Firmado", pending: "Pendiente" },
          detailTabs: {
            data: "Datos",
            costCenters: "Centros de costo",
            agreement: "Acuerdo comercial",
          },
          form: {
            sectionIdentification: "Identificación",
            sectionConditions: "Condiciones de operación",
            sectionOwners: "Responsables internos",
            sectionRequester: "Interlocutor del cliente",
            sectionLegalRep: "Representante legal",
            sectionContacts: "Contactos de facturación y pago",
            sectionAssessment: "Antecedentes de evaluación",
            legalName: "Razón social completa",
            rut: "RUT",
            auxiliaryRut: "RUT auxiliar (derivado)",
            industry: "Giro",
            serviceType: "Tipo de servicio",
            frameworkExists: "Contrato marco firmado",
            frameworkSignedAt: "Fecha de firma",
            usesPurchaseOrder: "Opera con orden de compra",
            allowsFactoring: "Autoriza factorización",
            kam: "KAM asignado",
            businessPartner: "Business Partner asignado",
            requesterName: "Nombre",
            requesterRole: "Cargo",
            requesterPhone: "Teléfono",
            requesterEmail: "Correo",
            legalRepName: "Nombre",
            legalRepRut: "RUT",
            legalRepEmail: "Correo",
            billingName: "Contacto envío de facturas",
            billingEmail: "Correo facturación",
            billingPhone: "Teléfono facturación",
            supplierName: "Contacto pago a proveedores",
            supplierEmail: "Correo pago a proveedores",
            supplierPhone: "Teléfono pago a proveedores",
            dicomChecked: "Verificación DICOM realizada",
            commercialEvaluation: "Evaluación comercial",
            taxFolderReviewed: "Carpeta tributaria revisada",
            assessmentNotes: "Notas de evaluación",
          },
          createSuccess: "Cliente creado correctamente",
          saveSuccess: "Cliente actualizado correctamente",
          deleteClient: "Eliminar cliente",
          deleteConfirmText: "Se eliminarán también sus centros de costo y su acuerdo comercial. Un cliente con cotizaciones no puede eliminarse. Esta acción no se puede deshacer.",
          deleteSuccess: "Cliente eliminado",
          deleteError: "No se pudo eliminar el cliente",
          deleteInUse: "El cliente tiene cotizaciones y no puede eliminarse (la trazabilidad depende de él).",
          saveError: "Error al guardar el cliente",
          invalidRut: "El RUT no es válido (falla el dígito verificador)",
          duplicateRut: "Ya existe un cliente con este RUT en la organización",
          review: {
            button: "Marcar revisión BP",
            done: "Revisado por BP",
            doneAt: "Revisado el {{date}}",
          },
          talana: {
            none: "Sin Talana",
            pending: "Talana pendiente",
            working: "Sincronizando…",
            failed: "Error Talana",
            costCenter: "Centro de costo Talana",
            patchUnsupported: "Talana no permite editar el centro de costo por API: actualizar el nombre/estado manualmente en Talana",
            sync: "Vincular o crear en Talana",
            pick: "Elegir centro de costo…",
            unlink: "Desvincular de Talana",
            pickTitle: "Elegir centro de costo de Talana",
            pickHint: "Se busca por código = RUT auxiliar ({{code}}) o por nombre. Solo aparecen los centros de costo sincronizados en Configuración → Talana.",
            catalogEmpty: "No hay centros de costo sincronizados. Sincroniza el catálogo en Configuración → Talana.",
            catalogError: "No se pudo cargar el catálogo de centros de costo",
            moreResults: "Se muestran los primeros 50; afina la búsqueda.",
            synced: "Cliente sincronizado con Talana",
            linked: "Cliente vinculado al centro de costo",
            unlinked: "Vínculo con Talana eliminado",
            error: "No se pudo completar la operación con Talana",
            reconcile: "Vincular clientes con Talana",
            reconcileHint: "Cruza todos los clientes sin vínculo con los centros de costo de Talana (por RUT auxiliar o nombre) y crea los que falten.",
            reconcileDone: "Clientes procesados: {{total}} · vinculados {{linked}} · creados {{created}} · con error {{failed}}",
          },
        },
        costCenters: {
          add: "Agregar centro de costo",
          edit: "Editar centro de costo",
          empty: "Este cliente aún no tiene centros de costo",
          loadError: "Error al cargar los centros de costo",
          table: {
            code: "Código",
            name: "Nombre",
            description: "Descripción",
            status: "Estado",
          },
          form: {
            code: "Código (asignado por finanzas)",
            name: "Nombre (proyecto, faena o sucursal)",
            description: "Descripción",
          },
          saveSuccess: "Centro de costo guardado",
          saveError: "Error al guardar el centro de costo",
          duplicateCode: "Ya existe un centro de costo con este código para el cliente",
        },
        agreement: {
          none: "Este cliente no tiene acuerdo comercial para todo el cliente. Sin acuerdo (del cliente o del centro de costo), la cotización no hereda condiciones y se ingresan a mano.",
          create: "Crear acuerdo comercial",
          newVersion: "Nueva versión del acuerdo",
          newVersionInfo: "Al guardar una nueva versión, la anterior queda inactiva como historial. Las cotizaciones existentes no se modifican.",
          historyTitle: "Historial de acuerdos",
          active: "Vigente",
          inactive: "Histórico",
          loadError: "Error al cargar el acuerdo comercial",
          margins: {
            title: "Márgenes por tipo de servicio",
            add: "Agregar margen",
            serviceType: "Tipo de servicio",
            feeType: "Tipo de fee",
            value: "Valor",
            percentage: "Porcentual (%)",
            fixed: "Fijo ($)",
            empty: "Sin márgenes definidos",
            legacy: "{{value}} (texto anterior: elige la modalidad)",
          },
          adminExpense: "Gasto de administración",
          adminExpenseAmount: "Monto gasto de administración",
          assistanceCost: "Costo de asistencia",
          assistanceCostAmount: "Monto costo de asistencia",
          paymentTermDays: "Condición de pago (días)",
          paymentDay: "Día de pago",
          paymentNotes: "Notas de la condición de pago",
          usesPurchaseOrder: "Opera con orden de compra",
          // Fase 4 del cotizador OUT/EST (2026-10-13): alcance, gastos y provisiones
          scope: "Acuerdo de",
          scopeClient: "Todo el cliente",
          scopeOwn: "acuerdo propio",
          scopeNoAgreement: "sin acuerdo",
          scopeInherits: "Este centro de costo no tiene acuerdo propio: sus cotizaciones heredan el de todo el cliente. El formulario parte de esos valores; al guardar se crea un acuerdo propio para el centro de costo.",
          scopeNone: "Este centro de costo no tiene acuerdo propio y el cliente tampoco tiene uno general: sus cotizaciones se ingresan a mano. Al guardar se crea un acuerdo para el centro de costo.",
          createForCostCenter: "Crear acuerdo del centro de costo",
          invalidAmounts: "Hay montos que no se entienden (en rojo): corrígelos para guardar.",
          missingAmounts: "Faltan montos (en rojo): escríbelos, o apaga el interruptor o quita la provisión, para guardar.",
          historyScope: "Alcance",
          marginMinimum: "Margen mínimo ($)",
          marginMinimumHint: "Vacío = el de Configuración → Parámetros (defecto 70.000)",
          operationalExpenses: "Gastos operacionales",
          operationalExpensesAmount: "Monto gastos operacionales",
          provisions: {
            title: "Provisiones",
            notice: "Aviso previo",
            severance: "Indemnización por años de servicio",
            vacationReplacement: "Reemplazo de vacaciones",
            formula: {
              notice: "Total haberes del período / 12",
              severance: "Total haberes del período / 12",
              vacationReplacement: "(Total haberes + aportes del empleador) / 30 × 21 / 12",
            },
            mode: {
              default: "Según la modalidad (OUT sí, EST no)",
              defaultNo: "Por defecto (no)",
              include: "Incluir siempre",
              exclude: "Excluir siempre",
            },
            fixedTitle: "Provisiones de monto fijo",
            fixedEmpty: "Sin provisiones de monto fijo",
            name: "Nombre (EPP, uniforme, aguinaldo…)",
            amount: "Monto mensual",
            prorated: "Proporcional en el mes parcial",
            add: "Agregar provisión",
            remove: "Quitar provisión",
          },
          saveSuccess: "Acuerdo comercial guardado",
          saveError: "Error al guardar el acuerdo comercial",
        },
        jobTitles: {
          talana: {
            sync: "Sincronizar con Talana ahora: busca el cargo por nombre en el catálogo de Talana y, si no existe, lo crea",
            columnHelp: "Vínculo del cargo con el catálogo de cargos de Talana. El cargo se crea o vincula en Talana automáticamente al usarse en una cotización (y se vuelve a verificar al exportar el contrato). No es necesario hacerlo a mano.",
            tipNone: "Aún no se ha usado en ninguna cotización. Se creará o vinculará en Talana al guardar la primera cotización con este cargo.",
            tipLinked: "Existe en Talana como \"{{name}}\" (ID {{id}}, {{method}}). Los contratos con este cargo saldrán enlazados a ese registro.",
            tipFailed: "El último intento de crearlo en Talana falló: {{error}}. Se reintenta solo al cotizar o exportar; un super-admin también puede reintentar con el botón de sincronizar.",
            tipPending: "Pendiente: Talana no estaba configurado cuando se usó. Se resolverá al cotizar o exportar.",
            created: "Cargo creado en Talana (ID {{id}})",
            linked: "Cargo vinculado a Talana (ID {{id}})",
            error: "No se pudo sincronizar el cargo con Talana",
            method: { name: "vinculado por nombre", created: "creado desde Amanda", manual: "vinculado a mano" },
          },
          title: "Cargos",
          add: "Agregar cargo",
          edit: "Editar cargo",
          empty: "Aún no hay cargos en el catálogo",
          loadError: "Error al cargar los cargos",
          table: { name: "Nombre", area: "Área", status: "Estado" },
          form: { name: "Nombre del cargo", area: "Área" },
          saveSuccess: "Cargo guardado",
          sourceAts: "Desde ATS",
          saveError: "Error al guardar el cargo",
          duplicateName: "Ya existe un cargo con este nombre",
        },
        talana: {
          title: "Catálogos de Talana",
          subtitle: "Talana es el maestro de estos catálogos: se leen por API y se espejan en Amanda para usarlos en fichas y contratos. Haz clic en un catálogo para ver sus registros.",
          syncAll: "Sincronizar con Talana",
          syncOne: "Sincronizar este catálogo",
          syncing: "Sincronizando…",
          started: "Sincronización iniciada. El estado se actualiza automáticamente.",
          startError: "No se pudo iniciar la sincronización",
          alreadyRunning: "Ya hay una sincronización en curso para esta organización",
          notConfigured: "Talana no está configurado en el servidor (TALANA_TOKEN / TALANA_BASE_URL).",
          loadError: "Error al cargar el estado de sincronización",
          environment: { sandbox: "Sandbox", production: "Producción" },
          state: { running: "En curso", ok: "Sincronizado", error: "Error", never: "Sin sincronizar" },
          table: {
            catalog: "Catálogo",
            state: "Estado",
            records: "Registros",
            changes: "Cambios (nuevos / act.)",
            lastSync: "Última sincronización",
            syncedBy: "Sincronizado por",
            created: "Nuevos",
            updated: "Actualizados",
            deactivated: "Desactivados",
          },
          detail: {
            open: "Ver registros",
            count: "{{count}} registros",
            inactiveCount: "{{count}} inactivos ocultos",
            searchPlaceholder: "Buscar por nombre, código o ID de Talana…",
            showInactive: "Mostrar inactivos",
            empty: "Sin registros para mostrar",
            loadError: "Error al cargar los registros del catálogo",
            table: { talanaId: "ID Talana", name: "Nombre", code: "Código", details: "Detalle", parent: "Padre" },
          },
          catalogs: {
            contractTypes: "Tipos de contrato",
            afps: "AFP",
            healthInstitutions: "Instituciones de salud (Isapre / Fonasa)",
            banks: "Bancos",
            legalEntities: "Razones sociales",
            branches: "Sucursales",
            workSchedules: "Jornadas laborales",
            jobTitles: "Cargos",
            costCenters: "Centros de costo",
            countries: "Países",
            locations: "Ubicaciones geográficas",
            periods: "Periodos",
            payrollParameters: "Variables de remuneraciones (vigencias)",
            afpCommissions: "Comisiones AFP (vigencias)",
            taxBrackets: "Tramos de impuesto único (vigencias)",
          },
        },
        config: {
          title: "Configuración ERP",
          menu: "Configuración",
          tabs: { jobTitles: "Catálogo de cargos", parameters: "Parámetros de cálculo", hiringCauses: "Causales", talana: "Talana", templates: "Plantillas Word (PDF de Amanda)", izydocs: "Formatos Izydocs" },
        },
        // Contrato tipo en Word (Configuración ERP → Plantillas; PLAN_ERP.md §15, fase B1, 2026-10-19)
        // Formatos de Izydocs (PLAN_ERP.md §15.4, fase B2, 2026-10-20)
        izydocsFormats: {
          title: "Formatos Izydocs",
          intro: "Formatos de Izydocs que usa Amanda para enviar documentos a firma. Las plantillas viven en Izydocs: el texto se cambia allá y Amanda no guarda copia. Los datos personales (nombre, RUT, dirección…) los completa Izydocs desde la ficha de la persona.",
          loadError: "No se pudieron cargar los formatos de Izydocs",
          notConfigured: "Izydocs no está configurado en el servidor (IZYDOCS_BASE_URL e IZYDOCS_API_KEY).",
          notWired: "La conexión con Izydocs está pendiente: falta {{list}}.",
          kinds: { contract: "Contratos", onboarding: "Documentos de ingreso", annex: "Anexos" },
          columns: { id: "ID", name: "Nombre en Izydocs", company: "Empresa", usage: "Cuándo se usa", tags: "Datos que pide", status: "Estado" },
          companies: { temporary_services: "EST (sucursal {{id}})", outsourcing: "OUT (sucursal {{id}})", general: "General" },
          variants: {
            workday: "Por jornada · trabajador chileno",
            workday_foreign: "Por jornada · trabajador extranjero",
            workday_no_allowances: "Por jornada · sin colación ni movilización",
            workday_allowances: "Por jornada · con colación y movilización",
            daily: "Sueldo diario",
            dictamen: "Carta dictamen",
            karin: "Protocolo Ley Karin",
            welcome: "Set de bienvenida",
            attendance: "Autorización de control de asistencia",
            continuity: "Anexo de continuidad",
            continuity_passport: "Anexo de continuidad · versión Pasaporte",
            overtime: "Pacto de horas extra",
            overtime_passport: "Pacto de horas extra · versión Pasaporte",
          },
          statuses: { active: "En uso", pending: "Pendiente" },
          pendingReasons: {
            out: "Contratos OUT: después de las respuestas de Grafton",
            daily_salary: "Falta el sueldo diario en Amanda",
            onboarding: "Documentos de ingreso: después del contrato",
            phase_c: "Anexos: fase C",
          },
          noTags: "Sin datos variables",
        },
        documentTemplates: {
          title: "Plantillas Word (PDF de Amanda)",
          subtitle: "Contrato tipo en Word (.docx) con marcadores {{marker}}. Amanda usa la plantilla activa que calza la modalidad y el tipo de contrato; una específica gana a la de \"Todas\" o \"Todos\". Es para el PDF que arma Amanda (\"Ver contrato (PDF)\"); la firma con Izydocs usa las plantillas de Izydocs (pestaña Formatos Izydocs).",
          upload: "Subir plantilla",
          uploadTitle: "Subir contrato tipo",
          replaceTitle: "Reemplazar el Word de «{{name}}»",
          editTitle: "Editar plantilla",
          name: "Nombre",
          serviceMode: "Modalidad",
          contractKind: "Tipo de contrato",
          chooseFile: "Elegir archivo Word (.docx)",
          noFile: "Ningún archivo elegido",
          active: "Activa",
          inactive: "Inactiva",
          activeLabel: "Plantilla activa",
          activeHint: "activarla deja inactiva la otra de la misma modalidad y tipo de contrato",
          preview: "Vista previa (PDF con datos de ejemplo)",
          download: "Descargar el Word",
          replace: "Reemplazar el Word",
          edit: "Editar",
          empty: "Aún no hay plantillas. Sube el contrato tipo en Word.",
          loadError: "No se pudieron cargar las plantillas",
          uploadSuccess: "Plantilla subida y activa",
          saveSuccess: "Plantilla guardada",
          saveError: "No se pudo guardar la plantilla",
          previewError: "No se pudo generar la vista previa",
          downloadError: "No se pudo descargar el Word",
          noPlaceholdersWarning: "La plantilla no tiene marcadores {{marker}}: el contrato saldrá igual para todas las personas.",
          deactivatedInfo: "Quedó inactiva la plantilla anterior de esa modalidad y tipo de contrato.",
          conversionNotes: "Avisos de la conversión del Word",
          table: {
            name: "Nombre",
            serviceMode: "Modalidad",
            contractKind: "Tipo de contrato",
            placeholders: "Marcadores",
            status: "Estado",
            updated: "Actualizada",
          },
          serviceModes: { temporary_services: "EST", outsourcing: "OUT", any: "Todas" },
          contractKinds: { fixed_term: "Plazo fijo", indefinite: "Indefinido", work_or_task: "Por obra o faena", any: "Todos" },
          errors: {
            UNKNOWN_PLACEHOLDERS: "La plantilla usa marcadores que no existen: {{list}}. Corrígelos en el Word (revisa la lista de marcadores) y vuelve a subirla.",
            INVALID_FILE: "El archivo debe ser un Word .docx. Un .doc antiguo no se puede leer: guárdalo como .docx.",
            EXTERNAL_IMAGE: "El Word enlaza una imagen externa (Insertar → Imagen → Vincular al archivo). Inserta las imágenes en el documento (incrustadas) y vuelve a subirlo.",
            FILE_TOO_LARGE: "El Word pesa más de 5 MB.",
            TEMPLATE_TOO_LARGE: "La plantilla convertida es muy pesada (¿imágenes grandes?). Achica las imágenes del Word.",
            FILE_REQUIRED: "Elige el archivo Word.",
            INVALID_FIELDS: "Completa el nombre, la modalidad y el tipo de contrato.",
            STORAGE_ERROR: "No se pudo guardar el Word. Intenta de nuevo.",
          },
          placeholders: {
            title: "Marcadores disponibles",
            intro: "Escribe el marcador tal cual en el Word, con las dos llaves, por ejemplo {{example}}. Si un marcador obligatorio está vacío en la ficha, Amanda no arma el contrato y dice qué falta; los opcionales quedan en blanco.",
            format: "Del Word se mantienen párrafos, negritas, cursivas, subrayado, listas, tablas e imágenes. No se mantienen encabezados ni pies de página, alineaciones ni tipos de letra: el PDF sale justificado, con los títulos (estilo \"Título\") centrados y \"Página X de Y\" al pie.",
            key: "Marcador",
            label: "Qué es",
            example: "Ejemplo",
            optional: "opcional",
            copy: "Copiar",
            copied: "Marcador copiado",
            groups: {
              trabajador: "Persona",
              empleador: "Empleador",
              cliente: "Cliente / empresa usuaria",
              cargo: "Cargo",
              jornada: "Jornada",
              lugar: "Lugar de trabajo",
              contrato: "Contrato",
              remuneracion: "Remuneración",
              documento: "Documento",
            },
          },
        },
        validation: {
          rut: "RUT inválido (falla el dígito verificador)",
          email: "Correo con formato inválido",
          phone: "Teléfono inválido: 8 a 12 dígitos, con +56 opcional",
          fixErrors: "Corrige los campos marcados en rojo antes de guardar",
        },
        talanaSelect: {
          notSynced: "Catálogo no sincronizado: ir a Configuración → Talana",
          loadError: "No se pudo cargar el catálogo de Talana",
          legacy: "texto legado, sin catálogo",
          legacyHint: "Valor de texto de una ficha anterior: elige el registro del catálogo de Talana",
          noOptions: "Sin resultados",
        },
        common: {
          save: "Guardar",
          saving: "Guardando...",
          cancel: "Cancelar",
          actions: "Acciones",
          view: "Ver",
          retry: "Reintentar",
          status: "Estado",
          active: "Activo",
          inactive: "Inactivo",
          close: "Cerrar",
          requiredFields: "Completa los campos obligatorios",
        },
      },
      // Hunting — búsqueda proactiva de candidatos en Apollo.io (PLAN_HUNTING_APOLLO.md)
      hunting: {
        home: {
          menu: "Inicio",
          welcome: "Hunting",
          welcomeName: "Hola, {{name}}",
          subtitle: "Busca candidatos que no han postulado e invítalos a tus procesos",
          actions: { newSearch: "Nueva búsqueda" },
          howItWorks: {
            title: "¿Cómo funciona?",
            step1: "Busca por cargo, palabras clave, ubicación y nivel (sin costo).",
            step2: "Revisa la lista y marca a quiénes quieres contactar.",
            step3: "Obtén sus datos de contacto: nombre completo, email, LinkedIn y ubicación. Cada email cuesta {{emailPoints}} puntos. El teléfono es opcional y cuesta {{phonePoints}} puntos, solo si Apollo lo encuentra. Lo ya obtenido no se vuelve a cobrar.",
            step4: "Guárdalos en la base y, si quieres, asócialos a un cargo (ATS o Evaluaciones) y avísales por correo.",
            step5: "Quedan en Evaluaciones → Postulantes; si los asociaste a una vacante ATS aparecen en su Kanban.",
            creditsNote: "Buscar es gratis: los puntos se cobran solo por los emails y teléfonos que se obtienen.",
          },
        },
        search: {
          menu: "Buscar candidatos",
          title: "Buscar candidatos",
          subtitle: "Apollo.io · la búsqueda es gratis; los datos de contacto consumen puntos",
          steps: { step1: "Buscar", step2: "Seleccionar", step3: "Datos de contacto", step4: "Destino", step5: "Resumen" },
          form: {
            titles: "Cargos",
            titlesHelp: "Escribe un cargo y presiona Enter (ej. Backend Developer, Data Engineer). Incluye títulos similares.",
            keywords: "Palabras clave",
            keywordsHelp: "Skills o tecnologías (ej. Python Django). Opcional si indicaste cargos.",
            locations: "Ubicación",
            locationsHelp: "País, región o ciudad (ej. Chile, Santiago, Chile).",
            level: "Nivel de experiencia",
            levelAny: "Cualquiera",
            levelJunior: "Junior (entry / intern)",
            levelMid: "Mid (senior individual)",
            levelSenior: "Senior (manager y superiores)",
            verifiedOnly: "Solo perfiles con email verificado (recomendado)",
            verifiedOnlyShort: "Email verificado",
            submit: "Buscar",
          },
          advanced: {
            title: "Filtros avanzados",
            active: "{{count}} activos",
            clear: "Limpiar avanzados",
            person: "Persona",
            notTitles: "Excluir cargos",
            notTitlesHelp: "Cargos que NO quieres en los resultados (ej. Intern, Manager).",
            pastTitles: "Cargos anteriores",
            pastTitlesHelp: "Cargos que la persona tuvo antes (no el actual).",
            personName: "Nombre de la persona",
            personNameHelp: "Para ubicar a alguien específico.",
            departments: "Departamento",
            departmentsHelp: "Área funcional según Apollo (ej. master_engineering_technical, master_sales).",
            seniorities: "Nivel (detalle Apollo)",
            senioritiesHelp: "Si eliges niveles aquí, se ignora el atajo junior / mid / senior.",
            emailStatuses: "Estado del email",
            emailStatusesHelp: "Si eliges estados aquí, se ignora el switch de email verificado.",
            includeSimilarTitles: "Incluir cargos similares a los indicados (desactívalo para coincidencia exacta)",
            exactTitles: "Cargos exactos",
            company: "Empresa (actual o anterior)",
            industries: "Industria",
            industriesHelp: "Nombre de industria LinkedIn en inglés (ej. banking, retail, mining & metals).",
            orgKeywords: "Palabras clave de la empresa",
            orgKeywordsHelp: "Etiquetas asociadas a la empresa (ej. fintech, saas, minería).",
            orgDomains: "Dominios de empresa",
            orgDomainsHelp: "Sitios web de empleadores actuales o anteriores (ej. latam.com).",
            excludeOrgDomains: "Excluir empresas",
            excludeOrgDomainsHelp: "Dominios que NO quieres (ej. tu propio cliente).",
            orgLocations: "Ubicación de la casa matriz",
            orgLocationsHelp: "País, región o ciudad de la sede de la empresa.",
            employeeRanges: "Tamaño de la empresa (empleados)",
            revenueMin: "Ingresos mín.",
            revenueMax: "Ingresos máx.",
            growthWindow: "Crecimiento de dotación",
            growthMonths: "últimos {{count}} meses",
            growthMin: "Mín. %",
            growthMax: "Máx. %",
            hiring: "Empresas que están contratando",
            orgJobTitles: "Cargos publicados",
            orgJobTitlesHelp: "Títulos de vacantes activas del empleador.",
            orgJobLocations: "Ubicación de las vacantes",
            orgJobLocationsHelp: "Dónde está contratando la empresa.",
            orgJobsMin: "Vacantes mín.",
            orgJobsMax: "Vacantes máx.",
            orgJobPostedFrom: "Publicadas desde",
            orgJobPostedTo: "Publicadas hasta",
            tech: "Tecnologías que usa la empresa",
            techHelp: "Identificadores de Apollo en minúsculas (ej. aws, salesforce, sap, python). Un valor desconocido no filtra.",
            techAny: "Usa alguna de",
            techAll: "Usa todas",
            techNone: "No usa ninguna de",
          },
          results: {
            count: "{{returned}} de {{total}} resultados",
            truncated: "Se muestran los primeros {{returned}}. Ajusta los filtros para acotar la búsqueda.",
            partialNote: "Lista orientativa: Apollo solo entrega nombre de pila, cargo y empresa antes de obtener los datos de contacto.",
            empty: "Sin resultados para esos filtros.",
            obtained: "Ya obtenido",
            obtainedTip: "Datos obtenidos el {{date}}: no se vuelven a cobrar",
            onlyWithPhone: "Solo con teléfono (según Apollo)",
            onlyWithPhoneCount: "{{count}} de {{total}}",
            noneWithPhone: "Ninguno de estos resultados tiene teléfono según Apollo.",
          },
          phone: {
            switch: "Incluir teléfono ({{points}} puntos por cada teléfono que llegue)",
            help: "Apollo indica teléfono para {{count}} de {{total}}. El número llega después, no al instante, y se guarda solo aunque cierres esta pantalla.",
            offHelp: "Sin teléfono: email, LinkedIn, ubicación y experiencia.",
            unavailable: "El teléfono no está disponible en este entorno.",
            flagYes: "Apollo indica que tiene teléfono.",
            flagMaybe: "Apollo no lo marca como disponible, pero al pedirlo a veces lo encuentra. Si no llega, no se cobra.",
          },
          charges: {
            title: "Cómo se cobra",
            email: "Email: {{points}} puntos por cada persona nueva que traiga email. Si no trae email, o tu organización ya la había obtenido, no se cobra.",
            phone: "Teléfono: {{points}} puntos solo si Apollo entrega un número válido. Si no lo encuentra, no se cobra.",
            max: "“Hasta X puntos” es el máximo posible; normalmente se cobra menos.",
          },
          columns: {
            name: "Nombre", title: "Cargo", company: "Empresa",
            hasEmail: "Email", hasPhone: "Teléfono", hasLocation: "Ubicación",
            email: "Email", linkedin: "LinkedIn", location: "Ubicación",
            current: "Cargo actual", experience: "Experiencia", inAmanda: "En Amanda",
            phone: "Teléfono",
          },
          enriched: {
            count: "{{matched}} de {{requested}} con datos",
            pointsCharged: "Puntos cobrados: {{points}}",
            notFound: "{{count}} sin datos en Apollo",
            current: "actual",
            registered: "Ya registrado ({{count}})",
            registeredNoProcess: "Registrado en Amanda sin procesos activos",
            new: "Nuevo",
            reused: "{{count}} ya obtenidos antes (sin costo)",
            reusedTip: "Ya estaba guardado: no se volvió a cobrar",
            phoneRequested: "teléfono pedido para {{count}} ({{points}} puntos solo por los que lleguen; si no se encuentra, no se cobra)",
            phonePending: "Esperando…",
            phonePendingTip: "Apollo envía el teléfono después. Se guarda solo, aunque cierres esta pantalla.",
            phoneLate: "Llegará más tarde",
            phoneLateTip: "Apollo todavía no lo envía. Se guarda solo apenas llegue: lo verás al volver a buscar a esta persona y, si ya la guardaste, en su ficha.",
            phoneNotFound: "No encontrado",
            phoneNotRequested: "No solicitado",
            phoneFallbackTip: "Número entregado por Apollo que no es un celular válido (p. ej. un fijo): se muestra, pero no se copia a la ficha.",
            personalEmails: "Personal: {{list}}",
            partial: "Apollo cortó la consulta antes de terminar: {{count}} quedaron sin pedir (sin costo). Lo obtenido quedó guardado; vuelve a seleccionar a los que faltan.",
          },
          invite: {
            title: "Destino de {{count}} candidato(s)",
            saveNote: "Siempre se guardan en la base de candidatos del proyecto (Evaluaciones → Postulantes), con nombre, email, teléfono (si se pidió), LinkedIn, ubicación y experiencia. Asociarlos a un cargo y avisarles por correo es opcional.",
            associateSwitch: "Asociar a un cargo",
            position: "Cargo",
            groupAts: "Vacantes ATS",
            groupEvaluations: "Cargos de Evaluaciones",
            noPositions: "No hay cargos disponibles en este proyecto (vacantes ATS activas que puedas editar o cargos de Evaluaciones).",
            atsNote: "Vacante ATS: el candidato queda en la primera etapa del Kanban.",
            evaluationsNote: "Cargo de Evaluaciones: el cargo se agrega al postulante; los tests se envían después desde Evaluaciones. No se envía correo en este paso.",
            emailSwitch: "Enviar correo de invitación al portal",
            emailNote: "Es el correo estándar del portal (\"Te invitamos a completar tu postulación\"): está redactado para alguien que ya postuló. El candidato recibe un link y entra con un código a su email. Úsalo con criterio: son personas reales que no conocen el proceso.",
          },
          summary: {
            title: "Resultado",
            saved_line: "Guardados en la base: {{count}}",
            associated_line: "Asociados a {{position}}: {{count}}",
            emails_line: "Correos enviados: {{count}}",
            errors_line: "Con error: {{count}}",
            already: "({{count}} ya estaban en ese cargo)",
            saved: "Guardado",
            added: "Asociado al cargo",
            sent: "Correo enviado",
            error: "Error",
            toast: "{{saved}} candidato(s) guardado(s)",
            phonesPending: "{{count}} teléfono(s) en camino: se agregan solos a la ficha cuando llegan.",
          },
          actions: {
            back: "Volver",
            enrich: "Obtener datos de contacto (hasta {{points}} puntos)",
            goInvite: "Continuar con {{count}}",
            invite: "Guardar y enviar {{count}} correo(s)",
            associate: "Guardar y asociar {{count}} al cargo",
            save: "Guardar {{count}} en la base",
            newSearch: "Nueva búsqueda",
            viewProcess: "Ver proceso en ATS",
            viewApplicants: "Ver postulantes en Evaluaciones",
          },
          errors: {
            noCriteria: "Indica al menos un criterio de búsqueda.",
            search: "No se pudo ejecutar la búsqueda en Apollo.",
            enrich: "No se pudieron obtener los datos de contacto.",
            organizationForbidden: "No perteneces a la organización seleccionada.",
            noPointsSystem: "Hunting no está disponible: tu organización no tiene el sistema de puntos activo. Contacta a tu administrador.",
            serviceNotAvailable: "Hunting no está incluido en el plan de tu organización: está disponible en los planes pagados.",
            insufficientPoints: "No te alcanzan los puntos: se necesitan hasta {{required}} y quedan {{remaining}}. Elige menos personas o desactiva el teléfono.",
            positions: "No se pudieron cargar las vacantes.",
            invite: "No se pudieron enviar las invitaciones.",
          },
        },
        emailStatus: {
          verified: "Verificado",
          likely_to_engage: "Probable",
          extrapolated: "Extrapolado",
          unverified: "No verificado",
          unavailable: "Sin email",
          unknown: "Desconocido",
        },
        seniority: {
          owner: "Dueño", founder: "Fundador", c_suite: "C-level", partner: "Socio", vp: "VP",
          head: "Head", director: "Director", manager: "Manager", senior: "Senior", entry: "Entry", intern: "Práctica",
        },
        filterLabels: {
          titles: "Cargos", keywords: "Palabras clave", locations: "Ubicación", level: "Nivel",
          personName: "Nombre", notTitles: "Excluir cargos", pastTitles: "Cargos anteriores", departments: "Departamento",
          seniorities: "Nivel", emailStatuses: "Email", verifiedOnly: "Email", includeSimilarTitles: "Cargos",
          orgDomains: "Empresas", excludeOrgDomains: "Excluir empresas", orgLocations: "Casa matriz",
          industries: "Industria", orgKeywords: "Keywords empresa", employeeRanges: "Tamaño",
          revenueMin: "Ingresos mín.", revenueMax: "Ingresos máx.", headcountGrowthMonths: "Crecimiento",
          headcountGrowthMin: "Crec. mín. %", headcountGrowthMax: "Crec. máx. %",
          orgJobTitles: "Cargos publicados", orgJobLocations: "Vacantes en", orgJobsMin: "Vacantes mín.", orgJobsMax: "Vacantes máx.",
          orgJobPostedFrom: "Publicadas desde", orgJobPostedTo: "Publicadas hasta",
          techAny: "Usa alguna", techAll: "Usa todas", techNone: "No usa",
        },
      },
      ats: {
        // Ferias: agrupaciones de vacantes con página pública y QR (PLAN_FERIAS)
        fairs: {
          menu: "Ferias",
          title: "Ferias",
          subtitle: "Reúne varias vacantes en una página con su propio link y QR, por ejemplo para una feria laboral.",
          newFair: "Nueva feria",
          empty: "Todavía no hay ferias. Crea una para reunir varias vacantes bajo un mismo link y QR.",
          loadError: "No se pudieron cargar las ferias.",
          colName: "Nombre",
          colPositions: "Vacantes visibles",
          colCreatedBy: "Creada por",
          colUpdated: "Última modificación",
          colActions: "Acciones",
          positionsShown: "{{shown}} de {{total}}",
          noneShown: "Ninguna visible: el QR lleva a una página vacía",
          copyLink: "Copiar link",
          linkCopied: "Link copiado",
          linkCopyError: "No se pudo copiar el link",
          showQr: "Ver QR",
          openPage: "Abrir página",
          edit: "Editar",
          view: "Ver",
          delete: "Eliminar",
          close: "Cerrar",
          origin: "Feria «{{name}}»",
          editor: {
            newTitle: "Nueva feria",
            editTitle: "Feria",
            back: "Volver a ferias",
            name: "Nombre de la feria",
            namePlaceholder: "Ej.: Feria MIL Las Condes",
            nameRequired: "Escribe el nombre de la feria.",
            readOnly: "Solo quien creó la feria o un administrador puede modificarla.",
            createdBy: "Creada por {{name}}",
            positionsTitle: "Vacantes de la feria",
            positionsHint: "En la página solo se muestran las vacantes activas, con «Visible en portal» encendido y, si son masivas, con cupo.",
            addPositions: "Agregar vacantes",
            noPositions: "Todavía no agregas vacantes.",
            remove: "Quitar de la feria",
            missingPosition: "Vacante eliminada",
            inaccessible: "{{count}} vacante(s) de proyectos que no tienes asignados. Se mantienen en la feria.",
            save: "Guardar cambios",
            create: "Crear feria",
            saved: "Feria guardada",
            created: "Feria creada",
            saveError: "No se pudo guardar la feria.",
            notAllowed: "Hay vacantes que no puedes agregar. Recarga la página e inténtalo de nuevo.",
            forbidden: "No tienes permiso para modificar esta feria.",
            tooMany: "Una feria puede tener hasta {{max}} vacantes.",
            notFound: "La feria no existe o fue eliminada.",
            unsaved: "Tienes cambios sin guardar.",
            linkTitle: "Link y QR",
            linkLabel: "Link de la feria",
            linkHint: "El link y el QR no cambian aunque cambies el nombre o las vacantes.",
            linkAfterSave: "El link y el QR se generan al crear la feria.",
            downloadPng: "Descargar PNG",
            downloadSvg: "Descargar SVG",
            boardNotPublished: "La web de empleos de la organización no está publicada, así que el link usa app.amandahr.ai en vez del subdominio de la organización. La feria funciona igual. La web se publica en Configuración → Web de empleos.",
          },
          state: {
            shown: "Se muestra",
            not_active: "No se muestra: {{status}}",
            hidden: "No se muestra: no visible en portal",
            limit_reached: "No se muestra: sin cupo",
            deleted: "No se muestra: eliminada",
            statuses: {
              draft: "en borrador",
              suspended: "suspendida",
              closed: "cerrada",
              cancelled: "cancelada",
            },
          },
          picker: {
            title: "Agregar vacantes",
            hint: "Aparecen las vacantes de tus proyectos asignados que no están cerradas ni canceladas.",
            search: "Buscar por nombre, cliente o ubicación",
            client: "Cliente",
            type: "Tipo",
            status: "Estado",
            all: "Todos",
            empty: "No hay vacantes que puedas agregar con estos filtros.",
            alreadyIn: "Ya está en la feria",
            notVisible: "No visible en portal",
            add: "Agregar ({{count}})",
            loadError: "No se pudieron cargar las vacantes.",
          },
          deleteDialog: {
            title: "Eliminar feria",
            confirm: "¿Eliminar la feria «{{name}}»?",
            warning: "El link y el QR dejarán de funcionar: quien los abra verá «Esta feria ya no está disponible». Las vacantes y las postulaciones no cambian.",
            success: "Feria eliminada",
            error: "No se pudo eliminar la feria.",
          },
        },
        contactSource: {
          whatsapp_libre: "Origen: WhatsApp libre",
          web_libre: "Origen: Web chat libre",
          whatsapp_cargo: "Origen: WhatsApp (link de cargo)",
          web_cargo: "Origen: Web chat (link de cargo)",
          simulator: "Origen: Simulador",
        },
        captation: {
          simulatorButton: "Simulador del bot",
          // Respuestas del formulario del portal en el drawer (PLAN_MASIVO_PORTAL, fase 2)
          portalAnswers: {
            title: "Respuestas de la postulación (formulario del portal)",
            viewFile: "Ver archivo",
            labels: {
              nacionalidad: "Nacionalidad",
              comuna: "Comuna",
              traslado: "Puede trasladarse",
              experiencia: "Experiencia",
              disponibilidad: "Disponibilidad",
              renta: "Expectativa de renta",
              // Importación (PLAN_IMPORTACION_COMPUTRABAJO, fase 1)
              region: "Región",
              fecha_postulacion: "Fecha de postulación",
              formacion: "Formación",
              doc_carnet_frente: "Documento de identidad (frente)",
              doc_carnet_reverso: "Documento de identidad (reverso)",
              doc_visa: "Visa o permiso de trabajo",
            },
          },
          limitBadge: {
            label: "Captación pausada por límite",
            tooltip: "El bot alcanzó el límite de captados configurado ({{count}}/{{limit}}). No acepta postulaciones nuevas; puedes subir o quitar el límite en la configuración de la vacante.",
          },
          campaigns: {
          title: "Campañas push",
          headerButton: "Campañas push (cargar base desde Excel)",
          subtitle: "Carga bases de candidatos desde Excel: se normalizan los teléfonos, se deduplica contra tu base y se envían por WhatsApp con la plantilla aprobada (goteo controlado y respeto del límite diario de Meta).",
          unnamed: "Carga sin nombre",
          status: {
            draft: "Borrador",
            ready: "Pendiente de envío",
            sending: "Enviando…",
            paused_tier: "Pausada (límite diario)",
            completed: "Envío completado",
          },
          sendButton: "Enviar campaña",
          whatsappUnavailable: "Esta organización no tiene WhatsApp disponible: las campañas no se pueden enviar (sí cargar bases). Configura un número propio o pide a un super-admin que permita el número compartido de Grafton (ATS → Configuración → WhatsApp → Canal).",
          issuesShow: "Ver omitidos y fallidos",
          issuesHide: "Ocultar omitidos y fallidos",
          issuesEmpty: "Sin omitidos ni fallidos",
          issuesError: "No se pudo cargar el detalle",
          detailShow: "Ver detalle de envíos",
          detailTitle: "Detalle de envíos — {{name}}",
          detailFilterLabel: "Filtrar por estado",
          detailFilterAll: "Todos los estados",
          detailEmpty: "Sin contactos para ese filtro",
          detailLoadMore: "Cargar más",
          detailError: "No se pudo cargar el detalle",
          detailSentAt: "Enviado {{time}}",
          detailDeliveredAt: "Entregado {{time}}",
          detailReadAt: "Leído {{time}}",
          detailRepliedAt: "Respondió {{time}}",
          detailDeclinedAt: "Rechazó {{time}}",
          contactStatus: {
            pending: "Pendiente",
            sent: "Enviado",
            delivered: "Entregado",
            read: "Leído",
            replied: "Respondió",
            declined: "No le interesó",
            failed: "Falló",
            skipped_optout: "Omitido — opt-out",
            skipped_veto: "Omitido — vetado",
            skipped_frequency: "Omitido — contactado hace menos de {{days}} días",
            skipped_active_conversation: "Omitido — conversación en curso",
            opted_out: "Pidió no ser molestado",
          },
          issueStatus: {
            failed: "Falló",
            skipped_optout: "Omitido — pidió no ser contactado",
            skipped_veto: "Omitido — vetado por conducta ofensiva",
            skipped_frequency: "Omitido — contactado hace menos de {{days}} días",
            skipped_active_conversation: "Omitido — conversación en curso con el bot",
            opted_out: "Pidió no ser molestado (opt-out)",
            declined: "No le interesó este cargo",
          },
          sendConfirmTitle: "¿Enviar la campaña?",
          sendConfirmBody: "\"{{name}}\" — se enviará la plantilla de WhatsApp a {{count}} contacto(s), con goteo de 10 mensajes por minuto.",
          sendConfirmNote: "Cada mensaje tiene costo (conversación de marketing de Meta). Los contactos con conversación activa, opt-out, veto o contactados hace menos de {{days}} días se omiten con motivo.",
          sendConfirmButton: "Sí, enviar",
          sendStarted: "Envío iniciado — goteo de 10 mensajes por minuto",
          sendError: "No se pudo iniciar el envío",
          sendCounts: "Enviados {{sent}} · Entregados {{delivered}} · Leídos {{read}} · Respondieron {{replied}} · No interesados {{declined}} · Fallidos/omitidos {{failed}} · No molestar {{optedOut}}",
          campaignCounts: "{{valid}} contactos · {{existing}} ya existían · {{invalid}} descartados",
          deleteConfirm: "Eliminar",
          deleteError: "Error eliminando la campaña",
          newTitle: "Nueva carga",
          fileButton: "Elegir Excel o CSV…",
          dbTitle: "O agrega candidatos de la BD del proyecto",
          dbSearchPlaceholder: "Buscar por nombre, RUT, email o teléfono (mín. 2 letras)",
          dbSearchButton: "Buscar",
          dbSearchError: "No se pudo buscar en la BD",
          dbNoResults: "Sin resultados para esa búsqueda",
          dbNoPhone: "sin teléfono",
          dbRowLabel: "BD",
          previewFromDb: "{{count}} desde la BD",
          fileHint: "Columnas: nombre y teléfono, ambas OBLIGATORIAS por fila (acepto encabezados tipo \"celular\", \"fono\", \"móvil\"). Si el archivo trae RUT o email, se usan solo para deduplicar contra tu base. Máx. 5 MB / 5.000 filas.",
          exampleButton: "Descargar planilla de ejemplo",
          nameLabel: "Nombre de la carga (opcional)",
          namePlaceholder: "ej: Base cliente marzo",
          nameHint: "Para distinguir esta carga de otras en la misma vacante. Si lo dejas vacío, queda como \"Carga sin nombre\".",
          origenLabel: "Origen de la base (opcional)",
          origenPlaceholder: "ej: base histórica del cliente, feria laboral…",
          origenHint: "De dónde salió esta lista de personas. Sirve de respaldo si alguien reclama por qué lo contactaron, y para saber qué base generó reclamos.",
          optInLabel: "Estas personas aceptaron ser contactadas (opcional)",
          optInHint: "Declaración de consentimiento: marca si la base viene de personas que dieron su autorización (postulaciones previas, formularios, etc.). Protege la calidad del número de WhatsApp ante reportes de spam.",
          uploadButton: "Cargar y revisar",
          uploadError: "Error cargando el archivo",
          previewTitle: "Revisión de la carga",
          previewValid: "{{count}} contactos válidos",
          previewExisting: "{{count}} ya existían (se reutilizan)",
          previewInvalid: "{{count}} filas inválidas",
          previewExcluded: "{{count}} excluidos (bloqueados/veto/opt-out)",
          rowLabel: "Fila {{row}}",
          confirmButton: "Confirmar carga ({{count}})",
          discardButton: "Descartar",
          confirmed: "Campaña guardada — pendiente de envío",
          confirmError: "Error confirmando la campaña",
        },
        whatsappLink: {
            button: "Copiar link de WhatsApp",
            copied: "Link de WhatsApp copiado al portapapeles",
            noNumber: "Esta organización no tiene un número de WhatsApp para el link: configura su número visible o pide a un super-admin que permita el número compartido de Grafton (ATS → Configuración → WhatsApp → Canal).",
            error: "No se pudo copiar el link de WhatsApp",
          },
          chatLink: {
            button: "Copiar link del chat",
            copied: "Link del chat copiado al portapapeles",
            error: "No se pudo copiar el link del chat",
          },
          publicFree: {
            title: "Busca tu próximo trabajo",
            subtitle: "Cuéntale al asistente qué buscas y te mostrará las vacantes disponibles",
          },
          drawer: {
            title: "Conversación del bot",
            show: "Ver conversación",
            hide: "Ocultar",
          },
          simulator: {
            title: "Simulador del bot de captación",
            subtitle: "Prueba el flujo de conversación en modo sandbox: no crea candidatos reales ni consume servicios externos.",
            testChip: "Modo prueba",
            restart: "Reiniciar",
            backToPosition: "Volver a la vacante",
            panelTitle: "Estado del motor",
            state: "Estado",
            result: "Resultado",
            intent: "Última intención",
            progress: "Pregunta",
            turnTokens: "Tokens último turno",
            totalTokens: "Tokens totales de la prueba",
            answers: "Respuestas capturadas",
            noAnswers: "Aún no hay respuestas",
            startError: "No se pudo iniciar la simulación",
          },
          chat: {
            inputPlaceholder: "Escribe tu mensaje…",
            send: "Enviar",
            typing: "Escribiendo…",
            attach: "Adjuntar archivo",
            finished: "Conversación finalizada",
          },
          public: {
            title: "Postulación",
            subtitle: "Asistente de postulación",
            connecting: "Conectando con el asistente…",
            error: "No pudimos conectar con el asistente. Intenta nuevamente en unos minutos.",
            retry: "Reintentar",
            uploadError: "No pudimos recibir el archivo. Inténtalo de nuevo (PDF, Word o imagen, máx. 10 MB).",
            finishedThanks: "¡Gracias por conversar con nosotros! Ya registramos tu información.",
            poweredBy: "Selección impulsada por Amanda",
          },
          states: {
            interes: "Interés",
            optin: "Opt-in base",
            optin_experiencia: "Experiencia (base)",
            preguntas: "Preguntas",
            confirmando_datos: "Confirmando datos",
            confirmando_cierre: "Confirmando cierre",
            identificando_cargo: "Identificando cargo",
            finalizada: "Finalizada",
          },
          results: {
            captado: "Captado",
            registrado_base: "Registrado en base",
            cerrado: "Cerrado",
          },
        },
        home: {
          menu: "Inicio",
          welcome: "Bienvenido al ATS",
          welcomeName: "Hola, {{name}}",
          subtitle: "Gestioná tus vacantes y candidatos",
          metrics: {
            positions: "Vacantes",
            activePositions: "Vacantes activas",
            candidates: "Candidatos",
          },
          actions: {
            newPosition: "Nueva vacante",
            viewPositions: "Ver vacantes",
            viewCandidates: "Ver candidatos",
            start: "Comenzar",
          },
          howItWorks: {
            title: "¿Cómo funciona el ATS?",
            step1: "Crea una vacante y define su pipeline (fases y etapas).",
            step2: "Recibe postulantes por el portal público o agrega postulantes existentes.",
            step3: "En cada etapa, filtra CVs y envía evaluaciones o entrevistas.",
            step4: "Mueves a los candidatos por el kanban a medida que avanzan.",
            step5: "Avanza de fase hasta contratar, o cierra el proceso.",
          },
        },
        config: {
          menu: "Configuración",
          title: "Configuración",
          // Botón al manual en PDF del título (AtsConfigurationLayout.js, 2026-10-15)
          manualLink: "Manual de configuración (PDF)",
          tabs: {
            rejectionEmail: "Correo de descarte",
            hiringEmail: "Correo de contratación",
            offerEmail: "Correo de oferta",
            shortlistEmail: "Correo al cliente",
            documentCatalog: "Tipos de documentos",
            documentsEmail: "Correo de documentos",
            branding: "Branding",
            emailSender: "Remitente",
            pipelineTemplates: "Pipelines predeterminados",
            jobBoard: "Web de empleos",
            captationTemplates: "Plantillas de captación",
            whatsapp: "WhatsApp",
            captationVetoes: "Vetos del bot",
          },
          jobBoard: {
            title: "Web pública de empleos",
            description: "Publica una página pública con todas las vacantes activas de la organización, donde los candidatos pueden ver el detalle y postular.",
            orgLevelNote: "Esta configuración es de toda la organización (no del proyecto activo): el board muestra las vacantes ATS activas de todos sus proyectos.",
            sharedSlugNote: "El subdominio (slug) también se usa en los links de tests y solicitudes de documentos que se envían a los candidatos (Configuración → URL personalizada del modo evaluaciones): cambiarlo afecta a ambos.",
            enabled: "Publicar la web de empleos",
            slugLabel: "Dirección (slug)",
            slugHint: "La página quedará en: {{url}}",
            slugRequired: "Debes definir una dirección (slug) para publicar la web",
            slugTaken: "Esa dirección ya está en uso o no está permitida",
            slugChangeWarning: "Al cambiar la dirección, el link anterior (/empleos/{{old}}) dejará de funcionar.",
            checking: "Verificando disponibilidad...",
            nameTitle: "Nombre mostrado en la página",
            nameOrganization: "Nombre de la organización ({{name}})",
            nameCustom: "Nombre personalizado",
            customName: "Nombre a mostrar",
            bannerUrl: "URL del banner (opcional)",
            bannerHint: "Imagen ancha para el encabezado de la página. Puedes usar la misma del branding del portal. Recomendado: ~1920×320 px (relación ancho:alto ~6:1); el exceso vertical se recorta centrado.",
            copy: "Copiar link",
            copied: "Link copiado",
            open: "Abrir la página",
            save: "Guardar",
            saveSuccess: "Web de empleos guardada",
            saveError: "No se pudo guardar la configuración",
            loadError: "No se pudo cargar la configuración",
          },
          whatsappTabs: {
            channel: "Canal",
            messages: "Mensajes del bot",
          },
          whatsappChannel: {
            title: "Canal de WhatsApp de la organización",
            description: "Qué número de WhatsApp le pertenece a esta organización. El token de acceso no se configura aquí: es del portafolio de Meta, no de la organización.",
            noNumberNote: "Sin número propio, esta organización no tiene WhatsApp: no se envían campañas ni solicitudes de documentos por WhatsApp y el bot no atiende sus vacantes. Para usarlo, configura un número propio o pide a un super-admin que permita el número compartido de Grafton.",
            // Número compartido de Grafton solo con permiso de un super-admin (2026-10-26)
            sharedOnNote: "Sin número propio: usa el número compartido de Grafton ({{number}}), permitido por un super-admin. El chat muestra «Grafton Chile» como remitente y comparte con Grafton el tope diario, las bajas y la calidad del número.",
            sharedNumberAllowed: "Permitir el número compartido de Grafton",
            sharedNumberAllowedHint: "Solo se usa si la organización no tiene número propio: las campañas y las solicitudes de documentos salen por el número de Grafton ({{number}}) con el nombre de esta organización.",
            sharedNumberSuperAdminOnly: "Solo un super-admin puede cambiarlo.",
            sharedNumberAllowedBy: "Permitido por {{name}} el {{date}}",
            sharedNumberRemovedBy: "Quitado por {{name}} el {{date}}",
            enabled: "Canal habilitado",
            enabledHint: "Si está deshabilitado, el bot no envía mensajes por este número.",
            phoneNumberId: "Phone Number ID (Meta)",
            phoneNumberIdHint: "El identificador del número en WhatsApp Manager, solo dígitos. Un número no puede pertenecer a dos organizaciones.",
            publicNumber: "Número visible",
            publicNumberHint: "El que ven los candidatos en los links wa.me. Ej: 56939535872",
            displayName: "Nombre de la empresa",
            displayNameHint: "El que usa el bot en sus mensajes. Vacío = el nombre de la organización.",
            defaultPositionId: "Vacante por defecto (opcional)",
            defaultPositionIdHint: "Si se define, quien escriba entra directo a esa vacante en vez de la entrada libre.",
            templatesTitle: "Plantillas de Meta",
            templatesHint: "Las plantillas son de la cuenta de WhatsApp Business, no del número: todos los números de la misma cuenta usan las mismas y no hay que recrearlas. Lo único que puede cambiar por organización es el idioma con que se envían.",
            templateLang: "Idioma de las plantillas",
            templateLangHint: "Solo si creaste una variante de idioma de la plantilla en Meta.",
            templateLangDefault: "Usar el del servidor ({{lang}})",
            loadError: "No se pudo cargar la configuración del canal",
            saved: "Configuración guardada",
            saveError: "No se pudo guardar la configuración",
          },
          whatsappFree: {
            title: "WhatsApp — entrada libre",
            description: "Lo que responde el bot cuando alguien escribe al número de WhatsApp SIN un link de vacante (y en el web chat libre de la organización). Vacío = se usa el texto por defecto del sistema (mostrado en gris). Aplica a conversaciones nuevas.",
            restoreDefault: "Restaurar por defecto",
            usingDefault: "Usando el texto por defecto",
            variablesLabel: "Variables disponibles",
            saved: "Mensajes guardados — aplican a conversaciones nuevas",
            saveError: "No se pudieron guardar los mensajes",
            loadError: "No se pudieron cargar los mensajes",
            groups: {
              busqueda: {
                title: "Búsqueda de vacantes",
                hint: "El bot prioriza el tipo de trabajo; la región solo se informa (una vacante del rubro en otra región se muestra igual). El nombre del bot (ej. \"Sofía\") se escribe en estos textos.",
              },
              bancoTalento: {
                title: "Banco de talento",
                hint: "Cuando la persona rechaza las vacantes mostradas (o pide dejar sus datos). Antes de guardar se pide autorización explícita; el registro queda en el banco de talento de la organización con origen \"WhatsApp libre\".",
              },
            },
            fields: {
              saludoLibre: {
                label: "Saludo inicial",
                hint: "El primer mensaje al escribir sin link de cargo. Debe pedir tipo de trabajo y región.",
              },
              saludoLibreRecurrente: {
                label: "Saludo a quien ya escribió antes",
                hint: "Cuando el número ya tuvo una conversación con este bot. No usa el nombre ni datos guardados: solo reconoce que ya escribió.",
              },
              listaVacantes: {
                label: "Lista de vacantes",
                hint: "Cuando la búsqueda encuentra cargos que calzan. {{lista}} se reemplaza por las vacantes numeradas con su región.",
              },
              listaVacantesFallback: {
                label: "Lista sin calce",
                hint: "Cuando nada calza con lo pedido pero hay vacantes abiertas (se muestran todas).",
              },
              sinVacantes: {
                label: "Sin vacantes abiertas",
                hint: "Cuando no hay ningún cargo con captación activa. {{boardLink}} agrega el link a la web de empleos si existe.",
              },
              pieBancoTalento: {
                label: "Pie de toda lista",
                hint: "Se agrega al final de cada lista de vacantes (y del mensaje sin vacantes): la opción de dejar los datos si ninguna interesa. Vacío en el texto = sin pie.",
              },
              ofertaBancoTalento: {
                label: "Oferta del banco de talento",
                hint: "Cuando la persona rechaza las vacantes en texto libre (\"ninguno me sirve\", \"no gracias\"). Es una pregunta de sí/no.",
              },
              bancoNombre: { label: "Pregunta: nombre completo", hint: "Primer dato del registro." },
              bancoNacionalidad: { label: "Pregunta: nacionalidad", hint: "Define si se pide RUT o documento extranjero." },
              bancoDocumento: { label: "Pregunta: RUT", hint: "Para chilenos. Para extranjeros se usa el texto de documento extranjero del flujo." },
              bancoEmail: { label: "Pregunta: correo", hint: "Obligatorio: con el correo se crea/vincula el candidato global." },
              bancoTelefono: { label: "Pregunta: teléfono", hint: "Solo en el web chat libre; por WhatsApp el teléfono viene del canal." },
              bancoTipoTrabajo: { label: "Pregunta: tipo de trabajo", hint: "Solo si la persona no lo dijo en la búsqueda." },
              bancoRegion: { label: "Pregunta: región de interés", hint: "Solo si la persona no la dijo en la búsqueda." },
              consentimientoBancoTalento: {
                label: "Autorización para guardar los datos",
                hint: "Se pide SIEMPRE antes de guardar cualquier dato. El texto por defecto viene SIN marco legal y SIN enlace de privacidad: pega aquí la redacción que apruebe legal, con la norma de tu país y tu enlace.",
                tooltip: "Es el consentimiento que la persona acepta antes de que sus datos queden guardados en la base de talentos: el respaldo legal de todo lo que se registra después. El texto por defecto dice qué datos se guardan, para qué, que no se venden a terceros y que se pueden eliminar cuando la persona quiera — pero no nombra ninguna norma ni enlaza ninguna política de privacidad, porque ambas dependen del país donde opera la organización: en Chile suelen ser la Ley N° 19.628 y la Ley N° 21.719; en Perú, la Ley N° 29733 y el D.S. 003-2013-JUS. Mientras dejes el campo vacío se envía el texto por defecto y se pide la autorización sin mencionar ninguna norma, que es más débil: conviene pegar aquí el texto aprobado por tu área legal, con su norma y el enlace a tu política de privacidad.",
              },
              registroBancoTalentoOk: {
                label: "Confirmación de registro",
                hint: "Solo confirma que los datos quedaron registrados; no comunicar plazos de respuesta.",
              },
              cierreBancoTalento: {
                label: "Cierre sin registro",
                hint: "Cuando la persona no quiere dejar sus datos o no autoriza. Sin insistir.",
              },
            },
          },
          captationTemplates: {
            title: "Plantillas de captación",
            description: "Flujos del bot de captación (preguntas, mensajes y reglas) con nombre, para reutilizarlos al crear vacantes masivas. La predeterminada se aplica sola en el wizard. Las vacantes copian el flujo al crearse: editar o eliminar una plantilla no las afecta.",
            empty: "Aún no hay plantillas de captación. Créala aquí o desde el wizard de una vacante con \"Guardar captación como plantilla\".",
            defaultChip: "Predeterminada",
            setDefault: "Marcar como predeterminada",
            unsetDefault: "Quitar predeterminada",
            edit: "Editar",
            delete: "Eliminar",
            add: "Agregar plantilla",
            createTitle: "Nueva plantilla de captación",
            editTitle: "Editar plantilla de captación",
            nameField: "Nombre",
            descriptionField: "Descripción (opcional)",
            questionsCount: "preguntas",
            flowStandard: "Flujo estándar",
            rulesActive: "Reglas activas",
            nameRequired: "El nombre es requerido",
            contentRequired: "Personaliza el flujo o las reglas antes de guardar: el flujo estándar del sistema ya está siempre disponible",
            saveSuccess: "Plantilla guardada",
            saveError: "No se pudo guardar la plantilla",
            deleteSuccess: "Plantilla eliminada",
            deleteError: "No se pudo eliminar la plantilla",
            deleteConfirmTitle: "¿Eliminar la plantilla?",
            deleteConfirmText: "Se eliminará \"{{name}}\". Las vacantes ya creadas con ella no se ven afectadas.",
            loadError: "No se pudieron cargar las plantillas",
          },
          pipelineTemplates: {
            title: "Pipelines predeterminados",
            description: "Guarda configuraciones de pipeline con nombre para reutilizarlas al crear vacantes. La marcada como predeterminada se precarga en cada vacante nueva. Editar o eliminar una plantilla no afecta a las vacantes ya creadas.",
            empty: "Aún no hay plantillas. Crea la primera con el botón de abajo.",
            add: "Nueva plantilla",
            createTitle: "Nueva plantilla de pipeline",
            editTitle: "Editar plantilla de pipeline",
            nameField: "Nombre de la plantilla",
            descriptionField: "Descripción (opcional)",
            nameRequired: "El nombre de la plantilla es requerido",
            phasesRequired: "La plantilla debe tener al menos una fase",
            defaultChip: "Predeterminada",
            setDefault: "Marcar como predeterminada",
            unsetDefault: "Quitar como predeterminada",
            phasesCount: "fases",
            stagesCount: "etapas",
            edit: "Editar",
            delete: "Eliminar",
            deleteConfirmTitle: "Eliminar plantilla",
            deleteConfirmText: "¿Eliminar la plantilla «{{name}}»? Las vacantes ya creadas con ella no se ven afectadas.",
            saveSuccess: "Plantilla guardada",
            saveError: "No se pudo guardar la plantilla",
            deleteSuccess: "Plantilla eliminada",
            deleteError: "No se pudo eliminar la plantilla",
            loadError: "No se pudieron cargar las plantillas",
          },
          rejectionEmail: {
            title: "Correo de descarte",
            description: "Plantilla del correo que se envía al descartar un candidato en este proyecto. Puedes ajustarla en cada descarte.",
            variables: "Variables disponibles",
            subject: "Asunto",
            body: "Cuerpo del correo",
            save: "Guardar",
            saveSuccess: "Plantilla guardada correctamente",
            saveError: "Error al guardar la plantilla",
            loadError: "Error al cargar la plantilla",
          },
          hiringEmail: {
            title: "Correo de contratación",
            description: "Plantilla del correo que se envía al contratar a un candidato (etapa Contratado). Los datos de recepción se completan al enviar.",
            variables: "Variables disponibles",
            subject: "Asunto",
            body: "Cuerpo del correo",
            save: "Guardar",
            saveSuccess: "Plantilla guardada correctamente",
            saveError: "Error al guardar la plantilla",
            loadError: "Error al cargar la plantilla",
          },
          offerEmail: {
            title: "Correo de oferta",
            description: "Plantilla del correo que se envía con la oferta (etapa Oferta). La carta de oferta se adjunta al enviar.",
            variables: "Variables disponibles",
            subject: "Asunto",
            body: "Cuerpo del correo",
            save: "Guardar",
            saveSuccess: "Plantilla guardada correctamente",
            saveError: "Error al guardar la plantilla",
            loadError: "Error al cargar la plantilla",
          },
          shortlistEmail: {
            title: "Correo al cliente (shortlist)",
            description: "Plantilla del correo que se envía al cliente con los candidatos preseleccionados. Lista a cada candidato con botones para ver su CV y su resumen ejecutivo (variable «candidatos», abajo).",
            variables: "Variables disponibles",
            subject: "Asunto",
            body: "Cuerpo del correo",
            save: "Guardar",
            saveSuccess: "Plantilla guardada correctamente",
            saveError: "Error al guardar la plantilla",
            loadError: "Error al cargar la plantilla",
          },
          documentCatalog: {
            title: "Tipos de documentos",
            description: "Catálogo de documentos que puedes solicitar a los candidatos en este proyecto. Se reutilizan en el modal «Solicitar documentos» del pipeline; los que agregues ahí también aparecen aquí.",
            empty: "Todavía no hay tipos de documentos. Agrega el primero.",
            labelField: "Nombre del documento",
            instructionsField: "Instrucciones (opcional)",
            addType: "Agregar tipo de documento",
            save: "Guardar",
            saveSuccess: "Catálogo guardado correctamente",
            saveError: "Error al guardar el catálogo",
            loadError: "Error al cargar el catálogo",
          },
          documentsEmail: {
            title: "Correo de documentos",
            description: "Plantilla del correo que se envía al solicitar documentos a un candidato. Se agrega automáticamente la lista de documentos y el botón para subirlos.",
            brandingNote: "El logo y el nombre de la empresa («De parte de») se toman del branding del proyecto. Se configuran en la pestaña «Branding», no aquí.",
            variables: "Variables disponibles",
            subject: "Asunto",
            body: "Cuerpo del correo",
            save: "Guardar",
            saveSuccess: "Plantilla guardada correctamente",
            saveError: "Error al guardar la plantilla",
            loadError: "Error al cargar la plantilla",
          },
          branding: {
            title: "Branding del portal",
            description: "Define el nombre y el logo que se muestran en el portal de postulación y en los correos de este proyecto.",
            note: "Por defecto no se muestra nada hasta que lo configures. Nunca se usa branding de la plataforma.",
            nameTitle: "Nombre a mostrar",
            logoTitle: "Logo",
            source: "Fuente",
            sourceNone: "No mostrar",
            sourceOrganization: "Organización",
            sourceProject: "Proyecto",
            sourceCustom: "Personalizado",
            customName: "Nombre personalizado",
            customLogoHint: "Sube un logo personalizado para este proyecto.",
            bannerTitle: "Banner (foto)",
            bannerHint: "Imagen ancha que se muestra arriba de la página de postulación. Opcional. Recomendado: ~1920×320 px (relación ancho:alto ~6:1). Se muestra a lo ancho completo con altura máxima de 240 px y el exceso vertical se recorta centrado — ubica el logo y el texto al centro de la imagen.",
            bannerRatioWarning: "Esta imagen es poco panorámica: en el portal se verá solo una franja central. Si es un logo, súbelo en el campo Logo; para el banner recomendamos ~1920×320 px.",
            bannerUpload: "Subir banner",
            bannerReplace: "Cambiar banner",
            bannerRemove: "Quitar",
            bannerError: "No se pudo subir el banner",
            save: "Guardar",
            saveSuccess: "Branding guardado correctamente",
            saveError: "Error al guardar el branding",
            loadError: "Error al cargar el branding",
          },
          emailSender: {
            title: "Remitente de los correos",
            description: "Define el nombre que ven los candidatos como remitente de los correos del ATS de este proyecto. Puedes ajustarlo también en cada envío.",
            note: "Solo cambia el nombre visible; los correos siempre se envían desde la misma dirección.",
            modeDefault: "Amanda HR (por defecto)",
            modeUser: "Nombre del usuario que envía el correo",
            modeCustom: "Nombre personalizado",
            modeUserHint: "En los envíos automáticos (sin usuario) se usa el nombre personalizado si está definido; si no, Amanda HR.",
            customName: "Nombre personalizado",
            preview: "Vista previa",
            fieldLabel: "Remitente (nombre visible)",
            save: "Guardar",
            saveSuccess: "Remitente guardado correctamente",
            saveError: "Error al guardar el remitente",
            loadError: "Error al cargar el remitente",
          },
        },
        positions: {
          editPosition: "Editar vacante",
          duplicatePosition: "Duplicar vacante",
          positionUpdated: "Vacante actualizada correctamente",
          copyPortalUrl: "Copiar link del portal",
          copyPortalUrlHidden: "No está visible en el portal: su link muestra «no disponible»",
          portalUrlCopied: "Link copiado al portapapeles",
          deleteDialog: {
            button: "Eliminar vacante",
            title: "Eliminar vacante",
            confirm: "¿Seguro que quieres eliminar la vacante \"{{name}}\"?",
            warning: "Dejará de aparecer en ATS y en Gestión de Cargos, y no recibirá más postulaciones. Los candidatos y su historial se conservan.",
            success: "Vacante eliminada",
            error: "No se pudo eliminar la vacante",
            // Confirmación reforzada (2026-10-05): escribir la palabra para habilitar "Eliminar"
            confirmWord: "ELIMINAR",
            typeToConfirm: "Escribe {{word}} para confirmar",
            candidates: "Tiene {{count}} candidato(s) en proceso: se conservan, pero la vacante deja de verse.",
            noCandidates: "No tiene candidatos.",
          },
          deadline: {
            closesIn: "Cierra en {{count}} día(s)",
            closesToday: "Cierra hoy",
            overdue: "Venció hace {{count}} día(s)",
          },
          view: "Ver detalle",
          title: "Vacantes",
          loadError: "Error al cargar las vacantes",
          saveError: "Error al guardar la vacante",
          positionCreated: "Vacante creada correctamente",
          positionsFound: "vacantes encontradas",
          newPosition: "Nueva Vacante",
          searchPositions: "Buscar vacantes...",
          noPositions: "No hay vacantes registradas",
          noPositionsSearch: "No se encontraron vacantes para esta búsqueda",
          positionName: "Cargo",
          processType: "Tipo",
          industry: "Industria",
          modality: "Modalidad",
          status: "Estado",
          actions: "Acciones",
          assignUsers: "Asignar responsables",
          noEditPermission: "No tienes permiso para editar esta vacante",
          assignDialog: {
            title: "Responsables de la vacante",
            description: "Selecciona los usuarios que podrán editar esta vacante y gestionar su proceso. Los administradores siempre pueden editarla.",
            selectLabel: "Usuarios con permiso de edición",
            noOptions: "No hay usuarios disponibles",
            loadError: "Error al cargar los usuarios",
            saved: "Responsables actualizados correctamente",
            saveError: "Error al actualizar los responsables",
            save: "Guardar",
            cancel: "Cancelar",
          },
          wizard: {
            tipo: "Tipo de proceso",
            tipoLockedHint: "El tipo de proceso no se puede cambiar después de crear la vacante: los flujos son distintos.",
            internalName: "Nombre interno (opcional)",
            // Switch "Visible en portal" de las vacantes hunting (PLAN_MASIVO_PORTAL)
            portalVisibility: {
              title: "Web de empleos",
              onHint: "La vacante aparece en la web de empleos y recibe postulaciones (si está Activa y la web de empleos está habilitada).",
              offHint: "La vacante no aparece en la web de empleos y su link muestra «no disponible». Puedes seguir agregando candidatos a mano.",
            },
            captacionBot: {
              templateSelector: "Plantilla de captación",
              templateStandard: "Flujo estándar del sistema",
              saveAsTemplate: "Guardar captación como plantilla",
              saveAsTemplateTitle: "Guardar como plantilla de captación",
              saveAsTemplateHint: "Guarda las preguntas, mensajes y reglas actuales como plantilla del proyecto. Las vacantes nuevas podrán partir desde ella (la predeterminada se aplica sola). Editar la plantilla después NO cambia vacantes ya creadas.",
              saveAsTemplateDisabledHint: "Personaliza el flujo o las reglas primero: el flujo estándar del sistema ya está siempre disponible.",
              templateSaved: "Plantilla de captación guardada",
              templateSaveError: "No se pudo guardar la plantilla de captación",
              limitLabel: "Límite de captados",
              limitPlaceholder: "Sin límite",
              limitHint: "Cuando los captados (bot + formulario del portal) alcanzan este número, la captación se pausa automáticamente en los dos canales (quienes ya estaban conversando pueden terminar). Vacío = sin límite.",
              
              title: "Parte 1 — Captación (bot y formulario)",
              switchLabel: "Bot (chat y WhatsApp)",
              portalSwitchLabel: "Visible en portal",
              portalEnabledHint: "Las mismas preguntas se muestran como formulario en la web de empleos (se entra con código por correo).",
              portalDisabledHint: "No visible: la vacante no aparece en la web de empleos y su link no recibe postulaciones.",
              enabledHint: "El bot capta candidatos por el chat público de esta vacante (y por WhatsApp cuando esté conectado).",
              disabledHint: "Captación apagada: el chat público no recibe candidatos. Puedes agregar gente manualmente al pipeline.",
              funnelHint: "Flujo automatizado de captación. Su configuración detallada llegará con las plantillas de captación.",
              editor: {
                questionsTitle: "Preguntas de datos del bot",
                questionsHint: "El bot las hace en este orden. Las fijas no se pueden desactivar (sin ellas no hay verificación de identidad ni contacto). Las preguntas filtradoras de la vacante se configuran en la pestaña Preguntas y el bot las hace al final.",
                newQuestionPlaceholder: "Escribe la pregunta…",
                lockedChip: "Fija",
                lockedTooltip: "Pregunta crítica del flujo: no se puede desactivar ni eliminar.",
                addQuestion: "Agregar pregunta",
                messagesTitle: "Mensajes del bot",
                stepsTitle: "Pasos del flujo",
                contactTitle: "1 · Contacto e interés",
                dataTitle: "2 · Datos del candidato",
                backgroundTitle: "3 · Revisión de antecedentes",
                rulesTitle: "4 · Reglas del cargo",
                closingTitle: "5 · Cierre",
                activeChip: "Activo",
                pendingChip: "Pendiente de integración",
                backgroundRutRow: "Validación de RUT/documento y detección de candidatos ya registrados",
                backgroundAltoRow: "Consulta de antecedentes (Chapi)",
                backgroundStageRow: "Consulta de antecedentes (Chapi, {{points}} puntos por consulta): se hace desde la etapa del pipeline que tenga el módulo \"Verificación de antecedentes\"",
                backgroundStageChip: "En el pipeline",
                backgroundStageRowUnavailable: "Consulta de antecedentes: disponible solo para organizaciones que operan en Chile",
                unavailableChip: "No disponible",
                rulesRow: "Reglas de auto-descarte y bloqueo por cargo/cliente",
                extranjeroDocsLabel: "Pedir documentos a extranjeros por el chat",
                extranjeroDocsHint: "Si la nacionalidad no es chilena, el bot pide foto del FRENTE del documento, luego el REVERSO y luego la visa/permiso — cada uno como paso propio (se puede omitir; los archivos quedan en la ficha).",
                extranjeroDocsUnavailableHint: "Disponible solo para organizaciones que operan en Chile.",
                altoChecksHint: "Consulta la identidad y los antecedentes en Chapi durante la captación (1 crédito por consulta nueva; repetirla en el mismo mes no cobra). Apagado: esta vacante no consulta antecedentes — los chilenos con RUT válido quedan \"Sin observaciones\" directo; extranjeros y sin RUT siguen cayendo a revisión manual.",
                altoChecksUnavailableHint: "Solo para organizaciones que operan en Chile: Chapi consulta registros chilenos. Esta organización opera en otro país, así que no se consultan antecedentes.",
                rules: {
                  disabledHint: "Desactivadas: el bot solo registra las respuestas y todos los captados entran al kanban sin marcas. Activa el switch para marcar o descartar automáticamente según reglas deterministas.",
                  hint: "Cada regla define qué hacer cuando la respuesta no calza: Nada, Marcar (badge para revisar) o Descartar (va a la columna Descartado, siempre rescatable).",
                  actionLabel: "Acción",
                  actions: {
                    nada: "Nada",
                    marcar: "Marcar",
                    descartar: "Descartar",
                  },
                  rentaLabel: "Expectativa de renta sobre el tope",
                  rentaHint: "Por defecto solo MARCA (\"Renta sobre tope: pidió X / tope Y\"). Sin tope configurado no se evalúa.",
                  rentaTope: "Tope líquido (CLP)",
                  comunaLabel: "Comuna distinta a la del cargo",
                  comunaHint: "Se ignora si el cargo es remoto. Si el candidato dijo que SÍ puede trasladarse, se salva; si la respuesta de traslado es ambigua, solo se marca (nunca descarta).",
                  noFiltering: "No hay preguntas filtradoras comparables (Sí/No o alternativas) en esta vacante.",
                  filteringHint: "Si la respuesta no está entre las esperadas, se aplica la acción. Respuestas fuera de las opciones solo se marcan.",
                  expectedLabel: "Respuestas esperadas",
                  discardNote: "Descartar nunca elimina: la postulación queda en la columna Descartado con su motivo y el consultor puede rescatarla.",
                },
                rutAdaptNote: "Esta pregunta se adapta automáticamente según la nacionalidad: a extranjeros se les pide su documento de identidad o pasaporte.",
                fieldLabel: "Guardar en campo…",
                fieldNone: "Ninguno",
                fieldOptions: {
                  gender: "Género",
                  profession: "Profesión u oficio",
                  currentPosition: "Cargo actual",
                  name: "Nombre",
                  rut: "Documento (RUT)",
                  phone: "Teléfono",
                  email: "Email",
                  country: "Nacionalidad",
                  salarioPretendido: "Renta esperada",
                  cvUrl: "CV",
                },
                systemFieldTooltip: "Mapeo del sistema: la respuesta alimenta este campo del candidato y no se puede cambiar (de él dependen la verificación y el contacto).",
                loadError: "No se pudo cargar la configuración del flujo. Recarga la página.",
                messagesHint: "Puedes usar las variables {{cargo}}, {{empresa}} y {{nombre}}.",
                messageLabels: {
                  bienvenida: "Bienvenida",
                  interes: "Pregunta de interés",
                  inicioPreguntas: "Inicio de preguntas",
                  cierreCaptado: "Cierre al captar",
                  optIn: "Invitación a base general",
                },
                restoreDefaults: "Restaurar mensajes por defecto",
                restoreFlow: "Restaurar flujo por defecto",
                restoreFlowHint: "Vuelve el flujo completo (preguntas y mensajes) al estándar del sistema, descartando las personalizaciones de esta vacante. Útil también para incorporar preguntas nuevas del sistema.",
                restoreFlowConfirm: "¿Restaurar el flujo por defecto? Se descartarán todas las personalizaciones de preguntas y mensajes de esta vacante.",
                restoreFlowCancel: "Cancelar",
                restoreFlowGo: "Restaurar",
                optInLabel: "Ofrecer registro en base general",
                optInHint: "Si el candidato no está interesado, el bot le ofrece quedar registrado para futuros cargos. Apagado: se despide directamente.",
              },
              pipelinePartTitle: "Parte 2 — Pipeline del proceso",
              steps: {
                contacto: "Contacto",
                interes: "Interés",
                datos: "Datos",
                validacion: "Validación",
                reglas: "Reglas",
              },
            },
            internalNameHint: "Solo visible dentro de la app, para identificar procesos (ej: Analista RRHH Masivo). Los candidatos siempre ven el nombre del cargo.",
            tooltips: {
              tipo: "Hunting: proceso de selección tradicional para un cargo específico. Reclutamiento masivo: captación de muchos candidatos con bot conversacional y pipeline masivo. No se puede cambiar después de crear la vacante.",
              prioridad: "Indicador interno para ordenar qué vacantes son más prioritarias. No afecta el flujo ni la publicación.",
              estado: "Borrador: no se muestra al ingresar al link y no permite postular. Activo: visible y recibiendo postulaciones al compartir el link. Suspendido: pausa temporal, el proceso se retomará pronto; deja de recibir postulaciones pero puedes seguir trabajando con los candidatos que ya están en el pipeline. Cerrado: el proceso terminó y la vacante se cubrió. Cancelado: el cargo ya no se necesita y la búsqueda se da de baja. Solo el estado Activo publica la vacante y recibe postulaciones.",
              visibilidad: "General: visible para todos los usuarios del proyecto. Confidencial: visible solo para administradores y para quien creó la vacante.",
              modalidad: "Cómo se trabaja el cargo: presencial, remoto o híbrido.",
              salarioTipo: "Rango: salario mínimo y máximo. Sueldo único: un monto fijo. Son alternativas: la vacante usa una u otra.",
              tipoBusqueda: "Indicador del tipo de búsqueda. Interna: la empresa busca dentro de su propia dotación. Externa: la búsqueda se encarga a un tercero (consultora de headhunting). General: sin distinción. No afecta la publicación.",
            },
            stepFields: "Campos del cargo",
            stepPipeline: "Pipeline",
            basicInfo: "Información básica",
            jobDescription: "Descripción del cargo",
            positionName: "Nombre del cargo",
            codigoRef: "Código de referencia",
            industry: "Industria",
            jerarquia: "Jerarquía",
            modalidad: "Modalidad",
            prioridad: "Prioridad",
            numPosiciones: "Número de posiciones",
            numVacantes: "Número de vacantes",
            area: "Área",
            subArea: "Subárea",
            tipoBusqueda: "Tipo de búsqueda",
            motivoBusqueda: "Motivo de búsqueda",
            motivoBusquedaPlaceholder: "Ej: Reemplazo, Crecimiento, Nueva posición",
            descripcion: "Descripción",
            responsabilidades: "Responsabilidades",
            perfil: "Perfil",
            conocimientosExcluyentes: "Conocimientos excluyentes",
            conocimientosDeseables: "Conocimientos deseables",
            competencias: "Competencias predeterminadas",
            competenciasHelper: "Se precargan al enviar un Test DISC en modo completo y orientan las preguntas de entrevista sugeridas por IA. En cada envío se pueden ajustar sin modificar la vacante.",
            salarioOfrecido: "Salario ofrecido",
            salary: "Rango salarial",
            currency: "Moneda",
            salarioMin: "Salario mínimo",
            salarioMax: "Salario máximo",
            salarioMonto: "Sueldo único",
            salarioTipo: "Tipo de sueldo",
            salarioVisible: "Mostrar salario a los candidatos",
            bonos: {
              title: "Bonos",
              tooltip: "Bonos asociados al cargo (nombre obligatorio; descripción y monto opcionales). Solo se usan para que el bot responda si un candidato pregunta; respetan el switch \"Mostrar salario\". No participan en cálculos ni reportes.",
              empty: "Este cargo no tiene bonos registrados.",
              nombre: "Nombre del bono",
              descripcion: "Descripción",
              monto: "Monto",
              add: "Agregar bono",
              remove: "Eliminar bono",
            },
            beneficios: {
              title: "Beneficios del cargo",
              tooltip: "Beneficios propios de esta vacante (nombre obligatorio; descripción opcional), por ejemplo seguro complementario o día administrativo. Se muestran al candidato y el bot los usa si le preguntan.",
              empty: "Este cargo no tiene beneficios registrados.",
              nombre: "Nombre del beneficio",
              descripcion: "Descripción",
              add: "Agregar beneficio",
              remove: "Eliminar beneficio",
            },
            condicionesPago: {
              enable: "Registrar condiciones económicas del encargo",
              title: "Condiciones económicas",
              internalNote: "Uso interno — no se muestra al candidato.",
              precio: "Precio del cargo",
              kickoff: "% Kick-off",
              cierre: "% Cierre",
              montoTramo: "Monto: {{monto}}",
            },
            autoSendRejectionEmail: "Enviar correo de descarte automáticamente",
            autoSendRejectionEmailHelper: "Si está activado, al descartar candidatos en esta vacante el envío del correo de no selección vendrá preseleccionado.",
            brandingTitle: "Branding del portal",
            brandingHelper: "Personaliza el logo y el nombre que verá el candidato en la página de postulación. Si no defines un logo aquí, se usa el del proyecto u organización.",
            brandingLogo: "Logo de la vacante (opcional)",
            brandingLogoHelper: "Reemplaza el logo del proyecto/organización solo para esta vacante.",
            brandingRemoveLogo: "Quitar logo",
            brandingCompanyName: "Nombre a mostrar",
            brandingCompanyNamePlaceholder: "Por defecto: nombre de la organización",
            brandingShowLogo: "Mostrar logo en el portal",
            brandingShowName: "Mostrar nombre de la empresa en el portal",
            fechaApertura: "Fecha de apertura",
            fechaCierre: "Fecha de cierre",
            country: "País",
            province: "Región / Estado",
            city: "Ciudad",
            statusLabel: "Estado",
            subtitle: "Completa los datos de la vacante",
            pipelineComingSoon: "Configuración del pipeline — siguiente paso",
            pipelineSkipHint: "Puedes guardar la vacante ahora y configurar el pipeline después.",
            required: "Este campo es requerido",
            next: "Siguiente",
            back: "Atrás",
            tabs: {
              general: "General",
              description: "Descripción",
              logistics: "Logística",
              salary: "Renta",
              pipeline: "Pipeline",
              questions: "Preguntas",
            },
            options: {
              salarioTipo: {
                rango: "Rango",
                unico: "Sueldo único",
              },
              modalidad: {
                presencial: "Presencial",
                remoto: "Remoto",
                hibrido: "Híbrido",
              },
              prioridad: {
                alta: "Alta",
                media: "Media",
                baja: "Baja",
              },
              tipoBusqueda: {
                internal: "Interna",
                external: "Externa",
                general: "General",
              },
              status: {
                draft: "Borrador",
                active: "Activo",
                suspended: "Suspendido",
                closed: "Cerrado",
                cancelled: "Cancelado",
                confidential: "Confidencial",
              },
              tipo: {
                vacancy: "Vacante",
                hunting: "Hunting",
                massive: "Reclutamiento masivo",
              },
            },
            pipeline: {
              catalogTitle: "Etapas disponibles",
              catalogSubtitle: "Selecciona las etapas que quieres incluir en el pipeline",
              activeStagesTitle: "Pipeline configurado",
              emptyStages: "Selecciona etapas del catálogo o crea etapas personalizadas",
              custom: "Custom",
              modules: "módulos",
              expandModules: "Ver módulos",
              moveUp: "Subir",
              moveDown: "Bajar",
              removeStage: "Eliminar etapa",
              modulesTitle: "Módulos de evaluación en esta etapa",
              addCustomTitle: "Agregar etapa personalizada",
              customStagePlaceholder: "Nombre de la etapa...",
              addStage: "Agregar",
              massiveNote: "El pipeline de reclutamiento masivo se configura en otro módulo",
              phaseCatalogTitle: "Fases disponibles",
              phaseCatalogSubtitle: "Selecciona las fases del proceso",
              stageCatalogTitle: "Agregar etapas predefinidas",
              stagesCount: "etapas",
              stageUsedElsewhere: "Esta etapa ya está en otra fase",
              moduleUsedElsewhere: "Ya está marcado en «{{stage}}». Desmárcalo ahí para usarlo en esta etapa.",
              backgroundCheckChileOnly: "Disponible solo para organizaciones que operan en Chile",
              // Consulta automática de antecedentes al llegar a la etapa (2026-10-13)
              backgroundCheckAuto: "Consultar automáticamente al llegar a esta etapa",
              backgroundCheckAutoHint: "Los antecedentes se consultan solos cuando un candidato llega a esta etapa, sin apretar el botón. A quienes agrega el equipo (importación, «Agregar postulantes», Hunting) se les consulta cuando completan su postulación. Cada consulta nueva cuesta {{points}} puntos; sin puntos suficientes no se consulta.",
              addCustomPhaseTitle: "Agregar fase personalizada",
              customPhasePlaceholder: "Nombre de la fase...",
              addPhase: "Agregar fase",
              templateSelector: "Partir desde plantilla",
              templateStandard: "Pipeline estándar (sistema)",
              templateDefaultSuffix: "predeterminada",
              templateReplaceConfirm: "Al aplicar la plantilla se reemplazará el pipeline que configuraste. ¿Continuar?",
              templateReplaceTitle: "Reemplazar pipeline",
              templateReplaceAction: "Aplicar plantilla",
              saveAsTemplate: "Guardar como plantilla",
              saveAsTemplateTitle: "Guardar pipeline como plantilla",
              saveAsTemplateHint: "El pipeline configurado quedará disponible como plantilla del proyecto para futuras vacantes.",
              templateNameField: "Nombre de la plantilla",
              templateSaved: "Plantilla guardada",
              templateSaveError: "No se pudo guardar la plantilla",
            },
            questions: {
              title: "Preguntas filtradoras",
              subtitle: "Las preguntas se mostrarán al candidato al momento de postular",
              generateAI: "Generar con IA",
              generating: "Generando...",
              aiSaveFirst: "Guarda la vacante primero para usar la IA",
              empty: "No hay preguntas configuradas",
              addTitle: "Agregar pregunta",
              questionLabel: "Texto de la pregunta",
              typeLabel: "Tipo",
              optionsLabel: "Opciones de respuesta (mínimo 2)",
              optionPlaceholder: "Agregar opción...",
              addOption: "Agregar",
              addQuestion: "Agregar pregunta",
              remove: "Eliminar pregunta",
            },
          },
        },
        candidates: {
          title: "Candidatos",
          found: "candidatos encontrados",
          search: "Buscar por nombre, email o profesión...",
          loadError: "Error al cargar los candidatos",
          deleteTitle: "Eliminar candidato",
          deleteConfirm: "¿Eliminar a {{name}} definitivamente?",
          deleteDetail: "Se eliminará su ficha, TODAS sus postulaciones (desaparecen de los kanban) y sus conversaciones del bot de captación. Esta acción no se puede deshacer.",
          deleteGo: "Eliminar definitivamente",
          deleteSuccess: "Candidato eliminado (ficha, postulaciones y conversaciones)",
          deleteError: "Error eliminando el candidato",
          noResults: "No hay candidatos registrados en este proyecto",
          noResultsSearch: "No se encontraron candidatos para esta búsqueda",
          blocked: "Bloqueados",
          blockedFound: "bloqueados",
          blockedOn: "Bloqueado el",
          noBlocked: "No hay candidatos bloqueados",
          name: "Nombre",
          profession: "Profesión",
          lastPosition: "Última vacante",
          appliedOn: "Fecha postulación",
          cv: "CV",
          noName: "Sin nombre",
          profile: "Perfil",
          currentPosition: "Cargo actual",
          phone: "Teléfono",
          country: "País",
          rut: "RUT / Identificación",
          salarioPretendido: "Pretensión de renta",
          registeredOn: "Registrado el",
          viewCv: "Ver CV",
          lastApplicationTitle: "Última postulación",
        },
        applications: {
          title: "Aplicaciones",
        },
        detail: {
          finalizeProcess: "Finalizar proceso",
          finalizeProcessTitle: "Finalizar proceso",
          finalizeProcessConfirm: "¿Estás seguro que deseas finalizar este proceso? Los candidatos quedarán en su estado actual.",
          reopenProcess: "Reabrir proceso",
          reopenProcessTitle: "Reabrir proceso",
          reopenProcessConfirm: "¿Estás seguro que deseas reabrir este proceso?",
          processClosed: "Proceso finalizado correctamente",
          processReopened: "Proceso reabierto correctamente",
          processStatusError: "Error al cambiar el estado del proceso",
          finalizeNote: "Nota",
          finalizeNotePlaceholderClose: "Ej: Proceso cerrado por cobertura de la vacante...",
          finalizeNotePlaceholderReopen: "Ej: Se reactiva el proceso por renuncia del candidato seleccionado...",
          finalizeNoteHelper: "La nota es opcional",
          edit: "Editar vacante",
          addExistingApplicant: "Agregar postulante existente",
          addApplicants: {
            title: "Agregar postulantes a la vacante",
            description: "Selecciona postulantes existentes del proyecto para incluirlos en esta vacante.",
            search: "Buscar por nombre o email...",
            withCv: "CV",
            withoutCv: "Sin CV",
            sendInvitation: "Enviar invitación por correo para que completen sus datos",
            add: "Agregar",
            cancel: "Cancelar",
            noApplicants: "No hay postulantes en este proyecto",
            loadError: "Error al cargar los postulantes",
            saveError: "Error al agregar los postulantes",
            summary: "{{added}} agregados · {{already}} ya estaban · {{missing}} sin CV",
            // Fase 0 (PLAN_IMPORTACION_COMPUTRABAJO): avisos del resultado
            rutMismatch: "{{names}}: se agregó sin vincular su cuenta del portal (la cuenta con ese correo tiene otro RUT)",
            pendingValidation: "{{names}}: se agregó como \"Por validar\" (su ficha no tiene correo)",
            noEmailSecondary: "Sin correo (por validar)",
          },
          currentPhase: "Fase actual",
          advancePhase: "Avanzar fase",
          retreatPhase: "Retroceder fase",
          phaseUpdated: "Fase actualizada",
          phaseUpdateError: "Error al actualizar la fase",
          selectStage: "Seleccionar etapa",
          stageUpdated: "Etapa actualizada",
          stageUpdateError: "Error al actualizar la etapa",
          discard: "Descartar candidato",
          discarded: "Descartados",
          discardTitle: "Confirmar descarte",
          discardConfirm: "¿Descartar la postulación de {{name}}?",
          discardConfirmButton: "Descartar",
          discardSendEmail: "Enviar correo de no selección",
          discardEmailSubject: "Asunto",
          discardEmailBody: "Cuerpo del correo",
          bulkDiscardTitle: "Descartar postulantes",
          bulkDiscardConfirm: "¿Descartar {{count}} postulantes seleccionados?",
          bulkEmailPreviewNote: "Se enviará este correo a cada postulante (el nombre se completa automáticamente). En el descarte masivo no es editable.",
          bulkDiscardSuccess: "{{count}} postulantes descartados",
          discardError: "Error al descartar el candidato",
          reactivate: "Reactivar",
          reactivated: "Candidato reactivado",
          block: "Bloquear",
          unblock: "Desbloquear",
          blockTitle: "Bloquear candidato",
          blockConfirm: "¿Bloquear a {{name}}? Quedará en la lista negra de la organización y no avanzará en ningún proceso.",
          blockReason: "Motivo del bloqueo",
          blockReasonPlaceholder: "Opcional (ej: no se presentó, datos falsos, etc.)",
          blockConfirmButton: "Bloquear",
          blockedChip: "Bloqueado",
          discardedChip: "Descartado",
          restore: "Restaurar",
          restored: "Candidato restaurado: vuelve a la etapa donde estaba",
          restoreError: "Error al restaurar el candidato",
          blocked: "Candidato bloqueado",
          unblocked: "Candidato desbloqueado",
          blockError: "Error al actualizar el bloqueo",
          actions: "Acciones",
          deleteApplication: "Eliminar postulación",
          deleteApplicationTitle: "Confirmar eliminación",
          deleteApplicationConfirm: "¿Estás seguro que deseas eliminar la postulación de {{name}}?",
          applicationDeleted: "Postulación eliminada correctamente",
          applicationDeleteError: "Error al eliminar la postulación",
          loadError: "Error al cargar la vacante",
          candidates: "Candidatos",
          info: "Información",
          pipeline: "Pipeline",
          allStages: "Todas las etapas",
          noApplications: "Aún no hay candidatos postulados a esta vacante",
          noApplicationsInStage: "No hay candidatos en esta etapa",
          candidate: "Candidato",
          source: "Origen",
          stage: "Etapa",
          appliedOn: "Fecha postulación",
          openPortal: "Abrir portal",
          duplicate: "Duplicar vacante",
          publicNameLabel: "Nombre público",
          pipelineComingSoon: "Configuración del pipeline — próximamente",
          viewPhaseNotes: "Ver notas de fase",
          phaseNotesTitle: "Notas del proceso",
        },
        backgroundReview: {
          title: "Revisión de antecedentes",
          status: {
            ok: "Sin observaciones",
            pendiente: "Pendiente",
            requiere_revision: "Requiere revisión",
            approved: "Revisión aprobada",
            rejected: "Revisión rechazada",
            // Sin consulta de antecedentes (2026-10-13; antes "Sin observaciones")
            sin_consultar: "Sin consultar",
          },
          notCheckedModule: "Se consultan con «Verificar antecedentes» en la columna «{{stage}}» ({{points}} puntos por consulta).",
          notCheckedAuto: "Se consultan solos al llegar a la columna «{{stage}}», o con «Verificar antecedentes» en esa columna ({{points}} puntos por consulta).",
          notCheckedNoModule: "Esta vacante no consulta antecedentes.",
          decidedAs: {
            approved: "Aprobada por",
            rejected: "Rechazada por",
          },
          changeDecision: "Cambiar decisión",
          notePlaceholder: "Nota de la revisión (opcional)…",
          approve: "Aprobar revisión",
          reject: "Rechazar",
          requestDocs: "Solicitar documentos",
          decisionSaved: "Decisión de revisión guardada",
          decisionError: "Error guardando la decisión",
          cardChip: "Antecedentes",
          filterChip: "Revisión de antecedentes",
          filterHint: "Mostrar solo candidatos que requieren revisión de antecedentes (transversal a las etapas)",
        },
        // Precio de la verificación de antecedentes en puntos (2026-11-01,
        // PLAN_COBRO_ANTECEDENTES): tooltips "Cómo se cobra" y avisos
        backgroundCheckPricing: {
          title: "Cómo se cobra",
          charge: "{{points}} puntos por cada consulta que trae un informe de Chapi.",
          free: "No se cobra si se reutiliza una consulta de menos de 30 días, si falla, si Chapi no tiene datos del RUT o si devuelve el mismo informe que ya tenía la ficha.",
          noPoints: "Sin puntos suficientes no se consulta.",
          noPointsAuto: "Sin puntos suficientes no se consulta: la persona queda «Sin consultar» y se puede verificar después con «Verificar pendientes».",
          moduleIntro: "Agrega «Verificar antecedentes» a esta columna.",
          short: "{{points}} puntos",
          upTo: "Hasta {{total}} puntos ({{count}} × {{points}})",
          recheck: "{{points}} puntos si Chapi trae un informe nuevo. Si este RUT ya se consultó en el mes, devuelve el mismo informe y no se cobra.",
          available: "Disponibles: {{points}} puntos",
          unlimited: "Puntos ilimitados",
          errors: {
            insufficient: "No te alcanzan los puntos para verificar antecedentes: cada consulta cuesta {{required}} y quedan {{remaining}}.",
            serviceNotAvailable: "La verificación de antecedentes no está incluida en el plan de tu organización.",
            noPointsSystem: "La verificación de antecedentes no está disponible: tu organización no tiene el sistema de puntos activo. Contacta a tu administrador.",
            unavailable: "La verificación de antecedentes no está disponible para tu organización.",
          },
          autoSkipped: {
            INSUFFICIENT_POINTS: "no quedan puntos suficientes (cada consulta cuesta {{required}}, quedan {{remaining}})",
            SERVICE_NOT_AVAILABLE: "la verificación no está incluida en el plan de tu organización",
            NO_POINTS_SYSTEM: "tu organización no tiene el sistema de puntos activo",
            default: "la verificación no está disponible para tu organización",
          },
          movedSkipped: "Etapa actualizada, pero no se consultaron los antecedentes de {{count}} candidato(s): {{reason}}. Quedaron «Sin consultar».",
        },
        // Módulo "Verificación de antecedentes" del pipeline (PLAN_MASIVO_PORTAL)
        backgroundCheckStage: {
          button: "Verificar antecedentes",
          // "Volver a consultar": consulta nueva aunque haya una reciente (quien
          // puede editar la vacante; antes solo super admin, 2026-10-13)
          forceRecheck: "Volver a consultar",
          forceRecheckHint: "Hace una consulta nueva en Chapi aunque haya una reciente.",
          forceRecheckConfirm: "Se hará una nueva consulta en Chapi: {{points}} puntos si trae un informe nuevo (si este RUT ya se consultó en el mes, devuelve el mismo y no se cobra). ¿Continuar?",
          recheckConfirmOne: "Se hará una nueva consulta en Chapi para {{name}}: {{points}} puntos si trae un informe nuevo (si este RUT ya se consultó en el mes, devuelve el mismo y no se cobra). ¿Continuar?",
          recheckConfirmBulk: "Se harán {{count}} consultas nuevas en Chapi: hasta {{total}} puntos ({{points}} c/u; no se cobran las de RUT ya consultados en el mes). ¿Continuar?",
          recheckBulk: "Volver a consultar ({{count}})",
          filters: {
            all: "Todos",
            none: "Sin consultar",
            consulted: "Consultados",
            error: "Con error",
            empty: "No hay postulantes con este filtro.",
          },
          // Columna con "Consultar automáticamente" encendido (2026-10-13)
          autoOn: "Consulta automática",
          autoOnHint: "Los antecedentes se consultan solos cuando un candidato llega a esta etapa ({{points}} puntos por consulta nueva).",
          forceRecheckGo: "Consultar ahora",
          forceRecheckDone: "Consulta nueva realizada",
          chileOnly: "La verificación de antecedentes está disponible solo para organizaciones que operan en Chile.",
          title: "Verificación de antecedentes — {{stage}}",
          costNote: "Cada consulta cuesta {{points}} puntos. No se cobra si se reutiliza una de menos de 30 días, si falla o si Chapi no tiene datos del RUT.",
          empty: "No hay postulantes en esta etapa.",
          loadError: "No se pudo cargar la información de antecedentes.",
          columns: { name: "Postulante", rut: "RUT", status: "Estado" },
          status: {
            none: "Sin consultar",
            processing: "En proceso",
            clean: "Sin alertas",
            flagged: "Con alertas",
            not_found: "Sin datos",
            error: "Error",
            notConsultable: "No consultable",
          },
          reason: {
            no_chilean_rut: "Sin RUT chileno",
            no_surnames: "Faltan nombres o apellidos separados en la ficha",
            outside_chile: "La organización no opera en Chile",
            not_configured: "Proveedor de antecedentes sin configurar",
            no_applicant: "Sin ficha del postulante",
          },
          review: {
            requiere_revision: "Requiere revisión",
            approved: "Revisión aprobada",
            rejected: "Revisión rechazada",
          },
          checkedOn: "Consultado el {{date}}",
          expired: "hace más de 30 días",
          verify: "Verificar",
          retry: "Reintentar",
          refresh: "Actualizar",
          verifying: "Verificando…",
          detail: "Ver detalle",
          verifyPending: "Verificar pendientes ({{count}})",
          confirmBulk: "Se consultarán {{count}} postulante(s): hasta {{total}} puntos ({{points}} c/u; las que fallen o no tengan datos no se cobran).",
          confirmBalance: "Tienes {{available}} puntos disponibles.",
          confirmShort: "Te alcanza para {{fit}}: el lote se detiene cuando se acaben los puntos.",
          bulkStopped: "El lote se detuvo: {{message}} Verificados: {{ok}}; quedaron {{left}} sin consultar.",
          confirm: "Confirmar",
          cancel: "Cancelar",
          progress: "Verificando {{done}} de {{total}}…",
          bulkDone: "Listo: {{ok}} verificado(s), {{failed}} con error.",
          verifyError: "No se pudo verificar los antecedentes",
          back: "Volver a la lista",
          reviewTitle: "Revisión",
          openProfile: "Abrir ficha del postulante",
          close: "Cerrar",
        },
        backgroundCheck: {
          title: "Antecedentes ({{provider}})",
          processing: "Procesando…",
          clean: "Limpio",
          flagged: "Alertas",
          causasCount: "{{count}} causa(s)",
          truncated: "Se muestran {{shown}} de {{total}} causas — el detalle completo está en el informe",
          nameMatchOnly: "Las causas calzaron solo por nombre: posible homonimia",
          score: "Riesgo {{label}} ({{value}})",
          scoreLabel: { low: "bajo", medium: "medio", high: "alto" },
          identity: {
            match: "Identidad verificada",
            partial: "Verificar nombre — diferencias menores con el nombre oficial",
            mismatch: "El nombre NO coincide con el RUT",
            not_found: "Sin datos para este RUT",
          },
          officialName: "Nombre según {{provider}}",
          officialNameRegistry: "Nombre según el registro civil",
          reportType: {
            penal: "Penal",
            civil: "Civil",
            laboral: "Laboral",
            cobranza: "Cobranza laboral y previsional",
            pep: "Persona políticamente expuesta",
            antecedentes: "Antecedentes",
          },
          fields: {
            caratulado: "Caratulado",
            rit: "RIT",
            ruc: "RUC",
            tribunal: "Tribunal",
            fechaIngreso: "Fecha de ingreso",
            rol: "Rol del candidato",
            formaInicio: "Forma de inicio",
            estado: "Estado",
            etapa: "Etapa",
            estadoProcesal: "Estado procesal",
            procedimiento: "Procedimiento",
            materia: "Materia",
            delitos: "Delitos",
            matchType: "Coincidencia",
          },
          matchType: { rut: "por RUT", name: "por nombre", nombre: "por nombre" },
          error: {
            title: "La consulta de antecedentes no se completó",
            insufficient_balance: "Sin saldo en el proveedor.",
            timeout: "El proveedor no respondió a tiempo.",
            provider_error: "Error del proveedor.",
            bad_request: "El proveedor rechazó la consulta.",
            auth: "Credenciales del proveedor inválidas.",
            not_configured: "El proveedor no está configurado.",
            incomplete: "El reporte quedó sin terminar.",
          },
          homonymDisclaimer: "Si alguna causa calzó solo por nombre puede ser homonimia: verificar con las referencias del informe antes de decidir.",
          openReport: "Ver informe en {{provider}}",
          retry: "Consultar antecedentes",
          retryHint: "{{points}} puntos si trae un informe; si vuelve a fallar, no se cobra.",
          retryOk: "Antecedentes consultados",
          retryFailedAgain: "La consulta volvió a fallar",
          retryError: "No se pudieron consultar los antecedentes",
        },
        captationVetoes: {
          title: "Tel\u00e9fonos vetados por el bot",
          description: "N\u00fameros bloqueados por la escalera anti-abuso de la captaci\u00f3n: el bot ignora en silencio sus mensajes en TODOS los canales. Quitar el veto es inmediato y vuelve a permitir postular.",
          empty: "No hay tel\u00e9fonos vetados \ud83c\udf89",
          phone: "Tel\u00e9fono",
          reason: "Motivo",
          vetoedAt: "Vetado el",
          remove: "Quitar veto",
          refresh: "Actualizar",
          evidence: "Ver evidencia",
          evidenceTitle: "Conversación del veto — {{phone}}",
          evidenceMeta: "Canal: {{channel}} · Iniciada: {{date}}",
          evidenceEmpty: "No hay transcript disponible para esta conversación",
          evidenceLoadError: "No se pudo cargar la conversación",
          removeConfirmTitle: "\u00bfQuitar el veto?",
          removeConfirmText: "El n\u00famero {{phone}} volver\u00e1 a poder conversar con el bot y postular. \u00bfContinuar?",
          removed: "Veto eliminado",
          removeError: "No se pudo quitar el veto",
          loadError: "No se pudieron cargar los vetos",
          reasons: {
            abuse: "Conducta ofensiva",
          },
        },
        captationRules: {
          marksTitle: "Marcas para revisar",
          autoDiscarded: "Descartado automáticamente por regla de la vacante",
          autoDiscardChip: "Auto",
        },
        // Descarga de candidatos a Excel desde el pipeline (PLAN_EXPORTACION_CANDIDATOS_ATS)
        export: {
          button: "Descargar Excel",
          downloading: "Descargando…",
          tooltip: "Descarga a todos los candidatos de la vacante, también descartados, bloqueados y por validar",
          empty: "La vacante no tiene candidatos",
          error: "No se pudo descargar el Excel. Intenta nuevamente.",
          forbidden: "No tienes permiso para descargar los candidatos de esta vacante",
          fileBase: "Candidatos",
        },
        pipeline: {
          lockedStage: "Etapa bloqueada — avanza la fase del proceso para desbloquear",
          dropHere: "Arrastra aquí",
          discardedColumn: "Descartado",
          noDiscarded: "Sin descartados",
          blockedColumn: "Bloqueado",
          noBlocked: "Sin bloqueados",
          pendingValidationColumn: "Por validar",
          noPendingValidation: "Sin pendientes",
          noPipeline: "Esta vacante no tiene un pipeline configurado",
          searchInStage: "Buscar...",
          noResults: "Sin resultados",
          cvScoreTooltip: "% de ajuste según filtrado CV",
        },
        // "Por validar" (PLAN_IMPORTACION_COMPUTRABAJO, fase 0)
        validation: {
          chip: "Por validar",
          reason: {
            email_in_use: "El correo {{email}} ya está en la ficha de {{name}}, y la persona no tenía otro.",
            not_same_person: "El correo {{email}} está en la ficha de {{name}}, y la persona indicó que no es ella.",
            other_rut: "El correo {{email}} ya está en la ficha de {{name}}, con otro RUT.",
            email_not_confirmed: "Su RUT está en la ficha de {{name}}, pero no pudo confirmar el correo de esa ficha. Postuló con {{email}}.",
            pending_email: "La ficha todavía no tiene correo: {{email}} quedó pendiente en una postulación anterior.",
            // Importación (fase 1): ficha sin correo y el correo del archivo es de otra ficha
            file_email_in_use: "La ficha no tiene correo y el del archivo importado ({{email}}) está en la ficha de {{name}}.",
            generic: "Hay datos de la persona que revisar antes de continuar.",
          },
          phone: "Teléfono: {{phone}}",
          validate: "Validar",
          dialogTitle: "Validar postulación de {{name}}",
          emailLabel: "Correo para la ficha",
          emailHelp: "Si el correo sigue en otra ficha, escribe otro correo de la persona.",
          confirmPerson: "Confirmo que es la persona. Su cuenta del portal se vincula a esta ficha y la postulación pasa a su etapa.",
          confirm: "Validar",
          cancel: "Cancelar",
          success: "Postulación validada",
          notLinked: "Postulación validada. La cuenta del portal no se vinculó: la ficha ya es de otra cuenta.",
          blocked: "Postulación validada, pero su correo está en la lista negra de la organización: quedó bloqueada.",
          emailInUse: "El correo {{email}} sigue en la ficha de {{name}}. Escribe otro correo para esta persona.",
          invalidEmail: "Escribe un correo válido",
          error: "No se pudo validar la postulación",
        },
        // Importación de postulantes desde un archivo (PLAN_IMPORTACION_COMPUTRABAJO, fase 1)
        import: {
          button: "Importar postulantes",
          title: "Importar postulantes",
          description: "Importa postulantes de cualquier portal (Computrabajo, Laborum, etc.) con la plantilla de esta vacante. Entran en la primera etapa, sin mensajes automáticos.",
          templateStep: "1. Descarga la plantilla de esta vacante y copia ahí los datos del portal, una fila por persona.",
          downloadTemplate: "Descargar plantilla",
          templateHelp: "Trae las columnas de datos y una columna por cada pregunta de filtro. En la hoja \"Instrucciones\" están las respuestas válidas.",
          fileStep: "2. Elige el portal de origen y el archivo.",
          originLabel: "Portal de origen",
          originHelp: "Queda guardado en cada postulación importada.",
          chooseFile: "Elegir archivo",
          fileHelp: ".xlsx, .xls o .csv; hasta 5 MB y 5.000 filas.",
          review: "Revisar archivo",
          cancel: "Cancelar",
          back: "Cambiar archivo",
          close: "Cerrar",
          importButton: "Importar ({{count}})",
          previewTitle: "Vista previa: {{file}}",
          counts: {
            toImport: "Para importar: {{count}}",
            new: "Fichas nuevas: {{count}}",
            existing: "Fichas existentes: {{count}}",
            pendingValidation: "Por validar: {{count}}",
            inPosition: "Ya en la vacante: {{count}}",
            errors: "No se importan: {{count}}",
            marked: "Con ⚠ para revisar: {{count}}",
            discarded: "Descartadas por las reglas: {{count}}",
            blocked: "Bloqueadas (lista negra): {{count}}",
          },
          // Explicación de cada indicador (tooltip del chip)
          countsHelp: {
            toImport: "Filas que se agregan a la vacante al pulsar Importar: fichas nuevas + fichas existentes + por validar. No se les envía ningún mensaje.",
            new: "Personas sin ficha en el proyecto: se les crea la ficha y la postulación.",
            existing: "Personas que ya tienen ficha en el proyecto (se encontraron por RUT o correo): se usa esa ficha y solo se completan los datos que le faltan.",
            pendingValidation: "El correo del archivo ya está en la ficha de otra persona. Entran a la vacante como \"Por validar\", fuera de las etapas, hasta que alguien las revise con \"Validar\".",
            inPosition: "Ya tienen postulación en esta vacante: no se modifican ni se duplican.",
            errors: "Filas con un error que impide importarlas (por ejemplo, sin correo o con un correo repetido en el archivo). El motivo está en la tabla de filas (en rojo), y al terminar puedes descargarlas para corregirlas.",
            marked: "Se importan con una marca ⚠: alguna respuesta no calza con las alternativas o, en vacantes masivas, una regla pide revisarla.",
            discarded: "Solo en vacantes masivas: se importan ya descartadas porque una respuesta no cumple una regla de descarte.",
            blocked: "Están en la lista negra de la organización: se importan como \"Bloqueada\".",
          },
          noRut: "Sin RUT: {{count}}. Entran igual; el RUT se les pide después.",
          blockedRow: "En la lista negra de la organización: entra Bloqueada",
          ignoredColumns: "Columnas no reconocidas (se ignoran): {{columns}}",
          questionsTitle: "Preguntas de filtro",
          questionsHelp: "Cada pregunta se vincula con la columna que tiene su texto. Si en tu archivo el encabezado es distinto, elige la columna.",
          questionsNoneLinked: "Este archivo no trae columnas con las preguntas: las personas entran sin respuestas. Solo elige una columna si las respuestas vienen con otro encabezado.",
          questionsSomeUnlinked: "Preguntas sin columna: {{count}}. Esas respuestas no se importan; si están en el archivo con otro encabezado, elige la columna.",
          noColumn: "Sin columna",
          fieldColumnOption: "{{header}} (columna de datos)",
          rowsTitle: "Filas del archivo ({{count}})",
          onlyReview: "Solo las que hay que revisar ({{count}})",
          noRutRow: "Sin RUT",
          discardedRow: "Se descarta",
          table: {
            row: "Fila",
            person: "Persona",
            status: "Estado",
            detail: "Detalle",
            pageRange: "{{from}}–{{to}} de {{count}}",
            nextPage: "Página siguiente",
            previousPage: "Página anterior",
          },
          status: {
            new: "Ficha nueva",
            existing: "Ficha existente",
            pending_validation: "Por validar",
            in_position: "Ya en la vacante",
            error: "No se importa",
          },
          errors: {
            MISSING_NAMES: "Sin nombres",
            MISSING_FIRST_LAST_NAME: "Sin apellido paterno",
            MISSING_EMAIL: "Sin correo",
            INVALID_EMAIL: "Correo inválido ({{value}})",
            DUPLICATE_EMAIL_IN_FILE: "Correo repetido en el archivo (fila {{row}})",
            DUPLICATE_RUT_IN_FILE: "RUT repetido en el archivo (fila {{row}})",
            SAVE_FAILED: "No se pudo guardar",
            REQUEST_FAILED: "No se alcanzó a importar",
          },
          warnings: {
            NO_RUT: "Sin RUT: entra igual",
            INVALID_RUT: "RUT inválido ({{value}}): entra sin RUT",
            INVALID_PHONE: "Teléfono ilegible ({{value}}): entra sin teléfono",
            INVALID_DATE: "Fecha no reconocida ({{value}}): se guarda tal cual",
            ANSWER_NOT_MATCHING: "{{question}}: \"{{value}}\" no calza con las alternativas (queda con ⚠)",
            OTHER_EMAIL: "Su RUT está en una ficha con otro correo ({{value}}): se usa esa ficha",
            EMAIL_IN_OTHER_APPLICANT: "Su ficha no tiene correo y este correo es de la ficha de {{value}}: queda Por validar",
            EMAIL_WITH_OTHER_RUT: "El correo es de la ficha de {{value}}, con otro RUT: queda Por validar",
            EMAIL_MATCH_OTHER_NAME: "Su correo está en la ficha de {{value}}, con otro nombre: se usa esa ficha (revisa que sea la misma persona)",
            SAME_PERSON_IN_FILE: "Misma persona que la fila {{row}}",
            HEADER_NOT_FIRST_ROW: "Los encabezados están en la fila {{row}}: se ignoraron las filas anteriores.",
            DUPLICATE_COLUMNS: "Columnas repetidas que no se usan: {{value}}",
            QUESTION_LIKE_FIELD: "La pregunta \"{{value}}\" se llama igual que una columna de datos: la primera columna con ese nombre se usa como dato y la siguiente como respuesta.",
            ROWS_NOT_READ: "Solo se leyeron las filas hasta la {{row}}: el archivo tiene más (las filas vacías también cuentan). Divídelo en dos archivos.",
            TOO_MANY_ROWS: "El archivo tiene más de {{max}} filas: solo se leyeron las primeras {{max}}.",
          },
          fileErrors: {
            FILE_REQUIRED: "Elige un archivo.",
            FILE_TOO_LARGE: "El archivo supera los 5 MB.",
            UNREADABLE_FILE: "No se pudo leer el archivo. ¿Es .xlsx, .xls o .csv?",
            EMPTY_FILE: "El archivo está vacío.",
            NO_ROWS: "El archivo no tiene filas con datos.",
            MISSING_COLUMNS: "Faltan columnas obligatorias: {{columns}}. Descarga la plantilla de la vacante y copia los datos ahí.",
            FORBIDDEN: "No tienes permiso para modificar esta vacante.",
            generic: "No se pudo revisar el archivo.",
          },
          importing: "Importando {{done}} de {{total}}…",
          doneTitle: "Importación terminada",
          doneSummary: "Fichas nuevas: {{added}} · Fichas existentes: {{existing}} · Por validar: {{pending}} · Ya estaban en la vacante: {{inPosition}} · No importadas: {{errors}}",
          doneMarks: "Con ⚠ para revisar: {{marked}} · Descartadas por las reglas: {{discarded}} · Bloqueadas: {{blocked}}",
          stopped: "La importación se detuvo: se procesaron {{done}} de {{total}} filas. Vuelve a importar el archivo: quienes ya entraron no se duplican.",
          downloadErrors: "Descargar filas no importadas",
          errorsFile: {
            name: "filas_no_importadas.xlsx",
            sheet: "No importadas",
            row: "Fila",
            reason: "Motivo",
          },
          sourceLabel: "Importado ({{origin}})",
          contactRut: "RUT: {{rut}}",
          contactDocument: "Documento: {{document}}",
          answersTitle: "Datos de la postulación (importados desde {{origin}})",
          template: {
            fileName: "plantilla_importacion",
            sheet: "Postulantes",
            instructionsSheet: "Instrucciones",
            instructionsTitle: "Plantilla de importación de postulantes — Vacante: {{position}}",
            colColumn: "Columna",
            colRequired: "Obligatoria",
            colFormat: "Formato y respuestas válidas",
            yes: "Sí",
            no: "No",
            columns: {
              names: "Nombres",
              firstLastName: "Apellido paterno",
              secondLastName: "Apellido materno",
              email: "Correo",
              phone: "Teléfono",
              document: "RUT o documento",
              nacionalidad: "Nacionalidad",
              comuna: "Comuna",
              region: "Región",
              appliedAt: "Fecha de postulación",
              experiencia: "Experiencia",
              formacion: "Formación",
            },
            formats: {
              names: "Texto",
              firstLastName: "Texto (solo el apellido paterno)",
              secondLastName: "Texto",
              email: "correo@dominio.cl. Sin correo, la fila no se importa.",
              phone: "Cualquier formato: +56 9 1234 5678, 912345678…",
              document: "RUT con o sin puntos y guion (12.345.678-5). Si es inválido, la persona entra sin RUT.",
              nacionalidad: "Texto (por ejemplo: Chilena, Venezolana)",
              comuna: "Texto",
              region: "Texto",
              appliedAt: "DD/MM/AAAA",
              experiencia: "Texto libre",
              formacion: "Texto libre",
            },
            questionText: "Texto libre",
            questionYesNo: "Sí o No",
            questionOptions: "Una de: {{options}} (si son varias, sepáralas con punto y coma)",
            note1: "Una fila por persona. Los encabezados van en la fila 1; el orden de las columnas da lo mismo y las columnas que no están en esta lista se ignoran.",
            note2: "Las respuestas que no calzan con las alternativas se guardan como texto y la postulación queda marcada con ⚠ para revisarla.",
          },
        },
        // Invitación por correo al portal ("Agregar postulantes" y Hunting):
        // solo si la vacante recibe postulaciones en el portal (2026-10-08).
        // Las claves de blocked son los motivos del backend (getPortalClosedReason)
        portalInvitation: {
          blocked: {
            not_active: "No se puede invitar: el estado de la vacante es «{{status}}». El link de la invitación solo funciona con la vacante activa.",
            not_visible: "No se puede invitar: la vacante no está visible en el portal. Enciende «Visible en portal» al editar la vacante.",
            limit_reached: "No se puede invitar: la vacante llegó a su límite de postulaciones y el portal ya no la muestra.",
          },
          notSent: "No se envió ninguna invitación: la vacante ya no recibe postulaciones en el portal.",
        },
        offer: {
          title: "Resultado de la oferta",
          accepted: "Aceptada",
          rejected: "Rechazada",
          pending: "Sin definir",
          reason: "Motivo del rechazo",
          reasonPlaceholder: "Ej: aceptó otra oferta, expectativa salarial, etc.",
          markAccepted: "Marcar aceptada",
          markRejected: "Marcar rechazada",
          confirmReject: "Confirmar rechazo",
          clear: "Quitar resultado",
          saved: "Resultado de la oferta actualizado",
          saveError: "No se pudo actualizar el resultado de la oferta",
          cardAction: "Oferta",
          dialogTitle: "Oferta",
          sendTitle: "Enviar oferta",
          sendButton: "Enviar oferta",
          resendOffer: "Volver a enviar oferta",
          subject: "Asunto",
          body: "Cuerpo",
          attachLetter: "Adjuntar carta de oferta",
          removeLetter: "Quitar",
          viewLastLetter: "Ver última carta enviada",
          sent: "Oferta enviada",
          sendError: "No se pudo enviar la oferta",
          loadError: "No se pudo cargar la plantilla",
          lastSent: "Oferta enviada el",
        },
        hire: {
          title: "Datos de contratación",
          startDate: "Fecha de ingreso",
          grossSalary: "Sueldo bruto",
          grossSalaryPlaceholder: "Ej: $1.500.000",
          save: "Guardar",
          saved: "Datos de contratación guardados",
          saveError: "No se pudieron guardar los datos",
          sendEmail: "Enviar email de contratación",
          cardAction: "Contratación",
          lastSent: "Correo de contratación enviado el",
          resend: "Volver a enviar el correo",
          resendHint: "Ya se envió el correo de contratación. Si necesitas enviarlo de nuevo, toca «Volver a enviar el correo».",
          email: {
            title: "Email de contratación",
            toCandidate: "Para",
            receptionData: "Datos de recepción",
            receiver: "Nombre de quien lo recibe",
            contact: "Teléfono de contacto",
            address: "Dirección de la empresa",
            time: "Hora de presentación",
            preview: "Vista previa (no editable)",
            subject: "Asunto",
            body: "Cuerpo",
            send: "Enviar",
            sent: "Correo de contratación enviado",
            sendError: "No se pudo enviar el correo",
            loadError: "No se pudo cargar la plantilla",
            missing: "Faltan datos",
          },
        },
        documents: {
          sectionTitle: "Documentos",
          requestButton: "Solicitar documentos",
          none: "Aún no se solicitaron documentos.",
          uploaded: "Subido",
          pending: "Pendiente",
          download: "Descargar",
          dialogTitle: "Solicitar documentos",
          dialogHelp: "Elige los documentos que el candidato debe subir. Los nuevos quedan guardados en el catálogo del proyecto para reutilizarlos.",
          catalogTitle: "Documentos del proyecto",
          catalogEmpty: "El proyecto todavía no tiene documentos en el catálogo. Agrega uno abajo.",
          required: "Obligatorio",
          newDocsTitle: "Documentos nuevos a agregar",
          addNewTitle: "Agregar un documento nuevo",
          labelField: "Nombre del documento",
          labelPlaceholder: "Ej: Certificado de antecedentes",
          instructionsField: "Instrucciones (opcional)",
          addButton: "Agregar",
          cancel: "Cancelar",
          sendButton: "Enviar solicitud",
          sent: "Solicitud enviada al candidato",
          sentNoEmail: "Solicitud guardada, pero no se pudo enviar el correo",
          sentWhatsapp: "Solicitud enviada por WhatsApp",
          channelTitle: "Canal de envío",
          channelEmail: "Correo (link de carga)",
          channelWhatsapp: "WhatsApp",
          channelWhatsappUnavailable: "WhatsApp no está disponible para esta organización: no tiene número propio ni el número compartido de Grafton permitido por un super-admin, o su canal está apagado (ATS → Configuración → WhatsApp → Canal).",
          channelNoPhone: "WhatsApp no está disponible porque el candidato no tiene teléfono registrado.",
          channelWhatsappHint: "Se enviará una plantilla de WhatsApp y el candidato podrá adjuntar los documentos respondiendo al bot.",
          sendError: "No se pudo enviar la solicitud",
          loadError: "No se pudo cargar el catálogo",
          selectAtLeastOne: "Selecciona al menos un documento",
          nothingPending: "Solicitud actualizada. No se envió nada porque no quedan documentos pendientes.",
          // Chip de la tarjeta del kanban (PLAN_SOLICITUD_DOCUMENTOS_MASIVA)
          cardChip: "Docs {{uploaded}}/{{total}}",
          cardChipComplete: "Docs ✓",
          // Solicitud masiva: módulo de la columna y barra de selección
          bulk: {
            columnButton: "Solicitar documentos",
            toolbarButton: "Solicitar documentos",
            title: "Solicitud de documentos",
            titleStage: "Solicitud de documentos — {{stage}}",
            statusHelp: "Avance de los documentos pedidos a los candidatos de esta etapa.",
            refresh: "Actualizar",
            filter: {
              all: "Todos ({{count}})",
              none: "Sin solicitud ({{count}})",
              pending: "Con pendientes ({{count}})",
              complete: "Completos ({{count}})",
            },
            colCandidate: "Candidato",
            colDocuments: "Documentos",
            colRequested: "Última solicitud",
            stateNone: "Sin solicitud",
            stateProgress: "{{uploaded}} de {{total}}",
            stateComplete: "Completo",
            viewCandidate: "Ver ficha",
            emptyStage: "No hay candidatos en esta etapa.",
            emptyFilter: "No hay candidatos con este filtro.",
            newRequest: "Nueva solicitud",
            newRequestTitle: "Nueva solicitud de documentos",
            documentsHelp: "Los documentos se suman a lo que cada candidato ya tenía pedido: no se quita nada, lo ya subido se conserva y un obligatorio sigue siéndolo. Cada uno recibe la lista de todo lo que le queda pendiente; a quien ya subió todo no se le envía nada. Los documentos nuevos quedan en el catálogo del proyecto.",
            whatsappHint: "Cada candidato recibe la plantilla de WhatsApp y envía los documentos respondiendo al bot. A quien no tenga un teléfono válido o tenga una conversación activa con el bot no se le envía; queda en el resumen.",
            candidatesTitle: "Candidatos",
            selectAll: "Seleccionar todos",
            noEmail: "Sin correo",
            removeDoc: "Quitar documento",
            noCandidates: "No hay candidatos a quienes enviar.",
            missing: "Pendientes: {{docs}}",
            send: "Enviar a {{count}}",
            remindButton: "Recordar a pendientes ({{count}})",
            remindTitle: "Recordar documentos pendientes",
            remindHelp: "Se reenvía la solicitud a los candidatos marcados. Cada uno recibe solo los documentos que le faltan.",
            remindNone: "No hay candidatos con documentos pendientes.",
            remindSend: "Enviar recordatorio ({{count}})",
            sending: "Enviando {{done}} de {{total}}…",
            sendingHint: "No cierres esta ventana hasta que termine.",
            resultSent: "Enviados: {{count}}",
            resultAlready: "Ya tenían todo lo pedido, no se les envió nada: {{count}}",
            resultFailed: "No enviados: {{count}}",
            resultStopped: "Se detuvo el envío: {{message}}",
            emailFailed: "Se guardó la solicitud, pero no se pudo enviar el correo",
            retryFailed: "Reintentar los no enviados",
            viewStatus: "Ver estado",
            back: "Volver",
            close: "Cerrar",
          },
        },
        modules: {
          title: "Módulos disponibles en esta etapa",
          noModules: "Esta etapa no tiene módulos configurados",
          currentStage: "Etapa actual",
          launch: "Enviar",
          launching: "Enviando...",
          launchSuccess: "{{module}} enviado correctamente",
          launchError: "Error al enviar el módulo",
          noApplicantId: "No se encontró el applicant asociado",
          cvFilteringRedirect: "Para filtrado de CV ve al módulo de CV Filtering",
          psycholaboralRedirect: "Para evaluación psicolaboral ve al módulo de Reportes",
          interviewNote: "La entrevista debe coordinarse manualmente",
          applicationInfo: "Información de la postulación",
          notes: "Notas",
          discTest: 'Test DISC',
          reasoningTest: 'Test de capacidades',
          personalSkills: 'Habilidades personales',
          salesAssessment: 'Assessment de ventas',
          cvFiltering: 'Filtrado de CV',
          interview: 'Entrevista',
          psicolaboral: 'Evaluación Psicolaboral',
          psicolaboralRecommendation: 'Para un mejor informe psicolaboral se recomienda que el candidato tenga CV, Test DISC, tests de razonamiento y entrevista.',
          psychoComparison: 'Ranking psicolaboral',
          psychoComparisonTooltip: 'Comparación Evaluaciones',
          psychoComparisonNoPsico: 'Requiere el módulo Evaluación Psicolaboral en el pipeline',
          psychoComparisonAfterPsico: 'Solo disponible en la etapa de la Evaluación Psicolaboral o en etapas posteriores',
          filteringAnswers: "Respuestas del formulario",
        },
        moveDialog: {
          titleStage: "Mover candidato de etapa",
          titlePhase: "Avanzar fase del proceso",
          noteLabel: "Nota",
          notePlaceholder: "Ej: Perfil interesante, pasa a la siguiente etapa...",
          notePlaceholderPhase: "Ej: Avanzamos porque ya tenemos candidatos suficientes para evaluar...",
          noteOptional: "La nota es opcional",
          confirm: "Confirmar",
        },
        // Selector de etapas de la ficha del candidato (cambio de etapa con un clic)
        stageSelector: {
          moveTo: "Mover a «{{stage}}»",
          lock: {
            positionClosed: "La vacante está cerrada; no se pueden mover candidatos.",
            positionCancelled: "La vacante está cancelada; no se pueden mover candidatos.",
            noPermission: "No tienes permiso para editar esta vacante.",
            discarded: "Candidato descartado. Restáuralo para moverlo de etapa.",
            blocked: "Candidato bloqueado; no se puede mover de etapa.",
            pendingValidation: "Candidato por validar. Valídalo desde su tarjeta en el pipeline para moverlo de etapa.",
          },
        },
        cvFilter: {
          button: "Filtrado de CV",
          dialogTitle: "Filtrado de CV",
          newFiltering: "Nuevo filtrado",
          dialogSubtitle: "Selecciona los candidatos a evaluar contra el descriptor del cargo",
          selectAll: "Seleccionar todos",
          launch: "Filtrar {{count}} candidatos",
          launching: "Iniciando...",
          launched: "Filtrado iniciado correctamente",
          error: "Error al iniciar el filtrado",
          noFilterings: "No hay filtrados para esta vacante. Crea uno nuevo.",
          noResults: "No se obtuvieron resultados",
          noApplicantId: "Sin applicant asociado",
          downloadReport: "Descargar reporte PDF",
        },
        notes: {
          placeholder: "Escribe una nota sobre el candidato...",
          add: "Agregar nota",
          save: "Guardar",
          empty: "Sin notas",
          error: "Error al guardar la nota",
          confirmDelete: "¿Eliminar?",
          edited: "(editada)",
          noteChip: "Nota",
          editTooltip: "Editar nota",
          deleteTooltip: "Eliminar nota",
          stageEditHint: "Si dejas el texto vacío, la nota se elimina; el registro del movimiento se conserva.",
        },
        cvSummary: {
          title: "Resumen CV (IA)",
          generate: "Generar resumen con IA (0.1 pts)",
          generating: "Generando resumen...",
          generated: "Resumen generado correctamente",
          regenerate: "Regenerar",
          regenerateConfirm: "Regenerar el resumen reemplazará el actual y cobrará 0.1 puntos. ¿Continuar?",
          regenerateAction: "Regenerar (0.1 pts)",
          error: "Error al generar el resumen. Intenta nuevamente.",
          limitReached: "No tienes puntos suficientes para generar el resumen",
          unreadable: "No se pudo leer el CV (archivo dañado o escaneado sin texto)",
          noCv: "El candidato no tiene CV cargado",
          staleWarning: "Este resumen fue generado con un CV anterior. Considera regenerarlo.",
          yearsExperience: "Años de experiencia",
          experience: "Experiencia",
          education: "Educación",
          flags: "Señales a revisar",
          generatedOn: "Generado el",
          viewCv: "Ver CV (se abre en una pestaña nueva)",
        },
        interviewQuestions: {
          title: "Preguntas de entrevista",
          // Preguntas del cargo (modal de entrevistas)
          positionTitle: "Preguntas del cargo",
          positionEmptyHint: "Pide sugerencias a la IA o escribe las preguntas del cargo, iguales para todos los candidatos.",
          positionReadyHint: "Las respuestas de cada candidato se anotan en su ficha.",
          defineQuestions: "Definir preguntas",
          viewPosition: "Ver y editar preguntas ({{count}})",
          positionEmpty: "Este cargo aún no tiene preguntas de entrevista.",
          hint: "Las preguntas son iguales para todos los candidatos del cargo. La IA sugiere 5 a partir de la información del cargo (0.1 pts) y tú eliges cuáles agregar; también puedes escribirlas. Máximo 10 por cargo.",
          writeManually: "Escribir manualmente",
          positionEditHint: "Estas preguntas son iguales para todos los candidatos del cargo. Los cambios se aplican al presionar Guardar (máximo 10). Si editas o quitas una pregunta, las respuestas ya anotadas se conservan.",
          questionRequired: "La pregunta no puede quedar vacía",
          rationale: "Qué evalúa: {{text}}",
          addQuestion: "Agregar pregunta",
          newQuestionPlaceholder: "Escribe la pregunta...",
          add: "Agregar",
          deleteQuestion: "Quitar pregunta",
          questionsCount: "{{current}} de {{max}} preguntas",
          maxReached: "Llegaste al máximo de {{max}} preguntas por cargo",
          blankQuestions: "Hay preguntas vacías: complétalas o quítalas antes de guardar.",
          back: "Atrás",
          positionSaved: "Preguntas del cargo guardadas",
          unsavedTitle: "¿Volver sin guardar?",
          unsavedConfirm: "Tienes cambios sin guardar en las preguntas del cargo. Si vuelves ahora, se perderán.",
          keepEditing: "Seguir editando",
          leaveWithoutSaving: "Volver sin guardar",
          conflictTitle: "Alguien más guardó cambios",
          conflictText: "Mientras editabas, otra persona del equipo guardó las preguntas de este cargo. Puedes cargar su versión (pierdes tus cambios) o guardar la tuya igual (reemplaza la suya).",
          conflictReload: "Cargar su versión",
          conflictOverwrite: "Guardar la mía",
          // Sugerencias de la IA (siempre 5, seleccionables)
          suggest: "Sugerir 5 con IA (0.1 pts)",
          suggesting: "Generando sugerencias...",
          suggested: "Sugerencias listas: marca las que quieras agregar",
          suggestionsTitle: "Sugerencias de la IA",
          suggestionsHint: "Marca las que quieras agregar al cargo (puedes agregar {{room}} más).",
          suggestionsNoRoom: "El cargo ya tiene {{max}} preguntas. Quita alguna para agregar sugerencias.",
          addSelected: "Agregar seleccionadas ({{count}})",
          discardSuggestions: "Descartar sugerencias",
          replaceSuggestionsTitle: "¿Pedir otras sugerencias?",
          replaceSuggestionsConfirm: "Las sugerencias que no agregaste se reemplazan por 5 nuevas y se descuentan 0.1 pts.",
          replaceSuggestionsAction: "Sugerir otras 5",
          serviceNotAvailable: "Este servicio no está habilitado para tu organización",
          limitReached: "No tienes puntos suficientes para pedir sugerencias a la IA",
          error: "No se pudieron generar las sugerencias. Intenta nuevamente.",
          // Botón "Entrevistas" de la columna del kanban
          columnTooltipEmpty: "Registra entrevistas y define las preguntas del cargo (con IA o a mano), iguales para todos los candidatos.",
          columnTooltipReady: "Preguntas del cargo listas ({{count}}). Las respuestas se anotan en la ficha de cada candidato.",
          // Respuestas del candidato (drawer)
          answer: "Anotar respuestas ({{answered}}/{{total}})",
          viewAnswers: "Ver respuestas ({{answered}}/{{total}})",
          viewAnswersPlain: "Ver respuestas",
          missingPositionQuestions: "Este cargo aún no tiene preguntas. Defínelas (con IA o a mano) desde Entrevistas, en la columna de la etapa.",
          sharedHint: "El equipo de la vacante ve estas respuestas. Los cambios se guardan automáticamente.",
          removedTitle: "Preguntas eliminadas del cargo",
          answerPlaceholder: "Respuesta o comentarios del candidato...",
          noAnswer: "Sin respuesta",
          saving: "Guardando...",
          saved: "Guardado",
          notSaved: "Sin guardar",
          saveError: "No se pudieron guardar los cambios. Revisa tu conexión.",
        },
        stats: {
          tab: "Estadísticas",
          totalTime: "Tiempo total del proceso",
          inProgress: "En curso",
          closed: "Cerrado",
          startedOn: "Inicio",
          closedOn: "Cierre",
          approx: "(aprox.)",
          candidatesTotal: "Candidatos",
          active: "Activos",
          discarded: "Descartados",
          blocked: "Bloqueados",
          hired: "Contratados",
          phaseTimes: "Tiempo por fase",
          stageTable: "Detalle por etapa",
          thStage: "Etapa",
          thPhase: "Fase",
          thCurrent: "Actuales",
          thPassed: "Pasaron por",
          thDiscarded: "Descartados",
          thAvgTime: "Tiempo promedio",
          noPipeline: "Esta vacante no tiene un pipeline configurado",
          liveNote: "Las estadísticas se calculan en vivo con los datos actuales del proceso. Si el proceso se reabre, los tiempos se siguen actualizando hasta el próximo cierre.",
        },
        psychoComparison: {
          dialogTitle: "Ranking psicolaboral",
          newComparison: "Nuevo ranking",
          dialogSubtitle: "Se comparan los candidatos con evaluación psicolaboral completada. Todos vienen seleccionados; puedes ajustar la selección (mínimo 2).",
          selectAll: "Seleccionar todos",
          launch: "Crear ranking ({{count}})",
          launching: "Iniciando...",
          launched: "Ranking iniciado correctamente",
          error: "Error al crear el ranking",
          noComparisons: "No hay rankings para esta vacante. Crea uno nuevo.",
          noEligible: "Ningún candidato tiene evaluación psicolaboral completada",
          reportNotReady: "Informe psicolaboral en proceso o no disponible",
          notEnough: "Se requieren al menos 2 candidatos",
          limitReached: "Límite de uso alcanzado para comparaciones",
          tableCandidates: "Candidatos",
          tableStatus: "Estado",
          tableDate: "Fecha",
          statusPending: "Pendiente",
          statusProcessing: "Procesando",
          statusCompleted: "Completado",
          statusError: "Error",
          viewResults: "Ver resultados",
          retry: "Reintentar",
          ranking: "Ranking de candidatos",
          totalCandidates: "Candidatos",
          affinity: "Afinidad",
          overallRecommendation: "Recomendación general",
          downloadReport: "Descargar informe Word",
          noResults: "No se obtuvieron resultados",
        },
        testDialog: {
          subtitle: "Selecciona los candidatos a quienes enviar el test",
          discPositionInfo: "Se usará el cargo de esta vacante para el análisis del test.",
          sending: "Enviando tests...",
          sent: "{{count}} test(s) enviados correctamente",
          failed: "{{count}} test(s) no pudieron enviarse",
          send: "Enviar a {{count}} candidatos",
          sendNew: "Nuevo envío",
          newSend: "Enviar test",
          noTestsSent: "No se han enviado tests de este tipo para esta vacante",
          selectTypes: "Selecciona los tipos de test",
          selectAtLeastOneType: "Selecciona al menos un tipo de test",
        },
        drawer: {
          testsTitle: "Tests",
          testNotSent: "No enviado",
          processTest: "Procesar test",
          viewResult: "Ver resultado",
          testProcessing: "Test enviado a procesar",
          testProcessError: "Error al procesar el test",
          sendTest: "Enviar test",
          resendTest: "Reenviar test",
          registerInterview: "Registrar entrevista",
          generatePsico: "Generar evaluación",
          prevCandidate: "Anterior",
          nextCandidate: "Siguiente",
          navPosition: "{{index}} de {{total}}",
          navStageHint: "Candidatos de «{{stage}}», en el orden de la columna",
          navOutOfStage: "— de {{total}}",
          navOutOfStageHint: "Ya no está en «{{stage}}»: anterior y siguiente siguen desde su lugar en esa etapa",
        },
        interview: {
          selectCandidate: "Selecciona un candidato para ver o registrar sus entrevistas",
          noCandidates: "No hay candidatos en esta etapa",
          noApplicantId: "Sin applicant asociado",
          replace: "Reemplazar",
          replaceTitle: "Reemplazar entrevista",
          replaceConfirm: "¿Eliminar esta entrevista? Luego podrás registrar una nueva para esta vacante.",
          replaceSuccess: "Entrevista eliminada. Puedes registrar una nueva.",
          replaceError: "No se pudo eliminar la entrevista",
        },
        testStatus: {
          pending: 'Pendiente',
          sent: 'Enviado',
          started: 'Iniciado',
          completed: 'Completado',
          processing: 'Procesando',
          evaluated: 'Evaluado',
          error: 'Error',
          expired: 'Expirado',
          invalid: 'Inválido',
        },
        interviewStatus: {
          botInMeeting: 'Bot en reunión',
          assignParticipants: 'Asignar participantes',
          completed: 'Completada',
          error: 'Error',
        },
        sendClient: {
          button: "Enviar al cliente",
          title: "Enviar fichas al cliente",
          description: "Se enviará un solo correo al cliente con la ficha (CV + resumen ejecutivo) de {{count}} candidato(s).",
          clientEmail: "Email del cliente",
          invalidEmail: "Email inválido",
          subject: "Asunto",
          body: "Mensaje",
          candidates: "Candidatos",
          resumenReady: "Resumen ejecutivo listo",
          resumenMissing: "Sin resumen ejecutivo",
          attachNote: "El correo lista a cada candidato con botones para ver su CV y su resumen ejecutivo (cuando estén disponibles).",
          bodyHint: "La lista de candidatos con sus botones se inserta automáticamente en el correo.",
          previewHint: "Presiona los botones para previsualizar lo que recibirá el cliente.",
          viewCv: "Ver CV",
          viewResumen: "Ver resumen",
          missingResumenWarning: "{{count}} candidato(s) no tienen resumen ejecutivo generado. Puedes generarlo antes de enviar o continuar sin él.",
          send: "Enviar correo",
          success: "Correo enviado a {{email}}",
          partialWarning: "Correo enviado, pero faltaron adjuntos: {{detail}}",
          resumenWord: "resumen",
          error: "No se pudo enviar el correo al cliente",
          defaultSubject: "Candidatos preseleccionados — {{position}}",
          defaultBody: "Estimado/a,\n\nComparto los candidatos preseleccionados para el cargo de {{position}}. Adjunto encontrará el CV y el resumen ejecutivo de cada uno.\n\nQuedamos atentos a sus comentarios.\n\nSaludos cordiales.",
        },
        psycholaboral: {
          title: "Evaluación Psicolaboral",
          noReports: "No hay evaluaciones psicolaborales para esta vacante",
          viewReport: "Ver informe",
          refresh: "Actualizar",
          newEvaluation: "Nueva evaluación",
          replace: "Reemplazar",
          downloadSummary: "Resumen (PDF)",
          replaceTitle: "Reemplazar evaluación psicolaboral",
          replaceWarning: "Generar un nuevo informe descuenta puntos de tu plan, igual que una evaluación nueva.",
          replaceConfirm: "Se eliminará el informe actual y deberás generar uno nuevo. Esta acción no se puede deshacer.",
          replaceSuccess: "Informe eliminado. Genera el nuevo informe.",
          replaceError: "No se pudo eliminar el informe",
          selectCandidate: "Seleccionar candidato",
          filesTitle: "Archivos que se cargarán",
          fileCV: "CV del candidato",
          fileDISC: "Test DISC evaluado",
          fileReasoning: "Test de razonamiento evaluado",
          fileInterview: "Transcripción de entrevista",
          available: "Disponible",
          notAvailable: "No disponible (opcional)",
          notAvailableRequired: "No disponible — requerido",
          noCvAlert: "El candidato no tiene CV cargado. Es obligatorio para generar la evaluación.",
          generate: "Generar evaluación",
          generating: "Generando...",
          generateSuccess: "¡Evaluación generada correctamente!",
          generateError: "Error al generar la evaluación",
          backToList: "Volver a la lista",
          statusCreating: "Creando informe...",
          statusAttaching: "Adjuntando archivos ({{current}}/{{total}})...",
          statusProcessing: "Procesando con IA...",
        },
      },
      jobBoard: {
        title: "Empleos",
        titleWithCompany: "Trabaja en {{company}}",
        searchPlaceholder: "¿Qué trabajo buscas?",
        jobsCount: "{{count}} empleos",
        empty: "No hay vacantes publicadas en este momento",
        publishedOn: "Publicada el",
        publishedBy: "Publicada por",
        apply: "Postular",
        backToList: "Volver al listado",
        signIn: "Ingresa o regístrate",
        myApplications: "Mis postulaciones",
        generalTitle: "Portal de empleos",
        companyJobs: "Ver más empleos de {{company}}",
        notFoundTitle: "Página no encontrada",
        notFoundBody: "Esta web de empleos no existe o ya no está disponible.",
        viewAllJobs: "Ver todos los empleos",
        // Página de una feria (/feria/:slug, PLAN_FERIAS)
        fair: {
          subtitle: "Vacantes de {{company}}",
          empty: "Por ahora no hay vacantes abiertas en esta feria.",
          alreadyApplied: "Ya postulaste",
          notFoundTitle: "Esta feria no está disponible",
          notFoundBody: "Puede que haya terminado o que el link no esté completo.",
        },
        // Página de una vacante (/vacante/:id, el link que entrega el ATS, 2026-10-25)
        vacancy: {
          closed: "Cerrada",
          closedBody: "Esta vacante está cerrada y ya no recibe postulaciones.",
          paused: "No recibe postulaciones",
          pausedBody: "Esta vacante no está recibiendo postulaciones en este momento.",
          unavailableTitle: "Esta vacante no está disponible",
          unavailableBody: "Puede que ya no esté publicada o que el link no esté completo.",
          seeOpenPositions: "Ver vacantes abiertas",
        },
        // Botón del detalle de una vacante para compartir su link (2026-10-25)
        share: {
          copy: "Copiar enlace",
          copied: "Enlace copiado",
          share: "Compartir",
          copyManually: "Copia el enlace de la vacante:",
        },
      },
      portal: {
        // Postulación desde una feria (PLAN_FERIAS)
        fair: {
          backToFair: "Ver más vacantes de la feria",
          headerLink: "Feria",
          signedInAs: "Postulando como",
          reusedTitle: "Usamos tus respuestas de la postulación anterior en esta feria",
          reusedDocs: "Documentos de extranjería ya subidos: {{count}}",
          edit: "Editar",
        },
        documents: {
          title: "Subir documentos",
          greeting: "Hola",
          intro: "Necesitamos que subas los siguientes documentos para continuar con tu proceso.",
          introWithPosition: "Necesitamos que subas los siguientes documentos para tu proceso del cargo de {{position}}.",
          allDone: "¡Listo! Recibimos todos los documentos.",
          uploaded: "Subido",
          replace: "Reemplazar",
          upload: "Subir",
          invalidTitle: "Enlace no válido",
          invalidBody: "Este enlace no es válido o ya expiró. Si crees que es un error, contacta a la empresa.",
          pendingRequired: "Te quedan {{count}} documento(s) obligatorio(s) por subir.",
          uploadError: "No se pudo subir el archivo. Intenta nuevamente.",
        },
        stepPersonalData: "Datos personales",
        stepQuestions: "Preguntas",
        next: "Continuar",
        closesOn: "Cierra el",
        positionDescription: "Descripción del cargo",
        positionResponsabilities: "Responsabilidades",
        positionProfile: "Perfil requerido",
        positionRequiredKnowledge: "Conocimientos requeridos",
        positionDesirableKnowledge: "Conocimientos deseables",
        positionBenefits: "Beneficios del cargo",
        title: "Portal de Postulantes",
        documentTitle: "Ingresa tu documento de identidad",
        documentSubtitle: "Indica tu nacionalidad e ingresa tu documento para continuar",
        documentLabel: "Documento de identidad",
        documentRequired: "El documento es requerido",
        documentInvalid: "El {{doc}} ingresado no es válido",
        // Acceso con correo y "Completa tus datos" (PLAN_MASIVO_PORTAL)
        emailAccess: {
          title: "Ingresa con tu correo",
          subtitle: "Te enviaremos un código de 6 dígitos. Si es tu primera vez, después crearás tu cuenta.",
        },
        identityStep: {
          title: "Completa tus datos",
          subtitleNew: "Es tu primera vez con {{email}}. Indica tu nacionalidad y tu documento para crear tu cuenta.",
          subtitleComplete: "Para continuar, indica tu nacionalidad y tu documento de identidad.",
          create: "Crear cuenta",
          save: "Guardar y continuar",
          saving: "Guardando...",
          documentInUse: "Ese documento ya está registrado con {{email}}.",
          useThatAccount: "Enviarme el código a ese correo",
          expired: "Pasó demasiado tiempo desde que confirmaste tu correo. Vuelve a ingresarlo para continuar.",
          restart: "Volver a ingresar mi correo",
          saveError: "No pudimos guardar tus datos. Intenta nuevamente.",
        },
        // Acceso: el documento se pide según la nacionalidad (PLAN_MASIVO_PORTAL)
        access: {
          nationality: "Nacionalidad",
          otherNationality: "Otra",
          nationalityOther: "Escribe tu nacionalidad",
          nationalityRequired: "Selecciona tu nacionalidad",
          nationalityOtherRequired: "Escribe tu nacionalidad",
          hasRut: "¿Tienes RUT chileno?",
          hasRutRequired: "Indica si tienes RUT chileno",
          documentType: "¿Con qué documento quieres ingresar?",
          nationalDoc: "{{doc}} de tu país",
          passport: "Pasaporte",
        },
        countryOther: "Otro",
        rutHint: "Ej: 12.345.678-9",
        rutVerified: "Documento verificado al ingresar",
        emailInUse: "Este email ya está asociado a otro documento",
        emailStepSubtitle: "Es tu primer ingreso: te enviaremos un código de verificación a tu email",
        tooManyRequests: "Has solicitado demasiados códigos. Espera unos minutos e intenta nuevamente.",
        tooManyAttempts: "Demasiados intentos fallidos. Espera unos minutos e intenta nuevamente.",
        resendIn: "Reenviar en {{seconds}}s",
        alreadyAppliedTitle: "Ya postulaste a esta vacante",
        alreadyAppliedMessage: "Tu postulación a {{position}} fue registrada el {{date}}.",
        alreadyAppliedMessageNoDate: "Tu postulación a {{position}} ya fue registrada.",
        viewMyApplications: "Ver mis postulaciones",
        accessTitle: "Ingresa tu email para continuar",
        accessSubtitle: "Te enviaremos un código de verificación",
        emailLabel: "Email",
        emailRequired: "El email es requerido",
        emailInvalid: "El formato del email no es válido",
        continue: "Continuar",
        sending: "Enviando...",
        otpSendError: "Error al enviar el código. Intenta nuevamente.",
        otpTitle: "Ingresa el código de verificación",
        otpSubtitle: "Enviamos un código de 6 dígitos a {{email}}",
        // Código enviado al email ya registrado: cuenta del portal o ficha del
        // proyecto de la vacante (PLAN_MASIVO_PORTAL, fase 0)
        otpSubtitleRegistered: "Enviamos un código de 6 dígitos a {{email}}, el correo con el que ya estabas registrado.",
        noAccessToEmail: "¿No tienes acceso a ese correo? Contacta al reclutador del proceso.",
        applicantEmailUnavailable: "Ese documento está registrado con un correo que no podemos usar. Contacta al reclutador del proceso.",
        applicationUnresolved: "No pudimos registrar tu postulación. Contacta al reclutador del proceso.",
        identity: {
          title: "Confirma tu identidad para postular",
          codeLabel: "Código de 6 dígitos",
          confirm: "Confirmar y postular",
          linkedElsewhere: "Tus datos en este proceso están asociados a otra cuenta. Contacta al reclutador del proceso.",
          // Fase 0 (PLAN_IMPORTACION_COMPUTRABAJO): nadie queda sin salida
          noAccess: "No tengo acceso a ese correo",
          noAccessHint: "Si no tienes acceso a ese correo, puedes postular igual: un reclutador revisará tus datos.",
          linkedElsewhereApply: "Tus datos en este proceso están asociados a otra cuenta. Puedes postular igual: un reclutador revisará tus datos.",
          applyAnyway: "Postular igual",
          confirmApplicantTitle: "Confirma tus datos",
          confirmApplicantText: "Te tenemos registrado en este proceso como {{name}}. ¿Eres tú?",
          confirmApplicantYes: "Sí, soy yo",
          confirmApplicantNo: "No, no soy yo",
        },
        // Formulario de vacantes masivas (PLAN_MASIVO_PORTAL, fase 2)
        massive: {
          stepCaptation: "Preguntas del cargo",
          fields: {
            nacionalidad: "Nacionalidad",
            nacionalidadOther: "Escribe tu nacionalidad",
            comuna: "Comuna donde vives",
            experiencia: "Experiencia en este tipo de cargo",
            disponibilidad: "Disponibilidad para empezar",
          },
          otherNationality: "Otra",
          traslado: "El cargo es en {{comuna}}. ¿Puedes trasladarte o mudarte para trabajar allí?",
          docsTitle: "Documentos (opcional)",
          docsHint: "Para la revisión de antecedentes puedes adjuntar tu documento de identidad y tu visa o permiso de trabajo (PDF, Word o foto, hasta 10 MB).",
          docs: {
            doc_carnet_frente: "Documento de identidad (frente)",
            doc_carnet_reverso: "Documento de identidad (reverso)",
            doc_visa: "Visa o permiso de trabajo",
          },
          upload: "Subir archivo",
          replace: "Cambiar archivo",
          uploaded: "Archivo subido",
          uploadError: "No se pudo subir el archivo",
          requiredFields: "Completa los campos obligatorios.",
          profileRequired: "Completa tus datos obligatorios: {{fields}}.",
          notAccepting: "Esta vacante ya no está recibiendo postulaciones.",
          missingAnswers: "Faltan respuestas obligatorias. Revisa el formulario.",
        },
        otpIncomplete: "Ingresa el código completo",
        otpInvalid: "Código inválido o expirado",
        otpResendSuccess: "Se envió un nuevo código",
        verify: "Verificar",
        verifying: "Verificando...",
        resend: "Reenviar código",
        resending: "Reenviando...",
        back: "Volver",
        personalData: "Datos personales",
        name: "Nombre completo",
        names: "Nombres",
        firstLastName: "Apellido paterno",
        secondLastName: "Apellido materno",
        secondLastNameHint: "Déjalo vacío si no tienes",
        fullNamePreview: "Nombre completo",
        fullNameHint: "Se arma automáticamente desde tus nombres y apellidos",
        phone: "Teléfono",
        rut: "RUT / Identificación",
        country: "País",
        profession: "Profesión",
        currentPosition: "Cargo actual",
        salarioPretendido: "Pretensión de renta",
        filteringQuestions: "Preguntas de la vacante",
        yourAnswer: "Tu respuesta...",
        apply: "Postular",
        applying: "Enviando postulación...",
        applicationError: "Error al enviar la postulación. Intenta nuevamente.",
        nameRequired: "El nombre es requerido",
        successTitle: "¡Postulación enviada!",
        successMessage: "Tu postulación fue enviada correctamente.",
        successMessagePosition: "Tu postulación a {{position}} fue enviada correctamente.",
        successPendingMessage: "Recibimos tu postulación a {{position}}. Un reclutador revisará tus datos antes de continuar.",
        // La postulación la creó el reclutador y la persona la completa (2026-10-08)
        completeApplication: {
          hint: "Ya estás en el proceso de {{position}}. Completa tus datos y responde las preguntas para terminar tu postulación.",
          doneTitle: "¡Postulación completa!",
          doneMessage: "Tus datos y respuestas quedaron en tu postulación a {{position}}.",
        },
        // Link de una invitación por correo (?inv=) abierto con la sesión de
        // otro correo, p. ej. en un equipo compartido (2026-10-09)
        invitation: {
          title: "Esta invitación es para {{email}}",
          sessionOpen: "En este equipo está abierta la sesión de {{email}}. Para responder la invitación, entra con el correo donde la recibiste.",
          useInvitation: "Entrar con el correo de la invitación",
          continueAs: "Seguir como {{email}}",
          accessHint: "Usa el correo donde recibiste la invitación ({{email}}).",
        },
        saveProfile: "Guardar perfil",
        header: {
          portal: "Portal",
          myApplications: "Mis postulaciones",
          myTests: "Mis evaluaciones",
          profile: "Mi perfil",
          logout: "Cerrar sesión",
          account: "Mi cuenta",
          signIn: "Ingresar",
        },
        profile: {
          title: "Mi perfil",
          subtitle: "Actualiza tus datos personales y tu CV",
          identityTitle: "Datos de tu cuenta",
          identityHint: "El email de tu cuenta no se puede modificar",
          save: "Guardar cambios",
          saving: "Guardando...",
          saveSuccess: "Cambios guardados correctamente",
          saveError: "Error al guardar los cambios. Intenta nuevamente.",
        },
        myApplications: {
          title: "Mis postulaciones",
          loadError: "Error al cargar las postulaciones",
          empty: "Aún no tienes postulaciones registradas",
          unknownPosition: "Cargo no disponible",
          appliedOn: "Postulado el",
          statusActive: "En proceso",
          statusPendingValidation: "En revisión",
          statusWithdrawn: "Retirada por ti",
          statusClosed: "Proceso finalizado",
          withdraw: "Retirar postulación",
          withdrawConfirmTitle: "¿Retirar postulación?",
          withdrawConfirmMessage: "Tu postulación a {{position}} será retirada del proceso. Esta acción no se puede deshacer.",
          withdrawCancel: "Cancelar",
          withdrawConfirm: "Retirar",
          withdrawSuccess: "Tu postulación fue retirada.",
          withdrawError: "No se pudo retirar la postulación. Intenta nuevamente.",
        },
        myTests: {
          title: "Mis evaluaciones",
          loadError: "Error al cargar las evaluaciones",
          empty: "No tienes evaluaciones asignadas",
          pendingSection: "Pendientes",
          finishedSection: "Finalizadas",
          sentOn: "Enviada el",
          unknownPosition: "Proceso general",
          statusPending: "Pendiente",
          statusStarted: "En curso",
          statusCompleted: "Completada",
          statusExpired: "Expirada",
          start: "Rendir",
          continue: "Continuar",
          kindDisc: "Test DISC",
          kindSales: "Evaluación de ventas",
          types: {
            wordAssociation: "Asociación de Palabras",
            logicalProcess: "Proceso Lógico",
            numericalReasoning: "Razonamiento Numérico",
            socialContext: "Contexto Social",
            logicalAbstract: "Lógico Abstracto",
            integrityTest: "Integridad Laboral",
            emotionalIntelligence: "Inteligencia Emocional",
          },
        },
        cv: "Currículum",
        cvUploaded: "CV cargado anteriormente",
        cvView: "Ver",
        cvUpload: "Cargar CV",
        cvReplace: "Reemplazar CV",
        cvHint: "Formatos aceptados: PDF, DOC, DOCX",
        cvInvalidType: "Formato no válido. Solo se aceptan PDF, DOC y DOCX",
        cvUploadError: "Error al subir el CV. Intenta nuevamente.",
      },
      companyContextConfig: {
        loading: "Cargando información de empresa y equipo...",
        title: "Información de empresa y equipo",
        description:
          "Esta información se usará como contexto en la generación del informe psicolaboral. Ayuda a que el análisis considere la cultura, el equipo, el estilo de trabajo y las expectativas reales del entorno donde se desempeñaría el candidato.",
        info:
          "Esta sección no cambia el estilo de redacción del informe. Solo entrega contexto para interpretar mejor el ajuste del candidato con la empresa y el equipo.",
        saveButton: "Guardar información",
        messages: {
          loadError: "Error al cargar la información de empresa y equipo",
          cannotSave: "No se puede guardar: organización o proyecto no disponibles",
          saveSuccess: "Información de empresa y equipo guardada exitosamente",
          saveError: "Error al guardar la información de empresa y equipo",
        },
        fields: {
          companyDescription: {
            label: "Descripción de la empresa",
            placeholder:
              "Ej: Empresa tecnológica en crecimiento, con foco en innovación, eficiencia operativa y servicio al cliente.",
          },
          teamDescription: {
            label: "Descripción del equipo",
            placeholder:
              "Ej: Equipo pequeño, colaborativo, con alta autonomía y necesidad de coordinación constante entre áreas.",
          },
          culture: {
            label: "Cultura organizacional",
            placeholder:
              "Ej: Cultura dinámica, directa, orientada a resultados y mejora continua.",
          },
          values: {
            label: "Valores relevantes",
            placeholder:
              "Ej: Responsabilidad, colaboración, transparencia, orientación al cliente y aprendizaje continuo.",
          },
          leadershipStyle: {
            label: "Estilo de liderazgo",
            placeholder:
              "Ej: Liderazgo cercano, exigente, con foco en autonomía, seguimiento por objetivos y comunicación directa.",
          },
          workStyle: {
            label: "Forma de trabajo",
            placeholder:
              "Ej: Trabajo ágil, alta carga de coordinación, cambios frecuentes de prioridad y foco en ejecución.",
          },
          expectations: {
            label: "Expectativas del entorno",
            placeholder:
              "Ej: Se espera una persona autónoma, flexible, proactiva y capaz de comunicar avances y riesgos oportunamente.",
          },
          additionalContext: {
            label: "Contexto adicional",
            placeholder:
              "Agrega cualquier información adicional que pueda ayudar a interpretar el ajuste del candidato.",
          },
        },
      },
      narrativesConfig: {
        loading: "Cargando narrativas...",
        title: "Narrativas del informe",
        create: "Crear narrativa",
        description:
          "Las narrativas permiten definir el tono, estilo y profundidad de redacción del informe psicolaboral completo. El usuario podrá seleccionar cuál utilizar antes de generar el reporte.",
        info: "La narrativa se aplicará de forma global al informe. No se configura por paso.",
        noAvailable: "No hay narrativas disponibles para este proyecto.",
        editTooltip: "Editar narrativa",
        edit: "Editar",
        createTitle: "Crear narrativa",
        editTitle: "Editar narrativa",
        cancel: "Cancelar",
        saveNarrative: "Guardar narrativa",
        messages: {
          requiredFields: "El nombre y el contenido de la narrativa son requeridos",
          cannotSave: "No se puede guardar: organización o proyecto no disponibles",
          updateSuccess: "Narrativa actualizada exitosamente",
          updateError: "Error al actualizar la narrativa",
          createSuccess: "Narrativa creada exitosamente",
          createError: "Error al crear la narrativa",
          loadError: "Error al cargar las narrativas",
          saveError: "Error al guardar la narrativa",
        },
        fields: {
          name: {
            label: "Nombre",
            placeholder: "Ej: Gerencial, Técnica, Ejecutiva breve",
          },
          description: {
            label: "Descripción",
            placeholder: "Describe brevemente cuándo se debería usar esta narrativa.",
          },
          content: {
            label: "Contenido de la narrativa",
            placeholder:
              "Ej: Redacta el informe con un estilo ejecutivo, claro y orientado a la toma de decisiones...",
          },
        },
      },
    },
  },
  en: {
    translation: {
      testReminder: {
        title: "Send a reminder if there is no reply",
        enabledHint: "If the candidate does not complete the test, an automatic reminder will be sent",
        disabledHint: "No reminder will be sent",
        daysAfterSent: "Days after sending",
        daysAfterSentHelp: "Counted from when the email goes out (1 to 30)",
        repeat: "Follow up if still no reply",
        repeatEveryDays: "Every how many days",
        maxReminders: "Maximum reminders",
        maxRemindersHelp: "Up to 5",
        stopNote: "Reminders stop as soon as the candidate starts the test.",
        urlCopiedAndMarked: "URL copied — the test was marked as sent",
        sendReminderNow: "Send reminder now",
        reminderSent: "Reminder sent to the candidate",
        reminderError: "Could not send the reminder",
        indicatorNext: "Reminder after {{days}} · approx. {{date}}",
        indicatorProgress: "Reminders: {{sent}} of {{max}} · next approx. {{date}}",
        day: "day",
        days: "days",
        indicatorDone: "Reminders: {{sent}} of {{max}} sent",
      },
      project: "Project",
      organization: "Organization",
      language: "Language",
      create: "Create",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      saving: "Saving...",
      yes: "Yes",
      no: "No",
      name: "Name",
      email: "Email",
      password: "Password",
      role: "Role",
      actions: "Actions",
      generalApiError: "Error processing request",
      noWayBack: "This action cannot be undone",
      showing: "Showing",
      of: "of",
      lastModified: "Last modified",
      lastUpdated: "Last updated",
      show: "Show",
      validationErrors: "Validation errors",
      description: "Description",
      noDescription: "No description",
      title: "Title",
      content: "Content",
      quantity: "Quantity",
      generating: "Generating...",
      suggestWithAI: "Suggest with AI",
      question: "Question",
      close: "Close",
      fullName: "Full Name",
      applicantNames: "First names",
      applicantFirstLastName: "Paternal last name",
      applicantSecondLastName: "Maternal last name",
      fullNameComposedHint: "Built automatically from names and last names; legacy records keep their value until completed",
      phone: "Phone",
      uniqueIdentifier: "Unique identifier",
      createdAt: "Created",
      industry: "Industry",
      clone: "Clone",
      pdfUploading: "Uploading PDF...",
      maxFileSize: "The file is too large. Maximum size is 10MB.",
      processing: "Processing...",
      step: "Step",
      dragOver: "Drag files over here",
      select: "Select",
      selected: "Selected",
      downloadFile: "Download File",
      deleteFile: "Delete File",
      uploadedFile: "File uploaded",
      uploadFilePending: "File loaded",
      optionalContext: "Additional Context (Optional)",
      optionalContextPlaceholder: "Add more information for this step...",
      markNotApply: "I don't have it / not apply",
      unmarkNotApply: "Unmark not apply",
      dateNotAvailable: "Date not available",
      report: "Report",
      noStatus: "No status available",
      createdBy: "Created by",
      unknown: "Unknown",
      notAvailable: "Not available",
      position: "Position",
      file: "File",
      sending: "Sending...",
      downloadWord: "Download Word",
      statusWord: "Status",
      created: "created",
      completeRequiredFields: "Please fill the required fields",
      processingError: "Processing Error",
      retrying: "Retrying",
      summary: "Summary",
      retry: "Retry",
      processedAt: "Processed at",
      active: "Active",
      inactive: "Inactive",
      back: "Back",
      goBack: "Go Back",
      next: "Next",
      evaluation: "Evaluation",
      nextSteps: "Next steps",
      basicInfo: "Basic Information",
      timeLimit: "Time limit",
      minutes: "minutes",
      total: "Total",
      noEmail: "No email",
      competency: "Competency",
      preview: "Preview",
      update: "Update",
      updating: "Updating...",
      capability: "Competency",
      previous: "Previous",
      all: "All",
      user: "User",
      admin: "Admin",
      note: "Note",
      important: "Important",
      reprocess: "Reprocess",
      remove: "Remove",
      industries: [
        "Advertising",
        "Agriculture",
        "Aquaculture",
        "Automotive",
        "Banking and Financial Services",
        "Construction",
        "Consulting",
        "Education",
        "Energy",
        "Entertainment",
        "Finance",
        "Fishing",
        "Food and Beverages",
        "Forestry",
        "Government",
        "Hardware Store",
        "Healthcare",
        "Human Resources",
        "Information Technology (IT)",
        "Insurance",
        "Livestock",
        "Logistics and Transportation",
        "Manufacturing",
        "Marketing",
        "Media and Communications",
        "Mining",
        "Professional Services",
        "Public Administration",
        "Real Estate",
        "Retail",
        "Sports",
        "Telecommunications",
        "Tourism and Hospitality",
        "Transportation",
        "Viticulture",
        "Wholesale Trade",
      ],
      status: {
        error: "Error",
        fallido: "Failed",
        completado: "Completed",
        procesando: "Processing",
        generando: "Generating",
        subiendo: "Uploading",
        subiendo_archivos: "Uploading Files",
        procesando_gpt: "Processing with GPT",
        iniciando_procesamiento_gpt: "Starting processing with GPT",
        extrayendo_contenido: "Extracting Content",
        analizando_contenido: "Analizing Content",
        generando_html: "Generating HTML",
        generando_word: "Generating Word",
        completado: "Completed",
      },
      organizations: {
        title: "Organizations",
        organizationSelect: "Select or edit an organization",
        organizationSelectUser: "Select an organization",
        organizationCreate:
          "Your organization list is empty, press the + button to create an organization",
        organizationCreateUser:
          "Your organization list is empty, please contact an administrator for more information",
        organizationLoading: "Loading organizations",
        loadError: "Error loading organizations",
        totalProjects: "Total Projects",
        organizationCreateSuccess: "Organization created successfully",
        organizationCreateError: "Error creating organization",
        organizationEditSuccess: "Organization edited successfully",
        organizationEditError: "Error editing organization",
        organizationDeleteSuccess: "Organization deleted successfully",
        organizationDeleteError: "Error deleting organization",
        organizationDeleteConfirm:
          "Are you sure you want to delete organization",
        organizationDeleteLoading: "Deleting...",
        organizationNew: "New Organization",
        organizationEdit: "Edit Organization",
        organizationName: "Organization Name",
        // ATS and Hunting modules per organization (super-admin, 2026-10-26)
        modules: {
          ats: "ATS module",
          atsHelper: "Shows ATS mode to this organization's users.",
          hunting: "Hunting module",
          huntingHelper: "Shows Hunting mode. Searching and getting contacts also requires the points system with Hunting among its modules (Manage points).",
          saveError: "Could not save the ATS and Hunting modules",
        },
        points: {
          enableSwitch: "Enable points system",
          pointsToLoad: "Points to load",
          modulesTitle: "Available modules",
          manageAction: "Manage points",
          manageTitle: "Manage Points",
          currentUsage: "Current usage",
          currentLimit: "Limit",
          available: "Available",
          unlimited: "Unlimited",
          // Unlimited points (super-admin, 2026-10-29)
          unlimitedSwitch: "Unlimited points",
          unlimitedSwitchHelper: "Nothing is blocked for lack of balance and usage is still recorded. Only the selected modules apply.",
          unlimitedHelper: "Points aren't loaded while unlimited",
          unlimitedOffHelper: "When unlimited is removed, the organization will have exactly these points available (0 if left empty)",
          huntingUnlimitedWarning: "With unlimited points, Hunting has no cap: every email and phone obtained uses Apollo credits.",
          willActivate: "This organization does not have the points system enabled. Saving will enable it with the escala plan.",
          assignSuccess: "Points assigned successfully",
          assignError: "Error assigning points",
          services: {
            psycholaborEvaluations: "Psycholabor Evaluations",
            assessments: "Assessments",
            comparisons: "Comparisons",
            discTest: "DISC Tests",
            reasoningTest: "Aptitude Tests",
            cvFiltering: "CV Filtering",
            cvSummary: "CV Summary",
            salesAssessment: "Sales Assessment",
            interview: "Interviews",
            interviewQuestions: "Interview questions",
            hunting: "Hunting",
            backgroundCheck: "Background check",
          },
        },
        settingsTitle: "Organization Settings",
        settingsSaveSuccess: "Settings saved successfully",
        settingsSaveError: "Error saving settings",
        settingsLoadError: "Error loading settings",
        settingsDescription: "Description",
        settingsWebsite: "Website",
        settingsPhone: "Phone",
        settingsContactEmail: "Contact email",
        settingsCurrency: "Currency",
        organizationCountry: "Operating country",
        settingsIndustry: "Industry",
        settingsAddress: "Address",
      },
      projects: {
        title: "Projects",
        currentOrganization: "Current organization",
        projectSelect: "Select or edit a project",
        projectSelectUser: "Select a project",
        projectCreate:
          "Your project list is empty, press the + button to create a project",
        projectCreateUser:
          "Your project list is empty, please contact an administrator for more information",
        projectLoading: "Loading projects",
        noProjects: "No projects found",
        loadError: "Error loading projects",
        projectCreateSuccess: "Project created successfully",
        projectCreateError: "Error creating project",
        projectEditSuccess: "Project edited successfully",
        projectEditError: "Error editing project",
        projectDelete: "Delete Project",
        projectDeleteSuccess: "Project deleted successfully",
        projectDeleteError: "Error deleting project",
        projectDeleteConfirm: "Are you sure you want to delete project",
        projectDeleteLoading: "Deleting...",
        projectNew: "New Project",
        projectEdit: "Edit Project",
        projectName: "Project Name",
        usageLimitReached: "Project Limit Reached",
        usageLimitMessage: "You have reached the maximum project limit. To continue creating projects, please contact your administrator to review your current plan or increase usage limits.",
        currentUsage: "Current usage",
        projects: "projects",
        remainingProjects: "Remaining projects",
        unlimited: "unlimited",
        checkingUsageLimits: "Checking usage limits...",
      },
      myOrganization: {
        "title": "My Organization",
        "configuring": "Setting up organization...",
        "configurationError": "Configuration Error",
        "noOrganizations": "You don't have any assigned organizations. Contact the administrator.",
        "loadError": "Error loading organizations. Please try again.",
        "loadErrorAlert": "Error loading organizations",
        "unauthorizedAccess": "Unauthorized access",
        "autoSelectedOrganization": "Organization automatically selected: {{organizationName}}",
        "couldNotLoadOrganizations": "Could not load organizations"
      },
      topBar: {
        title: "Account Options",
        changeOrganization: "Change Organization",
        changeProject: "Change Project",
        logout: "Logout",
        modeEvaluations: "Assessments",
      },
      users: {
        title: "Users",
        subTitle: "Users administration",
        userLoading: "Loading users...",
        loadError: "Error loading users/organizations",
        changePassword: "Change Password",
        changeOrganizations: "Change Organizations",
        generalEdit: "Edit General Fields",
        erpRole: "ERP role",
        erpRoleHelper: "Grants access to the ERP module per the access matrix: BP and Back Office see every section; KAM only quotations; Purchasing awaits its modules (next cycle).",
        erpRoleNone: "No ERP role",
        erpRoles: { admin: "Admin ERP", bp: "BP", back_office: "Back Office", kam: "KAM", compras: "Compras", comercial: "Comercial (legacy)" },
        noEditAllowed: "Not allowed to edit",
        deleteUser: "Delete User",
        userCreateSuccess: "User created successfully",
        userEditSuccess: "User edited successfully",
        userCreate: "Create new user",
        userEdit: "Edit user",
        userDelete: "Delete user",
        userDeleteConfirm: "Are you sure you want to delete user",
        projectsOf: "Projects of",
        assignOrganizationProjectsSuccess:
          "Organizations and/or projects assigned successfully",
        assignOrganizationProjectsError:
          "Error assigning organizations and/or projects",
        userOrganizationEdit: "Edit organizations of",
        userPasswordSuccess: "Password changed successfully",
        userPasswordError: "Error changing password",
        userPasswordTitle: "Change password of",
        newPassword: "New password",
        currentPassword: "Current password",
        currentPasswordRequired: "You must enter your current password",
        wrongCurrentPassword: "The current password is incorrect",
        passwordPolicy: "Minimum 6 characters and at least one number",
        organizationUsers: "Organization Users",
        userDeleteSuccess: "User deleted successfully",
        "noProjects": "No projects",
        "changeProjects": "Change projects",
        "assignProjects": "Assign Projects",
        "projectsLoadError": "Error loading projects",
        "assignProjectsSuccess": "Projects assigned successfully",
        "assignProjectsError": "Error assigning projects",
        "noProjectsInOrganization": "No projects available in this organization",
        "selectProjects": "Select projects for this user",
        "selectedProjects": "Selected projects",
        "usageLimitReached": "User Limit Reached",
        "usageLimitMessage": "You have reached the maximum user limit for your organization. To continue using this service, please contact your administrator to review your current plan or increase usage limits.",
        "currentUsage": "Current usage",
        "users": "users",
        "remainingUsers": "Remaining users",
        "unlimited": "unlimited",
        "checkingUsageLimits": "Checking usage limits...",
        "assignProjects": "Assign Projects",
        "selectProjects": "Select projects for this user",
        "selectedProjects": "Selected projects",
        "noProjectsInOrganization": "No projects available in this organization",
        "projectsLoadError": "Error loading projects",
      },
      drawer: {
        dashboard: "Dashboard",
        configuration: "Configuration",
        capabilities: "Skills",
        positions: "Positions",
        applicants: "Applicants",
        reports: "Psycholabor Evaluations",
        reportComparison: "Evaluations Comparison",
        evaluations: "Assessment",
        assessment2: "Assessment 2", // Assessment 2 (PLAN_ASSESSMENT2.md)
        disc: "DISC Test",
        reasoningTests: "Aptitude Tests",
        personalHabilities: "Personal Habilities Tests",
        cvFiltering: "CV Filtering",
        salesAssessment: "Sales Assessment",
        massiveRecruitment: "Massive Recruitment",
        trialUpgradeTooltip: "Available on paid plans",
      },
      capabilities: {
        noPermissionToEdit: "You don't have permission to edit this capability",
        noPermissionToDelete: "You don't have permission to delete this capability",
        loadError: "Error loading skills",
        capabilityDeleteSuccess: "Competency deleted successfully",
        capabilityDeleteError: "Error deleting competency",
        title: "Skills Management",
        search: "Search Skills...",
        clearSearch: "Clear Search",
        newCapability: "New Competency",
        editCapability: "Edit Competency",
        showCapability: "Show Competency",
        capabilities: "skills",
        noCapabilities: "No skills created",
        noCapabilitiesFound: "No skills found with",
        texts: "Cases",
        text: "case(s)",
        deleteTitle: "Confirm delete",
        deleteConfirm: "Are you sure you want to delete competency",
        generatedQuestions: "{{count}} question(s) generated by AI",
        generatedQuestionsError: "Error generating questions",
        nameError: "The name of the competency is required",
        descriptionError: "The description of the competency is required",
        textError: "The competency must have at least one case",
        textTitleError: "The title of case {{index}} is required",
        textContentError: "The content of case {{index}} is required",
        textQuestionError: "Text {{index}} must have at least one question",
        textQuestionTextError:
          "Question {{questionIndex}} of case {{textIndex}} is required",
        atLeastOneTextError: "At least one case is required",
        atLeastOneQuestionError: "Every case requires at least one question",
        capabilityCreated: "Competency created successfully",
        capabilityUpdated: "Competency updated successfully",
        capabilitySaveError: "Error saving competency",
        textsAndQuestions: "Cases and Questions",
        addQuestion: "Add Question",
        addText: "Add Case",
        descriptionHelper: "Describe what this competency evaluates",
        questions: "Questions",
        caseStudyHelper: "Describe the case study or situation to be evaluated",
        tabCapabilities: "Competencies",
        tabCaseStudies: "Case studies",
        linkedCaseStudies: "Linked case studies",
        linkedCaseStudiesHelper: "Pick case studies from the catalog and define this competency's questions for each one.",
        noCaseStudiesInCatalog: "There are no case studies in the catalog. Create them in the \"Case studies\" tab before linking them.",
        caso: "Case",
        selectCaseStudy: "Case study",
        linkCaseStudy: "Link case study",
        casoSelectError: "You must pick a case study in row {{index}}",
        casoDuplicatedError: "The case study in row {{index}} is already linked in another row",
      },
      caseStudies: {
        intro: "Case study catalog. A case is linked to one or more competencies from the competency itself, and in an assessment the candidate reads it only once.",
        newCaseStudy: "New Case Study",
        editCaseStudy: "Edit Case Study",
        showCaseStudy: "Show Case Study",
        search: "Search Case Studies...",
        none: "No case studies registered",
        noneFound: "No case studies found matching",
        loadError: "Error loading case studies",
        saveError: "Error saving case study",
        created: "Case study created successfully",
        updated: "Case study updated successfully",
        titleError: "Case study title is required",
        contentError: "Case study content is required",
        readingTimeError: "Reading time must be between {{min}} and {{max}} minutes",
        readingTime: "Reading time (min)",
        readingTimeHelper: "Default for assessments; adjustable in each one ({{min}}–{{max}} min)",
        contentHelper: "Describe the situation or scenario. Questions are defined in each competency.",
        showInactive: "Show inactive",
        inactive: "Inactive",
        deactivate: "Deactivate",
        activate: "Reactivate",
        deactivateTitle: "Deactivate case study",
        deactivateConfirm: "Do you want to deactivate the case study",
        deactivateHint: "It is not deleted: it stops showing up for linking or new assessments. Existing assessments are not affected. You can reactivate it later.",
        deactivated: "Case study deactivated",
        activated: "Case study reactivated",
        deactivateError: "Error deactivating case study",
        noPermissionToEdit: "You do not have permission to modify this case study",
      },
      applicants: {
        data: "Applicant data",
        noApplicantsMatchFilters: "No applicants found matching the applied filters",
        clearFilters: "Clear Filters",
        cvWillDeleteOnSave: "CV will be deleted when saving",
        cvMarkedForDeletion: "CV marked for deletion",
        cv: "Curriculum Vitae",
        cvSelectedWillUploadOnSave: "File selected. It will be uploaded when saving.",
        cvSummaryWillDelete: "This applicant has an AI summary of their CV. Replacing the CV will delete the summary.",
        cvSummaryKeep: "Keep the AI summary anyway",
        cvWillUploadOnSave: "Will be uploaded when saving",
        applicantSavedButCvFailed: "Applicant saved, but there was an error uploading the CV",
        invalidCvFormat: "Only PDF, DOC or DOCX files are allowed",
        positions: "Positions",
        selectPositions: "Select positions",
        cvTitle: "Curriculum Vitae",
        cvLoaded: "CV cargado",
        cvView: "Ver",
        cvDelete: "Eliminar",
        cvNotLoaded: "Este postulante no tiene CV cargado.",
        cvDragAndDrop: "Arrastra y suelta el CV aquí",
        cvClickToSelect: "o haz clic para seleccionar un archivo",
        cvFormats: "Formatos: PDF, DOC, DOCX (máx. 10MB)",
        cvSaveFirstNote: "Nota: primero guarda el postulante para poder subir el CV.",
        cvSaveFirstWarning: "Primero guarda el postulante para poder subir el CV",
        cvInvalidFormat: "Solo se permiten archivos PDF, DOC o DOCX",
        cvSizeExceeded: "El archivo no debe superar los 10MB",
        cvUploadSuccess: "CV subido exitosamente",
        cvUploadError: "Error al subir el CV",
        cvDeleteSuccess: "CV eliminado exitosamente",
        cvDeleteError: "Error al eliminar el CV",
        deleteCv: "Delete",
        importWithHiringRoom: "Import from HiringRoom",
        viewCv: "View CV",
        hiringRoomBadge: "HiringRoom",
        gender: "Gender",
        genderMale: "Male",
        genderFemale: "Female",
        genderOther: "Other",
        genderPreferNotToSay: "Prefer not to say",
        country: "Country",
        profession: "Profession",
        currentPosition: "Current Position",
        loadError: "Error loading applicants",
        deleteSuccess: "Applicant deleted successfully",
        deleteError: "Error deleting applicant",
        title: "Applicants",
        subTitle: "Applicant management",
        newApplicant: "New Applicant",
        emailAlreadyExists: "An applicant with this email already exists in this project",
        rutAlreadyExists: "An applicant with this RUT already exists in the project: {{name}}",
        searchPlaceholder:
          "Search by name, email, phone or unique identifier...",
        noApplicantsFound: "No applicants found for",
        noApplicants: "No applicants created",
        applicantDeleteConfirm: "Are you sure you want to delete applicant",
        deleteTitle: "Confirm delete",
        validateNameExist: "Full name is required",
        validateNameLength: "Full name must have at least 2 characters",
        validateEmailExist: "Email is required",
        validateEmailFormat: "Email format is not valid",
        applicantCreated: "Applicant created successfully",
        applicantUpdated: "Applicant updated successfully",
        applicantSaveError: "Error saving applicant",
        newApplicant: "New Applicant",
        editApplicant: "Edit Applicant",
        showApplicant: "View Applicant",
        emailNotEditable: "Email cannot be modified",
        validEmail: "Enter a valid email",
        noEmailChip: "No email",
        pendingEmailTooltip: "Pending email: {{email}} (it is on another record in this project)",
        noEmailHelper: "This record has no email. If you type one that no other record in this project uses, it is assigned on save; if you leave it empty, the rest is saved.",
        noEmailHelperPending: "This record has no email (pending email: {{email}}). If you type one that no other record in this project uses, it is assigned on save; if you leave it empty, the rest is saved.",
        noEmailView: "No email. Pending email: {{email}}",
        emailInOtherApplicant: "The email {{email}} is already on {{name}}'s record. Enter another one or leave it empty.",
        emailAssignedValidated: "Email assigned. {{count}} application(s) to validate moved to their stage.",
        uniqueIdentifierHelper:
          "Enter a unique identifier (can be DNI, ID, etc.)",
        bulkUpload: "Bulk Upload",

        bulk: {
          title: "Bulk Upload Applicants",
          confirmData: "Confirm Data",
          result: "Result",
          instructions: "Instructions:",
          requiredColumns: "Required columns:",
          requiredColumnsDesc: "names, first_last_name and email",
          optionalColumns: "Optional columns:",
          optionalColumnsDesc: "second_last_name, phone, dni/id, gender, country, profession and current_position",
          limit: "Limit:",
          limitDesc: "Maximum 3500 records per file",
          onlyAllowedColumns: "Only these columns are allowed",
          downloadTemplate: "Download Example Template",
          invalidFileType: "Please select a valid Excel file (.xls or .xlsx)",
          dragOrClick: "Click or drag an Excel file here",
          supportedFormats: "Supported formats: .xlsx, .xls",
          processingFile: "Processing file...",
          columnsIdentified: "Columns identified correctly:",
          columnsInFile: "Columns in file:",
          totalRows: "Total rows in file:",
          validRows: "Valid records to upload:",
          rowsOmitted: "rows will be omitted for not having names, first last name or email",
          preview: "Preview (first 5 records):",
          andMore: "... and",
          moreRecords: "more records",
          uploadingToSystem: "Uploading applicants to system...",
          uploadSummary: "Upload summary:",
          totalLabel: "Total:",
          createdLabel: "Created:",
          failedLabel: "Failed:",
          successfullyCreated: "Applicants created successfully",
          withErrors: "Applicants with errors",
          errorLabel: "Error:",
          emailLabel: "Email:",
          more: "more",
          cancel: "Cancel",
          processFile: "Process File",
          goBack: "Go Back",
          confirmAndLoad: "Confirm and Upload",
          applicants: "Applicants",
          selectFile: "Please select a file",
          bulkUploadError: "Error processing bulk upload",
          uploadCompleted: "Upload completed:",
          created: "created",
          failed: "failed",
          emptyFile: "The Excel file is empty",
          invalidColumns: "The file contains non-allowed columns:",
          onlyAllowed: "Only allowed: names, first_last_name, second_last_name, email, phone, dni/id, gender, country, profession, current_position",
          missingNameColumn: "The file must contain the columns \"names\" and \"first_last_name\". If your file uses the old format (a single \"name\" column), download the new template: last names are now separate.",
          missingEmailColumn: "The file must contain the column \"email\"",
          noValidRecords: "No valid records found. Make sure rows have names, first last name and email.",
          exceedsLimit: "The file contains",
          validRecords: "valid records, but the limit is 3500.",
          processingError: "Error processing Excel file:",
          readError: "Error reading file",
          noName: "No name",
          columnLabels: {
            name: "Name",
            names: "Names",
            firstLastName: "First last name",
            secondLastName: "Second last name",
            email: "Email",
            phone: "Phone",
            rut: "Identifier",
            gender: "Gender",
            country: "Country",
            profession: "Profession",
            currentPosition: "Current Position",
          },
        }
      },
      positions: {
        offeredSalary: "Offered Salary",
        offeredSalaryPlaceholder: "Ex: $1,500,000 - $2,000,000",
        offeredSalaryHelper: "Salary range or specific amount for this position",
        notAvailable: "N/A",
        copySuffix: "- Copy",
        importFromHiringRoom: "Import from HiringRoom",
        hiringRoomBadge: "HiringRoom",
        atsBadge: "ATS",
        loadError: "Error loading positions",
        deleteSuccess: "Position deleted successfully",
        deleteError: "Error deleting position",
        title: "Position Management",
        searchPlaceholder: "Search positions...",
        newPosition: "New Position",
        noPositionsFound: "No positions found for",
        noPositions: "No positions registered",
        deleteTitle: "Confirm delete",
        deleteConfirm: "Are you sure you want to delete the position",
        completeNameAndIndustry:
          "You need to complete the name and industry before generating the description",
        generateDescriptionSuccess:
          "Description generated successfully with AI",
        generateDescriptionError: "Error generating description with AI",
        processingPDF: "Processing PDF with AI...",
        processPDFSuccess: "PDF processed successfully by AI",
        processPDFError: "Could not process PDF",
        selectValidPDF: "Please select a valid PDF file",
        validateNameExist: "Position name is required",
        validateIndustryExist: "Industry is required",
        validateDescription: "Description is required",
        positionCreated: "Position created successfully",
        positionUpdated: "Position updated successfully",
        positionSaveError: "Error saving position",
        newPosition: "New Position",
        editPosition: "Edit Position",
        showPosition: "View Position",
        positionNamePlaceholder: "e.g: Fullstack Developer",
        positionIndustryPlaceholder: "e.g: Technology",
        positionDescriptionPlaceholder:
          "Describe the responsibilities and requirements for this position...",
        positionDescriptionDragOver:
          "Drop the PDF file here to extract its content!",
        positionDescriptionHelper: "Required position description",
        positionDescriptionHelperDragOver:
          "Drag a PDF file to automatically extract its content",
        "hierarchy": "Hierarchy",
        "hierarchyPlaceholder": "E.g.: Analyst, Coordinator, Manager...",
        "mission": "Mission: Fundamental purpose of the position",
        "missionPlaceholder": "Describe the fundamental purpose and mission of the position...",
        "missionDragOver": "Drop PDF file here to extract information",
        "missionHelper": "You can also drag a PDF here to automatically extract information",
        "missionHelperDragOver": "Drag and drop a PDF here to automatically extract information",
        "responsibilities": "Main responsibilities",
        "responsibilitiesPlaceholder": "Describe the main responsibilities of the position...",
        "responsibilitiesHelper": "Generic responsibilities common to the position, regardless of the unit to which the position belongs",
        "profile": "General Profile",
        "profilePlaceholder": "Describe the required general profile...",
        "profileHelper": "Minimum required profession and work experience",
        "excludingKnowledge": "Excluding knowledge",
        "excludingKnowledgePlaceholder": "List the essential knowledge...",
        "desirableKnowledge": "Desirable knowledge",
        "desirableKnowledgePlaceholder": "List the knowledge that would be a plus...",
        "defaultCompetencies": "Default competencies",
        "defaultCompetenciesHelper": "Preloaded when sending a DISC test in complete mode or configuring an Assessment for this position. Each send can add or remove competencies without changing the position.",
        "validateMission": "The mission/fundamental purpose of the position is required",
        "hierarchy": "Hierarchy",
        "mission": "Mission",
        "downloadTemplate": "Download Template",
        "loadTemplate": "Load Template",
        "selectValidDocx": "Please select a valid DOCX file",
        "templateProcessedSuccess": "Template processed successfully",
        "templateProcessError": "Error processing template",
        "missionDragOver": "Drop DOCX file here to extract information",
        "missionHelperDragOver": "Drag and drop a DOCX template here to automatically extract information",
        selectValidWord: "Please select a valid Word file (.doc or .docx)",
      },
      reports: {
        narrative: {
          title: "Deliverable narrative",
          description: "Define how GPT should write the analysis for this step. If left empty, the system default instruction will be used. This configuration applies to all future project evaluations.",
          label: "Narrative instructions",
          placeholder: "E.g.: Use a formal and direct tone. Highlight strengths before weaknesses. Avoid technical jargon. Prioritize concrete evidence over the target role...",
          helperEmpty: "No instructions configured: GPT will use the system default narrative for this step.",
          helperEmptyWithSaved: "You are removing the saved narrative. When saved, GPT will fall back to the system default narrative.",
          helperUnsaved: "You have unsaved changes. Save for them to take effect.",
          save: "Save narrative",
          saving: "Saving...",
          saveSuccess: "Narrative saved successfully",
          saveError: "Error saving narrative",
          errorTooShort: "The narrative must be at least {{min}} characters long.",
          errorTooLong: "The narrative cannot exceed {{max}} characters.",
          errorForbiddenChars: "The narrative contains forbidden characters ({ } [ ] \\). Please correct it.",
          errorInvalidContent: "The content is not a valid narrative instruction",
          stepScope: {
            step0: "This narrative applies to the CV analysis: general profile, career history and candidate strengths.",
            step2: "This narrative applies to the DISC behavioral test analysis.",
            step3: "This narrative applies to the reasoning assessment analysis.",
            step4: "This narrative applies to the interview and development areas analysis.",
          },
        },
        applicant: {
          applicantData: "Candidate Data (Optional)",
          applicantNamePlaceholder: "Enter candidate name...",
          applicantNoMatch: "No matches found",
          applicantEmailPlaceholder: "Enter candidate email...",
          selectedApplicant: "Selected candidate",
        },
        dynamicSteps: {
          stepTitle: "Extra Step",
          stepDescription: "Custom step description",
          stepGptInstructions:
            "Specific instructions for GPT on how to process this content",
          title: "Additional Steps",
          subTitle:
            "Add up to {{max}} custom steps with specific instructions for GPT",
          addStep: "Add Step",
          deleteStep: "Delete Step",
          gptInstructions: "Instructions for GPT",
          noAdditionalSteps: "No additional steps",
          config: "Configure Dynamic Step",
          dynamicStepInstructionPlaceholder:
            "Describe specifically what GPT should do with the content of this step...",
          dynamicStepInstructionHelper:
            "These instructions will tell GPT how to process and analyze the content of this step",
          instruction: "Click on the gear to configure this additional step indicating to the AI how it should process the file you will upload. You can use this step to load information such as job references, performance evaluations or other relevant documents."
        },
        reportList: {
          loadError: "Could not load evaluations. Try again.",
          title: "Psycholabor Evaluations",
          newReport: "Create new report",
          updateList: "Update list",
          loadingReports: "Loading Evaluations...",
          noReports: "No evaluations available",
          applicantName: "Applicant name",
        },
        steps: {
          step1: {
            title: "Step 1: Applicant CV",
            title: "Step 1: Candidate Resume",
            recommendation: "Recommendation:",
            recommendationText: "Upload the CV in Word format (.doc or .docx) for better automatic reading. If you use PDF, make sure it's the original file, not a scanned image.",
            cvAvailable: "CV Available",
            cvAvailableMessage: "The selected candidate has a CV loaded in the system.",
            candidateLabel: "Candidate:",
            loadAutomatically: "Load Automatically",
            checkingCv: "Checking candidate's CV...",
            cvLoadedSuccess: "Candidate's CV loaded automatically",
            cvLoadError: "Error loading candidate's CV",
            description:
              "Enter applicant data and upload their curriculum vitae",
          },
          step2: {
            title: "Step 2: Position Profile",
            description:
              "Select the corresponding position for the selection process from the positions configured in the system",
          },
          step3: {
            title: "Step 3: Behavioral Test",
            description: "Upload the applicant's behavioral test",
          },
          step4: {
            title: "Step 4: Skills Test",
            description: "Upload the applicant's skills test report",
          },
          step5: {
            title: "Step 5: Technical Interview / Behavioral Assessment",
            description:
              "Upload the technical interview and/or behavioral assessment report",
            recommendation: "Recommendation:",
            recommendationText: "Upload the interview in Word or original PDF. Ideally, use the transcription exported from video call software (Zoom, Meet, etc.) to ensure better automatic reading."
          },
        },
        layout: {
          fileOrUrlNotAvailable:
            "The file is not available or the URL is invalid",
          wordNotAvailable:
            "The Word document is not yet available. Please wait a few seconds and try again.",
          emailAndNameRequired: "Applicant email and name are required",
          uploadingFiles: "uploading files",
          uploadingFilesCount: "uploading files ({{count}})",
          uploadFilesSuccess: "files uploaded successfully",
          selectPosition:
            "Select the position corresponding to this selection process",
          positionsNotFound: "No positions found",
          selectedPosition: "Selected position",
          positionDescription: "Position description",
          stepsFlow: "Steps flow to generate psycholabor evaluation",
          reportTitle: "Report Generation",
          reportSubTitle:
            "Once all steps are completed, you will be able to generate the final report with AI",
          generateReport: "Generate Final Report",
          retryProccesing: "Retry processing",
          startProcessing: "Start processing",
          reportGeneratedSuccess: "Report generated successfully!",
          showHtmlReport: "View HTML report",
          uploadedPlural: "Uploaded",
          usageLimitReached: "Psycholabor Evaluations Limit Reached",
          usageLimitMessage: "You have reached the maximum limit of psycholabor evaluations. To continue using this service, please contact your administrator to review your current plan or increase usage limits.",
          currentUsage: "Current usage",
          evaluations: "evaluations",
          remainingEvaluations: "Remaining evaluations",
          unlimited: "unlimited",
          checkingUsageLimits: "Checking usage limits...",
        },
        usageLimitExceeded: "You have reached your evaluation limit ({{currentUsage}}/{{limit}}). Upgrade your plan to continue.",
        validationError: "Validation error. Please check the entered data.",
        unexpectedError: "Unexpected error creating the report. Please try again.",
        reasoningTestsAvailableCount: "Aptitude Tests Available ({{count}})",
        reasoningTestsFoundMessage: "Completed uptitude tests were found for this candidate.",
        reasoningTestCompleted: "Completed:",
        reasoningTestDateNotAvailable: "Date not available",
        loadAllReasoningTests: "Load All",
        searchingReasoningTests: "Searching for available aptitude tests...",
        reasoningTestTypes: {
          wordAssociation: "Word Association",
          logicalProcess: "Logical Process",
          numericalReasoning: "Numerical Reasoning",
          socialContext: "Social Context",
          logicalAbstract: "Logical Abstract Reasoning",
          integrityTest: "Work Integrity",
          emotionalIntelligence: "Emotional Intelligence"
        },
      },
      psycholabor: {
        title: "Psycholabor Evaluations",
        subTitle: "Create and manage complete psycholabor evaluations",
        create: "Create",
        dashboard: "Dashboard",
        dashboardTitle: "Psycholabor Evaluations Status",
        dashboardSubTitle: "View and filter all project psycholabor evaluations",
        reportId: "Evaluation ID",
        totalReports: "Total evaluations: {{count}}",
      },
      comparisonDashboard: {
        create: "Create",
        dashboard: "Dashboard",
        noHistoryFound: "No comparisons made yet",
        noHistoryFoundDesc: "Start your first comparison from the 'Create' tab",
        totalComparisons: "Total: {{count}} comparisons",
        viewResults: "View results",
        viewResultsDisabled: "The comparison is not completed yet",
        refresh: "Refresh",
        statusPendiente: "Pending",
        statusCancelado: "Cancelled",
        noName: "No name",
        noPosition: "Position not specified",
        selectReportForApplicant: "First select a report for this applicant",
        comparisonStarted: "Comparison started successfully",
        comparisonCreateError: "Error creating comparison",
        newComparison: "New Comparison",
        comparisonResults: "Comparison Results",
        title: "Applicant Comparison Dashboard",
        subTitle:
          "Compare applicants who have applied for the same position using specific metrics",
        config: "Configuration",
        results: "Results",
        targetPosition: "Target Position",
        selectPosition:
          "Select the position for which you want to find the best applicants",
        noPositionsFound: "No positions found",
        comparisonMode: "Comparison Mode",
        "1vsAll": "1 vs All",
        "1vsAllDescription": "Compare an ideal applicant against all others",
        allVsAll: "All vs All",
        allVsAllDescription: "Compare all applicants to find the best one",
        applicants: "Applicants",
        applicantsWithReports:
          "Applicants with completed evaluations. Select at least 2 to compare",
        applicantsLoading: "Loading applicants...",
        noApplicantsWithReports: "No applicants found with completed evaluations",
        selectReportForComparison: "Select the report to use for comparison",
        selectPositionToContinue: "Select a target position to continue",
        availableApplicants: "Available applicants",
        selectedReports: "Selected evaluations",
        idealApplicant: "Ideal applicant",
        starting: "Starting...",
        start: "Start Comparison",
        processingComparison: "Processing comparison...",
        processingText: "Applicant analysis is in progress",
        comparisonError: "Error in comparison",
        startingProcess: "Starting comparison process",
        firstPlace: "First Place",
        secondPlace: "Second Place",
        thirdPlace: "Third Place",
        noResultsAvailable: "No results available for download",
        applicantsAnalized: "Applicants analyzed",
        idealApplicantReference: "Ideal reference applicant",
        applicantsRanking: "Applicants Ranking",
        afinity: "Affinity",
        keyStrengths: "Key strengths for the position",
        analisis: "Fit analysis",
        generalRecommendation: "General Recommendation",
        downloadResults: "Download Results",
        requirements: {
          title: "To start the comparison you need",
          reqOne: "Select a target position",
          reqTwo: "Select at least 2 applicants",
          reqThree: "Choose a comparison mode",
          reqFour: "Mark an ideal applicant",
        },
        "searchApplicantPlaceholder": "Search applicant by name...",
        "showOnlyTargetPosition": "Target position only",
        "showingResults": "Showing",
        "of": "of",
        "filteredBy": "Filtered by",
        "onlyTargetPosition": "Target position only",
        "noApplicantsWithFilters": "No applicants found with the applied filters",
        usageLimitReached: "Comparison Limit Reached",
        usageLimitMessage: "You have reached the maximum limit of comparisons for your organization. To continue using this service, please contact your administrator to review your current plan or increase usage limits.",
        currentUsage: "Current usage",
        comparisons: "comparisons",
        remainingComparisons: "Remaining comparisons",
        unlimited: "unlimited",
        checkingUsageLimits: "Checking usage limits...",
        points: "points",
        remaining: "Available points",
      },
      // Assessment 2 (PLAN_ASSESSMENT2.md): separate module, no psycholabor report
      assessment2: {
        title: "Assessment 2",
        subTitle: "Competency assessment for any applicant, without psycholabor evaluation",
        noApplicants: "There are no applicants in this project. Create applicants to add them to the assessment.",
        processing: "Processing…",
        processingTooltip: "The AI evaluation and reports are being generated in the background. This list refreshes automatically.",
        processingError: "Processing error",
        processingErrorTooltip: "The automatic evaluation failed. You can reprocess it.",
        reprocessQueued: "Reprocessing queued. The result will appear in a few minutes.",
      },
      evaluations: {
        // Simple / complete mode (PLAN_UNIFICACION_ASSESSMENT.md)
        modeTitle: "Assessment mode",
        modeComplete: "Complete assessment",
        modeCompleteDescription: "Only applicants with a psycholabor report. Includes position fit (Nine Box) and considers DISC and reasoning.",
        modeSimple: "Simple assessment",
        modeSimpleDescription: "Any applicant in the project, without a psycholabor report. The evaluation considers only the assessment answers.",
        modeChipComplete: "Complete",
        modeChipSimple: "Simple",
        modeColumn: "Mode",
        modeFilterAll: "All",
        noEvaluationsForMode: "There are no assessments in {{mode}} mode.",
        noApplicantsSimple: "There are no applicants in this project. Create applicants to add them to the assessment.",
        // One case, several competencies (PLAN_CASOS_ESTUDIO.md)
        legacyCase: "legacy format",
        caseAlreadyInAssessment: "already in this assessment",
        duplicatedCapability: "Duplicated competency",
        duplicatedCapabilityError: "A competency is measured only once per assessment: there are duplicated competencies.",
        caseStudyRequiredError: "Every competency must have a case study selected.",
        assessmentCaseStudies: "Assessment case studies",
        assessmentCaseStudiesHelper: "The candidate reads each case only once and then answers, in sequence, the questions of every competency linked to it. Reading time is per case.",
        caseStudiesCount: "{{count}} case study(ies)",
        sharedCaseHint: "case shared with other competencies",
        expandAll: "Expand all",
        collapseAll: "Collapse all",
        noApplicantsWithReport: "No applicants with completed psycholabor evaluation. Candidates must have a psycholabor report to be added to the assessment.",
        points: "points",
        title: "Assessment Management",
        subTitle:
          "Configure and manage competency assessments for your selection processes.",
        loadError: "Error loading assessments",
        loadErrorSingle: "Error loading assessment",
        createSuccess: "Assessment created successfully",
        deleteSuccess: "Assessment deleted successfully",
        deleteError: "Error deleting assessment",
        myEvaluations: "My Assessments",
        newEvaluation: "New Assessment",
        searchPlaceholder:
          "Search assessments by title, position or description...",
        noEvaluationsFound: "No assessments found matching",
        noEvaluations:
          "No assessments registered. Create your first assessment using the 'New Assessment' button.",
        showDashboard: "View Dashboard",
        enterEvaluation: "Enter assessment",
        deleteConfirm: "Confirm Deletion",
        deleteConfirmText: "Are you sure you want to delete the assessment",
        pleaseSelectPosition: "Please select a position to continue",
        pleaseFillTitle: "Please complete the assessment title",
        pleaseSelectCapability: "Please select at least one competency",
        percentageError: "The sum of percentages must be exactly 100%",
        pleaseSelectApplicant: "Please select at least one applicant",
        unknownStep: "Unknown step",
        configurationTitle: "Assessment Form Configuration",
        configurationSubTitle:
          "Configure the assessment process step by step to optimize applicant selection.",
        configurationStepOneSubTitle:
          "Select the position and define the basic details of the assessment.",
        configurationStepOneFormTitle: "Assessment Configuration",
        configurationStepOneFormSubTitle:
          "Define the main details of the assessment for",
        configurationStepOneFormTitleLabel: "Assessment title",
        configurationStepOneFormTitlePlaceholder: "Assessment",
        configurationStepOneFormTitleHelper: "Assessment title",
        configurationStepOneFormDescriptionLabel: "Description (optional)",
        configurationStepOneFormDescriptionPlaceholder:
          "Description (optional)",
        configurationStepOneFormDescriptionHelper: "Description (optional)",
        configurationStepOneFormTimeLabel: "Time limit (minutes)",
        configurationStepOneFormTimeHelper: "Between 5 and 500 minutes",
        configurationStepOneFormTimeInfo:
          "Applicants will have {{timeLimit}} minutes to complete the assessment",
        selectPosition: "Select this position",
        createEvaluation: "Create Assessment",
        evaluationCreateSuccess: "Assessment created successfully!",
        evaluationCreateSucesssInfo:
          "The assessment has been configured and is ready to be sent to applicants.",
        evaluationId: "Assessment ID",
        evaluationCreateError: "Error creating assessment",
        evaluationReady: "Your assessment is ready. Now you can:",
        evaluationReadyPointOne: "Send invitations to selected applicants",
        evaluationReadyPointTwo: "Monitor progress from the assessments panel",
        evaluationReadyPointThree:
          "Review results when applicants complete the assessment",
        evaluationCreateConfirm: "Assessment Confirmation and Creation",
        evaluationCreateReview:
          "Review the configuration before creating the assessment.",
        evaluationSummary: "Assessment Summary",
        applicantNotFound: "Applicant not found",
        applicantAlreadyAdded: "This applicant has already been added",
        applicantAddedSuccessfully: "Applicant added successfully",
        applicantDeleted: "Applicant deleted",
        applicantManagement: "Applicant Management",
        applicantManagementSubTitle:
          "Add the applicants to whom you want to send the competency assessment for the position of",
        currentConfiguration: "Current configuration",
        configuredCapabilities: "Configured skills",
        totalPercentage: "Total percentage",
        addNewApplicant: "Add New Applicant",
        selectApplicant: "Select applicant",
        addApplicant: "Add Applicant",
        allApplicantsAdded: "All available applicants have already been added.",
        noApplicantsAvailable:
          "No applicants available. Add applicants from the Applicants section.",
        totalApplicantsAdded: "Total applicants added",
        readyToContinue: "Ready to continue ✓",
        addAtleastOneApplicant: "Add at least one applicant",
        noTitle: "No title",
        stepTwoTitle: "Competency Definition and Assessment Context",
        stepTwoSubTitle:
          "Define the skills, case studies and specific questions that will be assessed for each applicant.",
        selectCapability: "Select competency",
        evaluationWeigth: "Assessment weight (%)",
        selectCaseStudy: "Select case study",
        noContent: "No content",
        selectQuestion: "Select question",
        selectedQuestion: "Selected question",
        noCapability: "No competency",
        selectedCase: "Selected case",
        addNewCapability: "Add New Competency",
        noCapabilitiesAvailable:
          "No skills available. Create skills from the Skills section to configure the assessment.",
        finalConfigurationSummary: "Final Configuration Summary",
        totalWeigthsAsigned: "Total weights assigned",
        configurationComplete: "Configuration complete",
        configurationIncomplete: "Configuration incomplete",
        weigthWarning:
          "The sum of percentages must be exactly 100% to continue",
        left: "Missing",
        forAssignment: "to assign",
        youHave: "You have",
        surplusAssigned: "surplus assigned",
        evaluationSteps: [
          "Select Position and Configure Assessment",
          "Competency Definition",
          "Applicant Management",
          "Confirmation and Creation",
        ],
        maxQuestionsPerCompetency: "Maximum 5 questions per competency",
        minQuestionsPerCompetency: "Minimum 3 questions per competency",
        questionsConfigurationTitle: "📝 Questions Configuration per Competency",
        questionsConfigurationDescription: "• Minimum: 3 questions per competency\n• Maximum: 5 questions per competency\n• Selected questions will be presented sequentially to the candidate",
        selectMinimumQuestions: "Select at least {{minimum}} questions for this competency. You currently have {{current}} selected.",
        noQuestionsAvailable: "No questions available for the selected case study.",
        questionNumber: "Question {{number}}",
        selectedQuestions: "Selected Questions ({{count}})",
        questionsCount: "{{count}} questions",
        questionsCountMinimum: "{{count}} questions (min. {{minimum}})",
        totalQuestions: "Total Questions",
        questionsConfigurationRequired: "📝 Questions Configuration Required",
        competencyNumber: "Competency {{number}}",
        noQuestionsSelected: "No questions selected",
        insufficientQuestions: "Only has {{count}} question{{count, plural, one {} other {s}}} (minimum {{minimum}})",
        excessQuestions: "Has {{count}} questions (maximum {{maximum}})",
        caseStudy: "Case study",
        viewQuestions: "View questions",
        noQuestionsConfigured: "No questions configured for this competency",
        createNewEvaluation: "Create New Assessment",
        backToStep1: "Back to Step 1",
        resetToStep1Success: "Configuration reset successfully. You can create a new assessment.",
        "emailNotifications": "Email Notifications",
        "sendEmailsToCandidate": "Send emails automatically to candidates",
        "emailsWillBeSentAutomatically": "Emails will be sent automatically after creating the assessment",
        "emailsWillNotBeSent": "Emails will NOT be sent. You will need to send them manually from the assessments view",
        "emailWillInclude": "The email will include the direct link for candidates to access their assessment.",
        "creatingAndSendingEmails": "Creating assessment and sending emails...",
        "creatingEvaluation": "Creating assessment...",
        "evaluationCreateSuccessWithEmails": "Assessment created successfully and emails sent to candidates.",
        "evaluationCreateSuccessInfo": "Assessment created successfully. Candidates have not been invited yet: you can send the invitations from the assessments panel.",
        "evaluationReadyWithEmails": "Your assessment has been created and candidates have received their email invitations.",
        "emailsSentToCandidates": "Emails have been sent to all candidates",
        "candidatesCanStartEvaluation": "Candidates can start their assessment immediately",
        "monitorProgressInEvaluationView": "You can monitor progress from the assessments view",
        "readingTime": "Reading time (min)",
        "questionTime": "Questions time (min)",
        "timeRangeHelper": "5-60 minutes",
        "cannotExceed100": "Cannot exceed 100%",
        "unspecified": "Unspecified",
        "candidate": "Candidate",
        "reading": "Reading",
        "questions": "Questions",
        "minutes": "min",
        "totalTime": "Total time",
        "insufficientAssessments": "You don't have enough assessments available to send to all candidates",
      },
      evaluationAlert: {
        "checkingAssessments": "Checking available assessments...",
        "warning": "Warning",
        "limitsCouldNotBeVerified": "Limits could not be verified correctly.",
        "dismissAlert": "Dismiss alert",
        "insufficientAssessments": "Insufficient assessments",
        "assessmentsStatus": "Assessments status",
        "insufficientMessage": "Insufficient assessments: you have {{available}} available but need {{needed}} to send to all pending candidates.",
        "unlimitedMessage": "You have unlimited assessments available.",
        "availableAndPending": "Available assessments: {{available}}. Pending candidates: {{pending}}.",
        "remainingMessage": "You have {{remaining}} assessments remaining out of {{limit}} total.",
        "availableCompact": "{{count}} assessments available",
        "pendingCompact": "{{count}} pending",
        "currentUsage": "Current usage: {{current}} / {{limit}}",
        "usedChip": "{{count}} used",
        "availableChip": "{{count}} available",
        "pendingCandidatesChip": "{{count}} pending candidates",
        "unlimitedChip": "Unlimited assessments",
      },
      evaluationResponses: {
        downloadPdf: 'Download PDF',
        downloadWord: 'Download Word',
        noResultsAvailable: 'No results available',
        candidate: 'Candidate',
        position: 'Position',
        completedDate: 'Completion Date',
        talentMap: 'Talent Map (NineBox Matrix)',
        reportsLoadError: "Error loading evaluations",
        confidenceIndex: "Confidence Index",
        assessmentResults: 'Assessment Results',
        scoreAssessment: 'Assessment Score',
        scorePsycholabor: 'Psycholabor Evaluation Score',

        // Competencias
        evaluatedCompetencies: 'Evaluated Competencies',
        questionsEvaluated: 'question(s) evaluated',
        questionsAnswered: '{{answered}} of {{total}} question(s) answered',
        reprocessTitle: 'Reprocess assessment',
        reprocessConfirm: "{{name}}'s assessment will be re-evaluated with AI and the PDF and Word reports will be regenerated. This replaces the current score, conclusion and development plan, and may take several minutes. Continue?",
        reprocessSuccess: 'Assessment reprocessed successfully.',
        // Queue processing (PLAN_UNIFICACION_ASSESSMENT.md)
        reprocessQueued: 'Reprocessing queued. The result will appear in a few minutes.',
        processing: 'Processing…',
        processingTooltip: 'The AI evaluation and reports are being generated in the background. This list refreshes automatically.',
        processingError: 'Processing error',
        processingErrorTooltip: 'The automatic evaluation failed. You can reprocess it.',
        // Potential Report (PLAN_UNIFICACION_ASSESSMENT.md §7); the report texts come from the backend
        potentialReportLoading: 'Loading the assessment report…',
        potentialReportError: 'The assessment report could not be loaded.',
        potentialReportDownloadError: 'The assessment report could not be downloaded. Please try again.',
        reprocessError: 'Error reprocessing the assessment. Please try again.',
        strengthsForPosition: 'Strengths for the Position',
        improvementAreas: 'Areas for Improvement',
        noCompetenciesAvailable: 'No competencies evaluated available',
        noCompetency: 'No competency',

        // NineBox
        nineBoxPosition: 'NineBox Matrix Position',
        xAxisAssessment: 'X Axis (Assessment):',
        yAxisJobFit: 'Y Axis (Job Fit):',
        quadrantMeaning: 'Quadrant Meaning',
        positioningReasons: 'Positioning Reasons',
        elementsAndOpportunities: 'Elements to Consider and Opportunities',
        expectations6to12: 'Expectations (6-12 months)',
        unclassified: 'Unclassified',

        // NineBox Labels
        nineBoxLabels: {
          'high-high': 'High Potential - High Performance',
          'high-medium': 'High Potential - Medium Performance',
          'high-low': 'High Potential - Development Required',
          'medium-high': 'Key Professional with High Performance',
          'medium-medium': 'Solid Performance',
          'medium-low': 'Diamond in the Rough',
          'low-high': 'Effective Contributor',
          'low-medium': 'In Development',
          'low-low': 'Requires Immediate Attention'
        },

        // Plan de Desarrollo
        developmentPlan90180360: 'Development Plan (90/180/360 days)',
        first90Days: 'First 90 days',
        next90Days: 'Next 90 days (91-180)',
        thirdPeriod: 'Third period (181-360)',
        objectives: 'Objectives:',
        actions: 'Actions:',
        indicators: 'Indicators:',

        // Conclusión
        integratedConclusion: 'Integrated Conclusion',
        generalPerformanceView: 'General Performance Overview',
        discConnection: 'Connection with Work Style (DISC)',
        cognitiveCapabilities: 'Cognitive Capabilities',
        developmentOpportunities: 'Development Opportunities',
        profileSynthesis: 'Profile Synthesis',
        positionImplications: 'Implications for the Position',
        noConclusionAvailable: 'No integrated conclusion available',
        assessmentResults: 'Assessment Results',
        export: {
          title: "Evaluation Report",
          date: "Date",
          executiveSummary: "Executive Summary",
          totalCandidates: "Total Candidates",
          completedCandidates: "Completed Candidates",
          averageScore: "Average Score",
          bestCompetency: "Best Competency",
          worstCompetency: "Competency to Improve",
          candidateRanking: "Candidate Ranking",
          competencyAnalysis: "Competency Analysis",
          average: "average",
          analysis: "Analysis",
          overallScore: "Overall Score",
          timeSpent: "Time Spent",
          minutes: "minutes",
          unknownCompetency: "Unknown",
          strengths: "Strengths",
          noOutstandingSkills:
            "No outstanding skills identified (≥75%)",
          improvementAreas: "Areas for Improvement",
          allSkillsAdequate:
            "All evaluated skills are at adequate level",
          developmentPlan: "Development Plan",
          toImproveIn: "To improve in",
          generalRecommendations: "General recommendations",
          conclusion: "Conclusion",
          conclusions: "Conclusions",
          filename: "Report",
          description: "Automatically generated evaluation report",
          error: "Error generating Word report. Please try again.",

          developmentPlans: {
            reinforceFundamentals:
              "Reinforce fundamental concepts of the position.",
            participateInTraining:
              "Participate in competency-specific training.",
            requestDetailedFeedback:
              "Request detailed feedback to improve performance.",
            focusOnWeakSkills: "Focus on skills with lower scores.",
            practiceCaseStudies:
              "Practice case studies similar to those evaluated.",
            seekMentorship: "Seek mentorship in areas of opportunity.",
            maintainCurrentLevel: "Maintain current level of skills.",
            shareKnowledge: "Share knowledge with other candidates.",
            exploreAdvancedAreas: "Explore advanced specialization areas.",
          },

          conclusionTemplate: {
            profile:
              "{{name}} has a profile with an overall score of {{score}}%.",
            standOut: "Particularly stands out in {{competency}} ({{score}}%).",
            improvement:
              "With the proposed development plan, can improve in {{competency}} and reach maximum potential.",
          },

          finalConclusions: {
            evaluated:
              "{{total}} candidates were evaluated for the {{position}} position.",
            averageScore: "The overall average score was {{average}}%.",
            bestPerformance:
              "The best performing competency was {{competency}}.",
            recommendation:
              "It is recommended to reinforce the {{competency}} competency in future training.",
          },
          startingBackendExport: "Starting Word export from backend...",
          missingProjectData: "Error: Missing project data",
          downloadSuccessful: "Word document downloaded successfully",
          backendExportError: "Error exporting Word from backend:",
          incompleteData: "Incomplete data to generate document",
          serverError: "Internal server error",
          connectionError: "Server connection error",
        },
        loadError: "Error loading responses",
        dataUpdated: "Data updated",
        statusPending: "Pending",
        statusOpened: "Open",
        statusStarted: "Started",
        statusCompleted: "Completed",
        statusProcessing: "Processing",
        statusExpired: "Expired",
        title: "Evaluation Responses",
        answered: "Answered",
        notAnswered: "Not answered",
        noName: "Applicant without name",
        noPosition: "No position",
        loadingEvaluationData: "Loading evaluation data...",
        backToEvaluations: "Back to Evaluations",
        evaluations: "Evaluations",
        comparativeDashboard: "Comparative Dashboard",
        exportWord: "Export Word",
        totalApplicants: "Total Applicants",
        applicantsBreakdown:
          "{{qualified}} qualified, {{unqualified}} unqualified, {{inProgress}} in progress",
        averageScore: "Average Score",
        bestCompetency: "Best Competency",
        competencyToImprove: "Competency to Improve",
        averageWithValue: "{{value}}% average",
        noAnalysisDataAvailable:
          "No analysis data available for this applicant.",
        applicantId: "Applicant ID",
        unknownCompetency: "Unknown",
        strengths: "Strengths",
        improvementAreas: "Areas for Improvement",
        personalizedDevelopmentPlan: "Personalized Development Plan",
        conclusion: "Conclusion",
        excellent: "Excellent",
        noOutstandingStrengths:
          "No outstanding strengths identified in the evaluated skills.",
        allSkillsAdequateLevel:
          "All evaluated skills are at an adequate level.",
        noDevelopmentPlanAvailable: "No specific development plan available.",
        toImproveInCompetency: "To improve in {{competency}}",
        generalRecommendations: "General recommendations",
        conclusionFallback: {
          profile:
            "{{name}} has a profile with an overall score of {{score}}%.",
          standOut: "Particularly stands out in {{competency}} ({{score}}%).",
          canImprove:
            "With the proposed development plan, can improve in {{competency}} and reach maximum potential.",
        },
        statusCompleted: "Completed",
        statusProcessing: "Processing",
        statusInProgress: "In Progress",
        statusExpired: "Expired",
        statusPending: "Pending",
        statusSent: "Sent",
        statusUnknown: "Unknown",
        tabAllApplicants: "All Applicants",
        tabComparative: "Comparative",
        tabBySkills: "By Skills",
        searchApplicant: "Search applicant...",
        applicantsFound: "{{count}} applicants found",
        applicant: "Applicant",
        status: "Status",
        progress: "Progress",
        score: "Score",
        time: "Time",
        date: "Date",
        total: "Total",
        questionsProgress: "{{completed}}/{{total}} questions",
        notAvailable: "N/A",
        selectApplicants: "Select Applicants",
        selectApplicantsDescription:
          "Choose the applicants you want to compare",
        competenciesToCompare: "Skills to Compare",
        comparativeAnalysis: "Comparative Analysis",
        comparativeAnalysisDescription:
          "Detailed comparison of selected applicants and personalized recommendations",
        comparativeChart: "Comparative Chart",
        analysisByApplicant: "Analysis by Applicant",
        comparingInfo:
          "Comparing {{applicants}} applicants in {{competencies}} selected skills",
        selectAtLeastTwoApplicants:
          "Select at least 2 applicants to show the graphic comparison.",
        selectApplicantsForChart:
          "Select applicants to show the comparative chart.",
        selectApplicantsForAnalysis:
          "Select applicants to show the comparative analysis.",
        analysisBySkills: "Analysis by Skills",
        analysisBySkillsDescription:
          "Visualize each applicant's performance in the evaluated skills and personalized recommendations.",
        generalAverages: "General Averages",
        averagesWillShow:
          "Averages will be shown when there are qualified evaluations.",
        applicantRanking: "Applicant Ranking",
        applicantRankingDescription:
          "Ordered by total score from highest to lowest",
        detailedTableWillShow:
          "The detailed table will be shown when there are applicants with qualified evaluations.",
        analysisAndDevelopmentPlan: "Analysis and Development Plan",
        personalizedRecommendations:
          "Personalized recommendations for each applicant",
        applicantDeletedSuccessfully:
          "Applicant and their responses deleted successfully",
        errorDeletingApplicant: "Error deleting applicant",
        errorLoadingInitialData: "Error loading initial data",
        evaluationGeneratedSuccessfully:
          "Evaluation generated successfully with {{questionsCount}} questions using the defined skills. ID: {{responseId}}",
        evaluationCreatedButErrorUpdatingApplicant:
          "Evaluation created but error updating applicant status",
        errorCreatingEvaluation: "Error creating evaluation",
        errorGeneratingEvaluation: "Error generating evaluation",
        evaluationsGeneratedSuccessfully:
          "Evaluations generated successfully for {{count}} applicants",
        evaluationsFailed: "{{count}} evaluations failed to generate",
        errorGeneratingEvaluations: "Error generating evaluations",
        statusLabels: {
          pending: "Pending",
          sent: "Sent",
          opened: "Opened",
          started: "Started",
          completed: "Completed",
          expired: "Expired",
        },
        statusTooltips: {
          pending: "Waiting to generate evaluation link",
          sent: "Evaluation link generated and available for the applicant",
          opened: "The applicant has visited the evaluation link",
          started: "The applicant started answering the evaluation questions",
          completed: "The applicant finished all evaluation questions",
          expired:
            "The evaluation expired due to time limit without completion",
          unknown: "Unknown status",
        },
        evaluationNotFound: "Evaluation not found",
        goBack: "Go Back",
        evaluations: "Evaluations",
        viewDashboard: "View Dashboard",
        evaluationInformation: "Evaluation Information",
        title: "Title",
        description: "Description",
        position: "Position",
        competencies: "Skills",
        timeLimit: "Time limit",
        minutes: "minutes",
        addApplicants: "Add Applicants",
        noApplicantsAvailable:
          "No applicants available to add. All project applicants are already included in this evaluation.",
        selectApplicant: "Select applicant",
        add: "Add",
        applicantsCount: "Applicants ({{count}})",
        generateEvaluationsForAllPending:
          "Generate Evaluations for All Pending",
        noApplicantsAdded: "No applicants added",
        addApplicantsToStart:
          "Add applicants to this evaluation to start the selection process.",
        name: "Name",
        email: "Email",
        status: "Status",
        evaluationGenerated: "Evaluation generated",
        lastActivity: "Last activity",
        actions: "Actions",
        generateEvaluation: "Generate evaluation",
        copyEvaluationUrl: "Copy evaluation URL",
        deleteApplicant: "Delete applicant",
        confirmDeletion: "Confirm Deletion",
        deleteConfirmationMessage:
          "Are you sure you want to delete applicant {{name}}?",
        noName: "No name",
        thisAction: "This action",
        deleteActionRemove: "Will remove the applicant from this evaluation",
        deleteActionPermanent:
          "Will permanently delete all their evaluation responses",
        deleteActionUndoable: "Cannot be undone",
        applicant: "Applicant",
        noEmail: "No email",
        cancel: "Cancel",
        yesDelete: "Yes, Delete",
        tabTalentMap: "Talent Matrix",

        talentMap: {
          title: "Talent Matrix",
          description: "Visual analysis of potential and performance of evaluated candidates",
          noDataAvailable: "No data available to display the talent matrix",

          totalCandidates: "Total Candidates",
          highPerformers: "High Performers",
          needsDevelopment: "Need Development",
          averagePerformance: "Average Performance",

          performance: "Performance",
          profile: "Job Fit",
          performanceAxis: "Performance (%)",
          profileAxis: "Job Fit (%)",

          matrixTitle: "Talent Matrix - Performance vs Job Fit",
          candidates: "Candidates",
          legend: "Legend",

          starPerformer: "Star Performer",
          starPerformerDesc: "Ideal for succession and leadership plans. High organizational impact.",

          highPerformer: "Highly Qualified Professional",
          highPerformerDesc: "Not yet shining fully, but has potential. Needs development or mentoring.",

          keyContributor: "Key High-Performance Worker",
          keyContributorDesc: "Meets expectations, but with low growth margin.",

          emergingTalent: "Future Star",
          emergingTalentDesc: "Excellent in current role, may not scale up.",

          coreProfessional: "Solid Professional",
          coreProfessionalDesc: "Could improve with training or role change.",

          highPotential: "Highly Qualified Professional",
          highPotentialDesc: "Requires support, feedback or relocation.",

          inconsistentPerformer: "A Diamond in the Rough",
          inconsistentPerformerDesc: "Very valuable in current position, doesn't project to higher roles.",

          developmentNeeded: "Inconsistent Performance Worker",
          developmentNeededDesc: "Maintains stability, but without ambition for more.",

          underPerformer: "Low Performance Worker",
          underPerformerDesc: "Requires immediate intervention. Possible termination or relocation.",

          unclassified: "Unclassified",

          candidatesSummary: "Candidates Summary",
          candidate: "Candidate",
          classification: "Classification"
        },
        resendEmail: "Resend invitation email",
        emailResentSuccessfully: "Invitation email resent successfully",
        errorResendingEmail: "Error resending invitation email",
        applicantNotFound: "Applicant not found",
      },
      publicEvaluations: {
        // One case, several competencies (PLAN_CASOS_ESTUDIO.md)
        caseStudyOf: "Case study {{current}} of {{total}}",
        caseStudyCompetenciesHint: "Read the case only once: next you will answer the questions of {{count}} competency(ies) about this situation.",
        competencyOfCase: "competency {{current}} of {{total}} for this case",
        activityMonitoringDisclaimer: "Your activity will be monitored during this test to ensure process integrity. This includes detecting tab switches, copy/paste actions, screenshots, and other suspicious behaviors.",
        evaluationAlreadyCompleted:
          "This evaluation has already been completed.",
        evaluationExpiredNotAvailable:
          "This evaluation has expired and is no longer available.",
        timeToCompleteExpired:
          "The time to complete this evaluation has expired.",
        timeUpSavingAnswers:
          "Time is up. Saving all answers and completing automatically...",
        evaluationCompletedAutomatically:
          "Evaluation completed automatically due to time expiration.",
        errorCompletingAutomatically:
          "Error completing evaluation automatically.",
        errorSavingAnswersAutomatically: "Error saving answers automatically.",
        answerSavedSuccessfully: "Answer saved successfully",
        errorSavingAnswer: "Error saving answer. Please try again.",
        emptyAnswer: "Empty answer",
        errorSavingAllAnswers: "Error saving all answers: {{message}}",
        errorCompletingEvaluation: "Error completing evaluation",
        errorCompletingEvaluationTryAgain:
          "Error completing evaluation. Please try again.",
        noQuestionsFound: "No questions found for this evaluation.",
        evaluationExpired: "Evaluation Expired",
        timeToCompleteHasExpired:
          "The time to complete this evaluation has expired.",
        contactAdministratorIfError:
          "If you believe this is an error, contact the evaluation administrator.",
        questionProgress: "Question {{current}} of {{total}}",
        answeredCount: "{{answered}}/{{total}} answered",
        fiveMinutesWarning:
          "⚠️ Less than 5 minutes remaining to complete the evaluation.",
        lastMinuteWarning:
          "🚨 Last minute! The evaluation will close automatically when time runs out.",
        caseStudy: "Case Study",
        readCaseStudyCarefully:
          "Read this case study carefully before answering the following question.",
        aboutThisCompetency: "About this competency",
        evaluationExpiredPlaceholder: "Evaluation expired",
        writeAnswerPlaceholder: "Write your answer here...",
        previous: "Previous",
        finishEvaluation: "Finish Evaluation",
        next: "Next",
        finishConfirmationQuestion:
          "Are you sure you want to finish the evaluation?",
        finishConfirmationWarning:
          "Once finished, you will not be able to modify your answers.",
        ensureAllQuestionsAnswered:
          "Make sure you have answered all questions before finishing.",
        cancel: "Cancel",
        finishing: "Finishing...",
        confirm: "Confirm",
        evaluationAlreadyCompleted:
          "This evaluation has already been completed.",
        evaluationExpiredNotAvailable:
          "This evaluation has expired and is no longer available.",
        errorStartingEvaluation: "Error starting evaluation",
        errorLoadingEvaluation: "Error loading evaluation",
        invalidEmail: "Invalid email",
        pleaseEnterEmail: "Please enter your email",
        noAccessToEvaluation: "You do not have access to this evaluation",
        evaluationNotFound: "Evaluation not found",
        noAccessWithProvidedEmail:
          "You do not have access to this evaluation with the provided email",
        errorValidatingAccess: "Error validating access",
        errorValidatingAccessTryAgain:
          "Error validating access. Please try again.",
        evaluationAccess: "Evaluation Access",
        enterEmailToAccess: "Enter your email to access your evaluation",
        email: "Email",
        emailPlaceholder: "example@email.com",
        enterRegisteredEmail: "Enter your registered email",
        validating: "Validating...",
        accessEvaluation: "Access Evaluation",
        evaluationCompleted: "Evaluation Completed!",
        evaluationCompletedDescription:
          "You have successfully completed the evaluation. Your answers have been saved.",
        thanksForTimeMessage:
          "Thank you for your time. The results will be reviewed and we will contact you soon.",
        evaluationExpired: "Evaluation Expired",
        timeToCompleteHasExpired:
          "The time to complete this evaluation has expired.",
        contactAdministratorIfError:
          "If you believe this is an error, contact the evaluation administrator.",
        error: "Error",
        evaluationNotFoundTitle: "Evaluation Not Found",
        accessDenied: "Access Denied",
        timeFinishedContactAdmin:
          "The time to complete this evaluation has finished. If you believe this is an error, contact the administrator.",
        tryAgain: "Try Again",

        competenciesLabel: "{{count}} competencies",
        estimatedTimeLabel: "Estimated time: {{time}}",
        evaluationStructure: "Evaluation Structure",
        evaluationStructureDescription: "The evaluation is organized by competencies. Each competency has two phases: reading the case study and answering the questions.",
        evaluationStructureDescriptionGrouped: "The evaluation is organized by case studies. You will read each case only once and then answer, one after another, the questions of the competencies linked to that case.",
        caseStudyAndCompetencies: "Case study / Competencies",
        caseStudyGroupHint: "Read once · {{count}} competency(ies)",
        competency: "Competency",
        reading: "Reading",
        totalTime: "Total Time",
        timeWillStartPerPhase: "Time will start running in each phase",
        continueToQuestions: "Continue to Questions",
        continueToNextCompetency: "Continue to Next Competency",
        questionNumber: "Question {{number}}",
        questions: "Questions",
        total: "Total",

        timeFormat: {
          minutes: "{{minutes}} minutes",
          hoursAndMinutes: "{{hours}} {{hoursLabel}} and {{minutes}} minutes",
          hoursOnly: "{{hours}} {{hoursLabel}}",
          hour: "hour",
          hours: "hours"
        },
        defaultApplicantName: "Applicant",
        defaultEvaluationTitle: "Competency Evaluation",
        helloApplicant: "Hello, {{name}}",
        evaluationInformation: "Evaluation Information",
        timeLabel: "Time: {{time}}",
        questionsLabel: "{{count}} question(s)",
        importantInstructions: "Important Instructions",
        instructions: {
          readCarefully: "Read each question carefully before answering",
          readCarefullyDesc: "Take your time to understand what is being asked",
          answerHonestly: "Answer honestly and completely",
          answerHonestlyDesc:
            "There are no right or wrong answers, we want to know your perspective",
          timeLimit: "You have {{time}} to complete the entire evaluation",
          timeLimitDesc:
            "Time starts counting when you press 'Start Evaluation'",
          navigateBetween: "You can navigate between questions",
          navigateBetweenDesc:
            "You can go back to previous questions to review or modify your answers",
          saveProgress: "Save your progress regularly",
          saveProgressDesc:
            "Your answers are saved automatically, but make sure to complete all questions",

          competencyBased: "Competency-based evaluation",
          competencyBasedDesc: "The evaluation is divided into specific competencies that will assess different aspects of your professional profile.",
          readingPhase: "Case study reading phase",
          readingPhaseDesc: "First, you will read a case study or context for each competency. You will have limited time for this phase.",
          readingPhaseGroupedDesc: "First, you will read a case study, only once, with limited time. The case will not be shown again while you answer.",
          questionPhase: "Questions phase",
          questionPhaseDesc: "Then you will answer all questions for that competency on a single page with limited time.",
          noGoingBack: "No going back",
          noGoingBackDesc: "Once you advance from reading to questions, or from one competency to another, you cannot go back.",
          noGoingBackGroupedDesc: "Once you advance from reading to questions, from one competency to another, or from one case to the next, you cannot go back.",
          timeBackup: "Maximum absolute time: {{time}}",
          timeBackupDesc: "If you close the window and return later, this is the maximum total time available.",
        },
        importantAboutTime: "⚠️ Important about time",
        timeWillStart:
          'Time will start counting when you press "Start Evaluation".',
        recommendations: {
          stableConnection: "• Make sure you have a stable internet connection",
          quietPlace: "• Find a quiet place where you can concentrate",
          paperAndPen:
            "• Have paper and pen handy in case you need to take notes",
          dontCloseWindow:
            "• Do not close this browser window until you complete the evaluation",
          exactTime:
            "• Once started, you will have exactly {{time}} to complete all questions",

          estimatedTime: "Total estimated time: {{time}}",
          maxTime: "Maximum absolute time: {{time}}",
        },
        whenReady:
          "When you are ready, press the button to start your evaluation.",
        starting: "Starting...",
        startEvaluation: "Start Evaluation",
        competency: "Competency",
        of: "of",
        readInstructions: "Read the case study carefully. You have {{minutes}} minutes for this phase.",
        answered: "answered",
        question: "Question",
        writePlaceholder: "Write your answer here...",
        nextCompetency: "Next Competency",
        confirmFinish: "Are you sure you want to finish the evaluation?",
        noReturn: "You will not be able to access it again after finishing.",
        completingEvaluation: "Completing Evaluation",
        processingResponses: "We are processing your responses and generating the final report.",
        operationTime: "This operation may take several minutes.",
        doNotClose: "Please do not close this window or navigate to another page.",
        cancel: "Cancel",
        confirm: "Confirm",
      },
      configuration: {
        title: "Word Documents Configuration",
        description:
          "Configure headers and footers for Word documents generated by the system. You can use custom text or logos, and choose the position of each element.",
        header: "Header",
        footer: "Footer",
        enabled: "Enabled",
        disabled: "Disabled",
        contentType: "Content type",
        logo: "Logo",
        text: "Text",
        position: "Position",
        left: "Left",
        center: "Center",
        right: "Right",
        customText: "Custom text",
        dragDropImage: "Drag an image here or click to select",
        imageFormats: "PNG, JPG, JPEG (max. 2MB)",
        uploading: "Uploading",
        save: "Save Configuration",
        saving: "Saving...",
        downloadExample: "Download Example",
        generating: "Generating...",
        tabs: {
          word: "Word",
          hiringRoom: "HiringRoom",
          companyContext: "Company / Team",
          narratives: "Narratives",
          customUrl: "Custom URL",
        },
        customUrl: {
          title: "Custom URL for candidates",
          description: "Customize the subdomain your candidates see in emailed links: tests (DISC, reasoning, skills, sales) and document requests will use {slug}.amandahr.ai instead of app.amandahr.ai.",
          sharedNote: "This subdomain is shared with the ATS job board: changing it here also changes the job board URL (and vice versa).",
          slugLabel: "Subdomain (slug)",
          slugHint: "Lowercase letters, numbers and hyphens only. E.g.: grafton",
          previewLabel: "This is how the links your candidates receive will look:",
          noSlugNote: "Without a subdomain, links keep using app.amandahr.ai.",
          changeWarning: "You are about to change the subdomain: the current URL ({{old}}.amandahr.ai) will stop showing your job board and future emails will use the new one. Already-sent links will keep working.",
          slugRequiredBoard: "Your job board is enabled: the subdomain cannot be empty. Disable it first in ATS Settings if you want to remove it.",
          slugTaken: "That subdomain is already in use by another organization",
          checking: "Checking availability...",
          saveSuccess: "Custom URL saved",
          saveError: "Could not save the custom URL",
          loadError: "Could not load the settings",
          save: "Save",
        },
        sections: {
          header: "header",
          footer: "footer",
        },
        logoAlt: "{{section}} logo",
        exampleFileName: "configuration-example-{{timestamp}}.docx",
        validation: {
          textRequired: "Text is required when enabled",
          logoRequired: "Logo is required when enabled",
        },
        messages: {
          loadingConfig: "Loading configuration...",
          saveSuccess: "Configuration saved successfully",
          saveError: "Cannot save: organization or project are not available",
          cannotSave: "Cannot save: organization or project are not available",
          saveErrorResponse: "Error saving configuration",
          saveErrorWithMessage: "Error saving configuration: {{message}}",
          saveErrorGeneral: "Error saving configuration",
          downloadSuccess: "File downloaded successfully",
          downloadError: "Error downloading example",
          uploadError: "Error uploading image",
          uploadErrorWithMessage: "Error uploading image: {{message}}",
          logoSizeError: "The image cannot exceed 2MB",
          logoFormatError: "Only PNG, JPG and JPEG files are allowed",
          headerUploadSuccess: "Header image uploaded successfully",
          footerUploadSuccess: "Footer image uploaded successfully",
        },
      },
      dashboard: {
        title: "Metrics Dashboard",
        refresh: "Refresh",
        loading: "Loading...",
        selectProject: "Select a project to view metrics",
        loadError: "Error loading dashboard metrics",
        metrics: {
          totalUsers: "Registered Users",
          totalReports: "Evaluations Made",
          totalApplicants: "Registered Candidates",
          totalPositions: "Registered Positions",
          totalEvaluations: "Assessments",
          totalComparisons: "Comparisons Made"
        },
        tables: {
          topUsersTitle: "Users who have made the most evaluations",
          topPositionsTitle: "Positions with Most Evaluations",
          position: "Position",
          name: "Name",
          email: "Email",
          reportsCount: "Number of Evaluations",
          positionName: "Job Title",
          industry: "Industry",
          noUsersData: "No user report data available",
          noPositionsData: "No evaluations with assigned positions",
          unknownUser: "User without name",
          noEmail: "No email",
          unknownPosition: "Unknown position",
          noIndustry: "Not specified"
        },
        "filters": {
          "title": "Date filters (evaluations and comparisons)",
          "startDate": "Start date",
          "endDate": "End date",
          "applyFilters": "Apply filters",
          "lastSevenDays": "Last 7 days",
          "showingDataFrom": "Showing data from {{startDate}} to {{endDate}}",
          "dateRange": "({{startDate}} - {{endDate}})"
        }
      },
      home: {
        welcome: "Welcome back, {{name}}!",
        subtitle: "Manage your selection processes and make data-driven decisions",
        essentialConfig: "Essential Configuration",
        prerequisite: "Prerequisite",
        noPositionsAlert: "No positions created. Positions are required to use the Psycholabor Evaluation, Assessment Center, and Candidate Comparison services.",
        positionManagement: "Position Management",
        managePositionDesc: "Manage job profiles for your psycholabor evaluations, evaluations, and assessments",
        createPositionDesc: "Configure the job profiles needed to create psycholabor evaluations, evaluations, and assessments",
        currentPositions: "Current positions",
        managePositions: "Manage Positions",
        adminOnlyPositions: "Only administrator users can create and manage positions",
        requiredForServices: "Required for all services",
        candidateManagement: "Candidate Management",
        manageCandidateDesc: "Manage registered candidates for your assessments",
        createCandidateDesc: "Register candidates for assessments. Created automatically in psycholabor evaluations",
        currentApplicants: "Candidates",
        manageCandidates: "Manage Candidates",
        requiredForAssessments: "Required for assessments",
        availableCapabilities: "Available Competencies",
        viewCapabilityDesc: "Review predefined competencies available for your assessments",
        currentCapabilities: "Competencies",
        viewCapabilities: "View Competencies",
        mainServices: "Main Services",
        integratedReport: "Psycholabor Evaluation",
        integratedReportDesc: "Evaluate a specific candidate step by step with psychological tests",
        prerequisites: "Prerequisites",
        positionsCreated: "Positions created",
        candidateAutoCreated: "Candidate is automatically created if it doesn't exist",
        createReport: "Create Evaluation",
        assessmentCenter: "Assessment Center",
        assessmentCenterDesc: "Evaluate a candidate's specific competencies and analyze their compatibility with job requirements. Integrates psychological report information when available",
        applicantsRegistered: "Applicants registered",
        capabilitiesDefined: "Competencies defined",
        createAssessment: "Create Assessment",
        reportComparisonCandidates: "Report / Candidate Comparison",
        reportComparisonDesc: "Compare candidates to identify which one shows greater affinity with a specific position profile, based on their psycholabor evaluations",
        twoOrMoreReports: "2 or more psycholabor evaluations",
        compareReports: "Compare Evaluations",
        configAndManagement: "Configuration and Management",
        configuration: "Configuration",
        configurationDesc: "Configure headers and footers for downloadable Word documents",
        goToConfiguration: "Go to Configuration",
        dashboard: "Dashboard",
        dashboardDesc: "View general metrics, most active users, positions with most evaluations, and project statistics",
        goToDashboard: "View Dashboard",
        retrying: "Retrying...",
        retry: "Retry",
        trialBanner: {
          title: "You're using your trial account — 5 points available",
          description: "You have access to Reasoning Test, DISC Test, Psycholabor Evaluation and CV Filtering. Points don't reload once used up.",
          upgrade: "Interested in a full plan? Contact us at",
        },
      },
      subscription: {
        title: "Subscription",
        currentPlan: "Current Plan",
        availablePlans: "Available Plans",
        features: "Features included",
        price: "Price",
        monthly: "monthly",
        yearly: "yearly",
        free: "Free",
        upgrade: "Upgrade",
        downgrade: "Change to Free",
        currentPlanBadge: "Current Plan",
        recommended: "Recommended",
        comingSoon: "Coming Soon",
        subscriptionNote: "Subscription and payment logic will be implemented in an upcoming version. For now you can view available plans.",
        planChangeWarning: "When changing plans, changes will be applied immediately and will affect your organization's usage limits.",
        unlimited: "Unlimited",
        perMonth: "per month",
        organization: "Organization",
        currentSubscription: "Current Subscription",
        billingCycle: "Billing Cycle",
        nextBilling: "Next Billing",
        planFeatures: "Plan Features",
        upgradePlan: "Upgrade your plan to access more features",
        manageBilling: "Manage Billing",

        freePlan: {
          title: "Free Plan",
          current: "Current",
          description: "You are currently using the free plan. Upgrade to access more features."
        },
        availablePlansDescription: "Choose the plan that best fits your needs.",
        availablePlansSuspendedDescription: "Your subscription is suspended. Reactivate your current plan or wait for it to expire to change.",

        paymentHistory: {
          title: "Payment History",
          description: "Subscription changes may take a few minutes to be fully reflected. If you just made a payment, use the \"Refresh\" button to check the status.",
          headers: {
            date: "Date",
            concept: "Concept",
            amount: "Amount",
            status: "Status",
            method: "Method"
          },
          planConcept: "Plan {{plan}}",
          payment: "Payment",
          expected: "Expected"
        },
        billingCycleMonthly: "Monthly",
        billingCycleYearly: "Yearly",
        savingsUpTo8: "Save up to 10%",
        equivalencePerMonth: "(Equivalent to ${{amount}} per month)",

        plans: {
          starter: {
            name: "Starter",
            description: "Perfect for trying out the product"
          },
          crece: {
            name: "Grow",
            description: "For small teams starting to grow"
          },
          avanza: {
            name: "Advance",
            description: "For teams that need more functionality"
          },
          escala: {
            name: "Scale",
            description: "For large teams with advanced needs"
          },
          empresa: {
            name: "Enterprise",
            description: "For companies with unlimited needs"
          },
          features: {
            evaluations: {
              singular: "{{count}} Psycholabor evaluation per month",
              plural: "{{count}} Psycholabor evaluations per month",
              yearly: "{{count}} Psycholabor evaluations per year",
              unlimited: "Unlimited evaluations"
            },
            users: {
              singular: "{{count}} User",
              plural: "{{count}} Users",
              unlimited: "Unlimited users"
            },
            projects: {
              singular: "{{count}} Project",
              plural: "{{count}} Projects",
              unlimited: "Unlimited projects"
            },
            assessments: {
              singular: "{{count}} Assessment",
              plural: "{{count}} Assessments",
              yearly: "{{count}} Assessments per year",
              unlimited: "Unlimited assessments"
            },
            comparisons: {
              singular: "{{count}} Comparison",
              plural: "{{count}} Comparisons",
              yearly: "{{count}} Comparisons per year",
              unlimited: "Unlimited comparisons"
            }
          }
        },
        fields: {
          startDate: "Start date",
          nextBilling: "Next billing",
          limitsReset: "Limits reset",
          currentPeriodEnd: "Current period end",
          notApplicable: "Not applicable"
        },
        status: {
          active: "Active",
          suspended: "Suspended",
          expired: "Expired",
          pending: "Pending",
          completed: "Completed",
          failed: "Failed",
          cancelled: "Cancelled"
        },
        actions: {
          update: "Refresh",
          updating: "Updating...",
          processing: "Processing...",
          select: "Select",
          confirmUpgrade: "Confirm Upgrade",
          downgradeNotAvailable: "Downgrade not available",
          notAvailable: "Not available",
          cancel: "Cancel",
          suspendButton: "Suspend Subscription",
          suspendReason: "User requested suspension",
          reactivateButton: "Reactivate Subscription",
          reactivateReason: "User reactivated subscription"
        },
        alerts: {
          suspended: "Your subscription is suspended but you maintain access until the current period ends ({{endDate}}). You can reactivate it at any time.",
          recentPayment: "We detected a recent payment for the {{plan}} plan. Your subscription data will be updated automatically in a few minutes."
        },
        messages: {
          paymentProcessed: "Payment completed successfully. Updating data...",
          paymentCancelled: "Payment cancelled",
          popupClosed: "Popup closed. Checking payment status...",
          suspended: "Subscription suspended, the change may take a moment to be reflected",
          reactivated: "Subscription successfully reactivated, the change may take a moment to be reflected"
        },
        errors: {
          loadingData: "Error loading subscription data",
          createSubscription: "Error creating subscription",
          processSubscription: "Error processing subscription",
          upgrade: "Error processing upgrade",
          suspend: "Error suspending subscription",
          processSuspension: "Error processing suspension",
          reactivate: "Error reactivating subscription",
          processReactivation: "Error processing reactivation"
        },
        tooltips: {
          downgrade: "To downgrade, first suspend your current plan and wait for it to expire"
        },
        modals: {
          confirmTitle: "Confirm Action",
          suspendTitle: "Suspend Subscription",
          suspendDescription: "When suspending your subscription",
          suspendPointAccess: "You maintain access until {{endDate}}",
          suspendPointNoBilling: "No more automatic charges will be made",
          suspendPointReactivate: "You can reactivate at any time before {{endDate}}",
          suspendPointCancellation: "After that date, it will be permanently cancelled",
          suspendConfirmation: "Are you sure you want to suspend your subscription?",
          upgradeTitle: "Confirm Plan Upgrade",
          upgradeDescription: "You are upgrading from {{currentPlan}} to {{targetPlan}}",
          upgradeConfirm: "By confirming this upgrade",
          upgradePointCancel: "Your current subscription will be cancelled immediately",
          upgradePointCharge: "You will be charged the full ${{amount}} USD for the new plan",
          upgradePointLimitsReset: "Your usage limits will be reset to the new plan",
          upgradePointBillingDate: "The billing date will start from today",
          upgradeWarning: "Important: You will not recover the remaining time from your current plan."
        },
        enterprise: {
          title: "Need an enterprise plan?",
          description: "For organizations with specific needs or high volumes",
          contactButton: "Contact: dgalaz@grafton.cl"
        },
        terms: {
          title: "Terms and Conditions",
          description: "Before proceeding with the subscription, you must accept our terms and conditions.",
          planSelected: "Selected plan",
          billingCycle: "Billing cycle",
          agreement: "I have read and accept the",
          termsAndConditions: "terms and conditions",
          continue: "Continue",
          mustAccept: "You must accept the terms and conditions to continue"
        },

        contactEmail: "Contact",
        customPricing: "Custom Pricing",
        user: "user",
        users: "users",
        project: "project",
        projects: "projects",
        points: "points"
      },
      login: {
        title: "Sign In",
        subtitle: "Access your account to manage evaluations and projects",
        form: {
          email: "Email",
          password: "Password",
          signIn: "Sign In",
          signingIn: "Signing In..."
        },
        register: {
          question: "Don't have an account?",
          button: "Create Account",
          subtitle: "Register to start using AmandaHR"
        },
        passwordReset: {
          link: "Forgot your password?",
          title: "Reset Password",
          subtitle: "Enter your email address and we'll send you a link to reset your password",
          form: {
            email: "Email",
            sendButton: "Send Link",
            sending: "Sending...",
            backToLogin: "Back to Sign In"
          },
          success: "If the email is registered, you'll receive a link to reset your password. Check your inbox (and spam folder).",
          error: {
            userNotFound: "No account found with this email address.",
            invalidEmail: "The email format is not valid.",
            generic: "Error sending recovery email. Please try again."
          }
        },
        sessionExpired: "Your session expired. Please sign in again.",
        loading: "Signing in...",
        error: {
          generic: "Login error. Check your credentials and try again."
        }
      },
      resetPassword: {
        title: "Create new password",
        subtitle: "Set the new password for your account",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        policy: "Minimum 6 characters and at least one number",
        mismatch: "Passwords do not match",
        submit: "Save password",
        submitting: "Saving...",
        success: "Your password was updated successfully. You can now sign in.",
        goLogin: "Go to sign in",
        invalid: "The link is not valid. Request a new one from the sign-in screen.",
        expired: "The link expired (valid for 60 minutes). Request a new one from the sign-in screen.",
        used: "This link was already used. If you need to change your password again, request a new link.",
        requestNew: "Request a new link",
        error: "Error updating the password. Please try again."
      },
      register: {
        header: {
          title: "Join Amanda HR",
          subtitle: "Revolutionize your recruitment process with AI"
        },
        form: {
          title: "Create your free account",
          fields: {
            name: "Full name",
            email: "Email",
            password: "Password",
            passwordHelper: "Minimum 6 characters",
            confirmPassword: "Confirm password"
          },
          buttons: {
            hasAccount: "Already have an account? Sign in",
            creating: "Creating account...",
            createAccount: "Create free account"
          }
        },
        freeAccount: {
          title: "What's included in your free account?",
          features: {
            evaluations: "1 Psychological evaluation per month",
            userProject: "1 User and 1 Project",
            basicAccess: "Full access to basic functionalities",
            upgrade: "You can upgrade your plan anytime"
          }
        },
        validation: {
          nameRequired: "Name is required",
          emailRequired: "Email is required",
          passwordRequired: "Password is required",
          passwordMismatch: "Passwords don't match",
          passwordMinLength: "Password must be at least 6 characters",
          privacyRequired: "You must accept the privacy policy to continue"
        },
        success: {
          message: "Registration successful. Sign in with your credentials."
        },
        error: {
          generic: "Error registering user"
        },
        loading: {
          message: "Creating your account..."
        },
        privacy: {
          agreement: "I have read and accept the",
          privacyPolicy: "privacy policy"
        },
      },
      disc: {
        sendEmailOnCreate: "Send email to applicant",
        sendEmailOnCreateEnabled: "The test link will be sent automatically by email when created",
        sendEmailOnCreateDisabled: "The test will be created without sending an email, you can send it later from the dashboard",
        testCreatedSuccess: "Test created successfully. You can send the email from the dashboard.",
        createTest: "Create test",
        individualTests: "Individual Tests",
        testsCompared: "Compared Tests",
        tests: "tests",
        viewReport: "View Report",
        deleteComparison: "Delete Comparison",
        deleteComparisonTitle: "Delete Comparison",
        deleteComparisonConfirm: "Are you sure you want to delete this comparison?",
        type: "Type",
        statusProcessing: "Processing",
        statusEvaluated: "Evaluated",
        statusProcessing_error: "Processing Error",
        processTest: "Process",
        processing: "Processing...",
        retryProcess: "Retry",
        copyTestUrl: "Copy Test URL",
        urlCopied: "URL copied to clipboard",
        urlCopyError: "Error copying URL",
        processTestSuccess: "Test queued for processing",
        processTestError: "Error processing test",
        errorDetails: "Error details",
        title: "DISC Test Management",
        subTitle: "Configure and manage DISC tests to evaluate behavioral profiles of your applicants.",
        configuration: "Create",
        dashboard: "Dashboard",
        comparisons: "Comparisons",
        reanalyze: "Reanalyze",
        configurationTitle: "Create New DISC Test",
        configurationSubTitle: "Configure DISC test parameters for your applicants",
        testMode: "Test Mode",
        simpleMode: "Simple Mode",
        simpleModeDescription: "Applicant only takes the DISC test",
        completeMode: "Complete Mode",
        completeModeDescription: "DISC test with additional position context and competencies",
        selectApplicant: "Select Applicant",
        selectPosition: "Select Position",
        optional: "(Optional)",
        currentPosition: "Applicant's Current Position",
        currentPositionPlaceholder: "E.g: Marketing Analyst",
        selectCompetencies: "Select Competencies to Measure",
        competenciesDescription: "Select the competencies you want to evaluate based on test responses",
        sendTest: "Send Test",
        cancel: "Cancel",
        testSentSuccess: "DISC test sent successfully",
        testSentError: "Error sending DISC test",
        pleaseSelectApplicant: "Please select an applicant",
        dashboardTitle: "DISC Tests Status",
        dashboardSubTitle: "View progress and results of sent tests",
        applicantName: "Applicant",
        position: "Position",
        status: "Status",
        sentDate: "Sent Date",
        completedDate: "Completed Date",
        actions: "Actions",
        viewResult: "View Result",
        resendTest: "Resend Test",
        statusPending: "Pending",
        statusCompleted: "Completed",
        statusProcessing: "Processing",
        statusSent: "Sent",
        noTestsFound: "No DISC tests found",
        noTestsMessage: "Create your first DISC test from the Configuration tab",
        loadError: "Error loading DISC tests",
        notAvailable: "Not available",

        // Public texts
        emailVerification: "Email Verification",
        enterEmailToAccess: "Enter your email to access the DISC test",
        enterEmail: "Enter your email",
        accessTest: "Access Test",
        invalidEmail: "Invalid email",
        pleaseEnterEmail: "Please enter your email",
        testNotFound: "Test not found",
        testExpired: "Test Expired",
        testExpiredMessage: "This test has expired. Please contact the administrator.",
        // Automatic close when the timer runs out: the answers given so far
        // were already submitted, the test is not left as "started".
        timeUpTitle: "Time is up",
        timeUpMessage: "The time available to answer the test has ended. We automatically submitted the answers you managed to complete, so there is nothing else you need to do. If you think something went wrong, contact the person who sent you the test.",
        timeUpSubmitFailedMessage: "The time available to answer the test has ended, but we could not record your answers. Please contact the person who sent you the test.",
        accessDenied: "Access denied. Email does not match the test.",
        errorTitle: "Error",
        genericError: "An error occurred. Please try again.",
        errorStartingTest: "Error starting test",

        // Instructions
        extendedDiscModel: "Insight DISC by Amanda",
        modelDescription: "The intelligent evolution of the DISC model",
        modelHistory: "This assessment is not designed to measure your worth or rate you. Its purpose is to understand your natural way of thinking, communicating, and working. Answer spontaneously — there are no right or wrong answers. Every profile is unique and valuable, and understanding yours allows us to identify the environments where you can best showcase your talents.",

        // DISC Styles
        dominance: "Dominance",
        dominanceDescription: "Direct, decisive, results-oriented, competitive people",
        influence: "Influence",
        influenceDescription: "Sociable, optimistic, communicative, enthusiastic people",
        steadiness: "Steadiness",
        steadinessDescription: "Patient, loyal, collaborative, reliable people",
        conscientiousness: "Conscientiousness",
        conscientiousnessDescription: "Analytical, precise, systematic, detail-oriented people",

        // Test instructions
        instructionText: "Select one option from each column for each characteristic",
        testInstructions: "Test Instructions",
        instruction1: "The test consists of 24 questions with 4 options each",
        instruction2: "For each question, select the option that MOST describes you (M)",
        instruction3: "Also select the option that LEAST describes you (L)",
        instruction4: "Respond instinctively and honestly, there are no right or wrong answers",
        instruction5: "The test takes approximately 20 minutes to complete",

        starting: "Starting...",
        startTest: "Start Test",

        // Test navigation
        page: "Page",
        of: "of",
        completed: "completed",
        selectOptions: "Select your options",
        mostDescribesMe: "MOST describes me",
        leastDescribesMe: "LEAST describes me",
        previous: "Previous",
        next: "Next",
        completeTest: "Complete Test",
        completing: "Completing...",

        // Validations
        cannotSelectSameOption: "You cannot select the same option in both columns",
        mustSelectBothOptions: "You must select one option in each column (MOST and LEAST)",
        errorCompletingTest: "Error completing test. Please try again.",

        // Completed
        testCompletedTitle: "Test Completed!",
        testCompletedMessage: "You have successfully completed the DISC test. Results will be sent to the evaluator.",
        thankYou: "Thank you for your time",

        refresh: "Refresh",
        reportTitle: "DISC Report",
        discResults: "DISC Results",
        insufficientResponses: "Not enough responses to calculate.",
        downloadPdf: "Download PDF",
        statusStarted: "Started",
        statusExpired: "Expired",
        // Test closed with fewer than the 24 pages: the profile comes from a
        // partial set, so it cannot be processed or compared.
        statusInvalid: "Invalid",
        answeredPagesLabel: "{{answered}} of {{total}} answered",

        reliabilityAnalysis: "Reliability Analysis",
        completed: "Completed",
        state: "Status",
        primaryStyle: "Primary Style",

        // Validity states (for getValidityChipConfig)
        highReliability: "High reliability",
        acceptableReliability: "Acceptable reliability",
        questionableReliability: "Questionable reliability",
        lowReliability: "Low reliability",
        compromisedValidity: "Compromised validity",

        // DISC Styles
        dominance: "Dominance",
        influence: "Influence",
        steadiness: "Steadiness",
        conscientiousness: "Conscientiousness",

        naturalProfile: "Natural Profile",
        adaptedProfile: "Adapted Profile",
        flexibilityZone: "Flexibility Zone",
        characteristics: "Characteristics",
        strengths: "Strengths",
        motivators: "Motivators",
        demotivators: "Demotivators",
        developmentAreas: "Development Areas",
        thingsThatTryToAvoid: "Things to Try to Avoid",
        noContent: "No content.",
        overuseUnderuseAnalysis: "Overuse and Underuse Analysis",
        detailedAnalysis: "Detailed Analysis:",
        teamRole: "Team Role",
        practicalExamples: "Practical Examples:",
        emotionalInterpretationTitle: "Emotional Interpretation and Profile Proportionality",
        generalEmotionalAnalysis: "General Emotional Analysis",
        dominantTraits: "Dominant Traits",
        dominantTraitsDescription: "These traits define the primary behavioral style and are most visible in daily life.",
        nonDominantTraits: "Non-Dominant Traits",
        nonDominantTraitsDescription: "Present but with less natural emphasis; can be developed according to role needs.",
        adaptationAnalysis: "Adaptation Analysis (Natural vs Adapted)",
        adaptationPatternDescription: "The person shows a mixed adaptation pattern, intensifying some traits while suppressing others. This suggests a conscious adjustment to the work environment.",
        natural: "Natural:",
        adapted: "Adapted:",
        noInformation: "No information",
        overuseUnderuseConsiderations: "Considerations on Trait Overuse and Underuse",
        overuseRisk: "Overuse Risk:",
        overuseRiskDescription: "may become counterproductive if intensified excessively.",
        underuseRisk: "Underuse Risk:",
        underuseRiskDescription: "could be expressed below what the environment requires.",
        balancedUse: "Balanced Use:",
        balancedUseDescription: "appropriate level of expression.",
        practicalExample: "Practical example:",
        developmentPlan90Days: "90-Day Development Plan",
        howToLeverageThem: "How to Leverage Them:",
        concreteTip: "CONCRETE TIP:",
        whyItMatters: "Why does it matter?",
        dominant: "Dominant",
        deleteTest: "Delete Test",
        deleteTestTitle: "Confirm Deletion",
        deleteTestConfirm: "Are you sure you want to delete the DISC test from",
        testDeletedSuccess: "DISC test successfully deleted",
        testDeletedError: "Error deleting DISC test",
        testResentSuccess: "Test resent successfully",
        testResentError: "Error resending test",
        refresh: "Refresh",
        reanalyzeTitle: "Reanalyze DISC Test",
        reanalyzeDescription: "Select a completed test and specify new parameters (position and/or competencies) to generate a new analysis",
        reanalyzeNote: "Note:",
        reanalyzeNoteText: "Reanalysis will create a new test with the same DISC results but with the context (position and/or competencies) you specify. The original test will not be modified.",
        selectApplicantPlaceholder: "Select an applicant",
        reanalyzeWarning: "Important:",
        reanalyzeWarningText: "If you only send the position, competencies will be removed. If you only send competencies, the position will be removed.",
        reanalyzeValidation: "You must provide at least a position or competencies to reanalyze",
        reanalyzeSuccess: "Test successfully sent for reanalysis. New test ID: {{testId}}",
        reanalyzing: "Reanalyzing...",
        reanalyzeButton: "Reanalyze DISC Test",
        selectApplicantToStart: "Select an applicant to start reanalysis",
        noCompletedTestsForReanalysis: "No evaluated DISC tests available for reanalysis",
        evaluatedTestsNotice: "Only evaluated DISC tests will be shown. The most recent test for each candidate will be considered.",
        discComparisons: {
          title: "DISC Test Comparisons",
          subTitle: "Analyze and compare DISC profiles to identify compatibilities and team strengths",

          // Analysis types
          analysisType: "Analysis Type",
          selectAnalysisType: "Select the type of analysis you want to perform",

          // Option 1: Compare Candidates
          compareCandidates: "Compare Candidates",
          compareCandidatesTitle: "Compare Candidates",
          compareCandidatesDescription: "Rank candidates for a position. Compare multiple candidates and get a ranking based on position fit. Analyze what each candidate brings to the team.",

          // Option 2: Candidate vs Boss
          candidateVsBoss: "Candidate vs Boss",
          candidateVsBossTitle: "Candidate vs Boss",
          candidateVsBossDescription: "Analyze the complementarity between candidates and their future boss. Identify synergies and possible conflicts.",

          // Option 3: Team Analysis
          teamAnalysis: "Team Analysis",
          teamAnalysisTitle: "Established Team Analysis",
          teamAnalysisDescription: "Analyze established teams to identify strengths, gaps and strategies to maximize their performance.",

          // General configuration
          configuration: "Configuration",
          results: "Results",
          selectPosition: "Select Position",
          selectPositionDescription: "Select the target position for the analysis",
          positionRequired: "Position is required for this analysis",
          noPositionsFound: "No positions found",

          // Team context (for Team Analysis)
          teamContext: "Team Context",
          teamContextDescription: "Information about the team (optional)",
          teamName: "Team Name",
          teamNamePlaceholder: "E.g: Operations Team - Dental Laboratory",
          teamDescription: "Description",
          teamDescriptionPlaceholder: "Team responsible for daily laboratory operations management, including production coordination, quality control and customer service.",
          teamObjectives: "Objectives",
          teamObjectivesPlaceholder: "Optimize production times, maintain quality standards, improve communication with clients and technicians.",

          // People selection
          teamMembers: "Team Members",
          selectMembers: "Select team members",
          candidates: "Candidates",
          selectCandidates: "Select candidates to compare",
          boss: "Boss/Reference",
          selectBoss: "Mark who is the boss or reference",

          // DISC tests
          discTestsAvailable: "Available DISC Tests",
          noDiscTestsFound: "No completed DISC tests found",
          loadingTests: "Loading DISC tests...",
          testsLoadError: "Error loading DISC tests",
          selectedTests: "Selected tests",
          selectMinimum: "Select at least {{count}} DISC tests",

          // Test information
          testCompleted: "Test completed",
          testDate: "Test date",
          discProfile: "DISC Profile",
          naturalProfile: "Natural Profile",
          adaptedProfile: "Adapted Profile",

          // Search and filters
          searchApplicant: "Search by name...",
          filterByPosition: "Filter by position",
          showOnlySelectedPosition: "Only tests from selected position",
          showingResults: "Showing",
          of: "of",
          results: "results",

          // Requirements to start
          requirements: {
            title: "To start the analysis you need",
            selectAnalysisType: "Select an analysis type",
            selectPosition: "Select a position (for options 1 and 2)",
            fillTeamContext: "Complete team context (for option 3)",
            selectMinTests: "Select at least 2 DISC tests",
            selectBoss: "Mark who is the boss (for option 2)",
          },

          // Actions
          startAnalysis: "Start Analysis",
          starting: "Starting...",
          analyzing: "Analyzing DISC profiles...",
          processingAnalysis: "Processing in progress",
          processingText: "DISC profile analysis is in progress. This may take a few moments.",

          // Results
          analysisResults: "Analysis Results",
          candidateRanking: "Candidate Ranking",
          compatibilityAnalysis: "Compatibility Analysis",
          teamStrengths: "Team Strengths",
          teamGaps: "Identified Gaps",
          recommendations: "Recommendations",
          discProfileComparison: "DISC Profile Comparison",

          // Errors
          analysisError: "Analysis error",
          analysisCreateError: "Error creating analysis",
          analysisStarted: "Analysis started successfully",

          // Status
          statusPending: "Pending",
          statusProcessing: "Processing",
          statusCompleted: "Completed",
          statusProcessing: "Processing",
          statusError: "Error",

          // Result actions
          newAnalysis: "New Analysis",
          downloadResults: "Download Results",
          viewDetails: "View Details",

          // Usage limits
          usageLimitReached: "DISC Analysis Limit Reached",
          usageLimitMessage: "You have reached the maximum limit of DISC analyses for your organization. To continue using this service, please contact your administrator to review your current plan or increase usage limits.",
          currentUsage: "Current usage",
          analyses: "analyses",
          remainingAnalyses: "Remaining analyses",
          unlimited: "unlimited",
          checkingUsageLimits: "Checking usage limits...",
          teamContextRequired: "Team context is required",
          bossLabel: "Boss",
          markAsBoss: "Mark as Boss",
          noPosition: "No position",
          teamNameRequired: "Team name is required",
          teamDescriptionRequired: "Description is required",
          teamObjectivesRequired: "Objectives are required",

          processing: "Processing DISC Analysis",
          processingDescription: "We are analyzing DISC profiles with artificial intelligence. This may take a few minutes.",
          lastUpdate: "Last update",
          processingError: "Error processing analysis",
          unknownError: "Unknown error processing comparison",
          retryStarted: "Retry started successfully",
          retryError: "Error retrying analysis",

          naturalProfile: "Natural DISC Profile",
          candidatesRanking: "Candidates Ranking",
          analysisBasedOnCompetencies: "AI-generated analysis based on competencies and job description",

          fitAnalysis: "Fit Analysis",
          teamContribution: "Team Contribution",

          bossDataNotFound: "Boss/supervisor data not found",
          noResultsAvailable: "No results available",

          complementarityAnalysis: "Complementarity in Context",
          workDynamics: "Work Dynamics",
          synergiesAndTensions: "Synergies and Tensions",

          composition: "Team Composition",
          collectiveStrengths: "Collective Strengths",
          gaps: "Gaps and Opportunity Areas",
          currentDynamics: "Current Dynamics",
          roleRecommendations: "Role Recommendations",
          managementStrategies: "Management Strategies",
          actionPlan: "Action Plan",
          actionPlan306090: "Action Plan 30 / 60 / 90 Days",
          days30: "30 Days",
          days60: "60 Days",
          days90: "90 Days",
          inSummary: "In summary",
          teamAnalysisTitle: "Team Analysis",

          unknownAnalysisType: "Unknown analysis type",
          competenciesTitle: "Competencies",
          competenciesOptional: "(Optional)",
          competenciesDescription: "Select specific competencies to focus the DISC analysis",
          selectCompetencies: "Select Competencies",
          searchCompetencies: "Search competencies...",
          noCompetenciesFound: "No competencies found",
          competenciesSelected: "competenc(y/ies) selected",
          competenciesLabel: "Competencies:",

          summary: "Summary",
          positionInfo: "Position Information",
          positionDescription: "Description",
          evaluatedCompetencies: "Evaluated competencies",
          downloadPDF: "Download PDF",
          teamContext: "Team Context",
          teamDescription: "Description",
          teamObjectives: "Objectives",
          configuration: "Configuration",
          teamDiscMap: "Team DISC Map",
          teamMembersLegend: "Team Members:",
          natural: "Natural",
          adapted: "Adapted",
          teamMapLegendHint: "The dot marks the natural style and the arrow points to the adapted style (numbered circle).",
          reprocessTitle: "Reprocess analysis",
          reprocessConfirm: "The analysis will be generated again with AI, replacing the current result and PDF. No points are charged.",
          reprocessStarted: "Reprocessing started. The analysis will be updated in a few minutes.",
          reprocessError: "Reprocessing could not be started.",
          downloadGroupMapsPDF: "Download maps (PDF)",
          groupMapsPdfPending: "The maps PDF is generated when the analysis is processed. Older analyses will get it once they are reprocessed.",
        },
        bulkSend: {
          selectApplicants: "Select Applicants",
          selectionMethod: "Selection Method",
          uploadExcel: "Upload Excel",
          selectManually: "Select Manually",
          searchApplicants: "Search applicants by name or email...",
          selectAll: "Select All",
          deselectAll: "Deselect All",
          applicantsSelected: "{{count}} applicant(s) selected",
          noApplicantsFound: "No applicants found with applied filters",
          individualSend: "Individual Send",
          bulkSend: "Bulk Send",
          title: "Bulk DISC Test Send",
          subtitle: "Upload an Excel file with candidate emails to send DISC tests in bulk",

          instructions: {
            title: "Instructions:",
            step1: "The Excel file must have a column named \"email\"",
            step2: "Tests will only be sent to candidates that already exist in the system",
            step3: "You can download an example template",
            downloadTemplate: "Download Template",
          },

          configuration: {
            title: "Test Configuration",
            subtitle: "Select the mode and optional parameters that will be applied to all candidates",
          },

          fileUpload: {
            title: "Upload Excel File",
            dragOrClick: "Click or drag an Excel file here",
            supportedFormats: "Supported formats: .xlsx, .xls",
            processing: "Processing file...",
            invalidFileType: "Please select a valid Excel file (.xls or .xlsx)",
            emptyFile: "The Excel file is empty",
            noEmailColumn: "No emails found. Make sure there is an \"email\" column",
            readError: "Error reading file",
            processError: "Error processing file:",
          },

          preview: {
            summary: "File summary:",
            totalEmails: "Total emails:",
            candidatesFound: "Candidates found:",
            emailsNotFound: "Emails not found:",
            candidatesList: "Candidates who will receive the tests:",
            name: "Name",
            email: "Email",
            andMore: "... and",
            moreRecords: "more",
            notFoundEmails: "Emails not found:",
          },

          progress: {
            title: "Send status:",
            progressLabel: "Progress:",
            processed: "Processed:",
            successful: "Successful:",
            failed: "Failed:",
          },

          actions: {
            cancel: "Cancel",
            sending: "Sending...",
            sendTo: "Send to",
            candidates: "Candidates",
          },

          messages: {
            loadValidCandidates: "Please load a file with valid candidates",
            bulkStarted: "Bulk send started:",
            errorStartingBulk: "Error starting bulk send",
            sendCompleted: "Send completed:",
            successful: "successful",
            failed: "failed",
            bulkFailed: "The bulk send failed",
          },

          insufficientPoints: "Insufficient points",
          insufficientPointsMessage: "You have selected {{selected}} candidates but only have {{available}} points available.",
          sufficientPoints: "You have enough points to send {{selected}} tests ({{available}} available)",
        },
        usageCheck: {
          checkingLimits: "Checking available limits...",
          serviceNotAvailable: "DISC Test not available in your plan",
          limitReached: "DISC test limit reached",
          pointsAvailable: "Available points: {{points}}"
        },

        positionAffinity: "Position Affinity",
        affinityPercentage: "Affinity Percentage",
        affinityAnalysis: "Affinity Analysis",
        highAffinity: "High Affinity",
        moderateAffinity: "Moderate Affinity",
        lowAffinity: "Low Affinity",
        competenciesAffinity: "Competencies Affinity",
        createdBy: "Created by",
      },
      reasoningTests: {
        sendEmailOnCreate: "Send email to applicant",
        sendEmailOnCreateEnabled: "The test link will be sent automatically by email when created",
        sendEmailOnCreateDisabled: "The tests will be created without sending an email, you can send it later from the dashboard",
        testsCreatedSuccess: "{{count}} test(s) created successfully. You can send the email from the dashboard.",
        createTests: "Create tests",
        activityMonitoringDisclaimer: "Your activity will be monitored during this test to ensure process integrity. This includes detecting tab switches, copy/paste actions, screenshots, and other suspicious behaviors.",
        totalTime: 'Total Time',
        confidenceIndex: 'Confidence Index',
        confidenceHigh: 'High Reliability',
        confidenceMedium: 'Moderate Reliability',
        confidenceLow: 'Low Reliability',
        confidenceVeryLow: 'Very Low Reliability',
        statusProcessing: "Processing",
        statusEvaluated: "Evaluated",
        statusProcessing_error: "Processing Error",
        processTest: "Process",
        processing: "Processing...",
        retryProcess: "Retry",
        copyTestUrl: "Copy Test URL",
        urlCopied: "URL copied to clipboard",
        urlCopyError: "Error copying URL",
        processTestSuccess: "Test queued for processing",
        processTestError: "Error processing test",
        errorDetails: "Error details",
        createdBy: "Created by",
        // Layout
        title: "Aptitude Tests",
        subTitle: "Configure and manage aptitude tests to evaluate cognitive skills of your applicants",
        configuration: "Create",
        dashboard: "Dashboard",

        // Configuration
        configurationTitle: "Create New Aptitude Tests",
        configurationSubTitle: "Select the applicant and the tests you want to send",
        selectApplicant: "Select Applicant",
        searchApplicant: "Search applicant...",
        selectTests: "Select Tests",
        selectTestsDescription: "Select one or more tests to send to the applicant",

        // Test Types
        wordAssociation: "Word Association",
        wordAssociationDescription: "Evaluates creativity and associative thinking patterns",
        logicalProcess: "Logical Process",
        logicalProcessDescription: "Evaluates logical reasoning and sequential analysis capability",
        numericalReasoning: "Numerical Reasoning",
        numericalReasoningDescription: "Evaluates numerical skills and mathematical comprehension",

        // Form
        selectedTests: "Selected tests",
        sendTests: "Send Tests",
        sending: "Sending...",
        cancel: "Cancel",

        // Validations
        pleaseSelectApplicantAndTests: "Please select an applicant and at least one test",
        pleaseSelectAtLeastOneTest: "Please select at least one test to send",

        // Messages
        allTestsSentSuccess: "{{count}} test(s) sent successfully",
        testsCreatedAndEmailSent: "{{count}} test(s) created and sent in a single email",
        someTestsSentSuccess: "{{success}} test(s) sent, {{failed}} failed",
        allTestsFailed: "Error sending all tests",
        testSentError: "Error sending aptitude tests",
        loadApplicantsError: "Error loading applicants",
        testResentSuccess: "Test resent successfully",
        testResentError: "Error resending test",
        viewResultNotImplemented: "Result visualization will be available soon",

        // Dashboard
        dashboardTitle: "Aptitude Tests Status",
        dashboardSubTitle: "View progress and results of sent tests",
        allTests: "All Tests",
        refresh: "Refresh",

        // Table
        applicantName: "Applicant",
        testType: "Test Type",
        status: "Status",
        sentDate: "Sent Date",
        completedDate: "Completed Date",
        actions: "Actions",
        notAvailable: "Not available",

        // Status
        statusPending: "Pending",
        statusSent: "Sent",
        statusStarted: "Started",
        statusCompleted: "Completed",
        statusProcessing: "Processing",
        statusExpired: "Expired",

        // Actions
        viewResult: "View Result",
        resendTest: "Resend Test",

        // Empty states
        noTestsFound: "No aptitude tests found",
        noTestsMessage: "Create your first test from the Configuration tab",
        loadError: "Error loading aptitude tests",

        // TESTS
        questionProgress: "Question {{current}} of {{total}}",
        skipQuestion: "Skip question",
        next: "Next",
        finish: "Finish",
        savingProgress: "Saving progress...",

        // Instructions translations
        instructions: "Instructions",
        welcomeMessage: "Welcome {{name}}!",
        startTest: "Start Test",
        starting: "Starting...",

        // Word Association specific
        wordAssociation16Questions: "The test consists of 16 questions",
        wordAssociation10Minutes: "You have 10 minutes to complete it",
        wordAssociationPairs: "Each question shows a pair of related words",
        wordAssociationSimilar: "You must select the pair that has a similar relationship",
        wordAssociationNoPrevious: "You cannot go back to previous questions",
        wordAssociationCanSkip: "You can skip questions without answering",

        // Numerical Reasoning
        numericalReasoning42Series: "There are 42 number series",
        numericalReasoningNext2: "You must identify the pattern and write the next 2 numbers",
        numericalReasoningPractice: "The first 4 series are for practice to familiarize yourself",

        logicalProcess6Problems: "There are 6 logical problems",
        logicalProcessMultipleQuestions: "Each problem has several questions",
        logicalProcessReadCarefully: "Read each statement carefully",
        timeRemaining: "Time remaining",
        lessThanOneMinute: "Less than 1 minute!",
        invalidTestType: "Invalid test type",
        accessDenied: "Access denied",
        testNotFound: "Test not found",
        loadError: "Error loading test",

        // Error messages
        emailVerification: "Email Verification",
        enterEmailToAccess: "Enter your email to access the aptitude test",
        enterEmail: "Enter your email",
        accessTest: "Access Test",
        invalidEmail: "Invalid email",
        errorTitle: "Error",
        genericError: "An error occurred. Please try again.",
        testExpired: "Test Expired",
        testExpiredMessage: "This test has expired. Please contact the administrator.",
        errorStartingTest: "Error starting test",
        errorCompletingTest: "Error completing test",
        testCompletedTitle: "Test Completed",
        testCompletedMessage: "Thank you for completing the test. Your results have been saved.",
        // Automatic close when the timer runs out
        timeUpTitle: "Time is up",
        timeUpMessage: "The time available to answer the test has ended. We automatically submitted the answers you managed to complete, so there is nothing else you need to do.",
        timeUpSubmitFailedMessage: "The time available to answer the test has ended, but we could not record your answers. Please contact the person who sent you the test.",
        pleaseCompleteAllFields: "Please complete all fields",
        itIsKnownThat: "It is known that...",
        questions: "Questions",
        selectAnOption: "Select an option",
        similarRelationTo: "Which pair of words has a similar relationship to:",

        // Page navigation
        questionNumber: "Question {{number}}",
        pageProgress: "Page {{current}} of {{total}}",
        questionsInPage: "Questions {{start}}-{{end}} of {{total}}",
        previous: "Previous",
        next: "Next",
        nextPage: "Next Page",
        finish: "Finish",
        skipQuestion: "Skip",

        // States
        timeExpired: "Time expired! The test will be completed automatically.",
        savingProgress: "Saving progress...",
        pleaseCompleteAllFields: "Please complete all fields",

        resultsTitle: "Test Results",
        correctAnswers: "Correct answers",
        timeUsed: "Time Used",
        answersDetail: "Answer Details",
        yourAnswer: "Answer",
        correctAnswer: "Correct answer",
        incorrect: "Incorrect",
        noResults: "No results available",
        insufficientResponses: "Not enough responses",
        unknownTestType: "Unknown test type",
        of: "of",
        correct: "Correct",
        question: "Question",
        emptyAnswer: "No answer",
        score: "Score",
        totalTime: "Total Time",
        technicalDetails: "Technical Details Table",
        metric: "Metric",
        value: "Value",
        correctTotal: "Correct (total)",
        correctResponded: "Correct (Answered)",
        questionsAnswered: "Questions answered",
        answeredPercent: "Answered %",
        realTime: "Real time",
        performanceInterpretation: "Performance Interpretation",
        notAnswered: "Not answered",
        downloadReport: 'Download PDF',

        socialContext: "Social Context",
        socialContextDescription: "Evaluates the ability to order events in chronological sequence",
        socialContext20Questions: "The test consists of 20 questions",
        socialContext10Minutes: "You have 10 minutes to complete it",
        socialContextOrderImages: "Each question shows 4 images that you must order chronologically",
        socialContextDragDrop: "Drag the images to order them from first (1st) to last (4th)",
        socialContextChronological: "The order must be chronological according to the sequence of events",
        socialContextCanSkip: "You can skip questions if you're not sure",
        orderImagesChronologically: "Order the images chronologically",
        dragToOrderInstructions: "Drag the images to order them from first (1st) to last (4th) according to the chronological order of events.",
        currentOrder: "Current order:",
        checkOrder: 'Check order',
        correctOrderIs: 'The correct order is',
        correctOrderDescriptions: {
          a: "wakes up",
          b: "has breakfast",
          c: "walks to work",
          d: "works"
        },

        logicalAbstract: "Logical Abstract Reasoning",
        logicalAbstractDescription: "Evaluates ability to identify logical relationships between concepts and categorical thinking",
        logicalAbstract30Questions: "The test contains 30 questions about logical relationships between concepts",
        logicalAbstract10Minutes: "You have 10 minutes to complete the test",
        logicalAbstractAnalyzeConcepts: "Each question presents three concepts that you must analyze",
        logicalAbstractIdentifyRelation: "You must identify the correct relationship between them (A, B, C, D or E)",
        logicalAbstractNoPenalty: "There is no penalty for incorrect answers",
        logicalAbstractCanSkip: "You can skip questions and return later",

        integrityTest: "Work Integrity",
        integrityTestDescription: "Evaluates honesty, ethics and attitudes toward organizational rules",
        integrityTest45Questions: "The test contains 45 questions about integrity and work ethics",
        integrityTest15Minutes: "You have 15 minutes to complete the test",
        integrityTestHonestAnswers: "Answer honestly, there are no right or wrong answers",
        integrityTestConfidential: "Your answers are confidential",
        integrityTestNoReturn: "You cannot return to previous questions",
        integrityTestCanSkip: "You can skip questions if you wish",
        integrityIGI: "General Integrity Index (GII)",
        integrityRiskLevel: "Risk Level",
        integrityHighRisk: "High Risk",
        integrityMediumRisk: "Medium Risk",
        integrityLowRisk: "Low Risk",
        integrityValidResponses: "Response Validity",
        integrityValid: "Valid",
        integrityQuestionable: "Questionable",

        emotionalIntelligence: "Emotional Intelligence",
        emotionalIntelligenceDescription: "Evaluates ability to recognize and manage own and others' emotions",
        emotionalIntelligence48Questions: "The test consists of 48 statements",
        emotionalIntelligence10Minutes: "Estimated time: 10 minutes",
        emotionalIntelligenceLikertScale: "Respond using a 5-option Likert scale (Strongly disagree - Strongly agree)",
        emotionalIntelligenceHonestAnswers: "Answer honestly according to how you usually act, not how you would like to act",
        emotionalIntelligenceNoReturn: "You cannot go back once you proceed",
        emotionalCIE: "Emotional Intelligence Quotient (EQ)",
        emotionalLevel: "Level",
        emotionalHigh: "High",
        emotionalMedium: "Medium",
        emotionalLow: "Low",
        emotionalDimensions: "Dimension Scores",

        deleteTest: "Delete Test",
        deleteTestTitle: "Confirm Deletion",
        deleteTestConfirm: "Are you sure you want to delete the aptitude test from",
        testDeletedSuccess: "Aptitude test successfully deleted",
        testDeletedError: "Error deleting aptitude test",
        refresh: "Refresh",

        goToExamples: 'Go to Examples',
        practiceExamples: 'Practice Examples',
        practiceExamplesDescription: 'These are examples to help you get familiar with the test format. They do not count towards your score.',
        example: 'Example',
        firstNumber: 'First number',
        secondNumber: 'Second number',
        correct: 'CORRECT!',
        incorrect: 'INCORRECT',
        correctAnswerIs: 'The correct answer is',
        readyToStart: 'When you are ready, press the button to start the actual test.',
        practiceExamplesInstruction: 'Before starting the test, you will be presented with practice examples to familiarize yourself with the format. These do not count towards your score and do not start the timer.',
        selectSimilarPair: 'Select the pair with a similar relationship',

        bulkSend: {
          selectApplicants: "Select Applicants",
          selectionMethod: "Selection Method",
          uploadExcel: "Upload Excel",
          selectManually: "Select Manually",
          searchApplicants: "Search applicants by name or email...",
          selectAll: "Select All",
          deselectAll: "Deselect All",
          applicantsSelected: "{{count}} applicant(s) selected",
          noApplicantsFound: "No applicants found with applied filters",
          individualSend: "Individual Send",
          bulkSend: "Bulk Send",
          title: "Bulk Send of Reasoning Tests",
          subtitle: "Upload an Excel file with candidate emails to send reasoning tests in bulk",

          instructions: {
            title: "Instructions:",
            step1: "The Excel file must have a column called \"email\"",
            step2: "Tests will only be sent to candidates that already exist in the system",
            step3: "You can download an example template",
            downloadTemplate: "Download Template"
          },

          fileUpload: {
            title: "Upload Excel File",
            dragOrClick: "Click or drag an Excel file here",
            supportedFormats: "Supported formats: .xlsx, .xls",
            processing: "Processing file...",
            invalidFileType: "Please select a valid Excel file (.xls or .xlsx)",
            emptyFile: "The Excel file is empty",
            noEmailColumn: "No emails were found. Make sure there is an \"email\" column",
            readError: "Error reading the file",
            processError: "Error processing the file:"
          },

          preview: {
            summary: "File summary:",
            totalEmails: "Total emails:",
            candidatesFound: "Candidates found:",
            emailsNotFound: "Emails not found:",
            candidatesList: "Candidates who will receive the tests:",
            name: "Name",
            email: "Email",
            andMore: "... and",
            moreRecords: "more",
            notFoundEmails: "Emails not found:"
          },

          selectTestsTitle: "Select Tests to Send",
          selectedTests: "Selected tests:",

          progress: {
            title: "Send status:",
            progressLabel: "Progress:",
            processed: "Processed:",
            successful: "Successful:",
            failed: "Failed:"
          },

          actions: {
            cancel: "Cancel",
            sending: "Sending...",
            sendTo: "Send to",
            candidates: "Candidates"
          },

          messages: {
            loadValidCandidates: "Please upload a file with valid candidates and select at least one test",
            bulkStarted: "Bulk send started:",
            errorStartingBulk: "Error starting bulk send",
            sendCompleted: "Send completed:",
            successful: "successful",
            failed: "failed",
            bulkFailed: "Bulk send failed"
          },

          insufficientPoints: "Insufficient points",
          insufficientPointsMessage: "You have selected {{selected}} candidates but only have {{available}} points available.",
          sufficientPoints: "You have enough points to send {{selected}} tests ({{available}} available)",
          insufficientPointsMessageBulk: "You need {{total}} points ({{candidates}} candidates × {{tests}} tests) but only have {{available}} available.",
          sufficientPointsBulk: "You have enough points for {{total}} tests ({{candidates}} candidates × {{tests}} tests). {{available}} points available.",
          sufficientPointsBulkUnlimited: "You have enough points for {{total}} tests ({{candidates}} candidates × {{tests}} tests) (unlimited)."
        },

        usageCheck: {
          checkingLimits: "Checking available limits...",
          serviceNotAvailable: "Reasoning tests not available in your plan",
          limitReached: "Reasoning test limit reached",
          pointsAvailable: "Available points: {{points}}",
          insufficientPoints: "Insufficient points",
          insufficientPointsMessage: "You have selected {{selected}} tests but only have {{available}} points available.",
          sufficientPoints: "You have enough points for {{selected}} tests ({{available}} available)"
        }
      },
      personalHabilitiesTests: {
        sendEmailOnCreate: "Send email to applicant",
        sendEmailOnCreateEnabled: "The test link will be sent automatically by email when created",
        sendEmailOnCreateDisabled: "The tests will be created without sending an email, you can send it later from the dashboard",
        testsCreatedSuccess: "{{count}} test(s) created successfully. You can send the email from the dashboard.",
        createTests: "Create tests",
        activityMonitoringDisclaimer: "Your activity will be monitored during this test to ensure process integrity. This includes detecting tab switches, copy/paste actions, screenshots, and other suspicious behaviors.",
        totalTime: 'Total Time',
        confidenceIndex: 'Confidence Index',
        confidenceHigh: 'High Reliability',
        confidenceMedium: 'Moderate Reliability',
        confidenceLow: 'Low Reliability',
        confidenceVeryLow: 'Very Low Reliability',
        statusProcessing: "Processing",
        statusEvaluated: "Evaluated",
        statusProcessing_error: "Processing Error",
        processTest: "Process",
        processing: "Processing...",
        retryProcess: "Retry",
        copyTestUrl: "Copy Test URL",
        urlCopied: "URL copied to clipboard",
        urlCopyError: "Error copying URL",
        processTestSuccess: "Test queued for processing",
        processTestError: "Error processing test",
        errorDetails: "Error details",
        createdBy: "Created by",
        // Layout
        title: "Personal Habilities Tests",
        subTitle: "Configure and manage personal habilities tests to evaluate your applicants",
        configuration: "Create",
        dashboard: "Dashboard",

        // Configuration
        configurationTitle: "Create New Personal Habilities Tests",
        configurationSubTitle: "Select the applicant and the tests you want to send",
        selectApplicant: "Select Applicant",
        searchApplicant: "Search applicant...",
        selectTests: "Select Tests",
        selectTestsDescription: "Select one or more tests to send to the applicant",

        // Form
        selectedTests: "Selected tests",
        sendTests: "Send Tests",
        sending: "Sending...",
        cancel: "Cancel",

        // Validations
        pleaseSelectApplicantAndTests: "Please select an applicant and at least one test",
        pleaseSelectAtLeastOneTest: "Please select at least one test to send",

        // Messages
        allTestsSentSuccess: "{{count}} test(s) sent successfully",
        testsCreatedAndEmailSent: "{{count}} test(s) created and sent in a single email",
        someTestsSentSuccess: "{{success}} test(s) sent, {{failed}} failed",
        allTestsFailed: "Error sending all tests",
        testSentError: "Error sending personal habilities tests",
        loadApplicantsError: "Error loading applicants",
        testResentSuccess: "Test resent successfully",
        testResentError: "Error resending test",
        viewResultNotImplemented: "Result visualization will be available soon",

        // Dashboard
        dashboardTitle: "Personal Habilities Tests Status",
        dashboardSubTitle: "View the progress and results of the sent tests",
        allTests: "All Tests",
        refresh: "Refresh",

        // Table
        applicantName: "Applicant",
        testType: "Test Type",
        status: "Status",
        sentDate: "Sent Date",
        completedDate: "Completed Date",
        actions: "Actions",
        notAvailable: "Not available",

        // Status
        statusPending: "Pending",
        statusSent: "Sent",
        statusStarted: "Started",
        statusCompleted: "Completed",
        statusProcessing: "Processing",
        statusExpired: "Expired",

        // Actions
        viewResult: "View Result",
        resendTest: "Resend Test",

        // Empty states
        noTestsFound: "No personal habilities tests found",
        noTestsMessage: "Create your first test from the Configuration tab",
        loadError: "Error loading personal habilities tests",

        // TESTS
        questionProgress: "Question {{current}} of {{total}}",
        skipQuestion: "Skip question",
        next: "Next",
        finish: "Finish",
        savingProgress: "Saving progress...",
        instructions: "Instructions",
        welcomeMessage: "Welcome {{name}}!",
        startTest: "Start Test",
        starting: "Starting...",

        timeRemaining: "Time remaining",
        lessThanOneMinute: "Less than 1 minute!",
        invalidTestType: "Invalid test type",
        accessDenied: "Access denied",
        testNotFound: "Test not found",
        // esta sobreescribe la anterior, igual que en ES
        loadError: "Error loading test",

        resultsTitle: "Test Results",
        correctAnswers: "Correct answers",
        timeUsed: "Time used",
        answersDetail: "Answer details",
        yourAnswer: "Answer",
        correctAnswer: "Correct answer",
        incorrect: "Incorrect",
        noResults: "No results available",
        insufficientResponses: "Not enough responses",
        unknownTestType: "Unknown test type",
        of: "of",
        correct: "Correct",
        question: "Question",
        emptyAnswer: "No answer",
        score: "Score",
        totalTime: "Total time",
        technicalDetails: "Technical Details Table",
        metric: "Metric",
        value: "Value",
        correctTotal: "Correct (total)",
        correctResponded: "Correct (Answered)",
        questionsAnswered: "Questions answered",
        answeredPercent: "Answered %",
        realTime: "Real time",
        performanceInterpretation: "Performance Interpretation",
        notAnswered: "Not answered",
        downloadReport: "Download PDF",

        // Integrity Test
        integrityTest: "Work Integrity",
        integrityTestDescription: "Evaluates honesty, ethics and attitudes toward organizational rules",
        integrityTest45Questions: "The test contains 45 questions about integrity and work ethics",
        integrityTest15Minutes: "You have 15 minutes to complete the test",
        integrityTestHonestAnswers: "Answer honestly, there are no right or wrong answers",
        integrityTestConfidential: "Your answers are confidential",
        integrityTestNoReturn: "You cannot return to previous questions",
        integrityTestCanSkip: "You can skip questions if you wish",
        integrityIGI: "General Integrity Index (GII)",
        integrityRiskLevel: "Risk Level",
        integrityHighRisk: "High Risk",
        integrityMediumRisk: "Medium Risk",
        integrityLowRisk: "Low Risk",
        integrityValidResponses: "Response Validity",
        integrityValid: "Valid",
        integrityQuestionable: "Questionable",

        // Emotional Intelligence
        emotionalIntelligence: "Emotional Intelligence",
        emotionalIntelligenceDescription: "Evaluates ability to recognize and manage own and others' emotions",
        emotionalIntelligence48Questions: "The test consists of 48 statements",
        emotionalIntelligence10Minutes: "Estimated time: 10 minutes",
        emotionalIntelligenceLikertScale: "Respond using a 5-option Likert scale (Strongly disagree - Strongly agree)",
        emotionalIntelligenceHonestAnswers: "Answer honestly according to how you usually act, not how you would like to act",
        emotionalIntelligenceNoReturn: "You cannot go back once you proceed",
        emotionalCIE: "Emotional Intelligence Quotient (EQ)",
        emotionalLevel: "Level",
        emotionalHigh: "High",
        emotionalMedium: "Medium",
        emotionalLow: "Low",
        emotionalDimensions: "Dimension Scores",

        deleteTest: "Delete Test",
        deleteTestTitle: "Confirm Deletion",
        deleteTestConfirm: "Are you sure you want to delete the personal habilities test for",
        testDeletedSuccess: "Personal habilities test successfully deleted",
        testDeletedError: "Error deleting personal habilities test",
        refresh: "Refresh",

        goToExamples: "Go to Examples",
        practiceExamples: "Practice Examples",
        practiceExamplesDescription: "These are examples to help you get familiar with the test format. They do not count towards your score.",
        example: "Example",
        firstNumber: "First number",
        secondNumber: "Second number",
        correct: "CORRECT!",
        incorrect: "INCORRECT",
        correctAnswerIs: "The correct answer is",
        readyToStart: "When you are ready, press the button to start the actual test.",
        practiceExamplesInstruction: "Before starting the test, you will be presented with practice examples to familiarize yourself with the format. These do not count towards your score and do not start the timer.",
        selectSimilarPair: "Select the pair with a similar relationship",

        bulkSend: {
          selectApplicants: "Select Applicants",
          selectionMethod: "Selection Method",
          uploadExcel: "Upload Excel",
          selectManually: "Select Manually",
          searchApplicants: "Search applicants by name or email...",
          selectAll: "Select All",
          deselectAll: "Deselect All",
          applicantsSelected: "{{count}} applicant(s) selected",
          noApplicantsFound: "No applicants found with applied filters",
          individualSend: "Individual Send",
          bulkSend: "Bulk Send",
          title: "Bulk Send of Personal Habilities Tests",
          subtitle: "Upload an Excel file with candidate emails to send personal habilities tests in bulk",

          instructions: {
            title: "Instructions:",
            step1: "The Excel file must have a column called \"email\"",
            step2: "Tests will only be sent to candidates that already exist in the system",
            step3: "You can download an example template",
            downloadTemplate: "Download Template"
          },

          fileUpload: {
            title: "Upload Excel File",
            dragOrClick: "Click or drag an Excel file here",
            supportedFormats: "Supported formats: .xlsx, .xls",
            processing: "Processing file...",
            invalidFileType: "Please select a valid Excel file (.xls or .xlsx)",
            emptyFile: "The Excel file is empty",
            noEmailColumn: "No emails were found. Make sure there is an \"email\" column",
            readError: "Error reading the file",
            processError: "Error processing the file:"
          },

          preview: {
            summary: "File summary:",
            totalEmails: "Total emails:",
            candidatesFound: "Candidates found:",
            emailsNotFound: "Emails not found:",
            candidatesList: "Candidates who will receive the tests:",
            name: "Name",
            email: "Email",
            andMore: "... and",
            moreRecords: "more",
            notFoundEmails: "Emails not found:"
          },

          selectTestsTitle: "Select Tests to Send",
          selectedTests: "Selected tests:",

          progress: {
            title: "Send status:",
            progressLabel: "Progress:",
            processed: "Processed:",
            successful: "Successful:",
            failed: "Failed:"
          },

          actions: {
            cancel: "Cancel",
            sending: "Sending...",
            sendTo: "Send to",
            candidates: "Candidates"
          },

          messages: {
            loadValidCandidates: "Please upload a file with valid candidates and select at least one test",
            bulkStarted: "Bulk send started:",
            errorStartingBulk: "Error starting bulk send",
            sendCompleted: "Send completed:",
            successful: "successful",
            failed: "failed",
            bulkFailed: "Bulk send failed"
          },

          insufficientPoints: "Insufficient points",
          insufficientPointsMessage: "You have selected {{selected}} candidates but only have {{available}} points available.",
          sufficientPoints: "You have enough points to send {{selected}} tests ({{available}} available)",
          insufficientPointsMessageBulk: "You need {{total}} points ({{candidates}} candidates × {{tests}} tests) but only have {{available}} available.",
          sufficientPointsBulk: "You have enough points for {{total}} tests ({{candidates}} candidates × {{tests}} tests). {{available}} points available.",
          sufficientPointsBulkUnlimited: "You have enough points for {{total}} tests ({{candidates}} candidates × {{tests}} tests) (unlimited)."
        },

        usageCheck: {
          checkingLimits: "Checking available limits...",
          serviceNotAvailable: "Reasoning tests not available in your plan",
          limitReached: "Reasoning test limit reached",
          pointsAvailable: "Available points: {{points}}",
          insufficientPoints: "Insufficient points",
          insufficientPointsMessage: "You have selected {{selected}} tests but only have {{available}} points available.",
          sufficientPoints: "You have enough points for {{selected}} tests ({{available}} available)"
        }
      },
      usageFAB: {
        title: "Points Usage",
        used: "Used",
        limit: "Limit",
        remaining: "Available",
        unlimited: "Unlimited",
        unlimitedShort: "∞",
        pointsAvailableLabel: "Available Points",
      },
      hiringRoomConfig: {
        title: "HiringRoom Integration",
        subtitle: "Configure credentials to connect with HiringRoom API",
        connected: "Connected",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        email: "Email",
        password: "Password",
        clientIdTooltip: "Unique client identifier provided by HiringRoom to authenticate your application",
        clientSecretTooltip: "Secret key provided by HiringRoom to validate your application's identity",
        emailTooltip: "Email address you use to log in to the HiringRoom platform",
        passwordTooltip: "Password associated with your HiringRoom account",
        saving: "Saving...",
        saveConfig: "Save Configuration",
        testing: "Testing...",
        testConnection: "Test Connection",
        testBeforeSave: "You must test the connection successfully before saving the configuration",
        connectionSuccess: "Successful connection with HiringRoom",
        connectionError: "Error connecting to HiringRoom. Check your credentials.",
        cannotSave: "Cannot save: organization or project not available",
        saveSuccess: "HiringRoom configuration saved successfully",
        saveError: "Error saving configuration",
        saveErrorGeneral: "Error saving HiringRoom configuration",
        testSuccess: "Successful connection with HiringRoom!",
        testError: "Connection error",
        invalidCredentials: "Invalid credentials",
        testErrorGeneral: "Error testing connection with HiringRoom",
      },
      hiringRoomImport: {
        title: "Import Applicants from HiringRoom",
        applicantsFound: "applicants found",
        searchByDates: "Search by Dates",
        searchByData: "Search by Data",
        dateFrom: "Date from",
        dateTo: "Date to",
        search: "Search",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        position: "Position",
        phone: "Phone",
        applicationDate: "Application Date",
        status: "Status",
        notAvailable: "N/A",
        imported: "Imported",
        new: "New",
        searchToSeeApplicants: "Perform a search to see applicants",
        noApplicantsFound: "No applicants found with the applied filters",
        pageOfPages: "Page {{current}} of {{total}}",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        applicantsSelected: "{{count}} applicant(s) selected for import",
        alreadyImported: "This applicant has already been imported",
        cancel: "Cancel",
        importing: "Importing...",
        importSelected: "Import {{count}} selected",
        selectAtLeastOne: "You must select at least one applicant",
        importSuccess: "{{count}} applicants imported successfully",
        importErrors: "{{count}} applicants could not be imported",
        loadError: "Error loading applicants",
        loadErrorDetail: "Error loading applicants from HiringRoom",
        importError: "Error importing applicants",
        importErrorDetail: "Error importing applicants from HiringRoom",
      },
      hiringRoomVacanciesImport: {
        title: "Import Positions from HiringRoom",
        vacanciesAvailable: "positions available",
        name: "Name",
        area: "Area",
        hierarchy: "Hierarchy",
        creationDate: "Creation Date",
        status: "Status",
        notAvailable: "N/A",
        imported: "Imported",
        noVacanciesAvailable: "No positions available in HiringRoom",
        pageOfPages: "Page {{current}} of {{total}}",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        vacanciesSelected: "{{count}} position(s) selected for import",
        alreadyImported: "This position has already been imported",
        cancel: "Cancel",
        importing: "Importing...",
        importSelected: "Import {{count}} selected",
        selectAtLeastOne: "You must select at least one position",
        importSuccess: "{{count}} positions imported successfully",
        importErrors: "{{count}} positions could not be imported",
        loadError: "Error loading positions",
        loadErrorDetail: "Error loading positions from HiringRoom",
        importError: "Error importing positions",
        importErrorDetail: "Error importing positions from HiringRoom",
      },
      cvFiltering: {
        downloadPdf: "Download PDF",
        costEstimate: 'Estimated cost',
        pointsLabel: 'points',
        pointsPerApplicant: 'points per applicant',
        applicantsLabel: 'applicants',
        serviceNotAvailable: 'CV Filtering service is not available in your current plan',
        unlimitedPoints: 'Unlimited points',
        pointsAvailable: 'Points available',
        insufficientPoints: 'Insufficient points',
        youHave: 'You have',
        need: 'you need',
        totalCost: 'Total cost',
        remainingAfterProcess: 'Remaining points after process',
        title: 'CV Filtering',
        subTitle: 'Analyze and compare candidates using AI',
        createProcess: 'Create Process',
        dashboard: 'Dashboard',
        selectPosition: 'Select Position',
        addApplicants: 'Add Applicants',
        selectedApplicants: 'Selected Applicants',
        uploadCv: 'Upload CV',
        replaceCv: 'Replace CV',
        noCv: 'No CV',
        currentPosition: 'Current Position',
        summary: 'Summary',
        processing: 'Processing...',
        completed: 'Completed',
        failed: 'Failed',
        viewDetails: 'View Details',
        ranking: 'Candidate Ranking',
        score: 'Score',
        strengths: 'Strengths',
        weaknesses: 'Weaknesses',
        recommendation: 'Recommendation',
        dashboardTitle: 'CV Filtering Processes',
        dashboardSubtitle: 'Manage and review candidate filtering processes',
        noProcesses: 'No filtering processes created. Create one from the "Create Process" tab.',
        tableTitle: 'Title',
        tablePosition: 'Position',
        tableApplicants: 'Applicants',
        tableStatus: 'Status',
        tableDate: 'Date',
        statusPending: 'Pending',
        statusProcessing: 'Processing',
        statusCompleted: 'Completed',
        statusFailed: 'Failed',
        viewResults: 'View results',
        reprocess: 'Reprocess',
        retry: 'Retry',
        reprocessError: 'Error reprocessing. Please try again.',
        scoringWeights: 'Scoring Weights Configuration',
        scoringWeightsDescription: 'Define the weight of each component in the final score. They must add up to 100%.',
        cvWeight: 'CV Weight',
        answersWeight: 'Answers Weight',
        weightsError: 'Weights must add up to 100%',
        weight: 'Weight',
        position: 'Position',
        totalApplicants: 'Total Applicants',
        processed: 'Processed',
        averageScore: 'Average Score',
        candidateRanking: 'Candidate Ranking',
        noResults: 'No results to display',
        detailedScores: 'Detailed Scores',
        cv: 'CV',
        answers: 'Answers',
        strengths: 'Strengths',
        areasForImprovement: 'Areas for Improvement',
        cvAnalysis: 'CV Analysis',
        answersAnalysis: 'Answers Analysis',
        scoreJustification: 'Score Justification',
        observations: 'Observations',
        finalRecommendation: 'Final Recommendation',
        step1: 'Position and Applicant Selection',
        step2: 'Summary and Processing',
        mustSelectPosition: 'You must select a position',
        mustAddApplicant: 'You must add at least one applicant',
        createProcessError: 'Error creating filtering process',
        startProcessingError: 'Error starting processing',
        processingError: 'Processing error',
        selectPosition: 'Select Position',
        position: 'Position',
        searchPosition: 'Search position...',
        addApplicants: 'Add Applicants',
        applicant: 'Applicant',
        searchApplicant: 'Search applicant...',
        currentPosition: 'Current Position',
        noCv: 'No CV',
        positions: 'Positions',
        selectedApplicants: 'Selected Applicants',
        cvLoaded: 'CV loaded',
        selectedPosition: 'Selected Position',
        name: 'Name',
        industry: 'Industry',
        hierarchy: 'Hierarchy',
        description: 'Description',
        applicantsToAnalyze: 'Applicants to Analyze',
        successTitle: 'Filtering process successfully created',
        successMessage1: 'CV analysis is being processed in the background. You can view the results in the',
        successMessage2: 'once the process is completed.',
        dashboard: 'Dashboard',
        redirectingMessage: 'Redirecting to dashboard in a few seconds...',
        errorTitle: 'Error creating process',
        errorMessage: 'An error occurred while trying to create the filtering process. Please try again.',
        creatingProcess: 'Creating filtering process...',
        takeFewSeconds: 'This will only take a few seconds',
        back: 'Back',
        creating: 'Creating...',
        processing: 'Processing...',
        processCvs: 'Process CVs',
        next: 'Next',
        uploadCv: 'Upload CV',
        uploadCvMessage1: 'The applicant',
        uploadCvMessage2: 'does not have a CV uploaded. You can upload a CV now or continue without it.',
        uploading: 'Uploading...',
        selectCv: 'Select CV',
        continueWithoutCv: 'Continue without CV',
        invalidFileFormat: 'Invalid file format. Only PDF, DOC and DOCX are allowed.',
        uploadCvError: 'Error uploading CV',
        replaceCvError: 'Error replacing CV',
        filteringPrefix: 'Filtering',
        processDescription: 'CV filtering process for position',
        deleteTitle: 'Delete Filtering Process',
        deleteConfirm: 'Are you sure you want to delete the process',
        deleteSuccess: 'Process deleted successfully',
        deleteError: 'Error deleting process',
      },
      salesAssessment: {
        sendEmailOnCreate: "Send email to applicant",
        sendEmailOnCreateEnabled: "The assessment link will be sent automatically by email when created",
        sendEmailOnCreateDisabled: "The assessment will be created without sending an email, you can send it later from the dashboard",
        testCreatedSuccess: "Assessment created successfully. You can send the email from the dashboard.",
        createTest: "Create assessment",
        createTest: "Create Sales Assessment",
        selectApplicantDescription: "Select the applicant to send the sales assessment test. Optionally select a position to sort applicants.",
        selectPosition: "Select Position (Optional)",
        selectApplicant: "Select Applicant ({{count}} available)",
        applicantsSorted: "Applicants sorted: position applicants first",
        selectApplicantToSend: "Select an applicant to send the test",
        positionLabel: "Position:",
        industryLabel: "Industry:",
        descriptionLabel: "Description:",
        noIndustry: "No industry",
        notSpecified: "Not specified",
        cancel: "Cancel",
        sendTest: "Send Test",
        sending: "Sending...",
        mustSelectApplicant: "You must select an applicant",
        testSentSuccess: "Sales assessment sent successfully",
        testSentError: "Error sending sales assessment",
        dashboard: {
          individualTests: 'Individual Tests',
          comparison: 'Comparisons',
          statuses: {
            pending: 'Pending',
            sent: 'Sent',
            started: 'Started',
            completed: 'Completed',
            processing: 'Processing',
            evaluated: 'Evaluated',
            processing_error: 'Error',
            expired: 'Expired',
          },
          // Buttons and actions
          refresh: "Refresh",
          searchApplicant: "Search applicant...",

          // Table headers
          applicant: "Applicant",
          position: "Position",
          createdBy: "Created By",
          status: "Status",
          sentDate: "Sent Date",
          completedDate: "Completed Date",
          actions: "Actions",

          // Default values
          notSpecified: "Not specified",
          notAvailable: "Not available",

          // Action tooltips
          processTest: "Process Test",
          viewReport: "View Report",
          processing: "Processing...",
          reprocess: "Reprocess",
          retry: "Processing error - Retry",
          copyUrl: "Copy Test URL",
          resendTest: "Resend Test",
          deleteTest: "Delete Test",

          // Success messages
          testProcessing: "Test processing",
          testResentSuccess: "Test resent successfully",
          urlCopied: "URL copied to clipboard",
          urlCopyError: "Error copying the URL",
          testDeletedSuccess: "Test deleted successfully",

          // Error messages
          errorProcessing: "Error processing test",
          errorResending: "Error resending test",
          errorDeleting: "Error deleting test",
          errorLoading: "Error loading sales assessments",

          // Empty states
          noTestsFound: "No sales assessments found",
          createFirstTest: "Create your first test from the Create tab",

          // Delete modal
          deleteDialogTitle: "Delete Sales Assessment",
          deleteConfirmation: "Are you sure you want to delete the test for",
          deleteWarning: "This action cannot be undone.",
          cancel: "Cancel",
          delete: "Delete",
        },
        layout: {
          title: "Sales Assessment",
          subtitle: "Evaluate your applicants' sales skills",
          createTab: "Create",
          dashboardTab: "Dashboard",
          comparisonsTab: 'Comparisons',
        },
        report: {
          // Alerts
          noDataAvailable: "No data available to display",
          analysisNotAvailable: "Analysis is not yet available",
          assessmentCompleted: "Assessment Completed",

          // Main sections
          executiveSummary: "Sales Executive Summary",
          currentSalesProfile: "Current Sales Profile",
          competenciesEvaluation: "Sales Competencies Evaluation",
          predominantRole: "Predominant Sales Role",
          roleIndustryFit: "Role and Industry Fit",
          aspectsToManage: "Aspects to Manage for Maximum Effectiveness",
          developmentPriorities: "Sales Development Priorities",
          actionPlan: "Action Plan 30 / 60 / 90 Days",
          finalRecommendations: "Final Recommendations",

          // Executive Summary
          effectivenessLevel: "Effectiveness Level",
          sellerType: "Seller Type",
          optimalContexts: "Optimal Contexts",

          // Sales Profile
          salesProcess: "Sales Process",
          customerInteraction: "Customer Interaction",
          decisionMaking: "Decision Making",
          closingProgress: "Closing Progress",

          // Sales Role
          mainRole: "Main Role",
          secondary: "Secondary:",
          optimalSaleType: "Optimal Sale Type",

          // Fit
          fitLevel: "Fit Level:",

          // Aspects to Manage
          importance: "Importance:",
          context: "Context:",

          // Priorities
          priority: "Priority",
          impact: "Impact:",

          // Action Plan
          days30: "30 Days",
          days60: "60 Days",
          days90: "90 Days",

          // Final Recommendations
          synthesis: "Synthesis",
          practicalAdvice: "Practical Advice",

          // Glosario de roles de venta
          rolesGlossary: {
            title: "What do the sales roles represent?",
            intro: "Sales roles identify the type of commercial scenario in which a person tends to perform most naturally. They consider aspects such as the complexity of the solution, the customer's prior knowledge, the length of the sales cycle, the number of decision-makers and the level of relationship required to close the deal.",
            roleColumn: "Sales role",
            definitionColumn: "Definition",
            mainTag: "Main",
            secondaryTag: "Secondary",
            groups: {
              transactional: "Direct / transactional sales",
              opportunity: "Opportunity development sales",
              consultative: "Consultative / strategic sales",
            },
            roles: {
              distributor: {
                name: "Distributor",
                definition: "Works in direct, simple and transactional sales, where the customer knows what they need and can decide quickly. The focus is on making the purchase easy, responding quickly and closing the transaction efficiently.",
              },
              provider: {
                name: "Provider",
                definition: "Focuses on meeting a need the customer already knows, offering a clear solution that is easy to compare. The sale is usually quick, but the value lies in building trust, providing good service and generating new opportunities from the existing relationship.",
              },
              revealer: {
                name: "Revealer",
                definition: "Spots opportunities in customers who do not yet clearly recognize a need, but where the solution is relatively easy to understand. Their strength lies in making the problem visible, quickly connecting the need with a solution and making the purchase decision easier.",
              },
              creator: {
                name: "Creator",
                definition: "Focuses on creating a need or sparking interest in customers who were not initially looking for the solution. Requires initiative, the ability to capture attention and to quickly turn an opportunity into a sale, while maintaining the commercial relationship afterwards.",
              },
              pioneer: {
                name: "Pioneer",
                definition: "Works in sales where both the solution and the purchase decision may be new and complex for the customer. Requires the ability to explain, persuade and accompany a longer sales process, usually all the way to closing.",
              },
              innovator: {
                name: "Innovator",
                definition: "Introduces new or little-known solutions that the customer does not yet necessarily know they need. The challenge is to open the market, educate, build a vision of value and move complex decisions that may involve several people within the organization.",
              },
              consultant: {
                name: "Consultant",
                definition: "Handles complex, high-involvement sales where the customer recognizes their need but needs support to determine the best solution. The seller must diagnose, ask good questions, build a value proposition and guide different decision-makers to closing.",
              },
              partner: {
                name: "Partner",
                definition: "Acts as the customer's business partner in relevant or more complex decisions. Needs to deeply understand the business, engage with different stakeholders and build trust to sustain a long-term relationship.",
              },
            },
          },
        },
        reportModal: {
          title: "Sales Assessment Results",
          noDataAvailable: "No data available to display",
          downloadPDF: "Download PDF",
          close: "Close",
          fileNamePrefix: "sales-assessment-report-",
          defaultFileName: "result",
          downloadWord: 'Download Word',
        },
        public: {
          invalidEmail: "Invalid email",
          enterEmail: "Please enter your email",
          emailVerification: "Email Verification",
          emailVerificationDescription: "Enter your email to access the sales assessment test",
          enterEmailLabel: "Enter your email",
          verifying: "Verifying...",
          accessTest: "Access Test",
          testTitle: "Sales Assessment Test",
          instructions: "Instructions:",
          instruction1: "The test consists of a series of statements about sales behaviors",
          instruction2: "For each question, two options (A and B) will be presented",
          instruction3: "Select the option that best describes you when selling",
          instruction4: "There are no right or wrong answers",
          instruction5: "Answer honestly and spontaneously",
          starting: "Starting...",
          startTest: "Start Test",
          testCompleted: "Test Completed!",
          testCompletedDescription: "Thank you for completing the sales assessment test. Your responses have been saved successfully.",
        // Automatic close when the timer runs out
        timeUpTitle: "Time is up",
        timeUpMessage: "The time available to answer the test has ended. We automatically submitted the answers you managed to complete, so there is nothing else you need to do.",
        timeUpSubmitFailedMessage: "The time available to answer the test has ended, but we could not record your answers. Please contact the person who sent you the test.",
          testExpiredTitle: "Test Expired",
          testExpiredMessage: "This test has expired. Please contact the administrator.",
          error: "Error",
          genericError: "An error has occurred. Please try again.",
          tryAgain: "Try Again",
          testNotFound: "Test not found",
          accessDenied: "Access denied. The email does not match the test",
          testExpired: "This test has expired",
          emailValidationError: "Error validating email",
          startTestError: "Error starting test",
          invalidTestStatus: "Invalid test status",
          selectAnswer: "Please select an answer",
          completeTestError: "Error completing test",
          questionProgress: "Question {{current}} of {{total}}",
          optionLabel: "Option {{option}}",
          previous: "Previous",
          completing: "Completing...",
          completeTest: "Complete Test",
          next: "Next",
          completingEvaluation: "Completing Evaluation",
          processingResponses: "Processing your responses...",
          doNotCloseWindow: "Please do not close this window.",
          timeRemaining: "Time remaining",
        },
        comparison: {
          // Setup
          selectPosition: 'Reference Position',
          selectPositionDescription: 'Reference position for the analysis (optional)',
          positionPlaceholder: 'Search position...',
          noPositionsFound: 'No positions found',
          selectedPosition: 'Selected position',
          noPosition: 'No position',
          evaluatedTests: 'Evaluated applicants',
          searchApplicant: 'Search applicant...',
          onlyEvaluatedNotice: 'Only assessments with "evaluated" status are shown',
          loadingTests: 'Loading applicants...',
          noEvaluatedTests: 'No evaluated assessments available',
          selectedPersons: 'Selected people',
          persons: 'people',
          position: 'Position',
          requirements: 'Requirements',
          requirementMinTests: 'Minimum 2 applicants selected',
          startComparison: 'Start Analysis',
          creating: 'Creating...',
          selectAtLeastTwo: 'Select at least 2 applicants to compare',
          evaluatedAt: 'Evaluated on',
          testsLoadError: 'Error loading applicants',
          createError: 'Error creating comparison',
          createdSuccess: 'Comparison created successfully',

          // Results - table
          resultsTitle: 'Comparison Results',
          tabCompetencies: 'Competencies Table',
          tabRecommendations: 'GPT Analysis',
          competency: 'Competency',
          legendHighest: 'Highest score',
          legendMiddle: 'Middle level',
          legendLowest: 'Lowest score',

          // Results - GPT
          competenciesToDevelop: 'competencies to develop',
          objective: 'Improvement goal',
          actions: 'Recommended actions',
          noRecommendations: 'No recommendations available',

          // States
          processing: 'Processing analysis...',
          processingDescription: 'The GPT analysis may take a few seconds. This screen will update automatically.',
          processingError: 'Error processing the analysis',
          unknownError: 'Unknown error processing the comparison',
          fetchError: 'Error fetching the comparison',

          // Dashboard history
          noComparisons: 'No comparisons yet',
          noComparisonsDescription: 'Create your first comparison from the Comparisons tab',
          loadError: 'Error loading comparisons',
          status: 'Status',
          createdBy: 'Created by',
          deleteTitle: 'Delete comparison',
          deleteConfirm: 'Are you sure you want to delete this comparison?',

          statusCompleted: 'Completed',
          statusProcessing: 'Processing',
          statusPending: 'Pending',
          statusError: 'Error',
          tabDevelopment: 'Development Plan',
          developmentSubtitle: 'These are the 3 lowest-scoring competencies for each person, along with practical recommendations for their development.',
        },
        usageCheck: {
          checkingLimits: "Checking available limits...",
          serviceNotAvailable: "Sales Assessment not available in your plan",
          limitReached: "Points limit reached for Sales Assessment",
          pointsAvailable: "Available points: {{points}}",
        },
      },
      massiveRecruitment: {
        title: "Massive Recruitment",
        subTitle: "Manage bulk hiring processes",
        loadError: "Error loading recruitment processes",
        deleteSuccess: "Process deleted successfully",
        deleteError: "Error deleting the process",
        deleteTitle: "Confirm deletion",
        deleteConfirm: "Are you sure you want to delete the process",

        tabs: {
          list: "My Processes",
          new: "New Process",
        },

        estados: {
          borrador: "Draft",
          activo: "Active",
          pausado: "Paused",
          cerrado: "Closed",
          cubierto: "Covered",
          cancelado: "Cancelled",
        },

        list: {
          title: "Massive Recruitment Processes",
          searchPlaceholder: "Search processes...",
          newProcess: "New Process",
          empty: "No massive recruitment processes registered",
          noResults: "No processes found matching the search",
          vacantes: "Hired / Required",
          estado: "Status",
          prioridad: "Priority",
          fechaInicio: "Search start",
          fechaCierre: "Search end",
        },

        form: {
          updateSuccess: "Process updated successfully",
          editTitle: "Edit process",
          applicantsHelperEdit: "Here you can add new applicants to the process. Existing ones are kept.",
          title: "Create Massive Recruitment Process",
          createSuccess: "Process created successfully",
          validationError: "Please fix the errors before saving",

          tabs: {
            general: "General",
            logistics: "Logistics",
            publication: "Publication",
            budget: "Budget",
            stages: "Stages",
            applicants: "Applicants",
          },

          errors: {
            nombre: "Process name is required",
            position: "You must select a position",
            vacantes: "Number of vacancies must be greater than 0",
          },

          // Tab General
          nombre: "Process name",
          nombreHelper: "Internal identifier for this recruitment process",
          nombrePlaceholder: "E.g.: Plant Operators North Q1 2025",
          descripcion: "Process description",
          descripcionPlaceholder: "Describe the context, objective or particularities of this process...",
          position: "Position to fill",
          vacantesRequeridas: "Required vacancies",
          prioridad: "Priority",
          prioridades: {
            alta: "High",
            media: "Medium",
            baja: "Low",
          },
          estado: "Initial status",
          estadoHelper: "You can publish the process as active or leave it as a draft",

          // Tab Logistics
          modalidad: "Work modality",
          modalidades: {
            presencial: "On-site",
            remoto: "Remote",
            "híbrido": "Hybrid",
          },
          ubicacion: "Location",
          pais: "Country",
          ciudad: "City",
          comuna: "District",
          direccion: "Address",
          tipoContrato: "Contract type",
          tiposContrato: {
            indefinido: "Permanent",
            plazo_fijo: "Fixed term",
            proyecto: "By project",
            honorarios: "Freelance",
          },
          jornada: "Work schedule",
          jornadas: {
            "full-time": "Full-time",
            "part-time": "Part-time",
            turno: "Shift",
          },
          condicionesLaborales: "Working conditions",
          horario: "Schedule",
          comunaLugarTrabajo: "Work location district",
          tieneAcercamiento: "Transportation included",
          tieneAlmuerzo: "Lunch included",

          // Tab Publication
          aceptaExtranjeros: "Accepts foreign applicants",
          canalesPublicacion: "Publication channels",
          canales: {
            portales_empleo: "Job portals",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            referidos: "Referrals",
            whatsapp: "WhatsApp",
            otro: "Other",
          },
          fechaInicio: "Search start date",
          fechaCierre: "Search end date",

          // Tab Budget
          moneda: "Currency",
          presupuestoTotal: "Total budget",
          salarioPorPersona: "Salary per person",

          // Tab Stages
          stagesHelper: "Enable or disable stages according to your needs. The order remains fixed.",

          // Tab Applicants
          applicantsHelper: "Applicants are optional when creating the process. You can add them later from the detail view.",
          selectApplicants: "Search and add applicants",
          searchApplicants: "Type to search...",
          applicantsSelected: "applicant(s) selected",
        },

        view: {
          pais: "Country",
          filtrarPorEtapa: "Filter by stage",
          todasLasEtapas: "All stages",
          resultados: "result(s)",
          noResultadosFiltro: "No applicants in this stage",
          etapaActual: "Current stage",
          cambiarEtapa: "Change stage",
          etapaUpdated: "Stage updated",
          avanzar: "Advance",
          avanzarA: "Advance to",
          ultimaEtapa: "Last stage",
          sinEtapa: "No stage",
          changeStatus: "Change status",
          statusUpdated: "Status updated",
          vacantes: "Hired vacancies",
          completado: "completed",
          postulantes: "Applicants in process",
          fechas: "Dates",
          presupuesto: "Budget",
          modalidad: "Modality",
          etapas: "Stage pipeline",
          noEtapas: "No active stages configured",
          postulantesTitle: "Applicants",
          searchApplicant: "Add applicant",
          searchApplicantPlaceholder: "Search by name or email...",
          addApplicant: "Add",
          applicantAdded: "Applicant added to process",
          applicantRemoved: "Applicant removed from process",
          noApplicants: "No applicants in this process yet",
          removeApplicant: "Remove applicant",
          removeApplicantTitle: "Confirm",
          removeApplicantConfirm: "Remove",
          removeApplicantNote: "The applicant will only be removed from this process, not deleted from the system.",
          currentPosition: "Current position",
        },
      },
      registerTrial: {
        header: {
          title: "Try Amanda HR for free",
          subtitle: "Explore the most powerful features with 5 welcome points"
        },
        form: {
          title: "Create your trial account",
          buttons: {
            createAccount: "Start free trial"
          }
        },
        trialAccount: {
          pointsBanner: "5 points to use in these modules:",
          title: "What does your trial account include?",
          features: {
            points: "5 welcome points to use in the available modules",
            noRenewal: "Points do not renew — they are for exploring the platform",
            upgrade: "You can subscribe to a paid plan at any time"
          },
          services: {
            reasoningTest: "Reasoning Test",
            discTest: "DISC Test",
            psycholabor: "Psycholaboral Evaluation",
            cvFiltering: "CV Filtering"
          }
        },
        success: {
          message: "Trial account created. Sign in with your credentials."
        }
      },
      interviews: {
        title: 'Interviews',
        inviteBotTitle: 'Invite bot to a meeting',
        upload: {
          title: 'Upload transcript/report',
          hint: 'Accepts .txt, .pdf, .doc or .docx. Saved as a completed interview.',
          chooseFile: 'Choose file',
          dateLabel: 'Interview date (optional)',
          submit: 'Upload',
          uploading: 'Uploading...',
          success: 'Transcript uploaded successfully',
          error: 'Error uploading transcript',
          fileRequired: 'Select a file',
          manualBadge: 'Uploaded',
        },
        meetingUrlLabel: 'Meeting URL (Meet, Zoom, Teams)',
        meetingUrlHelper: 'The bot will join the meeting immediately',
        meetingUrlRequired: 'Meeting URL is required',
        inviting: 'Inviting...',
        inviteBot: 'Invite bot',
        botInvitedSuccess: 'Bot successfully invited to the meeting',
        inviteBotError: 'Error inviting the bot',
        refresh: 'Refresh',
        noInterviews: 'No interviews registered for this applicant.',
        detectedParticipants: 'Detected participants:',
        assignRoles: 'Assign roles',
        whoIsInterviewee: 'Who is the interviewee?',
        selectIntervieweeRequired: 'You must select the interviewee',
        confirm: 'Confirm',
        assignedSuccess: 'Participants assigned successfully',
        assignError: 'Error assigning participants',
        viewTranscript: 'View transcript',
        processingError: 'Error processing the interview',
        viewInterviews: 'View interviews',
        modalTitle: 'Interviews — {{name}}',
        status: {
          pending: 'Bot in meeting',
          pendingAssignment: 'Assign participants',
          completed: 'Completed',
          error: 'Error',
        },
        pointsCost: 'Each interview costs {{cost}} points. You have {{remaining}} points available.',
        pointsCostUnlimited: 'Each interview costs {{cost}} points. You have unlimited points.',
        noPoints: 'You do not have enough points to register an interview.',
        serviceNotAvailable: 'The Interviews module is not enabled for your organization. A super-admin can enable it under Organizations → Points & modules.',
      },
      branding: {
        changeLogo: "Change logo",
        logoUpdated: "Logo updated",
        uploadError: "Could not upload the logo",
        invalidImage: "The file must be an image",
        orgLogo: "Organization logo",
        projectLogo: "Project logo",
      },
      erp: {
        tooltips: {
          client: {
            industry: "Client's economic activity (tax line of business).",
            serviceType: "Contracted service type: Temporary Services, Outsourcing or both.",
            frameworkContract: "Framework agreement signed between Grafton and the client. If not signed yet, the service can still start and it is registered as pending, for control.",
            usesPurchaseOrder: "The client requires a purchase order to accept and pay invoices: quotation and billing must reference it.",
            allowsFactoring: "The client allows assigning its invoices to factoring (financing). If not, it conditions how billing is handled later.",
            kam: "Key Account Manager: executive in charge of the commercial relationship with the client.",
            businessPartner: "Business Partner responsible for the operation: manages the agreement and quotations, and validates employee records.",
            requesterSection: "Client-side person who requests the service day to day (name, role and contact).",
            contactsSection: "Who receives the invoices and who handles supplier payments.",
            assessmentSection: "Checks before operating with the client: credit bureau (DICOM), internal commercial evaluation and tax folder.",
            dicomChecked: "The client's credit bureau report (DICOM) was checked.",
            taxFolderReviewed: "The client's tax folder (SII) was reviewed.",
            commercialEvaluation: "Result or note of the internal commercial evaluation.",
            auxiliaryRut: "Tax ID without check digit, derived automatically. It is the key that links the client with the payroll system by cost center.",
            reviewBp: "Records (who and when) that the Business Partner verified the client was created correctly.",
          },
          agreement: {
            margins: "What Grafton charges for the service. Can differ by service type; the fee is percentage (% over subtotal) or fixed (agreed $).",
            serviceType: "Quotation service mode this margin applies to (once each).",
            adminExpense: "Fixed agreed amount added to the service price.",
            assistanceCost: "Additional assistance cost, when the agreement includes it.",
            paymentTermDays: "Invoice payment term, in days (e.g. 30).",
            paymentDay: "Fixed day of the month when the client runs payments (optional).",
            usesPurchaseOrder: "The client requires a purchase order to accept and pay invoices.",
            // OUT/EST quoter phase 4 (2026-10-13)
            scope: "A cost center agreement replaces the whole-client one in that cost center's quotations (e.g. a different margin or provisions per site).",
            operationalExpenses: "Monthly amount added to the quotation costs. When off, the quotation carries no operational expenses.",
            marginMinimum: "Minimum margin per quotation: if the calculated margin is below this amount, the minimum is charged.",
            formulaProvisions: "Provisions the quotation calculates from the period earnings. By default, notice and severance apply to OUT (indefinite contract) and not to EST; vacation replacement does not apply.",
            fixedProvisions: "Fixed monthly amounts added to the costs (PPE, uniform, bonus, insurance…). Charged in full in a partial start month unless marked as prorated.",
          },
          costCenter: {
            code: "Code assigned by finance: links the ERP with payroll and accounting.",
          },
          jobTitle: {
            name: "Catalog job title used for quoting (standard position name). Not the ATS vacancy.",
          },
          parameters: {
            monthly: "UF and UTM for the period: taxable caps and income tax brackets depend on them.",
            normative: "Change by adjustment or regulation: minimum wage, health and mutual insurance rates, VAT.",
            legal: "Fixed by law: vacation provision factor, gratification percentage and cap.",
            period: "YYYY-MM format (e.g. 2026-09).",
            partialMonth: "Applies to quotations whose start date is mid-month. Off = monthly caps, like the payroll spreadsheet. Turn it on if Talana prorates the caps in the first month. It is copied when the next period is filled in.",
          },
          causes: {
            renewable: "The cause allows contract renewal within its legal day limit.",
            code: "Short code for the cause (e.g. OBRA).",
          },
          quotation: {
            serviceMode: "Temporary Services and Outsourcing have different cost structures; the agreement margin can differ by mode.",
            jobTitle: "If the job title does not exist in the catalog, create it right here.",
            gratificationType: "How legal gratification is paid: monthly (Art. 50: 25% with cap) or annual (Art. 47). Review before saving.",
            vacationProvision: "Provisions 1.75 vacation days per month on total taxable income (OUT/EST minutes). You can set a monthly amount; in a partial month it is prorated. Turn off only if the service does not provision.",
            mealAllowance: "Non-taxable meal allowance.",
            transportAllowance: "Non-taxable transport allowance.",
            teleworkAllowance: "Non-taxable telework allowance (Law 21,220): compensates expenses such as internet and electricity. Same treatment as the meal allowance.",
            taxableBonuses: "Bonuses added to the taxable base: they affect social security contributions and income tax.",
            otherAllowances: "Other allowances agreed with the client (usually non-taxable).",
            additionalProvisions: "Extra provisions requested by the client: added to the service cost and passed through to the final price.",
          },
          employee: {
            visaRequired: "Foreign worker: requires a valid visa; its type and expiration are stored in the record.",
            submit: "Marks the record as complete and ready for operational validation.",
            validate: "The BP checks the record against the attached documents and completes schedule, shift and payment conditions.",
            toContract: "Creates the contract from the validated record: cause, dates and legal day control.",
            hiringCause: "Each cause has a legal limit of cumulative days per worker; the balance is shown below.",
          },
          contract: {
            causeDays: "Days consumed / legal limit for the cause, accumulating all the worker's contracts in the organization.",
          },
          export: {
            reExport: "Marks as exported again after reviewing the changes, closing the reprocess.",
          },
        },

        export: {
          menu: "Export",
          title: "Payroll export",
          subtitle: "Select the pending contracts and send them to Talana: for each one the person is created or updated and the contract is created, with per-record results. The load Excel remains as a fallback (download and mark manually). Records entered after the cutoff stay for the next reprocessing.",
          tabs: {
            pending: "Pending",
            modified: "Modified after export",
          },
          loadError: "Error loading the export view",
          noPending: "No contracts pending export",
          noModified: "No contracts modified after export",
          downloadSelected: "Download Excel ({{count}})",
          markSelected: "Mark as exported ({{count}})",
          markSuccess: "{{count}} contract(s) marked as exported",
          markError: "Error marking the contracts",
          downloadError: "Error generating the Excel",
          changesCount: "Changes",
          viewChanges: "View changes",
          reExport: "Re-export",
          changesTitle: "Post-export changes",
          changeSource: "Source",
          talana: {
            sendSelected: "Send to Talana ({{count}})",
            sendHint: "Creates or updates the person and creates the contract in Talana. Runs in the background; per-contract results appear below.",
            markHint: "Excel fallback only: marks as exported without calling Talana.",
            started: "Sending started: {{count}} contract(s). Results appear as Talana responds.",
            startError: "Could not start the Talana export",
            alreadyRunning: "A Talana export is already running",
            finished: "Export finished: {{ok}} ok, {{failed}} failed of {{total}}",
            jobTitle: "Last Talana export",
            running: "Running {{done}}/{{total}}",
            summary: "{{ok}} ok · {{failed}} failed · {{total}} total",
            stopped: "Stopped by {{code}}",
            state: "Status",
            detail: "Detail",
            sentAt: "Sent",
            sentBy: "By",
            retry: "Retry",
            resend: "Resend to Talana",
            itemStatus: { pending: "Pending", running: "Sending…", ok: "In Talana", failed: "Error", skipped: "Skipped" },
            steps: { validate: "Validating data", jobTitle: "Ensuring job title", persona: "Person", contrato: "Contract", mark: "Marking", documents: "Documents", done: "Done" },
            // Person documents → Talana (PLAN_DOCUMENTOS_TALANA, 2026-10-22)
            docs: {
              title: "Documents for Talana",
              titlePerson: "Send documents to Talana — {{name}}",
              intro: "Choose which documents of each person go with their contract. They are uploaded to the person's folder in Talana after the contract; if one fails, the contract is still sent.",
              introDocuments: "The person's documents (record, ATS and signed contract) and their status in Talana. Documents already in Talana are not sent again.",
              loading: "Loading documents…",
              loadError: "Could not load the documents",
              empty: "This person has no documents in Amanda",
              recordNotFound: "The person's record was not found: the contract is sent without documents.",
              contractsCount: "{{count}} contracts in this export",
              source: { record: "Record", ats: "ATS", contract: "Contract" },
              signedContract: "Signed contract",
              signedContractFrom: "Signed contract (start {{date}})",
              category: "Talana category",
              categoryRequired: "Choose or type a category",
              visible: "Visible",
              visibleHint: "Visible to the worker in the Talana app and portal (\"My documents\")",
              notSendable: {
                format: "Talana only accepts PDF or photos (JPG, PNG, WebP): convert it to PDF and upload it again.",
                external: "The file is not stored in Amanda: it cannot be sent.",
              },
              imageNote: "Photo: sent converted to PDF",
              status: { queued: "Queued", sending: "Sending…", sent: "In Talana · {{date}}", failed: "Talana error" },
              linkedHint: "Linked to the contract in Talana",
              uploadType: "Document type",
              upload: "Upload document",
              uploadHint: "It is saved in the person's record and marked to be sent",
              uploadSuccess: "Document uploaded to the record",
              uploadError: "Could not upload the document",
              sendWithDocs: "Send {{contracts}} contract(s) with {{docs}} document(s)",
              sendContracts: "Send {{contracts}} contract(s)",
              sendWithoutDocs: "Send without documents",
              sendDocuments: "Send {{count}} document(s) to Talana",
              sendStarted: "Sending {{count}} document(s) to Talana…",
              nothingToSend: "There were no new documents to send (already in Talana or in progress)",
              someIgnored: "{{count}} document(s) were not sent: already in Talana, in progress or not sendable",
              notInTalana: "The person is not in Talana yet: send their contract first from Export",
              alreadyRunning: "Documents for this person are already being sent",
              invalid: "Check the categories of the selected documents",
              sendError: "Could not send the documents",
              close: "Close",
              started: "Export started: {{count}} contract(s) with {{docs}} document(s). Results appear as Talana responds.",
              finished: "Documents: {{sent}} sent, {{failed}} failed.",
              summary: "Documents: {{sent}} sent · {{failed}} failed · {{skipped}} skipped",
              progress: "Documents {{done}}/{{total}}…",
              pendingCount: "{{count}} document(s) to send",
              retry: "Retry documents",
            },
          },
        },
        traceability: {
          title: "Worker traceability",
          subtitle: "Search by tax ID and walk the full chain: client → quotation → record → contract (both ways, with direct links).",
          placeholder: "Worker tax ID (e.g. 12345678-9)",
          search: "Search",
          empty: "No contracts for this tax ID in the organization",
          error: "Error searching traceability",
        },

        employees: {
          title: "Employee records",
          new: "New record",
          createTitle: "Create employee record",
          createSubtitle: "The record hangs from a quotation (spec 3.5). Documents are attached later, in the detail view.",
          searchPlaceholder: "Search by name or tax ID...",
          loadError: "Error loading employee records",
          empty: "No records in this status",
          noQuotations: "No quotations available: create a quotation before creating records.",
          createSuccess: "Record created successfully",
          saveSuccess: "Record saved",
          saveError: "Error saving the record",
          submitSuccess: "Record sent for validation",
          validateSuccess: "Record validated",
          deleteRecord: "Delete record",
          deleteConfirmTitle: "Delete record",
          deleteConfirmText: "The record and its attached documents will be permanently deleted. This action cannot be undone.",
          deleteSuccess: "Record deleted",
          deleteError: "The record could not be deleted",
          deleteHasContract: "The record has an associated contract and cannot be deleted.",
          recordIncomplete: "Required fields are missing to validate the record — check the checklist.",
          rutInProgressConfirm: "An in-progress record already exists for this RUT ({{name}}) in another quotation. Re-hiring is valid — cause control adds up days per RUT. Create the record anyway?",
          rutInProgressTitle: "RUT with an in-progress record",
          rutInProgressCreate: "Create anyway",
          rutDuplicateQuotation: "An in-progress record with this RUT already exists for this same quotation ({{name}}). Use that record instead of creating another one.",
          sourceAts: "From ATS",
          sourceManual: "Manual",
          tabs: { all: "All" },
          status: {
            draft: "Draft",
            submitted: "Pending validation",
            validated: "Validated",
            contracted: "Contracted",
          },
          table: {
            name: "Name",
            rut: "Tax ID",
            source: "Source",
          },
          form: {
            quotation: "Quotation",
            sectionPersonal: "Personal data",
            sectionVisa: "Visa",
            sectionEmployment: "Working conditions",
            names: "First names",
            firstLastName: "Last name (paternal)",
            secondLastName: "Last name (maternal)",
            rut: "Tax ID (RUT)",
            rutHelper: "Required for the contract cause-control tracking.",
            birthDate: "Birth date",
            country: "Country",
            address: "Address",
            phone: "Phone",
            email: "Email",
            gender: "Gender",
            genderOptions: { male: "Male", female: "Female", other: "Other" },
            maritalStatus: "Marital status",
            maritalOptions: { single: "Single", married: "Married", civil_union: "Civil union", divorced: "Divorced", widowed: "Widowed" },
            street: "Street",
            streetNumber: "Number",
            apartment: "Apt.",
            commune: "Commune",
            city: "City",
            sectionPrevision: "Social security",
            pensionFund: "Pension fund (AFP)",
            healthSystem: "Health system",
            healthOptions: { fonasa: "Fonasa", isapre: "Isapre", none: "No health insurance" },
            healthProvider: "Health (Fonasa / Isapre)",
            countryHelper: "Nationality from Talana's country catalog",
            cityFilteredHint: "Only cities in the same region as the commune",
            healthPlanValue: "Plan value",
            healthPlanUnit: "Unit",
            healthPlanHelper: "If it exceeds the legal 7%, the excess is deducted from the net salary.",
            isPensioner: "Is a pensioner",
            sectionPayment: "Payment details",
            paymentMethod: "Payment method",
            paymentMethods: { deposit: "Bank deposit", vale_vista: "Cashier's voucher", check: "Check", cash: "Cash" },
            bank: "Bank",
            accountType: "Account type",
            accountTypes: { corriente: "Checking account", vista: "Sight account", rut: "Cuenta RUT", ahorro: "Savings account" },
            accountNumber: "Account number",
            visaRequired: "Visa required",
            visaType: "Visa type",
            visaExpiresAt: "Visa expiration",
          },
          employment: {
            startDate: "Start date",
            endDate: "End date",
            schedule: "Working schedule (Talana)",
            scheduleHelper: "Working schedule from Talana's catalog",
            shift: "Schedule / shifts (text)",
            shiftHelper: "Working-time distribution as written in the contract (Mi DT). Free text.",
            paymentConditions: "Payment conditions",
            contractType: "Contract type (Talana)",
            contractTypes: { fixed_term: "Fixed term", indefinite: "Indefinite", work_or_task: "For work or task" },
            jobFunctions: "Job functions",
            workDays: "Working days",
            weeklyHours: "Weekly hours",
            mealBreakMinutes: "Meal break (minutes)",
            mealBreakMinutesHelper: "Break within the working day (contract)",
            workplaceAddress: "Workplace address",
            workplaceCommune: "Workplace commune",
            workplaceCity: "Workplace city",
            branch: "Branch (Talana)",
            branchHelper: "Branch from Talana (where the employee works); type to search. Required to send to Talana.",
          },
          actions: {
            submit: "Send for validation",
            validate: "Validate record",
            toContract: "Create contract",
          },
          validateDialog: {
            title: "Validate record",
            subtitle: "Check the information against the attached documents and complete the working conditions (spec 3.6).",
            checklistSubtitle: "Requirements to validate — data is filled in the record; this only checks completeness.",
            missingHint: "Complete the fields marked in red in the record and try again.",
            saveNote: "Validating first saves the record's pending changes.",
          },
          postExport: {
            title: "Record already exported",
            message: "This record was already exported to payroll: the change will NOT propagate automatically and will be logged for reprocessing. Continue?",
            confirm: "Save anyway",
          },
          docs: {
            title: "Attached documents",
            upload: "Upload document",
            type: "Document type",
            empty: "No documents attached (ID card, pension/health certificates, visa...)",
            uploadSuccess: "Document uploaded",
            uploadError: "Error uploading the document",
            // Documents in Talana (PLAN_DOCUMENTOS_TALANA §4.3, 2026-10-22)
            talana: {
              send: "Send pending to Talana",
              sendHint: "Sends to the person's Talana folder the documents that are not there yet (record, ATS and signed contract)",
              alsoSend: "Also send to Talana",
              category: "Talana category",
              visible: "Visible to the worker",
              notSentChip: "Not sent",
              sending: "Sending the document to Talana…",
              notSent: "The document was saved in the record but could not be sent to Talana: use \"Send to Talana\"",
              deleteKeepsTalana: "Delete from Amanda (the document stays in Talana)",
            },
            types: {
              id_card: "ID card",
              pension_certificate: "Pension certificate",
              health_certificate: "Health certificate",
              visa: "Visa",
              other: "Other",
            },
          },
        },
        contracts: {
          title: "Contracts",
          subtitle: "The contract is created from a validated record. Its identifier is the shared key with the payroll system.",
          createTitle: "Create contract",
          create: "Create contract",
          createSuccess: "Contract created successfully",
          createdWithSub: "Contract created with sub-quotation {{number}}",
          deleteContract: "Delete contract",
          deleteConfirmText: "Only contracts pending export can be deleted. The record goes back to Validated and the quotation is released if it has no other contracts. This action cannot be undone.",
          deleteSuccess: "Contract deleted — the record went back to Validated",
          deleteError: "The contract could not be deleted",
          deleteExported: "The contract was already exported to payroll and cannot be deleted.",
          deleteHasSignature: "The contract was sent for signature in Izydocs. Cancel the request before deleting it.",
          deleteSigned: "The contract is already signed in Izydocs and cannot be deleted.",
          saveError: "Error saving the contract",
          loadError: "Error loading contracts",
          empty: "No contracts yet",
          noCauses: "No hiring causes in the catalog: create them in ERP Settings → Hiring causes.",
          searchPlaceholder: "Search by worker, tax ID or client...",
          table: {
            worker: "Worker",
            rut: "Tax ID",
            client: "Client",
            cause: "Cause",
            dates: "Term",
            causeDays: "Cause days",
            exportStatus: "Export",
          },
          exportStatus: {
            pending: "Pending export",
            exported: "Exported",
            modified_after_export: "Modified after export",
          },
          openEnded: "open-ended",
          talana: {
            exported: "In Talana",
            failed: "Talana error",
            tipExported: "Sent to Talana ({{env}}): person {{persona}} · contract {{contrato}} · {{at}}",
            tipFailed: "The last Talana export failed at {{step}}: {{error}}. It can be resent from Export.",
            tipNone: "Not sent to Talana yet. Send it from Export → Send to Talana.",
          },
          form: {
            hiringCause: "Hiring cause",
            contractTypeFromRecord: "Contract type from the record",
            contractTypeUnknown: "not set",
            indefiniteHint: "no end date and no temp-staffing cause",
            quotation: "Quotation for this person",
            quotationOption: "{{number}} · start {{date}}",
            quotationUsed: "{{number}} · already has a contract",
            quotationUsedBy: "{{number}} · contract of {{person}}",
            quotationArchived: "{{number}} · archived",
            quotationNew: "New sub-quotation ({{number}}-N) with this start date",
            quotationHint: "If the contract starts on another date, the chosen quotation moves to that start date and its prorated period is recalculated.",
            quotationNewHint: "A sub-quotation is created with the parent quotation's structure and the contract start date. Its number travels to Talana.",
            quotationLoadError: "The quotations for this position could not be loaded. Retry: the contract can't be created without choosing this person's quotation.",
            quotationRetry: "Retry",
            quotationLoading: "Loading the quotations for this position…",
            quotationRequired: "Choose this person's quotation to create the contract.",
            quotationTaken: "That quotation already has a contract: choose another one or create a sub-quotation.",
            quotationArchivedError: "The chosen quotation (or its parent) is archived: reopen it or choose another one.",
            belowMinimum: "The contract was not created. {{reason}} Fix the quotation salary (or choose another start date).",
          },
          balance: {
            summary: "Days consumed for this cause: {{consumed}} of {{limit}} (available: {{available}})",
            warning: "The worker exhausts or exceeds the legal days for this cause",
            consumed: "Days consumed",
            limit: "Legal limit",
            available: "Available balance",
            renewals: "Previous contracts (renewals)",
          },
          detail: {
            payrollKey: "Payroll key (uid)",
            causeTitle: "Cause control",
            chainTitle: "Traceability chain",
            chainNote: "Client → quotation → record → contract. The contract uid identifies the worker in payroll.",
            changeLogTitle: "Post-export changes",
          },
          changeLog: {
            field: "Field",
            oldValue: "Old value",
            newValue: "New value",
            changedAt: "Date",
          },
          // Contract template as PDF (PLAN_ERP.md §15, phase B1, 2026-10-19)
          document: {
            title: "Contract document",
            template: "Contract template: {{name}}",
            download: "View contract (PDF)",
            downloadHint: "Contract with the data from the employee record, the quotation and the contract",
            noTemplate: "There is no active contract template for {{mode}} · {{kind}}. Upload it in ERP Settings → Word templates (Amanda PDF).",
            missing: "Data used by the contract template is missing: {{list}}. Complete it in the employee record or the quotation.",
            error: "The contract could not be generated",
            stale: "The quotation was simulated from net pay with the old version and the base salary is inflated. Re-simulate the quotation before issuing the contract.",
            checkError: "The contract template could not be checked",
            unknownMode: "no service mode",
            unknownKind: "no contract type",
          },
          // Signature with Izydocs (PLAN_ERP.md §15.4, phase B2, 2026-10-20)
          signature: {
            title: "Signature with Izydocs",
            send: "Send for signature",
            sendHint: "Creates the contract in Izydocs from the standard format and leaves it ready to sign",
            refresh: "Refresh status",
            cancel: "Cancel request",
            download: "Download signed",
            format: "Format: {{id}} · {{name}}",
            internalDocument: "Internal no.: {{number}}",
            sentAt: "Sent: {{date}}",
            lastCheckedAt: "Last checked: {{date}}",
            providerStatus: "In Izydocs: {{status}}",
            completedAt: "Signed: {{date}}",
            cancelledAt: "Cancelled: {{date}}",
            notSent: "The contract has not been sent for signature yet.",
            statuses: {
              sending: "Sending",
              sent: "Pending signature",
              signed_by_worker: "Signed by the employee",
              completed: "Signed",
              cancelled: "Cancelled",
              failed: "Sending failed",
            },
            failed: "Izydocs rejected the request: {{message}}",
            failedNotFound: "Izydocs does not have this request: the contract was not created. You can send it again.",
            // Test mode, super-admin only (2026-10-22)
            testMode: {
              label: "Test mode (super-admin only)",
              hint: "Lets you send even though the profile data is missing in Izydocs. The request is real.",
              dialogWarning: "Test mode: this request is real. The contract will reach {{name}} and the Business Partner in Izydocs. Nationality, date of birth and address will be blank if the person does not have them in their Izydocs profile.",
              chip: "Test",
              sent: "Contract sent for signature in test mode",
            },
            sendingHint: "The request was left halfway. Use \"Refresh status\" to find out whether it reached Izydocs.",
            inProgressHint: "The request is in progress. Wait a few minutes before checking or cancelling it.",
            dataChanged: "This data changed after sending: {{list}}. The contract in Izydocs has the previous values; if needed, cancel the request and send it again.",
            dataChangedSigned: "This data changed after signing: {{list}}. The signed contract has the previous values.",
            reasons: {
              notConfigured: "Izydocs is not configured on the server (IZYDOCS_BASE_URL and IZYDOCS_API_KEY).",
              notWired: "The Izydocs connection is pending: missing {{list}}.",
              formatNotAvailable: "For now, signing with Izydocs is only available for EST contracts.",
              stale: "The quotation was simulated from net pay with the old version and the base salary is inflated. Re-simulate the quotation before sending the contract.",
              gratification: "The Izydocs contract has the legal monthly gratification written in and this quotation uses another gratification type.",
              missing: "Data required by the Izydocs contract is missing: {{list}}.",
              checkError: "Could not check whether the contract can be sent for signature.",
            },
            operations: {
              enrollment: "enrolling the employee",
              status: "checking the status",
              cancellation: "cancelling the request",
              profile: "loading the personal data into the Izydocs profile (nationality, date of birth and address)",
            },
            dialog: {
              title: "Send contract for signature",
              intro: "The contract will be created in Izydocs with format {{id}} · {{name}} and this data:",
              person: "Employee: {{name}} · {{rut}} · {{email}}",
              personNote: "Izydocs fills in the name, RUT, address and other personal data from the employee record.",
              tag: "Field",
              value: "Value",
              confirm: "Send",
              cancel: "Cancel",
            },
            cancelDialog: {
              title: "Cancel request",
              body: "The contract will be cancelled in Izydocs. You can send it again afterwards.",
              confirm: "Cancel request",
              back: "Back",
            },
            sent: "Contract sent for signature",
            refreshed: "Status updated: {{status}}",
            cancelled: "Request cancelled",
            errors: {
              alreadySent: "The contract already has an active request.",
              notOpen: "The contract has no open request.",
              inProgress: "The request is in progress. Try again in a few minutes.",
              changed: "The request changed while it was being processed (another action or user). Check the updated status.",
              uncertain: "Izydocs did not confirm the request in time and the contract may have been created. Use \"Refresh status\" in a few minutes before sending it again.",
              loadNotFound: "Izydocs cannot find this request. Check in Izydocs whether it was cancelled or deleted.",
              testModeForbidden: "Only a super-admin can send in test mode.",
              izydocs: "Izydocs returned an error: {{message}}",
              fileNotAvailable: "The signed contract is not available yet.",
              fileNotSaved: "The signed contract could not be saved. Try again.",
              generic: "The action could not be completed",
            },
          },
          // Contract termination and expiration notice (PLAN_ERP.md §15, 2026-10-19)
          termination: {
            title: "Contract termination",
            column: "Termination",
            activeOpenEnded: "Active contract with no end date (indefinite).",
            endsOn: "Active contract · ends on {{date}} (in {{count}} days).",
            endsOn_one: "Active contract · ends on {{date}} (in {{count}} day).",
            endsToday: "Active contract · ends today ({{date}}).",
            expiredWithoutTermination: "The contract ended on {{date}} and has no termination recorded.",
            register: "Record termination",
            edit: "Edit termination",
            remove: "Undo termination",
            removeConfirm: "The recorded termination is removed and the contract becomes active again. A notice already printed or delivered is not voided.",
            removeSuccess: "Termination undone: the contract is active again",
            removeError: "The termination could not be undone",
            saveSuccess: "Termination saved",
            saveError: "The termination could not be saved",
            loadCausesError: "The termination causes could not be loaded",
            cause: "Cause",
            terminationDate: "Termination date",
            letterDate: "Letter date",
            letterDateHelper: "Defaults to the termination date",
            settlementAvailableFrom: "Settlement available from",
            settlementHelper: "Defaults to {{days}} calendar days after the termination (the settlement is due within 10 business days)",
            zeroPayment: "Settlement with no payment ($0): uses the EST $0 settlement letter",
            zeroPaymentShort: "$0 settlement",
            yes: "Yes",
            notes: "Notes",
            registeredAt: "Recorded on {{date}}",
            updatedAt: "edited on {{date}}",
            dateDiffersFromEnd: "The contract ends on {{date}}: check the termination date.",
            downloadNotice: "Download notice",
            downloadNoticeHint: "Expiration notice to print and hand to the person",
            downloadNotices: "Download notices ({{count}})",
            tooManyNotices: "Up to {{max}} notices per PDF: select fewer.",
            noticeError: "The notice could not be generated",
            noticeMissing: "Data missing for the notice: {{reasons}}.",
            noticeMissingTitle: "Data missing for some notices",
            noticeMissingIntro: "These contracts lack data the letter needs. Complete it in the employee record or the quotation:",
            noticeDownloadReady: "Download the {{count}} complete ones",
            noticeDownloadReady_one: "Download the complete one",
            selectForNotice: "Select to download its notice",
            selectAllNotices: "Select the contracts with an expiration notice (159-4)",
            chipExpired: "Expired, no termination",
            chipExpiresToday: "Ends today",
            chipExpiresIn: "Ends in {{count}} days",
            chipExpiresIn_one: "Ends tomorrow",
            filter: {
              label: "Validity",
              all: "All",
              expiring7: "Ending in 7 days",
              expiring15: "Ending in 15 days",
              expiring30: "Ending in 30 days",
              expired: "Expired, no termination",
              terminated: "Terminated",
            },
            missing: {
              termination: "no termination recorded",
              expirationCause: "its cause is not 159-4 (term expiration)",
              workerName: "first names or first surname missing in the employee record",
              workerRut: "RUT missing",
              address: "address (street and number) missing in the employee record",
              commune: "commune missing in the employee record",
              legalEntity: "the quotation has no legal entity (employer)",
              serviceMode: "the quotation has no service mode (EST / OUT)",
              contractStartDate: "the contract has no start date",
              contract: "contract not found",
            },
            errors: {
              TERMINATION_CAUSE_NOT_FOUND: "The chosen cause is not in the catalog.",
              EXPIRATION_REQUIRES_END_DATE: "Term expiration (159-4) only applies to contracts with an end date.",
              TERMINATION_BEFORE_START: "The termination date is before the contract start.",
              LETTER_BEFORE_START: "The letter date is before the contract start.",
              SETTLEMENT_BEFORE_TERMINATION: "The settlement cannot be available before the termination date.",
              ZERO_PAYMENT_NOT_APPLICABLE: "A $0 settlement only applies to the 159-4 notice of EST contracts.",
            },
          },
        },
        hiringCauses: {
          title: "Hiring causes",
          subtitle: "Catalog with legal day limits per cause.",
          add: "Add cause",
          edit: "Edit cause",
          empty: "No hiring causes yet. Contracts require at least one.",
          loadError: "Error loading hiring causes",
          saveSuccess: "Cause saved",
          saveError: "Error saving the cause",
          duplicateCode: "A cause with this code already exists",
          table: {
            code: "Code",
            name: "Name",
            maxDays: "Max days",
            renewable: "Renewable",
          },
          form: {
            code: "Code",
            name: "Cause name",
            maxDays: "Legal day limit",
            maxDaysHelper: "Empty = no parameterized limit",
            renewable: "Allows renewal",
          },
        },
        atsBridge: {
          button: "Create ERP record",
          create: "Create record",
          pickQuotation: "Choose the quotation the employee record will hang from:",
          created: "ERP record created with the candidate data",
          done: "ERP record created",
          alreadyLinked: "This hire already has an ERP record",
          error: "Error creating the ERP record",
          loadError: "Error loading quotations",
          noQuotations: "No quotations available in the ERP mode",
        },

        quotations: {
          title: "Quotations",
          new: "New quotation",
          createTitle: "Create quotation",
          editTitle: "Edit quotation {{number}}",
          searchPlaceholder: "Search by client, job title or cost center...",
          loadError: "Error loading quotations",
          empty: "No quotations yet",
          allStatuses: "All statuses",
          table: {
            number: "No.",
            client: "Client",
            costCenter: "Cost center",
            jobTitle: "Job title",
            serviceMode: "Service mode",
            period: "Period",
            targetNet: "Target net salary",
          },
          status: {
            draft: "Draft",
            quoted: "Quoted",
            in_use: "In use",
            archived: "Archived",
          },
          serviceMode: {
            temporary_services: "Temporary Services",
            outsourcing: "Outsourcing",
          },
          steps: {
            step1: "Client and mode",
            step2: "Job title and dates",
            step3: "Salary structure",
            step4: "Simulation",
            step5: "Summary",
          },
          form: {
            serviceMode: "Service mode",
            legalEntity: "Legal entity",
            legalEntityHelper: "Employer of the contract in Talana; suggested from the service mode",
            client: "Client",
            costCenter: "Cost center",
            noCostCenters: "This client has no active cost centers",
            jobTitle: "Job title",
            newJobTitle: "Create job title",
            startDate: "Start date",
            endDate: "End date",
            endDateHint: "At most, until the end of that month",
            entryDate: "Start date",
            entryDateHint: "The full month (contract) and the period are calculated; the start and end months are prorated if they are not full",
            periodUntil: "Period until",
            periodUntilHint: "By default, the end of the start month; it can span several months",
            baseSalary: "Base salary",
            gratificationType: "Gratification type",
            vacationProvision: "Provision vacations",
            vacationProvisionAmount: "Monthly vacation amount (optional)",
            vacationProvisionAmountHint: "Empty = automatic: taxable / 30 × 1.75",
            mealAllowance: "Meal allowance",
            transportAllowance: "Transport allowance",
            teleworkAllowance: "Telework allowance",
            taxableBonuses: "Taxable bonuses",
            otherAllowances: "Other allowances",
            additionalProvisions: "Additional provisions",
            targetNetSalary: "Target net salary",
            targetNetHelper: "The reverse calculator adjusts the gross salary until it reaches exactly this net amount",
            calcModeBase: "Quote from base salary",
            calcModeTarget: "Quote from target net salary",
            calcModeTargetHint: "It is the MONTHLY net salary: the engine finds the monthly base salary that yields it. For a partial period, both are prorated to the days.",
            itemName: "Name",
            itemAmount: "Amount",
            addItem: "Add",
          },
          gratification: {
            legal_monthly: "Legal monthly (Art. 50)",
            legal_annual: "Legal annual (Art. 47)",
            none: "No gratification",
          },
          inheritance: {
            label: "Commercial conditions",
            manualShort: "Entered manually",
          },
          // Commercial conditions editable in the quotation (OUT/EST quoter phase 4, 2026-10-13)
          conditions: {
            title: "Commercial conditions",
            loading: "Checking the commercial agreement…",
            fromCostCenter: "Inherited from the agreement of cost center {{costCenter}}. You can change them for this quotation only: changes are marked.",
            fromClient: "Inherited from the whole-client agreement (the cost center has no agreement of its own). You can change them for this quotation only: changes are marked.",
            manual: "Neither the client nor the cost center has a commercial agreement: enter the conditions; they are stored in the quotation.",
            keep: "The quotation's conditions are kept and you can change them. If you change the service mode or the cost center, they are inherited again from the current agreement.",
            keepError: "The commercial agreement could not be checked: the quotation's conditions are kept.",
            modified: "Modified",
            modifiedCount: "{{count}} changed from the agreement",
            reset: "Undo changes",
            margin: "Margin",
            marginMinimum: "Minimum margin ($)",
            marginMinimumHint: "Empty = the one in Configuration → Parameters",
            operationalExpenses: "Operational expenses",
            operationalExpensesAmount: "Operational expenses amount",
            provisionsTitle: "Calculated provisions",
            formula: {
              notice: "Notice",
              severance: "Severance (years of service)",
              vacationReplacement: "Vacation replacement",
            },
            formulaHint: {
              notice: "Period total earnings / 12",
              severance: "Period total earnings / 12",
              vacationReplacement: "(Total earnings + employer contributions) / 30 × 21 / 12",
            },
            fixedTitle: "Fixed-amount provisions",
            fixedName: "Provision",
            fixedAmount: "Monthly amount",
            fixedProrated: "Prorated",
            fixedAdd: "Add provision",
            fixedRemove: "Remove provision",
            summaryKeep: "The quotation's own",
            summaryCostCenter: "Inherited from the cost center agreement",
            summaryClient: "Inherited from the client agreement",
            fromParametersHint: "Earlier quotation: empty = the one in Parameters. Type an amount or switch it off to change it.",
            invalidAmount: "Invalid amount: use numbers only (e.g. 12,5 or 5.000)",
            missingAmount: "Amount missing",
          },
          simulate: "Simulate",
          simulationOk: "Simulation calculated",
          simulationError: "Error running simulation",
          simulationHint: "The simulation calculates the full structure: earnings, legal deductions, net salary, employer costs, margin, VAT and invoice total.",
          engineNotReady: "Calculation engine pending parameterization (payroll spreadsheet). The quotation can still be saved and simulated once the engine is available.",
          summary: {
            title: "Quotation summary",
            note: "On save, the quotation is stored as Quoted with its commercial conditions frozen (future agreement changes do not affect it).",
          },
          back: "Back",
          next: "Next",
          saveQuotation: "Save quotation",
          createSuccess: "Quotation created successfully",
          saveError: "Error saving quotation",
          duplicate: "Duplicate",
          duplicateTitle: "Duplicate quotation",
          duplicateHint: "The copy keeps client, job title, structure and conditions; only the dates change (worker with a different start date). The period can span several months.",
          periodInvalid: "The end date can't be before the start date.",
          duplicateSuccess: "Quotation duplicated",
          duplicateNoSimulation: "Quotation duplicated without simulation. {{reason}} Edit it to raise the salary.",
          duplicatedFrom: "Duplicated from",
          archive: "Archive",
          unarchive: "Reopen",
          document: "Document",
          documentNeedsSimulation: "Simulate the quotation before generating the document",
          documentError: "The quotation document could not be generated",
          excel: "Excel",
          excelNeedsSimulation: "Simulate the quotation before downloading the Excel file",
          excelError: "The quotation Excel file could not be generated",
          edit: "Edit",
          updateSuccess: "Quotation updated and simulated again",
          editNote: "Saving overwrites the quotation (what was sent to the client) and simulates it again.",
          editClientLocked: "The client can't be changed when editing: for another client, create a new quotation.",
          agreementLoadError: "The client's commercial agreement could not be loaded. Reload the page to retry.",
          editSubsWarning: "Linked sub-quotations: {{count}}. They are not updated automatically: after saving, use \"Update from parent\" in the detail.",
          editSubHint: "A sub-quotation only changes its start date; the structure is edited in the parent quotation.",
          editBlocked: {
            contract: "It can't be edited: it has a contract ({{person}}). To change the conditions, duplicate it.",
            contractNoName: "It can't be edited: it has a contract. To change the conditions, duplicate it.",
            archived: "It can't be edited: it is archived. Reopen it first.",
          },
          goToDetail: "Go to detail",
          family: {
            title: "People in this position",
            hint: "If more than one person joins in this position, add one sub-quotation per person ({{number}}-1, -2…) with their start date. The first person uses this quotation.",
            add: "Add person",
            addTitle: "Add person",
            addHint: "A sub-quotation ({{number}}-N) is created with the parent quotation's structure and conditions and the start date you enter. Its number travels to the contract and to Talana.",
            addSuccess: "Sub-quotation {{number}} created",
            addError: "The sub-quotation could not be created",
            addBelowMinimum: "The sub-quotation was not created. {{reason}} Raise the salary in the parent quotation (or duplicate it if it already has a contract).",
            parentArchived: "The parent quotation is archived: reopen it first.",
            number: "No.",
            entryDate: "Start",
            contract: "Contract",
            noContract: "No contract",
            withContract: "Has a contract",
            current: "this one",
            parent: "Parent",
            subOf: "Sub-quotation of {{number}}",
            outdated: "Outdated",
            outdatedTooltip: "The parent quotation changed after this sub-quotation was last updated.",
            outdatedAlert: "The parent quotation changed and {{count}} sub-quotation(s) without a contract are now outdated. They don't update on their own: use \"Update from parent\".",
            sync: "Update from parent",
            syncAll: "Update all from parent",
            syncSuccess: "Updated from parent: {{list}}",
            syncNone: "There were no sub-quotations to update",
            syncBelowMinimum: "{{list}} not updated: with the parent's structure the base salary falls below the minimum wage of its start month. Updated: {{count}}.",
            syncError: "Could not update from the parent",
            syncAllBlocked: "There are no outdated sub-quotations without a contract.",
            syncBlocked: {
              contract: "It can't be updated: it has a contract ({{person}}).",
              contractNoName: "It can't be updated: it has a contract.",
              archived: "It can't be updated: it is archived.",
              upToDate: "It already matches the parent quotation.",
            },
            loadError: "The sub-quotations of this quotation could not be loaded.",
          },
          entryDialog: {
            title: "Change start date",
            hint: "The structure and conditions come from the parent quotation; here only the start date changes. It is simulated again on save.",
            success: "Start date updated",
            belowMinimum: "The start date was not changed. {{reason}} Raise the salary in the parent quotation.",
          },
          list: {
            showSubs: "Show sub-quotations ({{count}})",
            hideSubs: "Hide sub-quotations",
          },
          detail: {
            salaryTitle: "Salary structure",
            snapshotTitle: "Commercial conditions (frozen)",
            snapshotNote: "Copied from the commercial agreement when quoting, with the changes made in the quotation. Editing the agreement does not change them.",
            scopeCostCenter: "Cost center {{costCenter}} agreement",
            scopeClient: "Client agreement",
            fromParameters: "the one in Parameters",
            provisions: "Provisions",
            prorated: "prorated",
            simulationTitle: "Simulation",
          },
          sim: {
            netSalary: "Net salary",
            subtotal: "Subtotal",
            marginAmount: "Margin",
            invoiceTotal: "Invoice total",
            summaryMonthlyAndPeriod: "Monthly net salary: {{net}} · Monthly invoice total: {{monthly}} · Period total ({{period}}): {{total}}",
          },
          noSimulation: "No simulation yet: press Simulate to calculate the full structure.",
          parameterSetMissing: "The period parameters are missing (UF, UTM and minimum wage). Create or complete them in Configuration → Parameters and simulate again.",
          // Minimum wage (OUT/EST quoter phase 1b, 2026-10-13)
          minimumWage: {
            base: "The monthly base salary ({{base}}) is below the minimum wage ({{minimum}}) of parameters {{period}}.",
            fromNet: "The target net salary ({{target}}) gives a monthly base salary of {{base}}, below the minimum wage ({{minimum}}) of parameters {{period}}.",
            fixInWizard: "Fix it in the salary structure step.",
            fixInDetail: "Edit the quotation to raise the salary.",
            fixInParent: "Raise the salary in the parent quotation and update from it.",
            fixByDuplicate: "It has a contract: duplicate it to change the salary.",
          },
          breakdown: {
            earnings: "EARNINGS",
            baseSalary: "Base salary",
            solvedFromTarget: "Calculated from the target net salary ({{target}}) with the inverse calculator.",
            solvedFromTargetPartial: "Monthly base salary of {{base}}, calculated for a monthly net salary of {{target}}; the period amounts are prorated.",
            monthlyReference: "Full month (what goes to the contract): base salary {{base}} · gratification {{gratification}}",
            staleInverse: "Calculated with the previous version of the net-salary calculator (for partial periods the base salary came out inflated). Press Simulate to recalculate before exporting the contract.",
            monthlyColumn: "Full month (contract)",
            monthlyColumnHint: "Monthly salary: this is what goes to the contract and to Talana.",
            partialColumn: "Prorated {{period}}",
            partialColumnHint: "Service in the start month: {{days}} days.",
            noMonthly: "Simulate again to also see the full month next to the prorated period.",
            entryColumn: "Start month",
            exitColumn: "End month",
            segmentColumnHint: "Prorated {{period}}: {{days}} days.",
            fullMonthsHint: "Monthly salary for the contract. Value of each full month × {{n}} ({{months}}).",
            fullMonthsReference: "Monthly salary for the contract. The period has no full months: reference only, not added to the total.",
            totalColumn: "Period total",
            totalColumnHint: "{{period}}: {{days}} days, sum of the months of the service.",
            multiPeriodNote: "Each month is calculated separately with the start month's parameters; fixed costs and the minimum margin are charged every month.",
            gratification: "Legal gratification",
            bonus: "Taxable bonus",
            totalTaxable: "Total taxable",
            allowance: "Allowance",
            totalEarnings: "Total earnings",
            deductions: "WORKER DEDUCTIONS",
            pension: "Pension (AFP)",
            health: "Health",
            unemploymentWorker: "Worker unemployment insurance",
            incomeTax: "Income tax",
            totalDeductions: "Total deductions",
            employerCosts: "EMPLOYER COSTS",
            mutual: "Work accident insurance (IST)",
            disabilityInsurance: "Disability and survival insurance (SIS)",
            unemploymentEmployer: "Employer unemployment insurance",
            lifeExpectancy: "Life expectancy social insurance",
            individualCapitalization: "Individual capitalization contribution",
            protectedProfit: "FAPP - Protected profitability",
            vacationProvision: "Vacation provision",
            vacationAgreed: "(agreed amount)",
            noticeProvision: "Notice provision",
            severanceProvision: "Severance provision (years of service)",
            vacationReplacementProvision: "Vacation replacement provision",
            agreementProvision: "Provision",
            operationalExpenses: "Operational expenses",
            provision: "Additional provision",
            adminExpense: "Administration expense (agreement)",
            assistanceCost: "Assistance cost (agreement)",
            totalCosts: "Total costs",
            netTotal: "Net total",
            vat: "VAT",
            marginMinimumApplied: "The configured minimum margin was applied.",
            footer: "{{days}}-day period · parameters of period {{period}}",
            parameterSetFallback: "Calculated with the parameters of {{used}}, not those of the start month ({{month}}). If they are missing, complete them in Configuration → Parameters; then simulate again.",
          },
        },
        parameters: {
          title: "Calculation parameters",
          subtitle: "Periods come from Talana (Periods catalog, Talana tab). Here you fill in each period's parameters: monthly UF/UTM, statutory values and legal factors. A period referenced by quotations cannot be edited: fill in the next one.",
          add: "Fill in parameters",
          edit: "Edit parameters",
          empty: "No open periods in Talana and no parameters loaded. Sync the Periods catalog in the Talana tab or enable \"Show closed periods\".",
          talana: {
            open: "Open in Talana",
            closed: "Closed in Talana",
            missing: "Not in Talana",
            fill: "Fill in parameters",
            showClosed: "Show closed periods",
            notSynced: "The Talana periods catalog is not synced. Go to the Talana tab and sync \"Periods\" to fill in parameters.",
            notInTalana: "That period does not exist in Talana. Sync the Periods catalog and try again.",
            fetch: "Fetch from Talana",
            fetching: "Fetching…",
            fetched: "{{count}} parameters fetched from Talana. Review and save.",
            fetchError: "Could not fetch parameters from Talana",
            paramsNotSynced: "Talana payroll catalogs are missing (Payroll variables, AFP commissions, Tax brackets). Sync them in the Talana tab.",
            fromTalana: "Talana · {{code}} · valid from {{desde}}",
            resolvedSummary: "{{count}} fields resolved from Talana validity ranges at the period start date ({{brackets}} tax brackets).",
            manualHint: "UF, UTM, VAT, minimum margin, vacation provision, gratification % and mutual rate do not come from Talana: typed values are kept.",
            warningNotFound: "no validity range covers the period start (current / default value kept)",
            warningChanges: "changes within the period; the value valid on day 1 is used",
            afpCommissions: "Mandatory {{base}}% + commission per AFP ({{count}} AFPs; the engine uses the worker's AFP when known)",
          },
          loadError: "Error loading parameters",
          invalidPeriod: "The period must have YYYY-MM format",
          correction: {
            invalidated: "{{count}} quotation(s) lost their simulation and must be simulated again: {{list}}.",
            untouched: "{{count}} in use or archived kept their previous simulation, review them: {{list}}.",
          },
          implausibleAmount: "{{field}}: \"{{value}}\" was read as an implausibly small amount. Type it without separators or with dot thousands and comma decimals (553.553 or 41.057,2).",
          saveSuccess: "Parameters saved",
          saveError: "Error saving parameters",
          referencedError: "This period has been used by quotations and cannot be edited; create a new period (a super-admin can correct it)",
          duplicatePeriod: "A parameter set for this period already exists",
          table: { period: "Period", talana: "Talana" },
          sections: {
            monthly: "Monthly (UF / UTM)",
            normative: "Normative (adjustments)",
            legal: "Legal constants",
            partialMonth: "Partial start month",
          },
          defaultsHint: "Rates are entered as percentages (e.g. 7 = 7%; comma or dot both work: 10.46). Amounts accept dot thousands and comma decimals (553.553 · 41.057,2). Empty fields use the engine default, taken from the payroll spreadsheet (00. MODELO ESTRUCTURA DE RENTA).",
          operationalExpensesMoved: "Operational expenses are set in the commercial agreement of the client or its cost center (since 2026-10-13). The value saved in this period is only used by earlier quotations.",
          fields: {
            uf: "UF",
            utm: "UTM",
            minimumWage: "Minimum wage",
            pensionRate: "Reference pension rate % (10 + highest commission; default 11.45)",
            sisRate: "SIS rate % (default 1.78)",
            unemploymentWorkerRate: "Worker unemployment, indefinite (OUT) % (default 0.6; EST does not contribute)",
            unemploymentEmployerRate: "Employer unemployment, fixed term (EST) % (default 3)",
            unemploymentEmployerRateIndefinite: "Employer unemployment, indefinite (OUT) % (default 2.4)",
            lifeExpectancyRate: "Life expectancy % (default 0.72)",
            individualCapitalizationRate: "Individual capitalization % (default 0.1)",
            protectedProfitRate: "FAPP % (default 0.9)",
            taxableCapUf: "Taxable cap UF (default 90)",
            unemploymentCapUf: "Unemployment cap UF (default 135.2)",
            operationalExpenses: "Operational expenses (default 10000)",
            marginMinimum: "Minimum margin CLP (default 70000; unless the agreement sets another)",
            healthRate: "Health rate % (default 7)",
            mutualRate: "Mutual insurance rate % (default 0.93 base; Grafton with surcharge 2.29)",
            vatRate: "VAT % (default 19)",
            vacationProvisionFactor: "Vacation provision factor",
            gratificationRate: "Gratification % (default 25)",
            gratificationCap: "Gratification cap (IMM)",
            prorateCaps: "Prorate the pension, health and unemployment caps (90 / 135.2 UF) to the period's days",
            prorateGratificationCap: "Prorate the gratification cap to the period's days",
          },
        },

        admin: {
          moduleSwitch: "ERP module",
          moduleSwitchHelper: "Enables the ERP mode for this organization (currently visible to super-admins only)",
          saveError: "The organization was saved, but updating the ERP module setting failed",
        },
        home: {
          menu: "Home",
          welcome: "Welcome to the ERP module",
          welcomeName: "Hi, {{name}}",
          subtitle: "Cycle A: clients, commercial agreements and job title catalog",
          metrics: {
            clients: "Clients",
            activeClients: "Active clients",
            jobTitles: "Job titles in catalog",
          },
          quickActions: {
            title: "Quick actions",
            newClient: "Create client",
            viewClients: "View clients",
            newQuotation: "Create quotation",
            viewQuotations: "View quotations",
            configuration: "ERP settings",
          },
          underConstruction: "Your modules (purchase orders, suppliers, purchase requisitions, HES) arrive in an upcoming ERP cycle. No sections are enabled for you yet.",
        },
        clients: {
          title: "Clients",
          serviceTypes: {
            temporary_services: "Temporary Services",
            outsourcing: "Outsourcing",
            mixed: "Both (Temporary Services and Outsourcing)",
            legacy: "{{value}} (old text)",
          },
          new: "New client",
          createTitle: "Create client",
          createSubtitle: "Client record — replaces the Excel form: everything is registered in the platform",
          searchPlaceholder: "Search by legal name or tax ID...",
          loadError: "Error loading clients",
          empty: "No clients created yet",
          table: {
            legalName: "Legal name",
            rut: "Tax ID (RUT)",
            industry: "Industry",
            kam: "KAM",
            frameworkContract: "Framework contract",
            talana: "Talana",
            status: "Status",
          },
          status: { active: "Active", inactive: "Inactive" },
          framework: { signed: "Signed", pending: "Pending" },
          detailTabs: {
            data: "Details",
            costCenters: "Cost centers",
            agreement: "Commercial agreement",
          },
          form: {
            sectionIdentification: "Identification",
            sectionConditions: "Operating conditions",
            sectionOwners: "Internal owners",
            sectionRequester: "Client requester",
            sectionLegalRep: "Legal representative",
            sectionContacts: "Billing and payment contacts",
            sectionAssessment: "Assessment background",
            legalName: "Full legal name",
            rut: "Tax ID (RUT)",
            auxiliaryRut: "Auxiliary RUT (derived)",
            industry: "Industry",
            serviceType: "Service type",
            frameworkExists: "Framework contract signed",
            frameworkSignedAt: "Signing date",
            usesPurchaseOrder: "Operates with purchase order",
            allowsFactoring: "Allows factoring",
            kam: "Assigned KAM",
            businessPartner: "Assigned Business Partner",
            requesterName: "Name",
            requesterRole: "Role",
            requesterPhone: "Phone",
            requesterEmail: "Email",
            legalRepName: "Name",
            legalRepRut: "Tax ID",
            legalRepEmail: "Email",
            billingName: "Invoice delivery contact",
            billingEmail: "Billing email",
            billingPhone: "Billing phone",
            supplierName: "Supplier payment contact",
            supplierEmail: "Supplier payment email",
            supplierPhone: "Supplier payment phone",
            dicomChecked: "DICOM verification done",
            commercialEvaluation: "Commercial evaluation",
            taxFolderReviewed: "Tax folder reviewed",
            assessmentNotes: "Assessment notes",
          },
          createSuccess: "Client created successfully",
          saveSuccess: "Client updated successfully",
          deleteClient: "Delete client",
          deleteConfirmText: "Its cost centers and commercial agreement will also be deleted. A client with quotations cannot be deleted. This action cannot be undone.",
          deleteSuccess: "Client deleted",
          deleteError: "The client could not be deleted",
          deleteInUse: "The client has quotations and cannot be deleted (traceability depends on it).",
          saveError: "Error saving client",
          invalidRut: "The RUT is not valid (check digit verification failed)",
          duplicateRut: "A client with this RUT already exists in the organization",
          review: {
            button: "Mark BP review",
            done: "Reviewed by BP",
            doneAt: "Reviewed on {{date}}",
          },
          talana: {
            none: "No Talana",
            pending: "Talana pending",
            working: "Syncing…",
            failed: "Talana error",
            costCenter: "Talana cost center",
            patchUnsupported: "Talana does not allow editing the cost center via API: update name/status manually in Talana",
            sync: "Link or create in Talana",
            pick: "Choose cost center…",
            unlink: "Unlink from Talana",
            pickTitle: "Choose Talana cost center",
            pickHint: "Matched by code = auxiliary RUT ({{code}}) or by name. Only cost centers synced in Configuration → Talana are listed.",
            catalogEmpty: "No cost centers synced. Sync the catalog in Configuration → Talana.",
            catalogError: "Could not load the cost center catalog",
            moreResults: "Showing the first 50; refine your search.",
            synced: "Client synced with Talana",
            linked: "Client linked to the cost center",
            unlinked: "Talana link removed",
            error: "The Talana operation could not be completed",
            reconcile: "Link clients with Talana",
            reconcileHint: "Matches every unlinked client with Talana cost centers (by auxiliary RUT or name) and creates the missing ones.",
            reconcileDone: "Clients processed: {{total}} · linked {{linked}} · created {{created}} · failed {{failed}}",
          },
        },
        costCenters: {
          add: "Add cost center",
          edit: "Edit cost center",
          empty: "This client has no cost centers yet",
          loadError: "Error loading cost centers",
          table: {
            code: "Code",
            name: "Name",
            description: "Description",
            status: "Status",
          },
          form: {
            code: "Code (assigned by finance)",
            name: "Name (project, site or branch)",
            description: "Description",
          },
          saveSuccess: "Cost center saved",
          saveError: "Error saving cost center",
          duplicateCode: "A cost center with this code already exists for the client",
        },
        agreement: {
          none: "This client has no whole-client commercial agreement. Without an agreement (client or cost center), quotations do not inherit conditions and they are entered manually.",
          create: "Create commercial agreement",
          newVersion: "New agreement version",
          newVersionInfo: "Saving a new version deactivates the previous one as history. Existing quotations are not modified.",
          historyTitle: "Agreement history",
          active: "Active",
          inactive: "Historical",
          loadError: "Error loading the commercial agreement",
          margins: {
            title: "Margins by service type",
            add: "Add margin",
            serviceType: "Service type",
            feeType: "Fee type",
            value: "Value",
            percentage: "Percentage (%)",
            fixed: "Fixed ($)",
            empty: "No margins defined",
            legacy: "{{value}} (old text: pick the service mode)",
          },
          adminExpense: "Administration expense",
          adminExpenseAmount: "Administration expense amount",
          assistanceCost: "Assistance cost",
          assistanceCostAmount: "Assistance cost amount",
          paymentTermDays: "Payment terms (days)",
          paymentDay: "Payment day",
          paymentNotes: "Payment condition notes",
          usesPurchaseOrder: "Operates with purchase order",
          // OUT/EST quoter phase 4 (2026-10-13): scope, expenses and provisions
          scope: "Agreement for",
          scopeClient: "Whole client",
          scopeOwn: "own agreement",
          scopeNoAgreement: "no agreement",
          scopeInherits: "This cost center has no agreement of its own: its quotations inherit the whole-client one. The form starts from those values; saving creates an agreement for the cost center.",
          scopeNone: "This cost center has no agreement of its own and the client has no general one either: its quotations are entered manually. Saving creates an agreement for the cost center.",
          createForCostCenter: "Create cost center agreement",
          invalidAmounts: "Some amounts cannot be read (in red): fix them to save.",
          missingAmounts: "Some amounts are missing (in red): enter them, switch the toggle off or remove the provision to save.",
          historyScope: "Scope",
          marginMinimum: "Minimum margin ($)",
          marginMinimumHint: "Empty = the one in Configuration → Parameters (default 70,000)",
          operationalExpenses: "Operational expenses",
          operationalExpensesAmount: "Operational expenses amount",
          provisions: {
            title: "Provisions",
            notice: "Notice",
            severance: "Severance (years of service)",
            vacationReplacement: "Vacation replacement",
            formula: {
              notice: "Period total earnings / 12",
              severance: "Period total earnings / 12",
              vacationReplacement: "(Total earnings + employer contributions) / 30 × 21 / 12",
            },
            mode: {
              default: "By service mode (OUT yes, EST no)",
              defaultNo: "Default (no)",
              include: "Always include",
              exclude: "Always exclude",
            },
            fixedTitle: "Fixed-amount provisions",
            fixedEmpty: "No fixed-amount provisions",
            name: "Name (PPE, uniform, bonus…)",
            amount: "Monthly amount",
            prorated: "Prorated in a partial month",
            add: "Add provision",
            remove: "Remove provision",
          },
          saveSuccess: "Commercial agreement saved",
          saveError: "Error saving the commercial agreement",
        },
        jobTitles: {
          talana: {
            sync: "Sync with Talana now: looks the job title up by name in Talana's catalog and creates it if missing",
            columnHelp: "Link between this job title and Talana's job-title catalog. It is created or linked in Talana automatically when used in a quotation (and re-checked when the contract is exported). No manual step needed.",
            tipNone: "Not used in any quotation yet. It will be created or linked in Talana when the first quotation with this job title is saved.",
            tipLinked: "Exists in Talana as \"{{name}}\" (ID {{id}}, {{method}}). Contracts with this job title will be linked to that record.",
            tipFailed: "The last attempt to create it in Talana failed: {{error}}. It retries automatically when quoting or exporting; a super-admin can also retry with the sync button.",
            tipPending: "Pending: Talana was not configured when it was used. It will be resolved when quoting or exporting.",
            created: "Job title created in Talana (ID {{id}})",
            linked: "Job title linked to Talana (ID {{id}})",
            error: "Could not sync the job title with Talana",
            method: { name: "matched by name", created: "created from Amanda", manual: "linked manually" },
          },
          title: "Job titles",
          add: "Add job title",
          edit: "Edit job title",
          empty: "No job titles in the catalog yet",
          loadError: "Error loading job titles",
          table: { name: "Name", area: "Area", status: "Status" },
          form: { name: "Job title name", area: "Area" },
          saveSuccess: "Job title saved",
          sourceAts: "From ATS",
          saveError: "Error saving job title",
          duplicateName: "A job title with this name already exists",
        },
        talana: {
          title: "Talana catalogs",
          subtitle: "Talana is the master for these catalogs: they are read through its API and mirrored in Amanda for employee records and contracts. Click a catalog to see its records.",
          syncAll: "Sync with Talana",
          syncOne: "Sync this catalog",
          syncing: "Syncing…",
          started: "Sync started. Status refreshes automatically.",
          startError: "Could not start the sync",
          alreadyRunning: "A sync is already running for this organization",
          notConfigured: "Talana is not configured on the server (TALANA_TOKEN / TALANA_BASE_URL).",
          loadError: "Error loading sync status",
          environment: { sandbox: "Sandbox", production: "Production" },
          state: { running: "Running", ok: "Synced", error: "Error", never: "Never synced" },
          table: {
            catalog: "Catalog",
            state: "State",
            records: "Records",
            changes: "Changes (new / upd.)",
            lastSync: "Last sync",
            syncedBy: "Synced by",
            created: "Created",
            updated: "Updated",
            deactivated: "Deactivated",
          },
          detail: {
            open: "View records",
            count: "{{count}} records",
            inactiveCount: "{{count}} inactive hidden",
            searchPlaceholder: "Search by name, code or Talana ID…",
            showInactive: "Show inactive",
            empty: "No records to show",
            loadError: "Error loading catalog records",
            table: { talanaId: "Talana ID", name: "Name", code: "Code", details: "Details", parent: "Parent" },
          },
          catalogs: {
            contractTypes: "Contract types",
            afps: "Pension funds (AFP)",
            healthInstitutions: "Health institutions (Isapre / Fonasa)",
            banks: "Banks",
            legalEntities: "Legal entities",
            branches: "Branches",
            workSchedules: "Work schedules",
            jobTitles: "Job titles",
            costCenters: "Cost centers",
            countries: "Countries",
            locations: "Geographic locations",
            periods: "Periods",
            payrollParameters: "Payroll variables (validity ranges)",
            afpCommissions: "AFP commissions (validity ranges)",
            taxBrackets: "Income tax brackets (validity ranges)",
          },
        },
        config: {
          title: "ERP Settings",
          menu: "Settings",
          tabs: { jobTitles: "Job title catalog", parameters: "Calculation parameters", hiringCauses: "Hiring causes", talana: "Talana", templates: "Word templates (Amanda PDF)", izydocs: "Izydocs formats" },
        },
        // Contract template in Word (ERP Settings → Templates; PLAN_ERP.md §15, phase B1, 2026-10-19)
        // Izydocs formats (PLAN_ERP.md §15.4, phase B2, 2026-10-20)
        izydocsFormats: {
          title: "Izydocs formats",
          intro: "Izydocs formats that Amanda uses to send documents for signature. The templates live in Izydocs: the text is changed there and Amanda keeps no copy. Izydocs fills in personal data (name, RUT, address…) from the employee record.",
          loadError: "The Izydocs formats could not be loaded",
          notConfigured: "Izydocs is not configured on the server (IZYDOCS_BASE_URL and IZYDOCS_API_KEY).",
          notWired: "The Izydocs connection is pending: missing {{list}}.",
          kinds: { contract: "Contracts", onboarding: "Onboarding documents", annex: "Annexes" },
          columns: { id: "ID", name: "Name in Izydocs", company: "Company", usage: "When it is used", tags: "Data it requires", status: "Status" },
          companies: { temporary_services: "EST (branch {{id}})", outsourcing: "OUT (branch {{id}})", general: "General" },
          variants: {
            workday: "Working day · Chilean employee",
            workday_foreign: "Working day · foreign employee",
            workday_no_allowances: "Working day · no meal or transport allowance",
            workday_allowances: "Working day · with meal and transport allowance",
            daily: "Daily wage",
            dictamen: "Dictamen letter",
            karin: "Ley Karin protocol",
            welcome: "Welcome pack",
            attendance: "Attendance control authorization",
            continuity: "Continuity annex",
            continuity_passport: "Continuity annex · Passport version",
            overtime: "Overtime agreement",
            overtime_passport: "Overtime agreement · Passport version",
          },
          statuses: { active: "In use", pending: "Pending" },
          pendingReasons: {
            out: "OUT contracts: after Grafton's answers",
            daily_salary: "Amanda does not have the daily wage yet",
            onboarding: "Onboarding documents: after the contract",
            phase_c: "Annexes: phase C",
          },
          noTags: "No variable data",
        },
        documentTemplates: {
          title: "Word templates (Amanda PDF)",
          subtitle: "Contract template in Word (.docx) with {{marker}} placeholders. Amanda uses the active template matching the service mode and contract type; a specific one wins over \"All\". It is for the PDF that Amanda builds (\"View contract (PDF)\"); signing with Izydocs uses the Izydocs templates (Izydocs formats tab).",
          upload: "Upload template",
          uploadTitle: "Upload contract template",
          replaceTitle: "Replace the Word file of «{{name}}»",
          editTitle: "Edit template",
          name: "Name",
          serviceMode: "Service mode",
          contractKind: "Contract type",
          chooseFile: "Choose Word file (.docx)",
          noFile: "No file chosen",
          active: "Active",
          inactive: "Inactive",
          activeLabel: "Active template",
          activeHint: "activating it deactivates the other one with the same service mode and contract type",
          preview: "Preview (PDF with sample data)",
          download: "Download the Word file",
          replace: "Replace the Word file",
          edit: "Edit",
          empty: "No templates yet. Upload the contract template in Word.",
          loadError: "The templates could not be loaded",
          uploadSuccess: "Template uploaded and active",
          saveSuccess: "Template saved",
          saveError: "The template could not be saved",
          previewError: "The preview could not be generated",
          downloadError: "The Word file could not be downloaded",
          noPlaceholdersWarning: "The template has no {{marker}} placeholders: the contract will be the same for everyone.",
          deactivatedInfo: "The previous template with that service mode and contract type is now inactive.",
          conversionNotes: "Word conversion notes",
          table: {
            name: "Name",
            serviceMode: "Service mode",
            contractKind: "Contract type",
            placeholders: "Placeholders",
            status: "Status",
            updated: "Updated",
          },
          serviceModes: { temporary_services: "EST", outsourcing: "OUT", any: "All" },
          contractKinds: { fixed_term: "Fixed term", indefinite: "Indefinite", work_or_task: "Per project", any: "All" },
          errors: {
            UNKNOWN_PLACEHOLDERS: "The template uses placeholders that do not exist: {{list}}. Fix them in the Word file (check the placeholder list) and upload it again.",
            INVALID_FILE: "The file must be a Word .docx. An old .doc cannot be read: save it as .docx.",
            EXTERNAL_IMAGE: "The Word file links to an external image (Insert → Picture → Link to File). Embed the images in the document and upload it again.",
            FILE_TOO_LARGE: "The Word file is larger than 5 MB.",
            TEMPLATE_TOO_LARGE: "The converted template is too heavy (large images?). Make the images in the Word file smaller.",
            FILE_REQUIRED: "Choose the Word file.",
            INVALID_FIELDS: "Fill in the name, service mode and contract type.",
            STORAGE_ERROR: "The Word file could not be saved. Try again.",
          },
          placeholders: {
            title: "Available placeholders",
            intro: "Type the placeholder exactly as shown in the Word file, with both braces, for example {{example}}. If a required placeholder is empty in the employee record, Amanda does not build the contract and says what is missing; optional ones are left blank.",
            format: "Paragraphs, bold, italics, underline, lists, tables and images are kept from the Word file. Headers and footers, alignment and fonts are not: the PDF is justified, with titles (\"Title\" style) centered and \"Page X of Y\" at the bottom.",
            key: "Placeholder",
            label: "What it is",
            example: "Example",
            optional: "optional",
            copy: "Copy",
            copied: "Placeholder copied",
            groups: {
              trabajador: "Person",
              empleador: "Employer",
              cliente: "Client / user company",
              cargo: "Job title",
              jornada: "Working hours",
              lugar: "Workplace",
              contrato: "Contract",
              remuneracion: "Pay",
              documento: "Document",
            },
          },
        },
        validation: {
          rut: "Invalid RUT (check digit verification failed)",
          email: "Invalid email format",
          phone: "Invalid phone: 8 to 12 digits, optional +56",
          fixErrors: "Fix the fields marked in red before saving",
        },
        talanaSelect: {
          notSynced: "Catalog not synced: go to Configuration → Talana",
          loadError: "Could not load the Talana catalog",
          legacy: "legacy text, not in catalog",
          legacyHint: "Text value from an older record: pick the entry from Talana's catalog",
          noOptions: "No results",
        },
        common: {
          save: "Save",
          saving: "Saving...",
          cancel: "Cancel",
          actions: "Actions",
          view: "View",
          retry: "Retry",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          close: "Close",
          requiredFields: "Fill in the required fields",
        },
      },
      // Hunting — proactive candidate sourcing with Apollo.io (PLAN_HUNTING_APOLLO.md)
      hunting: {
        home: {
          menu: "Home",
          welcome: "Hunting",
          welcomeName: "Hi, {{name}}",
          subtitle: "Find people who haven't applied and invite them to your processes",
          actions: { newSearch: "New search" },
          howItWorks: {
            title: "How does it work?",
            step1: "Search by job title, keywords, location and level (free).",
            step2: "Review the list and pick who you want to reach.",
            step3: "Get their contact data: full name, email, LinkedIn and location. Each email costs {{emailPoints}} points. The phone is optional and costs {{phonePoints}} points, only if Apollo finds it. What was already retrieved is not charged again.",
            step4: "Save them to the base and, optionally, link them to a position (ATS or Evaluations) and email them.",
            step5: "They show up in Evaluations → Applicants; if linked to an ATS position, also in its Kanban.",
            creditsNote: "Searching is free: points are charged only for the emails and phones retrieved.",
          },
        },
        search: {
          menu: "Search candidates",
          title: "Search candidates",
          subtitle: "Apollo.io · searching is free; contact data uses points",
          steps: { step1: "Search", step2: "Select", step3: "Contact data", step4: "Destination", step5: "Summary" },
          form: {
            titles: "Job titles",
            titlesHelp: "Type a title and press Enter (e.g. Backend Developer, Data Engineer). Similar titles are included.",
            keywords: "Keywords",
            keywordsHelp: "Skills or technologies (e.g. Python Django). Optional if you set titles.",
            locations: "Location",
            locationsHelp: "Country, region or city (e.g. Chile, Santiago, Chile).",
            level: "Experience level",
            levelAny: "Any",
            levelJunior: "Junior (entry / intern)",
            levelMid: "Mid (senior individual)",
            levelSenior: "Senior (manager and above)",
            verifiedOnly: "Only profiles with a verified email (recommended)",
            verifiedOnlyShort: "Verified email",
            submit: "Search",
          },
          advanced: {
            title: "Advanced filters",
            active: "{{count}} active",
            clear: "Clear advanced",
            person: "Person",
            notTitles: "Exclude titles",
            notTitlesHelp: "Titles you do NOT want in the results (e.g. Intern, Manager).",
            pastTitles: "Past titles",
            pastTitlesHelp: "Titles the person held before (not the current one).",
            personName: "Person name",
            personNameHelp: "To find a specific person.",
            departments: "Department",
            departmentsHelp: "Functional area as Apollo names it (e.g. master_engineering_technical, master_sales).",
            seniorities: "Seniority (Apollo detail)",
            senioritiesHelp: "If you pick levels here, the junior / mid / senior shortcut is ignored.",
            emailStatuses: "Email status",
            emailStatusesHelp: "If you pick statuses here, the verified-email switch is ignored.",
            includeSimilarTitles: "Include titles similar to the ones given (turn off for exact match)",
            exactTitles: "Exact titles",
            company: "Company (current or past)",
            industries: "Industry",
            industriesHelp: "LinkedIn industry name in English (e.g. banking, retail, mining & metals).",
            orgKeywords: "Company keywords",
            orgKeywordsHelp: "Tags associated with the company (e.g. fintech, saas, mining).",
            orgDomains: "Company domains",
            orgDomainsHelp: "Websites of current or past employers (e.g. latam.com).",
            excludeOrgDomains: "Exclude companies",
            excludeOrgDomainsHelp: "Domains you do NOT want (e.g. your own client).",
            orgLocations: "Headquarters location",
            orgLocationsHelp: "Country, region or city of the company HQ.",
            employeeRanges: "Company size (employees)",
            revenueMin: "Min. revenue",
            revenueMax: "Max. revenue",
            growthWindow: "Headcount growth",
            growthMonths: "last {{count}} months",
            growthMin: "Min. %",
            growthMax: "Max. %",
            hiring: "Companies that are hiring",
            orgJobTitles: "Posted job titles",
            orgJobTitlesHelp: "Titles of the employer's active job postings.",
            orgJobLocations: "Job posting locations",
            orgJobLocationsHelp: "Where the company is hiring.",
            orgJobsMin: "Min. postings",
            orgJobsMax: "Max. postings",
            orgJobPostedFrom: "Posted from",
            orgJobPostedTo: "Posted until",
            tech: "Technologies the company uses",
            techHelp: "Apollo identifiers in lowercase (e.g. aws, salesforce, sap, python). Unknown values do not filter.",
            techAny: "Uses any of",
            techAll: "Uses all of",
            techNone: "Does not use any of",
          },
          results: {
            count: "{{returned}} of {{total}} results",
            truncated: "Showing the first {{returned}}. Narrow the filters to refine.",
            partialNote: "Indicative list: Apollo only returns first name, title and company before contact data is retrieved.",
            empty: "No results for those filters.",
            obtained: "Already retrieved",
            obtainedTip: "Data retrieved on {{date}}: not charged again",
            onlyWithPhone: "Only with phone (per Apollo)",
            onlyWithPhoneCount: "{{count}} of {{total}}",
            noneWithPhone: "None of these results has a phone according to Apollo.",
          },
          phone: {
            switch: "Include phone ({{points}} points per phone that arrives)",
            help: "Apollo shows a phone for {{count}} of {{total}}. The number arrives later, not instantly, and is saved even if you close this screen.",
            offHelp: "Without phone: email, LinkedIn, location and experience.",
            unavailable: "Phone is not available in this environment.",
            flagYes: "Apollo indicates a phone is available.",
            flagMaybe: "Apollo doesn't mark it as available, but when requested it sometimes finds one. If none arrives, there's no charge.",
          },
          charges: {
            title: "How charges work",
            email: "Email: {{points}} points for each new person who has an email. If they have no email, or your organization already retrieved them, there's no charge.",
            phone: "Phone: {{points}} points only if Apollo returns a valid number. If none is found, there's no charge.",
            max: "“Up to X points” is the maximum possible; usually less is charged.",
          },
          columns: {
            name: "Name", title: "Title", company: "Company",
            hasEmail: "Email", hasPhone: "Phone", hasLocation: "Location",
            email: "Email", linkedin: "LinkedIn", location: "Location",
            current: "Current role", experience: "Experience", inAmanda: "In Amanda",
            phone: "Phone",
          },
          enriched: {
            count: "{{matched}} of {{requested}} with data",
            pointsCharged: "Points charged: {{points}}",
            notFound: "{{count}} without data in Apollo",
            current: "current",
            registered: "Already registered ({{count}})",
            registeredNoProcess: "Registered in Amanda with no active processes",
            new: "New",
            reused: "{{count}} retrieved before (no charge)",
            reusedTip: "Already saved: not charged again",
            phoneRequested: "phone requested for {{count}} ({{points}} points only for those that arrive; no charge if not found)",
            phonePending: "Waiting…",
            phonePendingTip: "Apollo sends the phone later. It is saved automatically, even if you close this screen.",
            phoneLate: "Arriving later",
            phoneLateTip: "Apollo hasn't sent it yet. It's saved automatically as soon as it arrives: you'll see it when you search for this person again and, if you already saved them, in their profile.",
            phoneNotFound: "Not found",
            phoneNotRequested: "Not requested",
            phoneFallbackTip: "Number returned by Apollo that is not a valid mobile (e.g. a landline): shown, but not copied to the profile.",
            personalEmails: "Personal: {{list}}",
            partial: "Apollo stopped the request before finishing: {{count}} were not requested (no cost). What was retrieved is saved; select the missing ones again.",
          },
          invite: {
            title: "Destination for {{count}} candidate(s)",
            saveNote: "They are always saved to the project's candidate base (Evaluations → Applicants) with name, email, phone (if requested), LinkedIn, location and experience. Linking them to a position and emailing them is optional.",
            associateSwitch: "Link to a position",
            position: "Position",
            groupAts: "ATS positions",
            groupEvaluations: "Evaluations positions",
            noPositions: "No positions available in this project (active ATS positions you can edit, or Evaluations positions).",
            atsNote: "ATS position: the candidate lands in the first Kanban stage.",
            evaluationsNote: "Evaluations position: the position is added to the applicant; tests are sent later from Evaluations. No email is sent in this step.",
            emailSwitch: "Send the portal invitation email",
            emailNote: "This is the standard portal email (\"Complete your application\"), written for someone who already applied. The candidate gets a link and signs in with an email code. Use with care: these are real people who don't know the process.",
          },
          summary: {
            title: "Result",
            saved_line: "Saved to the base: {{count}}",
            associated_line: "Linked to {{position}}: {{count}}",
            emails_line: "Emails sent: {{count}}",
            errors_line: "Errors: {{count}}",
            already: "({{count}} were already in that position)",
            saved: "Saved",
            added: "Linked to position",
            sent: "Email sent",
            error: "Error",
            toast: "{{saved}} candidate(s) saved",
            phonesPending: "{{count}} phone(s) on the way: they are added to the profile automatically when they arrive.",
          },
          actions: {
            back: "Back",
            enrich: "Get contact data (up to {{points}} points)",
            goInvite: "Continue with {{count}}",
            invite: "Save and send {{count}} email(s)",
            associate: "Save and link {{count}} to the position",
            save: "Save {{count}} to the base",
            newSearch: "New search",
            viewProcess: "View process in ATS",
            viewApplicants: "View applicants in Evaluations",
          },
          errors: {
            noCriteria: "Enter at least one search criterion.",
            search: "The Apollo search could not be executed.",
            enrich: "Contact data could not be retrieved.",
            organizationForbidden: "You don't belong to the selected organization.",
            noPointsSystem: "Hunting is not available: your organization doesn't have the points system enabled. Contact your administrator.",
            serviceNotAvailable: "Hunting is not included in your organization's plan: it's available on paid plans.",
            insufficientPoints: "Not enough points: up to {{required}} are needed and {{remaining}} are left. Pick fewer people or turn off the phone.",
            positions: "Positions could not be loaded.",
            invite: "Invitations could not be sent.",
          },
        },
        emailStatus: {
          verified: "Verified",
          likely_to_engage: "Likely",
          extrapolated: "Extrapolated",
          unverified: "Unverified",
          unavailable: "No email",
          unknown: "Unknown",
        },
        seniority: {
          owner: "Owner", founder: "Founder", c_suite: "C-level", partner: "Partner", vp: "VP",
          head: "Head", director: "Director", manager: "Manager", senior: "Senior", entry: "Entry", intern: "Intern",
        },
        filterLabels: {
          titles: "Titles", keywords: "Keywords", locations: "Location", level: "Level",
          personName: "Name", notTitles: "Exclude titles", pastTitles: "Past titles", departments: "Department",
          seniorities: "Seniority", emailStatuses: "Email", verifiedOnly: "Email", includeSimilarTitles: "Titles",
          orgDomains: "Companies", excludeOrgDomains: "Exclude companies", orgLocations: "HQ",
          industries: "Industry", orgKeywords: "Company keywords", employeeRanges: "Size",
          revenueMin: "Min. revenue", revenueMax: "Max. revenue", headcountGrowthMonths: "Growth",
          headcountGrowthMin: "Min. growth %", headcountGrowthMax: "Max. growth %",
          orgJobTitles: "Posted titles", orgJobLocations: "Hiring in", orgJobsMin: "Min. postings", orgJobsMax: "Max. postings",
          orgJobPostedFrom: "Posted from", orgJobPostedTo: "Posted until",
          techAny: "Uses any", techAll: "Uses all", techNone: "Not using",
        },
      },
      ats: {
        // Job fairs: groups of openings with a public page and QR code (PLAN_FERIAS)
        fairs: {
          menu: "Job fairs",
          title: "Job fairs",
          subtitle: "Group several openings on one page with its own link and QR code, for example for a job fair.",
          newFair: "New job fair",
          empty: "There are no job fairs yet. Create one to group several openings under a single link and QR code.",
          loadError: "Could not load the job fairs.",
          colName: "Name",
          colPositions: "Visible openings",
          colCreatedBy: "Created by",
          colUpdated: "Last updated",
          colActions: "Actions",
          positionsShown: "{{shown}} of {{total}}",
          noneShown: "None visible: the QR code leads to an empty page",
          copyLink: "Copy link",
          linkCopied: "Link copied",
          linkCopyError: "Could not copy the link",
          showQr: "Show QR code",
          openPage: "Open page",
          edit: "Edit",
          view: "View",
          delete: "Delete",
          close: "Close",
          origin: "Job fair “{{name}}”",
          editor: {
            newTitle: "New job fair",
            editTitle: "Job fair",
            back: "Back to job fairs",
            name: "Job fair name",
            namePlaceholder: "E.g.: MIL Las Condes Job Fair",
            nameRequired: "Enter the job fair name.",
            readOnly: "Only the person who created the job fair or an administrator can change it.",
            createdBy: "Created by {{name}}",
            positionsTitle: "Job fair openings",
            positionsHint: "The page only shows active openings with “Visible on portal” turned on and, for mass hiring, with spots left.",
            addPositions: "Add openings",
            noPositions: "You have not added any openings yet.",
            remove: "Remove from the job fair",
            missingPosition: "Deleted opening",
            inaccessible: "{{count}} opening(s) from projects you are not assigned to. They stay in the job fair.",
            save: "Save changes",
            create: "Create job fair",
            saved: "Job fair saved",
            created: "Job fair created",
            saveError: "Could not save the job fair.",
            notAllowed: "Some openings cannot be added. Reload the page and try again.",
            forbidden: "You do not have permission to change this job fair.",
            tooMany: "A job fair can have up to {{max}} openings.",
            notFound: "The job fair does not exist or was deleted.",
            unsaved: "You have unsaved changes.",
            linkTitle: "Link and QR code",
            linkLabel: "Job fair link",
            linkHint: "The link and QR code stay the same even if you change the name or the openings.",
            linkAfterSave: "The link and QR code are created when you create the job fair.",
            downloadPng: "Download PNG",
            downloadSvg: "Download SVG",
            boardNotPublished: "The organization's job board is not published, so the link uses app.amandahr.ai instead of the organization's subdomain. The job fair works the same. The job board is published in Configuración → Job board.",
          },
          state: {
            shown: "Shown",
            not_active: "Not shown: {{status}}",
            hidden: "Not shown: not visible on portal",
            limit_reached: "Not shown: no spots left",
            deleted: "Not shown: deleted",
            statuses: {
              draft: "draft",
              suspended: "suspended",
              closed: "closed",
              cancelled: "cancelled",
            },
          },
          picker: {
            title: "Add openings",
            hint: "Openings from your assigned projects that are not closed or cancelled.",
            search: "Search by name, client or location",
            client: "Client",
            type: "Type",
            status: "Status",
            all: "All",
            empty: "There are no openings you can add with these filters.",
            alreadyIn: "Already in the job fair",
            notVisible: "Not visible on portal",
            add: "Add ({{count}})",
            loadError: "Could not load the openings.",
          },
          deleteDialog: {
            title: "Delete job fair",
            confirm: "Delete the job fair “{{name}}”?",
            warning: "The link and QR code will stop working: anyone who opens them will see “This job fair is not available”. Openings and applications do not change.",
            success: "Job fair deleted",
            error: "Could not delete the job fair.",
          },
        },
        contactSource: {
          whatsapp_libre: "Source: WhatsApp (free entry)",
          web_libre: "Source: Web chat (free entry)",
          whatsapp_cargo: "Source: WhatsApp (position link)",
          web_cargo: "Source: Web chat (position link)",
          simulator: "Source: Simulator",
        },
        captation: {
          simulatorButton: "Bot simulator",
          portalAnswers: {
            title: "Application answers (portal form)",
            viewFile: "View file",
            labels: {
              nacionalidad: "Nationality",
              comuna: "District",
              traslado: "Can relocate",
              experiencia: "Experience",
              disponibilidad: "Availability",
              renta: "Salary expectation",
              region: "Region",
              fecha_postulacion: "Application date",
              formacion: "Education",
              doc_carnet_frente: "ID document (front)",
              doc_carnet_reverso: "ID document (back)",
              doc_visa: "Visa or work permit",
            },
          },
          limitBadge: {
            label: "Captation paused by limit",
            tooltip: "The bot reached the configured captation limit ({{count}}/{{limit}}). It is not accepting new applications; you can raise or remove the limit in the position settings.",
          },
          campaigns: {
          title: "Push campaigns",
          headerButton: "Push campaigns (load base from Excel)",
          subtitle: "Load candidate bases from Excel: phones are normalized, deduplicated against your base, and left ready for WhatsApp sending (available once Meta approves the templates).",
          unnamed: "Unnamed load",
          whatsappUnavailable: "WhatsApp is not available for this organization: campaigns cannot be sent (bases can still be loaded). Set up its own number or ask a super-admin to allow Grafton's shared number (ATS → Configuration → WhatsApp → Channel).",
          status: {
            draft: "Draft",
            ready: "Pending send",
          },
          campaignCounts: "{{valid}} contacts · {{existing}} already existed · {{invalid}} discarded",
          deleteConfirm: "Delete",
          deleteError: "Error deleting the campaign",
          newTitle: "New load",
          fileButton: "Choose Excel or CSV…",
          dbTitle: "Or add candidates from the project database",
          dbSearchPlaceholder: "Search by name, ID, email or phone (min. 2 chars)",
          dbSearchButton: "Search",
          dbSearchError: "Could not search the database",
          dbNoResults: "No results for that search",
          dbNoPhone: "no phone",
          dbRowLabel: "DB",
          previewFromDb: "{{count}} from the database",
          fileHint: "Minimum columns: name and phone (headers like \"celular\", \"fono\", \"mobile\" are accepted). RUT and email are optional and improve deduplication. Max 5 MB / 5,000 rows.",
          nameLabel: "Load name (optional)",
          namePlaceholder: "e.g.: Client base March",
          nameHint: "To tell this load apart from others in the same position. If empty, it stays as \"Unnamed load\".",
          origenLabel: "Base origin (optional)",
          origenPlaceholder: "e.g.: client's historical base, job fair…",
          origenHint: "Where this list of people came from. Useful as backup if someone asks why they were contacted, and to know which base generated complaints.",
          optInLabel: "These people agreed to be contacted (optional)",
          optInHint: "Consent declaration: check it if the base comes from people who authorized contact (previous applications, forms, etc.). Protects the WhatsApp number's quality against spam reports.",
          uploadButton: "Load and review",
          detailShow: "View delivery detail",
          detailTitle: "Delivery detail — {{name}}",
          detailFilterLabel: "Filter by status",
          detailFilterAll: "All statuses",
          detailEmpty: "No contacts for that filter",
          detailLoadMore: "Load more",
          detailError: "Could not load the detail",
          detailSentAt: "Sent {{time}}",
          detailDeliveredAt: "Delivered {{time}}",
          detailReadAt: "Read {{time}}",
          detailRepliedAt: "Replied {{time}}",
          detailDeclinedAt: "Declined {{time}}",
          contactStatus: {
            pending: "Pending",
            sent: "Sent",
            delivered: "Delivered",
            read: "Read",
            replied: "Replied",
            declined: "Not interested",
            failed: "Failed",
            skipped_optout: "Skipped — opt-out",
            skipped_veto: "Skipped — vetoed",
            skipped_frequency: "Skipped — contacted less than {{days}} days ago",
            skipped_active_conversation: "Skipped — active conversation",
            opted_out: "Asked not to be contacted",
          },
          uploadError: "Error loading the file",
          previewTitle: "Load review",
          previewValid: "{{count}} valid contacts",
          previewExisting: "{{count}} already existed (reused)",
          previewInvalid: "{{count}} invalid rows",
          previewExcluded: "{{count}} excluded (blocked/vetoed/opt-out)",
          rowLabel: "Row {{row}}",
          confirmButton: "Confirm load ({{count}})",
          discardButton: "Discard",
          confirmed: "Campaign saved — pending send",
          confirmError: "Error confirming the campaign",
        },
        whatsappLink: {
            button: "Copy WhatsApp link",
            copied: "WhatsApp link copied to clipboard",
            noNumber: "This organization has no WhatsApp number for the link: set its visible number or ask a super-admin to allow Grafton's shared number (ATS → Configuration → WhatsApp → Channel).",
            error: "Could not copy the WhatsApp link",
          },
          chatLink: {
            button: "Copy chat link",
            copied: "Chat link copied to clipboard",
            error: "Could not copy the chat link",
          },
          publicFree: {
            title: "Find your next job",
            subtitle: "Tell the assistant what you are looking for and it will show you the open positions",
          },
          drawer: {
            title: "Bot conversation",
            show: "View conversation",
            hide: "Hide",
          },
          simulator: {
            title: "Captation bot simulator",
            subtitle: "Test the conversation flow in sandbox mode: it does not create real candidates or consume external services.",
            testChip: "Test mode",
            restart: "Restart",
            backToPosition: "Back to position",
            panelTitle: "Engine status",
            state: "State",
            result: "Result",
            intent: "Last intent",
            progress: "Question",
            turnTokens: "Last turn tokens",
            totalTokens: "Total test tokens",
            answers: "Captured answers",
            noAnswers: "No answers yet",
            startError: "Could not start the simulation",
          },
          chat: {
            inputPlaceholder: "Type your message…",
            send: "Send",
            typing: "Typing…",
            attach: "Attach file",
            finished: "Conversation finished",
          },
          public: {
            title: "Application",
            subtitle: "Application assistant",
            connecting: "Connecting to the assistant…",
            error: "We couldn't connect to the assistant. Please try again in a few minutes.",
            retry: "Retry",
            uploadError: "We could not receive the file. Try again (PDF, Word or image, max 10 MB).",
            finishedThanks: "Thanks for chatting with us! Your information has been saved.",
            poweredBy: "Recruiting powered by Amanda",
          },
          states: {
            interes: "Interest",
            optin: "Opt-in",
            optin_experiencia: "Experience (pool)",
            preguntas: "Questions",
            confirmando_datos: "Confirming data",
            confirmando_cierre: "Final confirmation",
            identificando_cargo: "Finding position",
            finalizada: "Finished",
          },
          results: {
            captado: "Captured",
            registrado_base: "Saved to pool",
            cerrado: "Closed",
          },
        },
        home: {
          menu: "Home",
          welcome: "Welcome to the ATS",
          welcomeName: "Hi, {{name}}",
          subtitle: "Manage your positions and candidates",
          metrics: {
            positions: "Positions",
            activePositions: "Active positions",
            candidates: "Candidates",
          },
          actions: {
            newPosition: "New position",
            viewPositions: "View positions",
            viewCandidates: "View candidates",
            start: "Get started",
          },
          howItWorks: {
            title: "How does the ATS work?",
            step1: "Create a position and define its pipeline (phases and stages).",
            step2: "Receive applicants through the public portal or add existing applicants.",
            step3: "At each stage, filter CVs and send assessments or interviews.",
            step4: "Move candidates across the kanban as they progress.",
            step5: "Advance through phases until hiring, or close the process.",
          },
        },
        config: {
          menu: "Configuración",
          title: "Configuration",
          // Link to the PDF manual next to the title (AtsConfigurationLayout.js, 2026-10-15)
          manualLink: "Setup manual (PDF, in Spanish)",
          tabs: {
            rejectionEmail: "Rejection email",
            hiringEmail: "Hiring email",
            offerEmail: "Offer email",
            shortlistEmail: "Client email",
            documentCatalog: "Document types",
            documentsEmail: "Documents email",
            branding: "Branding",
            emailSender: "Sender",
            pipelineTemplates: "Pipeline templates",
            jobBoard: "Job board",
          },
          jobBoard: {
            title: "Public job board",
            description: "Publish a public page with all the organization's active openings, where candidates can see details and apply.",
            orgLevelNote: "This setting applies to the whole organization (not the active project): the board lists active ATS openings from all its projects.",
            sharedSlugNote: "The subdomain (slug) is also used in the test and document-request links sent to candidates (Settings → Custom URL in evaluations mode): changing it affects both.",
            enabled: "Publish the job board",
            slugLabel: "Address (slug)",
            slugHint: "The page will live at: {{url}}",
            slugRequired: "You must set an address (slug) to publish the board",
            slugTaken: "That address is already in use or not allowed",
            slugChangeWarning: "If you change the address, the previous link (/empleos/{{old}}) will stop working.",
            checking: "Checking availability...",
            nameTitle: "Name shown on the page",
            nameOrganization: "Organization name ({{name}})",
            nameCustom: "Custom name",
            customName: "Name to display",
            bannerUrl: "Banner URL (optional)",
            bannerHint: "Wide image for the page header. You can reuse the portal branding one. Recommended: ~1920×320 px (~6:1 width:height ratio); vertical overflow is center-cropped.",
            copy: "Copy link",
            copied: "Link copied",
            open: "Open page",
            save: "Save",
            saveSuccess: "Job board saved",
            saveError: "Could not save the configuration",
            loadError: "Could not load the configuration",
          },
          pipelineTemplates: {
            title: "Pipeline templates",
            description: "Save named pipeline configurations to reuse when creating openings. The one marked as default is preloaded on every new opening. Editing or deleting a template does not affect openings already created.",
            empty: "No templates yet. Create the first one with the button below.",
            add: "New template",
            createTitle: "New pipeline template",
            editTitle: "Edit pipeline template",
            nameField: "Template name",
            descriptionField: "Description (optional)",
            nameRequired: "The template name is required",
            phasesRequired: "The template must have at least one phase",
            defaultChip: "Default",
            setDefault: "Set as default",
            unsetDefault: "Unset as default",
            phasesCount: "phases",
            stagesCount: "stages",
            edit: "Edit",
            delete: "Delete",
            deleteConfirmTitle: "Delete template",
            deleteConfirmText: "Delete the template \u201c{{name}}\u201d? Openings already created with it are not affected.",
            saveSuccess: "Template saved",
            saveError: "Could not save the template",
            deleteSuccess: "Template deleted",
            deleteError: "Could not delete the template",
            loadError: "Could not load the templates",
          },
          rejectionEmail: {
            title: "Rejection email",
            description: "Template of the email sent when discarding a candidate in this project. You can tweak it on each discard.",
            variables: "Available variables",
            subject: "Subject",
            body: "Email body",
            save: "Save",
            saveSuccess: "Template saved successfully",
            saveError: "Error saving the template",
            loadError: "Error loading the template",
          },
          hiringEmail: {
            title: "Hiring email",
            description: "Template of the email sent when hiring a candidate (Hired stage). Reception details are filled in when sending.",
            variables: "Available variables",
            subject: "Subject",
            body: "Email body",
            save: "Save",
            saveSuccess: "Template saved successfully",
            saveError: "Error saving the template",
            loadError: "Error loading the template",
          },
          offerEmail: {
            title: "Offer email",
            description: "Template of the email sent with the offer (Offer stage). The offer letter is attached when sending.",
            variables: "Available variables",
            subject: "Subject",
            body: "Email body",
            save: "Save",
            saveSuccess: "Template saved successfully",
            saveError: "Error saving the template",
            loadError: "Error loading the template",
          },
          shortlistEmail: {
            title: "Client email (shortlist)",
            description: "Template of the email sent to the client with the shortlisted candidates. It lists each candidate with buttons to view their CV and executive summary (variable «candidatos», below).",
            variables: "Available variables",
            subject: "Subject",
            body: "Email body",
            save: "Save",
            saveSuccess: "Template saved successfully",
            saveError: "Error saving the template",
            loadError: "Error loading the template",
          },
          documentCatalog: {
            title: "Document types",
            description: "Catalog of documents you can request from candidates in this project. They are reused in the pipeline's 'Request documents' dialog; anything you add there also shows up here.",
            empty: "No document types yet. Add the first one.",
            labelField: "Document name",
            instructionsField: "Instructions (optional)",
            addType: "Add document type",
            save: "Save",
            saveSuccess: "Catalog saved successfully",
            saveError: "Error saving the catalog",
            loadError: "Error loading the catalog",
          },
          documentsEmail: {
            title: "Documents email",
            description: "Template of the email sent when requesting documents from a candidate. The document list and the upload button are added automatically.",
            brandingNote: "The logo and company name ('From') come from the project's branding. Configure them in the 'Branding' tab, not here.",
            variables: "Available variables",
            subject: "Subject",
            body: "Email body",
            save: "Save",
            saveSuccess: "Template saved successfully",
            saveError: "Error saving the template",
            loadError: "Error loading the template",
          },
          branding: {
            title: "Portal branding",
            description: "Define the name and logo shown in the application portal and emails for this project.",
            note: "Nothing is shown by default until you configure it. Platform branding is never used.",
            nameTitle: "Display name",
            logoTitle: "Logo",
            source: "Source",
            sourceNone: "Don't show",
            sourceOrganization: "Organization",
            sourceProject: "Project",
            sourceCustom: "Custom",
            customName: "Custom name",
            customLogoHint: "Upload a custom logo for this project.",
            bannerTitle: "Banner (photo)",
            bannerHint: "Wide image shown at the top of the application page. Optional. Recommended: ~1920×320 px (~6:1 width:height ratio). Displayed full-width with a max height of 240 px; vertical overflow is center-cropped — keep the logo and text centered in the image.",
            bannerRatioWarning: "This image is not very panoramic: only a central strip will be visible in the portal. If it is a logo, upload it in the Logo field; for the banner we recommend ~1920×320 px.",
            bannerUpload: "Upload banner",
            bannerReplace: "Replace banner",
            bannerRemove: "Remove",
            bannerError: "Could not upload the banner",
            save: "Save",
            saveSuccess: "Branding saved successfully",
            saveError: "Error saving the branding",
            loadError: "Error loading the branding",
          },
          emailSender: {
            title: "Email sender",
            description: "Define the name candidates see as the sender of this project's ATS emails. You can also tweak it on each send.",
            note: "Only the display name changes; emails are always sent from the same address.",
            modeDefault: "Amanda HR (default)",
            modeUser: "Name of the user sending the email",
            modeCustom: "Custom name",
            modeUserHint: "For automatic sends (no user), the custom name is used if defined; otherwise Amanda HR.",
            customName: "Custom name",
            preview: "Preview",
            fieldLabel: "Sender (display name)",
            save: "Save",
            saveSuccess: "Sender saved successfully",
            saveError: "Error saving the sender",
            loadError: "Error loading the sender",
          },
        },
        positions: {
          editPosition: "Edit position",
          duplicatePosition: "Duplicate position",
          positionUpdated: "Position updated successfully",
          copyPortalUrl: "Copy portal link",
          copyPortalUrlHidden: "Not visible on the portal: its link shows \"not available\"",
          portalUrlCopied: "Link copied to clipboard",
          deleteDialog: {
            button: "Delete position",
            title: "Delete position",
            confirm: "Are you sure you want to delete the position \"{{name}}\"?",
            warning: "It will no longer appear in ATS or in Position Management, and it will stop receiving applications. Candidates and their history are kept.",
            success: "Position deleted",
            error: "Could not delete the position",
            confirmWord: "DELETE",
            typeToConfirm: "Type {{word}} to confirm",
            candidates: "It has {{count}} candidate(s) in process: they are kept, but the position is hidden.",
            noCandidates: "It has no candidates.",
          },
          deadline: {
            closesIn: "Closes in {{count}} day(s)",
            closesToday: "Closes today",
            overdue: "Overdue by {{count}} day(s)",
          },
          view: "View detail",
          title: "Positions",
          loadError: "Error loading positions",
          saveError: "Error saving the position",
          positionCreated: "Position created successfully",
          positionsFound: "positions found",
          newPosition: "New Position",
          searchPositions: "Search positions...",
          noPositions: "No positions registered",
          noPositionsSearch: "No positions found for this search",
          positionName: "Position",
          processType: "Type",
          industry: "Industry",
          modality: "Modality",
          status: "Status",
          actions: "Actions",
          assignUsers: "Assign editors",
          noEditPermission: "You don't have permission to edit this position",
          assignDialog: {
            title: "Position editors",
            description: "Select the users who can edit this position and manage its process. Administrators can always edit it.",
            selectLabel: "Users allowed to edit",
            noOptions: "No users available",
            loadError: "Error loading users",
            saved: "Editors updated successfully",
            saveError: "Error updating editors",
            save: "Save",
            cancel: "Cancel",
          },
          wizard: {
            tipo: "Process type",
            tipoLockedHint: "The process type cannot be changed after the position is created: the flows are different.",
            internalName: "Internal name (optional)",
            portalVisibility: {
              title: "Job board",
              onHint: "The position appears on the job board and accepts applications (if it is Active and the job board is enabled).",
              offHint: "The position does not appear on the job board and its link shows \"not available\". You can still add candidates manually.",
            },
            captacionBot: {
              templateSelector: "Captation template",
              templateStandard: "System default flow",
              saveAsTemplate: "Save captation as template",
              saveAsTemplateTitle: "Save as captation template",
              saveAsTemplateHint: "Saves the current questions, messages and rules as a project template. New positions can start from it (the default one is applied automatically). Editing the template later does NOT change positions already created.",
              saveAsTemplateDisabledHint: "Customize the flow or rules first: the system default flow is always available.",
              templateSaved: "Captation template saved",
              templateSaveError: "Could not save the captation template",
              limitLabel: "Captation limit",
              limitPlaceholder: "No limit",
              limitHint: "When captured candidates (bot + portal form) reach this number, captation pauses automatically on both channels (people already chatting can finish). Empty = no limit.",
              
              title: "Part 1 — Captation (bot and form)",
              switchLabel: "Bot (chat and WhatsApp)",
              portalSwitchLabel: "Visible on portal",
              portalEnabledHint: "The same questions are shown as a form on the job board (sign-in with an email code).",
              portalDisabledHint: "Not visible: the position does not appear on the job board and its link does not accept applications.",
              enabledHint: "The bot captures candidates through this position's public chat (and WhatsApp once connected).",
              disabledHint: "Captation off: the public chat does not receive candidates. You can add people to the pipeline manually.",
              funnelHint: "Automated captation flow. Detailed configuration arrives with captation templates.",
              editor: {
                questionsTitle: "Bot data questions",
                questionsHint: "The bot asks them in this order. Fixed ones cannot be disabled (without them there is no identity check or contact). The position's filtering questions are configured in the Questions tab and the bot asks them at the end.",
                newQuestionPlaceholder: "Type the question…",
                lockedChip: "Fixed",
                lockedTooltip: "Critical flow question: it cannot be disabled or removed.",
                addQuestion: "Add question",
                messagesTitle: "Bot messages",
                stepsTitle: "Flow steps",
                contactTitle: "1 · Contact & interest",
                dataTitle: "2 · Candidate data",
                backgroundTitle: "3 · Background review",
                rulesTitle: "4 · Position rules",
                closingTitle: "5 · Closing",
                activeChip: "Active",
                pendingChip: "Integration pending",
                backgroundRutRow: "ID/document validation and detection of already registered candidates",
                backgroundAltoRow: "Background check (Chapi)",
                backgroundStageRow: "Background check (Chapi, {{points}} points per check): done from the pipeline stage that has the \"Background check\" module",
                backgroundStageChip: "In the pipeline",
                backgroundStageRowUnavailable: "Background check: only available for organizations operating in Chile",
                unavailableChip: "Not available",
                altoChecksHint: "Checks identity and background records in Chapi during captation (1 credit per new check; repeating it within the same month is free). Off: this position does not run background checks — Chileans with a valid RUT go straight to \"No observations\"; foreigners and people without a RUT still go to manual review.",
                altoChecksUnavailableHint: "Only for organizations operating in Chile: Chapi checks Chilean records. This organization operates in another country, so no background checks are run.",
                rulesRow: "Auto-discard and blocking rules per position/client",
                extranjeroDocsLabel: "Ask foreigners for documents via chat",
                extranjeroDocsHint: "If the nationality is not Chilean, the bot asks for a photo of the FRONT of the ID, then the BACK, then the visa/permit — each as its own step (skippable; files are stored on the profile).",
                extranjeroDocsUnavailableHint: "Only available for organizations operating in Chile.",
                rules: {
                  disabledHint: "Disabled: the bot only records answers and every captured candidate enters the kanban without marks. Turn the switch on to auto-mark or auto-discard using deterministic rules.",
                  hint: "Each rule defines what to do when the answer doesn't match: Nothing, Mark (badge for review) or Discard (goes to the Discarded column, always recoverable).",
                  actionLabel: "Action",
                  actions: {
                    nada: "Nothing",
                    marcar: "Mark",
                    descartar: "Discard",
                  },
                  rentaLabel: "Salary expectation above the cap",
                  rentaHint: "By default it only MARKS (\"Salary above cap: asked X / cap Y\"). Without a configured cap it is not evaluated.",
                  rentaTope: "Net cap (CLP)",
                  comunaLabel: "Commune different from the position's",
                  comunaHint: "Ignored if the position is remote. If the candidate said they CAN relocate, they are saved; if the relocation answer is ambiguous, it only marks (never discards).",
                  noFiltering: "This position has no comparable filtering questions (Yes/No or multiple choice).",
                  filteringHint: "If the answer is not among the expected ones, the action applies. Answers outside the options are only marked.",
                  expectedLabel: "Expected answers",
                  discardNote: "Discard never deletes: the application stays in the Discarded column with its reason and the consultant can recover it.",
                },
                rutAdaptNote: "This question adapts automatically based on nationality: foreigners are asked for their ID document or passport.",
                fieldLabel: "Save to field…",
                fieldNone: "None",
                fieldOptions: {
                  gender: "Gender",
                  profession: "Profession or trade",
                  currentPosition: "Current position",
                  name: "Name",
                  rut: "ID document (RUT)",
                  phone: "Phone",
                  email: "Email",
                  country: "Nationality",
                  salarioPretendido: "Expected salary",
                  cvUrl: "CV",
                },
                systemFieldTooltip: "System mapping: the answer feeds this candidate field and cannot be changed (verification and contact depend on it).",
                loadError: "Could not load the flow configuration. Reload the page.",
                messagesHint: "You can use the {{cargo}}, {{empresa}} and {{nombre}} variables.",
                messageLabels: {
                  bienvenida: "Welcome",
                  interes: "Interest question",
                  inicioPreguntas: "Questions intro",
                  cierreCaptado: "Capture closing",
                  optIn: "Talent pool invitation",
                },
                restoreDefaults: "Restore default messages",
                restoreFlow: "Restore default flow",
                restoreFlowHint: "Resets the whole flow (questions and messages) to the system default, discarding this position's customizations. Also useful to pick up new system questions.",
                restoreFlowConfirm: "Restore the default flow? All question and message customizations of this position will be discarded.",
                restoreFlowCancel: "Cancel",
                restoreFlowGo: "Restore",
                optInLabel: "Offer talent pool registration",
                optInHint: "If the candidate is not interested, the bot offers to keep them registered for future positions. Off: it says goodbye directly.",
              },
              pipelinePartTitle: "Part 2 — Process pipeline",
              steps: {
                contacto: "Contact",
                interes: "Interest",
                datos: "Data",
                validacion: "Validation",
                reglas: "Rules",
              },
            },
            internalNameHint: "Only visible inside the app, to identify processes (e.g. HR Analyst Massive). Candidates always see the position name.",
            tooltips: {
              tipo: "Hunting: traditional selection process for a specific role. Massive recruitment: high-volume candidate captation with a conversational bot and a massive pipeline. It cannot be changed after the position is created.",
              prioridad: "Internal indicator to sort which positions are more urgent. It does not affect the flow or publication.",
              estado: "Draft: not shown when opening the link and does not allow applying. Active: visible and receiving applications when the link is shared. Suspended: temporary pause, the process will resume soon; it stops receiving applications but you can keep working with the candidates already in the pipeline. Closed: the process ended and the position was filled. Cancelled: the role is no longer needed and the search is dropped. Only the Active status publishes the position and receives applications.",
              visibilidad: "General: visible to every user in the project. Confidential: visible only to admins and to whoever created the position.",
              modalidad: "How the role is performed: on-site, remote or hybrid.",
              salarioTipo: "Range: minimum and maximum salary. Fixed salary: a single amount. They are alternatives: the position uses one or the other.",
              tipoBusqueda: "Indicator of the search type. Internal: the company recruits from within its own staff. External: the search is handled by a third party (headhunting consultancy). General: no distinction. It does not affect publication.",
            },
            stepFields: "Position fields",
            stepPipeline: "Pipeline",
            basicInfo: "Basic information",
            jobDescription: "Job description",
            positionName: "Position name",
            codigoRef: "Reference code",
            industry: "Industry",
            jerarquia: "Hierarchy",
            modalidad: "Modality",
            prioridad: "Priority",
            numPosiciones: "Number of positions",
            numVacantes: "Number of vacancies",
            area: "Area",
            subArea: "Sub-area",
            tipoBusqueda: "Search type",
            motivoBusqueda: "Reason for search",
            motivoBusquedaPlaceholder: "E.g.: Replacement, Growth, New position",
            descripcion: "Description",
            responsabilidades: "Responsibilities",
            perfil: "Profile",
            conocimientosExcluyentes: "Required knowledge",
            conocimientosDeseables: "Desirable knowledge",
            competencias: "Default competencies",
            competenciasHelper: "Preloaded when sending a DISC test in complete mode, and used to guide the AI-suggested interview questions. Each send can adjust them without changing the vacancy.",
            salarioOfrecido: "Offered salary",
            salary: "Salary range",
            currency: "Currency",
            salarioMin: "Minimum salary",
            salarioMax: "Maximum salary",
            salarioMonto: "Fixed salary",
            salarioTipo: "Salary type",
            salarioVisible: "Show salary to candidates",
            bonos: {
              title: "Bonuses",
              tooltip: "Bonuses tied to the role (name required; description and amount optional). Only used so the bot can answer if a candidate asks; they follow the \"Show salary\" switch. Not used in calculations or reports.",
              empty: "No bonuses recorded for this role.",
              nombre: "Bonus name",
              descripcion: "Description",
              monto: "Amount",
              add: "Add bonus",
              remove: "Remove bonus",
            },
            beneficios: {
              title: "Role benefits",
              tooltip: "Benefits specific to this position (name required; description optional), e.g. supplementary insurance or personal days. Shown to candidates and used by the bot when asked.",
              empty: "No benefits recorded for this role.",
              nombre: "Benefit name",
              descripcion: "Description",
              add: "Add benefit",
              remove: "Remove benefit",
            },
            condicionesPago: {
              enable: "Record the engagement's commercial terms",
              title: "Commercial terms",
              internalNote: "Internal use — not shown to the candidate.",
              precio: "Role fee",
              kickoff: "% Kick-off",
              cierre: "% Completion",
              montoTramo: "Amount: {{monto}}",
            },
            autoSendRejectionEmail: "Send rejection email automatically",
            autoSendRejectionEmailHelper: "If enabled, when discarding candidates in this position the rejection email will be pre-selected to be sent.",
            brandingTitle: "Portal branding",
            brandingHelper: "Customize the logo and name the candidate sees on the application page. If you don't set a logo here, the project or organization logo is used.",
            brandingLogo: "Position logo (optional)",
            brandingLogoHelper: "Overrides the project/organization logo only for this position.",
            brandingRemoveLogo: "Remove logo",
            brandingCompanyName: "Display name",
            brandingCompanyNamePlaceholder: "Default: organization name",
            brandingShowLogo: "Show logo on the portal",
            brandingShowName: "Show company name on the portal",
            fechaApertura: "Opening date",
            fechaCierre: "Closing date",
            country: "Country",
            province: "Province / State",
            city: "City",
            statusLabel: "Status",
            subtitle: "Fill in the position details",
            pipelineComingSoon: "Pipeline configuration — next step",
            pipelineSkipHint: "You can save the position now and configure the pipeline later.",
            required: "This field is required",
            next: "Next",
            back: "Back",
            tabs: {
              general: "General",
              description: "Description",
              logistics: "Logistics",
              salary: "Salary",
              pipeline: "Pipeline",
              questions: "Questions",
            },
            options: {
              salarioTipo: {
                rango: "Range",
                unico: "Fixed salary",
              },
              modalidad: {
                presencial: "On-site",
                remoto: "Remote",
                hibrido: "Hybrid",
              },
              prioridad: {
                alta: "High",
                media: "Medium",
                baja: "Low",
              },
              tipoBusqueda: {
                internal: "Internal",
                external: "External",
                general: "General",
              },
              status: {
                draft: "Draft",
                active: "Active",
                suspended: "Suspended",
                closed: "Closed",
                cancelled: "Cancelled",
                confidential: "Confidential",
              },
              tipo: {
                vacancy: "Vacancy",
                hunting: "Hunting",
                massive: "Massive recruitment",
              },
            },
            pipeline: {
              catalogTitle: "Available stages",
              catalogSubtitle: "Select the stages you want to include in the pipeline",
              activeStagesTitle: "Configured pipeline",
              emptyStages: "Select stages from the catalog or create custom stages",
              custom: "Custom",
              modules: "modules",
              expandModules: "View modules",
              moveUp: "Move up",
              moveDown: "Move down",
              removeStage: "Remove stage",
              modulesTitle: "Evaluation modules in this stage",
              addCustomTitle: "Add custom stage",
              customStagePlaceholder: "Stage name...",
              addStage: "Add",
              massiveNote: "Massive recruitment pipeline is configured in another module",
              phaseCatalogTitle: "Available phases",
              phaseCatalogSubtitle: "Select the process phases",
              stageCatalogTitle: "Add predefined stages",
              stagesCount: "stages",
              stageUsedElsewhere: "This stage is already in another phase",
              moduleUsedElsewhere: "Already selected in \"{{stage}}\". Uncheck it there to use it in this stage.",
              backgroundCheckChileOnly: "Only available for organizations operating in Chile",
              // Consulta automática de antecedentes al llegar a la etapa (2026-10-13)
              backgroundCheckAuto: "Check automatically when a candidate arrives at this stage",
              backgroundCheckAutoHint: "Background checks run on their own when a candidate arrives at this stage, without pressing the button. Candidates added by the team (imports, “Add applicants”, Hunting) are checked when they complete their application. Each new check costs {{points}} points; without enough points, no check is run.",
              addCustomPhaseTitle: "Add custom phase",
              customPhasePlaceholder: "Phase name...",
              addPhase: "Add phase",
              templateSelector: "Start from template",
              templateStandard: "Standard pipeline (system)",
              templateDefaultSuffix: "default",
              templateReplaceConfirm: "Applying the template will replace the pipeline you configured. Continue?",
              templateReplaceTitle: "Replace pipeline",
              templateReplaceAction: "Apply template",
              saveAsTemplate: "Save as template",
              saveAsTemplateTitle: "Save pipeline as template",
              saveAsTemplateHint: "The configured pipeline will be available as a project template for future openings.",
              templateNameField: "Template name",
              templateSaved: "Template saved",
              templateSaveError: "Could not save the template",
            },
            questions: {
              title: "Filtering questions",
              subtitle: "Questions will be shown to candidates when applying",
              generateAI: "Generate with AI",
              generating: "Generating...",
              aiSaveFirst: "Save the position first to use AI",
              empty: "No questions configured",
              addTitle: "Add question",
              questionLabel: "Question text",
              typeLabel: "Type",
              optionsLabel: "Answer options (minimum 2)",
              optionPlaceholder: "Add option...",
              addOption: "Add",
              addQuestion: "Add question",
              remove: "Remove question",
            },
          },
        },
        candidates: {
          title: "Candidates",
          found: "candidates found",
          search: "Search by name, email or profession...",
          loadError: "Error loading candidates",
          deleteTitle: "Delete candidate",
          deleteConfirm: "Permanently delete {{name}}?",
          deleteDetail: "Their profile, ALL their applications (they disappear from the kanbans) and their captation bot conversations will be deleted. This cannot be undone.",
          deleteGo: "Delete permanently",
          deleteSuccess: "Candidate deleted (profile, applications and conversations)",
          deleteError: "Error deleting the candidate",
          noResults: "No candidates registered in this project",
          noResultsSearch: "No candidates found for this search",
          blocked: "Blocked",
          blockedFound: "blocked",
          blockedOn: "Blocked on",
          noBlocked: "No blocked candidates",
          name: "Name",
          profession: "Profession",
          lastPosition: "Last position",
          appliedOn: "Applied on",
          cv: "CV",
          noName: "No name",
          profile: "Profile",
          currentPosition: "Current position",
          phone: "Phone",
          country: "Country",
          rut: "ID / Tax number",
          salarioPretendido: "Salary expectation",
          registeredOn: "Registered on",
          viewCv: "View CV",
          lastApplicationTitle: "Last application",
        },
        applications: {
          title: "Applications",
        },
        detail: {
          finalizeProcess: "Finalize process",
          finalizeProcessTitle: "Finalize process",
          finalizeProcessConfirm: "Are you sure you want to finalize this process? Candidates will remain in their current state.",
          reopenProcess: "Reopen process",
          reopenProcessTitle: "Reopen process",
          reopenProcessConfirm: "Are you sure you want to reopen this process?",
          processClosed: "Process finalized successfully",
          processReopened: "Process reopened successfully",
          processStatusError: "Error changing process status",
          finalizeNote: "Note",
          finalizeNotePlaceholderClose: "E.g.: Process closed due to vacancy coverage...",
          finalizeNotePlaceholderReopen: "E.g.: Process reopened due to selected candidate resignation...",
          finalizeNoteHelper: "Note is optional",
          edit: "Edit position",
          addExistingApplicant: "Add existing applicant",
          addApplicants: {
            title: "Add applicants to the position",
            description: "Select existing applicants from the project to include them in this position.",
            search: "Search by name or email...",
            withCv: "CV",
            withoutCv: "No CV",
            sendInvitation: "Send an email invitation so they can complete their information",
            add: "Add",
            cancel: "Cancel",
            noApplicants: "No applicants in this project",
            loadError: "Error loading applicants",
            saveError: "Error adding applicants",
            summary: "{{added}} added · {{already}} already in · {{missing}} without CV",
            rutMismatch: "{{names}}: added without linking their portal account (the account with that email has another ID number)",
            pendingValidation: "{{names}}: added as \"To validate\" (their record has no email)",
            noEmailSecondary: "No email (to validate)",
          },
          currentPhase: "Current phase",
          advancePhase: "Advance phase",
          retreatPhase: "Retreat phase",
          phaseUpdated: "Phase updated",
          phaseUpdateError: "Error updating phase",
          selectStage: "Select stage",
          stageUpdated: "Stage updated",
          stageUpdateError: "Error updating stage",
          discard: "Discard candidate",
          discarded: "Discarded",
          discardTitle: "Confirm discard",
          discardConfirm: "Discard the application from {{name}}?",
          discardConfirmButton: "Discard",
          discardSendEmail: "Send rejection email",
          discardEmailSubject: "Subject",
          discardEmailBody: "Email body",
          bulkDiscardTitle: "Discard applicants",
          bulkDiscardConfirm: "Discard {{count}} selected applicants?",
          bulkEmailPreviewNote: "This email will be sent to each applicant (their name is filled in automatically). It is not editable in bulk.",
          bulkDiscardSuccess: "{{count}} applicants discarded",
          discardError: "Error discarding candidate",
          reactivate: "Reactivate",
          reactivated: "Candidate reactivated",
          block: "Block",
          unblock: "Unblock",
          blockTitle: "Block candidate",
          blockConfirm: "Block {{name}}? They will be added to the organization's blacklist and won't advance in any process.",
          blockReason: "Block reason",
          blockReasonPlaceholder: "Optional (e.g., no-show, fake data, etc.)",
          blockConfirmButton: "Block",
          blockedChip: "Blocked",
          discardedChip: "Discarded",
          restore: "Restore",
          restored: "Candidate restored: back to the stage they were in",
          restoreError: "Error restoring the candidate",
          blocked: "Candidate blocked",
          unblocked: "Candidate unblocked",
          blockError: "Error updating block",
          actions: "Actions",
          deleteApplication: "Delete application",
          deleteApplicationTitle: "Confirm deletion",
          deleteApplicationConfirm: "Are you sure you want to delete the application from {{name}}?",
          applicationDeleted: "Application deleted successfully",
          applicationDeleteError: "Error deleting application",
          loadError: "Error loading position",
          candidates: "Candidates",
          info: "Information",
          pipeline: "Pipeline",
          allStages: "All stages",
          noApplications: "No candidates have applied to this position yet",
          noApplicationsInStage: "No candidates in this stage",
          candidate: "Candidate",
          source: "Source",
          stage: "Stage",
          appliedOn: "Applied on",
          openPortal: "Open portal",
          duplicate: "Duplicate position",
          publicNameLabel: "Public name",
          pipelineComingSoon: "Pipeline configuration — coming soon",
          viewPhaseNotes: "View phase notes",
          phaseNotesTitle: "Process notes",
        },
        backgroundReview: {
          title: "Background review",
          status: {
            ok: "No observations",
            pendiente: "Pending",
            requiere_revision: "Needs review",
            approved: "Review approved",
            rejected: "Review rejected",
            sin_consultar: "Not checked",
          },
          notCheckedModule: "Checked with “Check background” in the “{{stage}}” column ({{points}} points per check).",
          notCheckedAuto: "Checked automatically on arriving at the “{{stage}}” column, or with “Check background” in that column ({{points}} points per check).",
          notCheckedNoModule: "This position doesn't run background checks.",
          decidedAs: {
            approved: "Approved by",
            rejected: "Rejected by",
          },
          changeDecision: "Change decision",
          notePlaceholder: "Review note (optional)…",
          approve: "Approve review",
          reject: "Reject",
          requestDocs: "Request documents",
          decisionSaved: "Review decision saved",
          decisionError: "Error saving the decision",
          cardChip: "Background",
          filterChip: "Background review",
          filterHint: "Show only candidates that need background review (across all stages)",
        },
        // Background check price in points (2026-11-01, PLAN_COBRO_ANTECEDENTES)
        backgroundCheckPricing: {
          title: "How it's charged",
          charge: "{{points}} points for each check that brings a Chapi report.",
          free: "Nothing is charged when a check from the last 30 days is reused, when it fails, when Chapi has no data for the RUT or when it returns the same report the profile already had.",
          noPoints: "Without enough points, no check is run.",
          noPointsAuto: "Without enough points, no check is run: the person stays “Not checked” and can be checked later with “Check pending”.",
          moduleIntro: "Adds “Check background” to this column.",
          short: "{{points}} points",
          upTo: "Up to {{total}} points ({{count}} × {{points}})",
          recheck: "{{points}} points if Chapi brings a new report. If this RUT was already checked this month, Chapi returns the same report and nothing is charged.",
          available: "Available: {{points}} points",
          unlimited: "Unlimited points",
          errors: {
            insufficient: "You don't have enough points to run background checks: each check costs {{required}} and {{remaining}} are left.",
            serviceNotAvailable: "Background checks are not included in your organization's plan.",
            noPointsSystem: "Background checks are not available: your organization doesn't have the points system enabled. Contact your administrator.",
            unavailable: "Background checks are not available for your organization.",
          },
          autoSkipped: {
            INSUFFICIENT_POINTS: "there are not enough points (each check costs {{required}}, {{remaining}} left)",
            SERVICE_NOT_AVAILABLE: "background checks are not included in your organization's plan",
            NO_POINTS_SYSTEM: "your organization doesn't have the points system enabled",
            default: "background checks are not available for your organization",
          },
          movedSkipped: "Stage updated, but the background of {{count}} candidate(s) was not checked: {{reason}}. They stay “Not checked”.",
        },
        backgroundCheckStage: {
          button: "Check background",
          forceRecheck: "Check again",
          forceRecheckHint: "Runs a new Chapi check even if there is a recent one.",
          forceRecheckConfirm: "A new Chapi check will be run: {{points}} points if it brings a new report (if this RUT was already checked this month, Chapi returns the same one and nothing is charged). Continue?",
          recheckConfirmOne: "A new Chapi check will be run for {{name}}: {{points}} points if it brings a new report (if this RUT was already checked this month, Chapi returns the same one and nothing is charged). Continue?",
          recheckConfirmBulk: "{{count}} new Chapi checks will be run: up to {{total}} points ({{points}} each; RUTs already checked this month are not charged). Continue?",
          recheckBulk: "Check again ({{count}})",
          filters: {
            all: "All",
            none: "Not checked",
            consulted: "Checked",
            error: "With errors",
            empty: "No applicants match this filter.",
          },
          autoOn: "Automatic check",
          autoOnHint: "Background checks run on their own when a candidate arrives at this stage ({{points}} points per new check).",
          forceRecheckGo: "Check now",
          forceRecheckDone: "New check done",
          chileOnly: "Background checks are only available for organizations operating in Chile.",
          title: "Background check — {{stage}}",
          costNote: "Each check costs {{points}} points. Nothing is charged when a check from the last 30 days is reused, when it fails or when Chapi has no data for the RUT.",
          empty: "There are no applicants in this stage.",
          loadError: "Could not load the background check information.",
          columns: { name: "Applicant", rut: "RUT", status: "Status" },
          status: {
            none: "Not checked",
            processing: "Processing",
            clean: "No alerts",
            flagged: "Alerts",
            not_found: "No data",
            error: "Error",
            notConsultable: "Can't be checked",
          },
          reason: {
            no_chilean_rut: "No Chilean RUT",
            no_surnames: "The profile is missing separate names or surnames",
            outside_chile: "The organization doesn't operate in Chile",
            not_configured: "Background check provider not configured",
            no_applicant: "No applicant profile",
          },
          review: {
            requiere_revision: "Needs review",
            approved: "Review approved",
            rejected: "Review rejected",
          },
          checkedOn: "Checked on {{date}}",
          expired: "more than 30 days ago",
          verify: "Check",
          retry: "Retry",
          refresh: "Update",
          verifying: "Checking…",
          detail: "View detail",
          verifyPending: "Check pending ({{count}})",
          confirmBulk: "{{count}} applicant(s) will be checked: up to {{total}} points ({{points}} each; failed checks and RUTs without data are not charged).",
          confirmBalance: "You have {{available}} points available.",
          confirmShort: "You have enough for {{fit}}: the batch stops when points run out.",
          bulkStopped: "The batch stopped: {{message}} Checked: {{ok}}; {{left}} left unchecked.",
          confirm: "Confirm",
          cancel: "Cancel",
          progress: "Checking {{done}} of {{total}}…",
          bulkDone: "Done: {{ok}} checked, {{failed}} with errors.",
          verifyError: "Could not run the background check",
          back: "Back to the list",
          reviewTitle: "Review",
          openProfile: "Open applicant profile",
          close: "Close",
        },
        backgroundCheck: {
          title: "Background check ({{provider}})",
          processing: "Processing…",
          clean: "Clear",
          flagged: "Alerts",
          causasCount: "{{count}} case(s)",
          truncated: "Showing {{shown}} of {{total}} cases — the full detail is in the report",
          nameMatchOnly: "The cases matched by name only: possible homonym",
          score: "{{label}} risk ({{value}})",
          scoreLabel: { low: "Low", medium: "Medium", high: "High" },
          identity: {
            match: "Identity verified",
            partial: "Verify name — minor differences with the official name",
            mismatch: "The name does NOT match the RUT",
            not_found: "No data for this RUT",
          },
          officialName: "Name per {{provider}}",
          officialNameRegistry: "Name per the civil registry",
          reportType: {
            penal: "Criminal",
            civil: "Civil",
            laboral: "Labor",
            cobranza: "Labor and social security collection",
            pep: "Politically exposed person",
            antecedentes: "Background",
          },
          fields: {
            caratulado: "Case title",
            rit: "RIT",
            ruc: "RUC",
            tribunal: "Court",
            fechaIngreso: "Filing date",
            rol: "Candidate's role",
            formaInicio: "Initiated by",
            estado: "Status",
            etapa: "Stage",
            estadoProcesal: "Procedural status",
            procedimiento: "Procedure",
            materia: "Subject",
            delitos: "Offenses",
            matchType: "Match",
          },
          matchType: { rut: "by RUT", name: "by name", nombre: "by name" },
          error: {
            title: "The background check did not complete",
            insufficient_balance: "No balance left with the provider.",
            timeout: "The provider did not respond in time.",
            provider_error: "Provider error.",
            bad_request: "The provider rejected the request.",
            auth: "Invalid provider credentials.",
            not_configured: "The provider is not configured.",
            incomplete: "The report never finished.",
          },
          homonymDisclaimer: "If a case matched by name only it may be a homonym: verify with the report references before deciding.",
          openReport: "Open report in {{provider}}",
          retry: "Run background check",
          retryHint: "{{points}} points if it brings a report; if it fails again, nothing is charged.",
          retryOk: "Background check completed",
          retryFailedAgain: "The check failed again",
          retryError: "Could not run the background check",
        },
        captationRules: {
          marksTitle: "Marks to review",
          autoDiscarded: "Automatically discarded by a position rule",
          autoDiscardChip: "Auto",
        },
        // Candidate download to Excel from the pipeline (PLAN_EXPORTACION_CANDIDATOS_ATS)
        export: {
          button: "Download Excel",
          downloading: "Downloading…",
          tooltip: "Downloads all of the position's candidates, including discarded, blocked and to-validate ones",
          empty: "The position has no candidates",
          error: "The Excel file could not be downloaded. Please try again.",
          forbidden: "You don't have permission to download this position's candidates",
          fileBase: "Candidates",
        },
        pipeline: {
          lockedStage: "Locked stage — advance the process phase to unlock",
          dropHere: "Drop here",
          discardedColumn: "Discarded",
          noDiscarded: "No discarded",
          blockedColumn: "Blocked",
          noBlocked: "No blocked",
          pendingValidationColumn: "To validate",
          noPendingValidation: "Nothing to validate",
          noPipeline: "This position has no pipeline configured",
          searchInStage: "Search...",
          noResults: "No results",
          cvScoreTooltip: "Fit % from CV filtering",
        },
        validation: {
          chip: "To validate",
          reason: {
            email_in_use: "The email {{email}} is already on {{name}}'s record, and the person had no other.",
            not_same_person: "The email {{email}} is on {{name}}'s record, and the person said it is not them.",
            other_rut: "The email {{email}} is already on {{name}}'s record, with another ID number.",
            email_not_confirmed: "Their ID number is on {{name}}'s record, but they could not confirm that record's email. They applied with {{email}}.",
            pending_email: "The record has no email yet: {{email}} is pending from an earlier application.",
            file_email_in_use: "The record has no email and the imported file's email ({{email}}) is on {{name}}'s record.",
            generic: "Some of the person's details need review before continuing.",
          },
          phone: "Phone: {{phone}}",
          validate: "Validate",
          dialogTitle: "Validate {{name}}'s application",
          emailLabel: "Email for the record",
          emailHelp: "If the email is still on another record, enter another email for this person.",
          confirmPerson: "I confirm it is the person. Their portal account is linked to this record and the application moves to its stage.",
          confirm: "Validate",
          cancel: "Cancel",
          success: "Application validated",
          notLinked: "Application validated. The portal account was not linked: the record belongs to another account.",
          blocked: "Application validated, but its email is on the organization's blacklist: it was blocked.",
          emailInUse: "The email {{email}} is still on {{name}}'s record. Enter another email for this person.",
          invalidEmail: "Enter a valid email",
          error: "Could not validate the application",
        },
        import: {
          button: "Import applicants",
          title: "Import applicants",
          description: "Import applicants from any job board (Computrabajo, Laborum, etc.) with this position's template. They enter the first stage, with no automatic messages.",
          templateStep: "1. Download this position's template and copy the job board data into it, one row per person.",
          downloadTemplate: "Download template",
          templateHelp: "It has the data columns and one column per screening question. The \"Instructions\" sheet lists the valid answers.",
          fileStep: "2. Choose the source job board and the file.",
          originLabel: "Source job board",
          originHelp: "It is saved on every imported application.",
          chooseFile: "Choose file",
          fileHelp: ".xlsx, .xls or .csv; up to 5 MB and 5,000 rows.",
          review: "Review file",
          cancel: "Cancel",
          back: "Change file",
          close: "Close",
          importButton: "Import ({{count}})",
          previewTitle: "Preview: {{file}}",
          counts: {
            toImport: "To import: {{count}}",
            new: "New records: {{count}}",
            existing: "Existing records: {{count}}",
            pendingValidation: "To validate: {{count}}",
            inPosition: "Already in the position: {{count}}",
            errors: "Not imported: {{count}}",
            marked: "With ⚠ to review: {{count}}",
            discarded: "Discarded by the rules: {{count}}",
            blocked: "Blocked (blacklist): {{count}}",
          },
          // What each indicator means (chip tooltip)
          countsHelp: {
            toImport: "Rows added to the position when you click Import: new records + existing records + to validate. No message is sent to them.",
            new: "People without a record in the project: their record and application are created.",
            existing: "People who already have a record in the project (found by ID number or email): that record is used and only its missing details are filled in.",
            pendingValidation: "The file's email is already on another person's record. They join the position as \"To validate\", outside the stages, until someone reviews them with \"Validate\".",
            inPosition: "They already have an application in this position: nothing is changed or duplicated.",
            errors: "Rows with an error that prevents importing them (for example, no email or an email repeated in the file). The reason is in the rows table (in red), and when the import finishes you can download them to fix them.",
            marked: "Imported with a ⚠ mark: an answer doesn't match the options or, in massive recruitment positions, a rule asks to review it.",
            discarded: "Massive recruitment positions only: imported already discarded because an answer fails a discard rule.",
            blocked: "They're on the organization's blacklist: imported as \"Blocked\".",
          },
          noRut: "Without ID number: {{count}}. They are imported anyway; the ID number is requested later.",
          blockedRow: "On the organization's blacklist: imported as Blocked",
          ignoredColumns: "Unrecognized columns (ignored): {{columns}}",
          questionsTitle: "Screening questions",
          questionsHelp: "Each question is linked to the column with its text. If the header in your file is different, choose the column.",
          questionsNoneLinked: "This file has no columns for the questions: applicants are imported without answers. Only choose a column if the answers come under a different header.",
          questionsSomeUnlinked: "Questions without a column: {{count}}. Those answers aren't imported; if they're in the file under a different header, choose the column.",
          noColumn: "No column",
          fieldColumnOption: "{{header}} (data column)",
          rowsTitle: "File rows ({{count}})",
          onlyReview: "Only rows to review ({{count}})",
          noRutRow: "Without ID number",
          discardedRow: "Will be discarded",
          table: {
            row: "Row",
            person: "Person",
            status: "Status",
            detail: "Detail",
            pageRange: "{{from}}–{{to}} of {{count}}",
            nextPage: "Next page",
            previousPage: "Previous page",
          },
          status: {
            new: "New record",
            existing: "Existing record",
            pending_validation: "To validate",
            in_position: "Already in the position",
            error: "Not imported",
          },
          errors: {
            MISSING_NAMES: "No first names",
            MISSING_FIRST_LAST_NAME: "No paternal last name",
            MISSING_EMAIL: "No email",
            INVALID_EMAIL: "Invalid email ({{value}})",
            DUPLICATE_EMAIL_IN_FILE: "Email repeated in the file (row {{row}})",
            DUPLICATE_RUT_IN_FILE: "ID number repeated in the file (row {{row}})",
            SAVE_FAILED: "Could not be saved",
            REQUEST_FAILED: "Was not imported in time",
          },
          warnings: {
            NO_RUT: "No ID number: imported anyway",
            INVALID_RUT: "Invalid ID number ({{value}}): imported without it",
            INVALID_PHONE: "Unreadable phone ({{value}}): imported without it",
            INVALID_DATE: "Unrecognized date ({{value}}): saved as is",
            ANSWER_NOT_MATCHING: "{{question}}: \"{{value}}\" does not match the options (marked with ⚠)",
            OTHER_EMAIL: "Their ID number is on a record with another email ({{value}}): that record is used",
            EMAIL_IN_OTHER_APPLICANT: "Their record has no email and this email is on {{value}}'s record: to validate",
            EMAIL_WITH_OTHER_RUT: "The email is on {{value}}'s record, with another ID number: to validate",
            EMAIL_MATCH_OTHER_NAME: "Their email is on {{value}}'s record, under another name: that record is used (check it is the same person)",
            SAME_PERSON_IN_FILE: "Same person as row {{row}}",
            HEADER_NOT_FIRST_ROW: "The headers are on row {{row}}: the rows above were ignored.",
            DUPLICATE_COLUMNS: "Repeated columns that are not used: {{value}}",
            QUESTION_LIKE_FIELD: "The question \"{{value}}\" has the same name as a data column: the first column with that name is used as data and the next one as the answer.",
            ROWS_NOT_READ: "Only rows up to {{row}} were read: the file has more (blank rows count too). Split it into two files.",
            TOO_MANY_ROWS: "The file has more than {{max}} rows: only the first {{max}} were read.",
          },
          fileErrors: {
            FILE_REQUIRED: "Choose a file.",
            FILE_TOO_LARGE: "The file is larger than 5 MB.",
            UNREADABLE_FILE: "The file could not be read. Is it .xlsx, .xls or .csv?",
            EMPTY_FILE: "The file is empty.",
            NO_ROWS: "The file has no rows with data.",
            MISSING_COLUMNS: "Required columns are missing: {{columns}}. Download the position's template and copy the data into it.",
            FORBIDDEN: "You do not have permission to modify this position.",
            generic: "The file could not be reviewed.",
          },
          importing: "Importing {{done}} of {{total}}…",
          doneTitle: "Import finished",
          doneSummary: "New records: {{added}} · Existing records: {{existing}} · To validate: {{pending}} · Already in the position: {{inPosition}} · Not imported: {{errors}}",
          doneMarks: "With ⚠ to review: {{marked}} · Discarded by the rules: {{discarded}} · Blocked: {{blocked}}",
          stopped: "The import stopped: {{done}} of {{total}} rows were processed. Import the file again: those already imported are not duplicated.",
          downloadErrors: "Download rows not imported",
          errorsFile: {
            name: "rows_not_imported.xlsx",
            sheet: "Not imported",
            row: "Row",
            reason: "Reason",
          },
          sourceLabel: "Imported ({{origin}})",
          contactRut: "RUT: {{rut}}",
          contactDocument: "ID: {{document}}",
          answersTitle: "Application data (imported from {{origin}})",
          template: {
            fileName: "import_template",
            sheet: "Applicants",
            instructionsSheet: "Instructions",
            instructionsTitle: "Applicant import template — Position: {{position}}",
            colColumn: "Column",
            colRequired: "Required",
            colFormat: "Format and valid answers",
            yes: "Yes",
            no: "No",
            columns: {
              names: "First names",
              firstLastName: "Paternal last name",
              secondLastName: "Maternal last name",
              email: "Email",
              phone: "Phone",
              document: "ID number",
              nacionalidad: "Nationality",
              comuna: "District",
              region: "Region",
              appliedAt: "Application date",
              experiencia: "Experience",
              formacion: "Education",
            },
            formats: {
              names: "Text",
              firstLastName: "Text (paternal last name only)",
              secondLastName: "Text",
              email: "name@domain.com. Rows without email are not imported.",
              phone: "Any format: +56 9 1234 5678, 912345678…",
              document: "Chilean RUT with or without dots and dash (12.345.678-5), or the ID number of your country. If invalid, the person is imported without it.",
              nacionalidad: "Text (for example: Chilean, Venezuelan)",
              comuna: "Text",
              region: "Text",
              appliedAt: "DD/MM/YYYY",
              experiencia: "Free text",
              formacion: "Free text",
            },
            questionText: "Free text",
            questionYesNo: "Yes or No",
            questionOptions: "One of: {{options}} (for several, separate them with semicolons)",
            note1: "One row per person. Headers go on row 1; column order does not matter and columns not in this list are ignored.",
            note2: "Answers that do not match the options are saved as text and the application is marked with ⚠ for review.",
          },
        },
        portalInvitation: {
          blocked: {
            not_active: "Can't invite: the position's status is \"{{status}}\". The invitation link only works while the position is active.",
            not_visible: "Can't invite: the position isn't visible on the portal. Turn on \"Visible on portal\" when editing the position.",
            limit_reached: "Can't invite: the position reached its application limit and the portal no longer shows it.",
          },
          notSent: "No invitation was sent: the position no longer accepts applications on the portal.",
        },
        offer: {
          title: "Offer outcome",
          accepted: "Accepted",
          rejected: "Rejected",
          pending: "Not set",
          reason: "Rejection reason",
          reasonPlaceholder: "E.g. accepted another offer, salary expectations, etc.",
          markAccepted: "Mark accepted",
          markRejected: "Mark rejected",
          confirmReject: "Confirm rejection",
          clear: "Clear outcome",
          saved: "Offer outcome updated",
          saveError: "Could not update offer outcome",
          cardAction: "Offer",
          dialogTitle: "Offer",
          sendTitle: "Send offer",
          sendButton: "Send offer",
          resendOffer: "Resend offer",
          subject: "Subject",
          body: "Body",
          attachLetter: "Attach offer letter",
          removeLetter: "Remove",
          viewLastLetter: "View last sent letter",
          sent: "Offer sent",
          sendError: "Could not send the offer",
          loadError: "Could not load the template",
          lastSent: "Offer sent on",
        },
        hire: {
          title: "Hiring details",
          startDate: "Start date",
          grossSalary: "Gross salary",
          grossSalaryPlaceholder: "E.g. $1,500,000",
          save: "Save",
          saved: "Hiring details saved",
          saveError: "Could not save the data",
          sendEmail: "Send hiring email",
          cardAction: "Hiring",
          lastSent: "Hiring email sent on",
          resend: "Resend email",
          resendHint: "The hiring email was already sent. If you need to send it again, click 'Resend email'.",
          email: {
            title: "Hiring email",
            toCandidate: "To",
            receptionData: "Reception details",
            receiver: "Name of who receives them",
            contact: "Contact phone",
            address: "Company address",
            time: "Arrival time",
            preview: "Preview (read-only)",
            subject: "Subject",
            body: "Body",
            send: "Send",
            sent: "Hiring email sent",
            sendError: "Could not send the email",
            loadError: "Could not load the template",
            missing: "Missing fields",
          },
        },
        documents: {
          sectionTitle: "Documents",
          requestButton: "Request documents",
          none: "No documents requested yet.",
          uploaded: "Uploaded",
          pending: "Pending",
          download: "Download",
          dialogTitle: "Request documents",
          dialogHelp: "Choose the documents the candidate must upload. New ones are saved to the project catalog for reuse.",
          catalogTitle: "Project documents",
          catalogEmpty: "This project has no documents in the catalog yet. Add one below.",
          required: "Required",
          newDocsTitle: "New documents to add",
          addNewTitle: "Add a new document",
          labelField: "Document name",
          labelPlaceholder: "E.g. Background check certificate",
          instructionsField: "Instructions (optional)",
          addButton: "Add",
          cancel: "Cancel",
          sendButton: "Send request",
          sent: "Request sent to the candidate",
          sentNoEmail: "Request saved, but the email could not be sent",
          sentWhatsapp: "Request sent via WhatsApp",
          channelTitle: "Delivery channel",
          channelEmail: "Email (upload link)",
          channelWhatsapp: "WhatsApp",
          channelWhatsappUnavailable: "WhatsApp is not available for this organization: it has no number of its own nor Grafton's shared number allowed by a super-admin, or its channel is off (ATS → Configuration → WhatsApp → Channel).",
          channelNoPhone: "WhatsApp is unavailable because the candidate has no phone on file.",
          channelWhatsappHint: "A WhatsApp template will be sent and the candidate can attach the documents by replying to the bot.",
          sendError: "Could not send the request",
          loadError: "Could not load the catalog",
          selectAtLeastOne: "Select at least one document",
          nothingPending: "Request updated. Nothing was sent because there are no pending documents.",
          // Kanban card chip (PLAN_SOLICITUD_DOCUMENTOS_MASIVA)
          cardChip: "Docs {{uploaded}}/{{total}}",
          cardChipComplete: "Docs ✓",
          // Bulk request: column module and selection bar
          bulk: {
            columnButton: "Request documents",
            toolbarButton: "Request documents",
            title: "Document request",
            titleStage: "Document request — {{stage}}",
            statusHelp: "Progress of the documents requested from the candidates in this stage.",
            refresh: "Refresh",
            filter: {
              all: "All ({{count}})",
              none: "Not requested ({{count}})",
              pending: "With pending docs ({{count}})",
              complete: "Complete ({{count}})",
            },
            colCandidate: "Candidate",
            colDocuments: "Documents",
            colRequested: "Last request",
            stateNone: "Not requested",
            stateProgress: "{{uploaded}} of {{total}}",
            stateComplete: "Complete",
            viewCandidate: "View profile",
            emptyStage: "There are no candidates in this stage.",
            emptyFilter: "No candidates match this filter.",
            newRequest: "New request",
            newRequestTitle: "New document request",
            documentsHelp: "Documents are added to what each candidate was already asked for: nothing is removed, uploaded files are kept and required documents stay required. Each candidate gets the list of everything still pending; candidates who already uploaded everything get nothing. New documents are saved to the project catalog.",
            whatsappHint: "Each candidate gets the WhatsApp template and sends the documents by replying to the bot. Candidates without a valid phone or with an active bot conversation are skipped and listed in the summary.",
            candidatesTitle: "Candidates",
            selectAll: "Select all",
            noEmail: "No email",
            removeDoc: "Remove document",
            noCandidates: "There are no candidates to send to.",
            missing: "Pending: {{docs}}",
            send: "Send to {{count}}",
            remindButton: "Remind pending ({{count}})",
            remindTitle: "Remind pending documents",
            remindHelp: "The request is sent again to the selected candidates. Each one only gets the documents they are missing.",
            remindNone: "There are no candidates with pending documents.",
            remindSend: "Send reminder ({{count}})",
            sending: "Sending {{done}} of {{total}}…",
            sendingHint: "Don't close this window until it finishes.",
            resultSent: "Sent: {{count}}",
            resultAlready: "Already had everything requested, nothing sent: {{count}}",
            resultFailed: "Not sent: {{count}}",
            resultStopped: "Sending stopped: {{message}}",
            emailFailed: "The request was saved, but the email could not be sent",
            retryFailed: "Retry the ones not sent",
            viewStatus: "View status",
            back: "Back",
            close: "Close",
          },
        },
        modules: {
          title: "Available modules in this stage",
          noModules: "This stage has no modules configured",
          currentStage: "Current stage",
          launch: "Send",
          launching: "Sending...",
          launchSuccess: "{{module}} sent successfully",
          launchError: "Error sending module",
          noApplicantId: "No applicant found for this candidate",
          cvFilteringRedirect: "For CV filtering go to the CV Filtering module",
          psycholaboralRedirect: "For psycholaboral evaluation go to the Reports module",
          interviewNote: "The interview must be coordinated manually",
          applicationInfo: "Application information",
          notes: "Notes",
          discTest: 'DISC Test',
          reasoningTest: 'Aptitude Tests',
          personalSkills: 'Personal Skills',
          salesAssessment: 'Sales Assessment',
          cvFiltering: 'CV Filtering',
          interview: 'Interview',
          psicolaboral: 'Psycholaboral Report',
          psicolaboralRecommendation: 'For a better psycholaboral report, the candidate should have a CV, DISC test, aptitude tests and an interview.',
          psychoComparison: 'Psycholaboral Ranking',
          psychoComparisonTooltip: 'Evaluations Comparison',
          psychoComparisonNoPsico: 'Requires the Psycholaboral Report module in the pipeline',
          psychoComparisonAfterPsico: 'Only available in the Psycholaboral Report stage or later stages',
          filteringAnswers: "Form answers",
        },
        moveDialog: {
          titleStage: "Move candidate to stage",
          titlePhase: "Advance process phase",
          noteLabel: "Note",
          notePlaceholder: "E.g.: Interesting profile, moves to next stage...",
          notePlaceholderPhase: "E.g.: Moving forward because we have enough candidates to evaluate...",
          noteOptional: "Note is optional",
          confirm: "Confirm",
        },
        // Selector de etapas de la ficha del candidato (cambio de etapa con un clic)
        stageSelector: {
          moveTo: "Move to “{{stage}}”",
          lock: {
            positionClosed: "This position is closed; candidates can't be moved.",
            positionCancelled: "This position is cancelled; candidates can't be moved.",
            noPermission: "You don't have permission to edit this position.",
            discarded: "Candidate discarded. Restore them to change their stage.",
            blocked: "Candidate blocked; their stage can't be changed.",
            pendingValidation: "Candidate pending validation. Validate them from their card in the pipeline to change their stage.",
          },
        },
        cvFilter: {
          button: "CV Filtering",
          dialogTitle: "CV Filtering",
          newFiltering: "New filtering",
          dialogSubtitle: "Select candidates to evaluate against the position descriptor",
          selectAll: "Select all",
          launch: "Filter {{count}} candidates",
          launching: "Starting...",
          launched: "Filtering started successfully",
          error: "Error starting the filtering",
          noFilterings: "No filterings for this position. Create a new one.",
          noResults: "No results obtained",
          noApplicantId: "No associated applicant",
          downloadReport: "Download PDF report",
        },
        notes: {
          placeholder: "Write a note about the candidate...",
          add: "Add note",
          save: "Save",
          empty: "No notes",
          error: "Error saving the note",
          confirmDelete: "Delete?",
          edited: "(edited)",
          noteChip: "Note",
          editTooltip: "Edit note",
          deleteTooltip: "Delete note",
          stageEditHint: "If you leave the text empty, the note is removed; the stage-move record is kept.",
        },
        cvSummary: {
          title: "CV Summary (AI)",
          generate: "Generate AI summary (0.1 pts)",
          generating: "Generating summary...",
          generated: "Summary generated successfully",
          regenerate: "Regenerate",
          regenerateConfirm: "Regenerating will replace the current summary and charge 0.1 points. Continue?",
          regenerateAction: "Regenerate (0.1 pts)",
          error: "Error generating the summary. Please try again.",
          limitReached: "You don't have enough points to generate the summary",
          unreadable: "The CV could not be read (corrupted file or scanned without text)",
          noCv: "The candidate has no CV uploaded",
          staleWarning: "This summary was generated from a previous CV. Consider regenerating it.",
          yearsExperience: "Years of experience",
          experience: "Experience",
          education: "Education",
          flags: "Points to review",
          generatedOn: "Generated on",
          viewCv: "View CV (opens in a new tab)",
        },
        interviewQuestions: {
          title: "Interview questions",
          // Role questions (interviews dialog)
          positionTitle: "Role questions",
          positionEmptyHint: "Get AI suggestions or write the role's questions, the same for every candidate.",
          positionReadyHint: "Each candidate's answers are recorded in their profile.",
          defineQuestions: "Define questions",
          viewPosition: "View and edit questions ({{count}})",
          positionEmpty: "This role doesn't have interview questions yet.",
          hint: "The questions are the same for every candidate in this role. AI suggests 5 based on the role information (0.1 pts) and you choose which ones to add; you can also write them yourself. Maximum 10 per role.",
          writeManually: "Write manually",
          positionEditHint: "These questions are the same for every candidate in this role. Changes apply when you click Save (maximum 10). If you edit or remove a question, answers already recorded are kept.",
          questionRequired: "The question can't be empty",
          rationale: "What it assesses: {{text}}",
          addQuestion: "Add question",
          newQuestionPlaceholder: "Write the question...",
          add: "Add",
          deleteQuestion: "Remove question",
          questionsCount: "{{current}} of {{max}} questions",
          maxReached: "You reached the maximum of {{max}} questions per role",
          blankQuestions: "Some questions are empty: fill them in or remove them before saving.",
          back: "Back",
          positionSaved: "Role questions saved",
          unsavedTitle: "Go back without saving?",
          unsavedConfirm: "You have unsaved changes to the role questions. If you go back now, they will be lost.",
          keepEditing: "Keep editing",
          leaveWithoutSaving: "Go back without saving",
          conflictTitle: "Someone else saved changes",
          conflictText: "While you were editing, someone on the team saved this role's questions. You can load their version (your changes are lost) or save yours anyway (it replaces theirs).",
          conflictReload: "Load their version",
          conflictOverwrite: "Save mine",
          // AI suggestions (always 5, selectable)
          suggest: "Suggest 5 with AI (0.1 pts)",
          suggesting: "Generating suggestions...",
          suggested: "Suggestions ready: check the ones you want to add",
          suggestionsTitle: "AI suggestions",
          suggestionsHint: "Check the ones you want to add to the role (you can add {{room}} more).",
          suggestionsNoRoom: "The role already has {{max}} questions. Remove one to add suggestions.",
          addSelected: "Add selected ({{count}})",
          discardSuggestions: "Discard suggestions",
          replaceSuggestionsTitle: "Get other suggestions?",
          replaceSuggestionsConfirm: "The suggestions you didn't add are replaced by 5 new ones and 0.1 pts are charged.",
          replaceSuggestionsAction: "Suggest another 5",
          serviceNotAvailable: "This service is not enabled for your organization",
          limitReached: "You don't have enough points to get AI suggestions",
          error: "Suggestions could not be generated. Please try again.",
          // "Interviews" button in the kanban column
          columnTooltipEmpty: "Record interviews and define the role's questions (with AI or manually), the same for every candidate.",
          columnTooltipReady: "Role questions ready ({{count}}). Answers are recorded in each candidate's profile.",
          // Candidate answers (drawer)
          answer: "Record answers ({{answered}}/{{total}})",
          viewAnswers: "View answers ({{answered}}/{{total}})",
          viewAnswersPlain: "View answers",
          missingPositionQuestions: "This role doesn't have questions yet. Define them (with AI or manually) from Interviews, in the stage column.",
          sharedHint: "The position team can see these answers. Changes are saved automatically.",
          removedTitle: "Questions deleted from the role",
          answerPlaceholder: "Candidate's answer or comments...",
          noAnswer: "No answer",
          saving: "Saving...",
          saved: "Saved",
          notSaved: "Not saved",
          saveError: "Changes could not be saved. Please check your connection.",
        },
        stats: {
          tab: "Statistics",
          totalTime: "Total process time",
          inProgress: "In progress",
          closed: "Closed",
          startedOn: "Started",
          closedOn: "Closed on",
          approx: "(approx.)",
          candidatesTotal: "Candidates",
          active: "Active",
          discarded: "Discarded",
          blocked: "Blocked",
          hired: "Hired",
          phaseTimes: "Time per phase",
          stageTable: "Breakdown by stage",
          thStage: "Stage",
          thPhase: "Phase",
          thCurrent: "Current",
          thPassed: "Passed through",
          thDiscarded: "Discarded",
          thAvgTime: "Average time",
          noPipeline: "This position has no pipeline configured",
          liveNote: "Statistics are computed live from the current process data. If the process is reopened, times keep updating until the next close.",
        },
        psychoComparison: {
          dialogTitle: "Psycholaboral Ranking",
          newComparison: "New ranking",
          dialogSubtitle: "Candidates with a completed psycholaboral evaluation are compared. All are pre-selected; you can adjust the selection (minimum 2).",
          selectAll: "Select all",
          launch: "Create ranking ({{count}})",
          launching: "Starting...",
          launched: "Ranking started successfully",
          error: "Error creating the ranking",
          noComparisons: "No rankings for this position. Create a new one.",
          noEligible: "No candidate has a completed psycholaboral evaluation",
          reportNotReady: "Psycholaboral report processing or unavailable",
          notEnough: "At least 2 candidates are required",
          limitReached: "Usage limit reached for comparisons",
          tableCandidates: "Candidates",
          tableStatus: "Status",
          tableDate: "Date",
          statusPending: "Pending",
          statusProcessing: "Processing",
          statusCompleted: "Completed",
          statusError: "Error",
          viewResults: "View results",
          retry: "Retry",
          ranking: "Candidate ranking",
          totalCandidates: "Candidates",
          affinity: "Affinity",
          overallRecommendation: "Overall recommendation",
          downloadReport: "Download Word report",
          noResults: "No results obtained",
        },
        testDialog: {
          subtitle: "Select the candidates to send the test to",
          discPositionInfo: "This vacancy's position will be used for the test analysis.",
          sending: "Sending tests...",
          sent: "{{count}} test(s) sent successfully",
          failed: "{{count}} test(s) could not be sent",
          send: "Send to {{count}} candidates",
          sendNew: "New send",
          newSend: "Send test",
          noTestsSent: "No tests of this type have been sent for this position",
          selectTypes: "Select test types",
          selectAtLeastOneType: "Select at least one test type",
        },
        drawer: {
          testsTitle: "Tests",
          testNotSent: "Not sent",
          processTest: "Process test",
          viewResult: "View result",
          testProcessing: "Test sent for processing",
          testProcessError: "Error processing test",
          sendTest: "Send test",
          resendTest: "Resend test",
          registerInterview: "Register interview",
          generatePsico: "Generate evaluation",
          prevCandidate: "Previous",
          nextCandidate: "Next",
          navPosition: "{{index}} of {{total}}",
          navStageHint: "Candidates in “{{stage}}”, in column order",
          navOutOfStage: "— of {{total}}",
          navOutOfStageHint: "No longer in “{{stage}}”: previous and next continue from its place in that stage",
        },
        interview: {
          selectCandidate: "Select a candidate to view or register their interviews",
          noCandidates: "No candidates in this stage",
          noApplicantId: "No associated applicant",
          replace: "Replace",
          replaceTitle: "Replace interview",
          replaceConfirm: "Delete this interview? You can then register a new one for this position.",
          replaceSuccess: "Interview deleted. You can register a new one.",
          replaceError: "Could not delete the interview",
        },
        testStatus: {
          pending: 'Pending',
          sent: 'Sent',
          started: 'Started',
          completed: 'Completed',
          processing: 'Processing',
          evaluated: 'Evaluated',
          error: 'Error',
          expired: 'Expired',
          invalid: 'Invalid',
        },
        interviewStatus: {
          botInMeeting: 'Bot in meeting',
          assignParticipants: 'Assign participants',
          completed: 'Completed',
          error: 'Error',
        },
        sendClient: {
          button: "Send to client",
          title: "Send profiles to client",
          description: "A single email will be sent to the client with the profile (CV + executive summary) of {{count}} candidate(s).",
          clientEmail: "Client email",
          invalidEmail: "Invalid email",
          subject: "Subject",
          body: "Message",
          candidates: "Candidates",
          resumenReady: "Executive summary ready",
          resumenMissing: "No executive summary",
          attachNote: "The email lists each candidate with buttons to view their CV and executive summary (when available).",
          bodyHint: "The candidate list with its buttons is inserted automatically in the email.",
          previewHint: "Click the buttons to preview what the client will receive.",
          viewCv: "View CV",
          viewResumen: "View summary",
          missingResumenWarning: "{{count}} candidate(s) have no executive summary generated. You can generate it before sending or continue without it.",
          send: "Send email",
          success: "Email sent to {{email}}",
          partialWarning: "Email sent, but some attachments were missing: {{detail}}",
          resumenWord: "summary",
          error: "Could not send the email to the client",
          defaultSubject: "Shortlisted candidates — {{position}}",
          defaultBody: "Dear Sir/Madam,\n\nPlease find the shortlisted candidates for the {{position}} position. Attached you will find each candidate's CV and executive summary.\n\nWe look forward to your feedback.\n\nBest regards.",
        },
        psycholaboral: {
          title: "Psycholaboral Evaluation",
          noReports: "No psycholaboral evaluations for this position",
          viewReport: "View report",
          refresh: "Refresh",
          newEvaluation: "New evaluation",
          replace: "Replace",
          downloadSummary: "Summary (PDF)",
          replaceTitle: "Replace psycholaboral evaluation",
          replaceWarning: "Generating a new report will deduct points from your plan, just like a new evaluation.",
          replaceConfirm: "The current report will be deleted and you'll need to generate a new one. This action cannot be undone.",
          replaceSuccess: "Report deleted. Generate the new report.",
          replaceError: "Could not delete the report",
          selectCandidate: "Select candidate",
          filesTitle: "Files to be loaded",
          fileCV: "Candidate CV",
          fileDISC: "Evaluated DISC test",
          fileReasoning: "Evaluated reasoning test",
          fileInterview: "Interview transcript",
          available: "Available",
          notAvailable: "Not available (optional)",
          notAvailableRequired: "Not available — required",
          noCvAlert: "The candidate has no CV uploaded. It is required to generate the evaluation.",
          generate: "Generate evaluation",
          generating: "Generating...",
          generateSuccess: "Evaluation generated successfully!",
          generateError: "Error generating the evaluation",
          backToList: "Back to list",
          statusCreating: "Creating report...",
          statusAttaching: "Attaching files ({{current}}/{{total}})...",
          statusProcessing: "Processing with AI...",
        },
      },
      jobBoard: {
        title: "Jobs",
        titleWithCompany: "Work at {{company}}",
        searchPlaceholder: "What job are you looking for?",
        jobsCount: "{{count}} jobs",
        empty: "There are no openings published right now",
        publishedOn: "Published on",
        publishedBy: "Published by",
        apply: "Apply",
        backToList: "Back to list",
        signIn: "Sign in or register",
        myApplications: "My applications",
        generalTitle: "Job board",
        companyJobs: "More jobs at {{company}}",
        notFoundTitle: "Page not found",
        notFoundBody: "This job board does not exist or is no longer available.",
        viewAllJobs: "View all jobs",
        // Job fair page (/feria/:slug, PLAN_FERIAS)
        fair: {
          subtitle: "Openings at {{company}}",
          empty: "There are no open positions at this job fair right now.",
          alreadyApplied: "Already applied",
          notFoundTitle: "This job fair is not available",
          notFoundBody: "It may have ended, or the link may be incomplete.",
        },
        // Position page (/vacante/:id, the link the ATS hands out, 2026-10-25)
        vacancy: {
          closed: "Closed",
          closedBody: "This position is closed and no longer accepts applications.",
          paused: "Not accepting applications",
          pausedBody: "This position is not accepting applications right now.",
          unavailableTitle: "This position is not available",
          unavailableBody: "It may no longer be published, or the link may be incomplete.",
          seeOpenPositions: "See open positions",
        },
        // Button in the position detail to share its link (2026-10-25)
        share: {
          copy: "Copy link",
          copied: "Link copied",
          share: "Share",
          copyManually: "Copy the job link:",
        },
      },
      portal: {
        // Applying from a job fair (PLAN_FERIAS)
        fair: {
          backToFair: "See more openings at this job fair",
          headerLink: "Job fair",
          signedInAs: "Applying as",
          reusedTitle: "We are using your answers from your previous application at this job fair",
          reusedDocs: "Foreign documents already uploaded: {{count}}",
          edit: "Edit",
        },
        documents: {
          title: "Upload documents",
          greeting: "Hi",
          intro: "We need you to upload the following documents to continue with your process.",
          introWithPosition: "We need you to upload the following documents for your process for the {{position}} role.",
          allDone: "All set! We received all the documents.",
          uploaded: "Uploaded",
          replace: "Replace",
          upload: "Upload",
          invalidTitle: "Invalid link",
          invalidBody: "This link is invalid or has expired. If you think this is a mistake, contact the company.",
          pendingRequired: "You still have {{count}} required document(s) to upload.",
          uploadError: "Could not upload the file. Please try again.",
        },
        stepPersonalData: "Personal data",
        stepQuestions: "Questions",
        next: "Continue",
        closesOn: "Closes on",
        positionDescription: "Job description",
        positionResponsabilities: "Responsibilities",
        positionProfile: "Required profile",
        positionRequiredKnowledge: "Required knowledge",
        positionDesirableKnowledge: "Desirable knowledge",
        positionBenefits: "Role benefits",
        title: "Candidate Portal",
        documentTitle: "Enter your ID document",
        documentSubtitle: "Select your nationality and enter your ID document to continue",
        documentLabel: "ID document",
        documentRequired: "The document is required",
        documentInvalid: "The {{doc}} entered is not valid",
        emailAccess: {
          title: "Sign in with your email",
          subtitle: "We will send you a 6-digit code. If it is your first time, you will create your account next.",
        },
        identityStep: {
          title: "Complete your details",
          subtitleNew: "This is your first time with {{email}}. Enter your nationality and your ID document to create your account.",
          subtitleComplete: "To continue, enter your nationality and your ID document.",
          create: "Create account",
          save: "Save and continue",
          saving: "Saving...",
          documentInUse: "That document is already registered with {{email}}.",
          useThatAccount: "Send me the code to that email",
          expired: "Too much time has passed since you confirmed your email. Please enter it again to continue.",
          restart: "Enter my email again",
          saveError: "We could not save your details. Please try again.",
        },
        access: {
          nationality: "Nationality",
          otherNationality: "Other",
          nationalityOther: "Type your nationality",
          nationalityRequired: "Select your nationality",
          nationalityOtherRequired: "Type your nationality",
          hasRut: "Do you have a Chilean RUT?",
          hasRutRequired: "Tell us whether you have a Chilean RUT",
          documentType: "Which document do you want to sign in with?",
          nationalDoc: "{{doc}} from your country",
          passport: "Passport",
        },
        countryOther: "Other",
        rutHint: "E.g.: 12.345.678-9",
        rutVerified: "Document verified at sign-in",
        emailInUse: "This email is already linked to another document",
        emailStepSubtitle: "This is your first time here: we will send a verification code to your email",
        tooManyRequests: "You have requested too many codes. Please wait a few minutes and try again.",
        tooManyAttempts: "Too many failed attempts. Please wait a few minutes and try again.",
        resendIn: "Resend in {{seconds}}s",
        alreadyAppliedTitle: "You already applied to this position",
        alreadyAppliedMessage: "Your application to {{position}} was submitted on {{date}}.",
        alreadyAppliedMessageNoDate: "Your application to {{position}} was already submitted.",
        viewMyApplications: "View my applications",
        accessTitle: "Enter your email to continue",
        accessSubtitle: "We will send you a verification code",
        emailLabel: "Email",
        emailRequired: "Email is required",
        emailInvalid: "Invalid email format",
        continue: "Continue",
        sending: "Sending...",
        otpSendError: "Error sending the code. Please try again.",
        otpTitle: "Enter the verification code",
        otpSubtitle: "We sent a 6-digit code to {{email}}",
        otpSubtitleRegistered: "We sent a 6-digit code to {{email}}, the email you were already registered with.",
        noAccessToEmail: "Don't have access to that email? Contact the recruiter for this process.",
        applicantEmailUnavailable: "That document is registered with an email we can't use. Contact the recruiter for this process.",
        applicationUnresolved: "We couldn't register your application. Contact the recruiter for this process.",
        identity: {
          title: "Confirm your identity to apply",
          codeLabel: "6-digit code",
          confirm: "Confirm and apply",
          linkedElsewhere: "Your details in this process are linked to another account. Contact the recruiter for this process.",
          noAccess: "I don't have access to that email",
          noAccessHint: "If you don't have access to that email, you can still apply: a recruiter will review your details.",
          linkedElsewhereApply: "Your details in this process are linked to another account. You can still apply: a recruiter will review your details.",
          applyAnyway: "Apply anyway",
          confirmApplicantTitle: "Confirm your details",
          confirmApplicantText: "You are registered in this process as {{name}}. Is that you?",
          confirmApplicantYes: "Yes, it's me",
          confirmApplicantNo: "No, it's not me",
        },
        massive: {
          stepCaptation: "Position questions",
          fields: {
            nacionalidad: "Nationality",
            nacionalidadOther: "Type your nationality",
            comuna: "District where you live",
            experiencia: "Experience in this type of job",
            disponibilidad: "Availability to start",
          },
          otherNationality: "Other",
          traslado: "The job is in {{comuna}}. Could you commute or relocate to work there?",
          docsTitle: "Documents (optional)",
          docsHint: "For the background review you can attach your ID document and your visa or work permit (PDF, Word or photo, up to 10 MB).",
          docs: {
            doc_carnet_frente: "ID document (front)",
            doc_carnet_reverso: "ID document (back)",
            doc_visa: "Visa or work permit",
          },
          upload: "Upload file",
          replace: "Replace file",
          uploaded: "File uploaded",
          uploadError: "Could not upload the file",
          requiredFields: "Please complete the required fields.",
          profileRequired: "Please complete your required details: {{fields}}.",
          notAccepting: "This position is no longer accepting applications.",
          missingAnswers: "Some required answers are missing. Please review the form.",
        },
        otpIncomplete: "Please enter the complete code",
        otpInvalid: "Invalid or expired code",
        otpResendSuccess: "A new code was sent",
        verify: "Verify",
        verifying: "Verifying...",
        resend: "Resend code",
        resending: "Resending...",
        back: "Back",
        personalData: "Personal data",
        name: "Full name",
        names: "First names",
        firstLastName: "Paternal last name",
        secondLastName: "Maternal last name",
        secondLastNameHint: "Leave empty if you don't have one",
        fullNamePreview: "Full name",
        fullNameHint: "Built automatically from your names and last names",
        phone: "Phone",
        rut: "ID / Tax number",
        country: "Country",
        profession: "Profession",
        currentPosition: "Current position",
        salarioPretendido: "Salary expectation",
        filteringQuestions: "Position questions",
        yourAnswer: "Your answer...",
        apply: "Apply",
        applying: "Submitting application...",
        applicationError: "Error submitting application. Please try again.",
        nameRequired: "Name is required",
        successTitle: "Application submitted!",
        successMessage: "Your application was submitted successfully.",
        successMessagePosition: "Your application to {{position}} was submitted successfully.",
        successPendingMessage: "We received your application to {{position}}. A recruiter will review your details before continuing.",
        completeApplication: {
          hint: "You are already in the {{position}} process. Complete your details and answer the questions to finish your application.",
          doneTitle: "Application complete!",
          doneMessage: "Your details and answers were added to your application to {{position}}.",
        },
        invitation: {
          title: "This invitation is for {{email}}",
          sessionOpen: "This device is signed in as {{email}}. To answer the invitation, sign in with the email where you received it.",
          useInvitation: "Sign in with the invitation email",
          continueAs: "Continue as {{email}}",
          accessHint: "Use the email where you received the invitation ({{email}}).",
        },
        saveProfile: "Save profile",
        header: {
          portal: "Job board",
          myApplications: "My applications",
          myTests: "My assessments",
          profile: "My profile",
          logout: "Log out",
          account: "My account",
          signIn: "Sign in",
        },
        profile: {
          title: "My profile",
          subtitle: "Update your personal information and your CV",
          identityTitle: "Account information",
          identityHint: "Your account email cannot be changed",
          save: "Save changes",
          saving: "Saving...",
          saveSuccess: "Changes saved successfully",
          saveError: "Error saving changes. Please try again.",
        },
        myApplications: {
          title: "My applications",
          loadError: "Error loading applications",
          empty: "You have no applications yet",
          unknownPosition: "Position not available",
          appliedOn: "Applied on",
          statusActive: "In progress",
          statusPendingValidation: "Under review",
          statusWithdrawn: "Withdrawn by you",
          statusClosed: "Process closed",
          withdraw: "Withdraw application",
          withdrawConfirmTitle: "Withdraw application?",
          withdrawConfirmMessage: "Your application to {{position}} will be withdrawn from the process. This action cannot be undone.",
          withdrawCancel: "Cancel",
          withdrawConfirm: "Withdraw",
          withdrawSuccess: "Your application was withdrawn.",
          withdrawError: "Could not withdraw the application. Please try again.",
        },
        myTests: {
          title: "My assessments",
          loadError: "Error loading assessments",
          empty: "You have no assessments assigned",
          pendingSection: "Pending",
          finishedSection: "Finished",
          sentOn: "Sent on",
          unknownPosition: "General process",
          statusPending: "Pending",
          statusStarted: "In progress",
          statusCompleted: "Completed",
          statusExpired: "Expired",
          start: "Take test",
          continue: "Continue",
          kindDisc: "DISC Test",
          kindSales: "Sales assessment",
          types: {
            wordAssociation: "Word Association",
            logicalProcess: "Logical Process",
            numericalReasoning: "Numerical Reasoning",
            socialContext: "Social Context",
            logicalAbstract: "Logical Abstract",
            integrityTest: "Work Integrity",
            emotionalIntelligence: "Emotional Intelligence",
          },
        },
        cv: "Resume / CV",
        cvUploaded: "CV previously uploaded",
        cvView: "View",
        cvUpload: "Upload CV",
        cvReplace: "Replace CV",
        cvHint: "Accepted formats: PDF, DOC, DOCX",
        cvInvalidType: "Invalid format. Only PDF, DOC and DOCX are accepted.",
        cvUploadError: "Error uploading CV. Please try again.",
      },
      companyContextConfig: {
        loading: "Loading company and team information...",
        title: "Company and team information",
        description:
          "This information will be used as context when generating the psycholabor report. It helps the analysis consider the culture, team, work style, and real expectations of the environment where the candidate would perform.",
        info:
          "This section does not change the report writing style. It only provides context to better interpret the candidate's fit with the company and team.",
        saveButton: "Save information",
        messages: {
          loadError: "Error loading company and team information",
          cannotSave: "Cannot save: organization or project are not available",
          saveSuccess: "Company and team information saved successfully",
          saveError: "Error saving company and team information",
        },
        fields: {
          companyDescription: {
            label: "Company description",
            placeholder:
              "Example: Growing technology company focused on innovation, operational efficiency, and customer service.",
          },
          teamDescription: {
            label: "Team description",
            placeholder:
              "Example: Small, collaborative team with high autonomy and constant coordination between areas.",
          },
          culture: {
            label: "Organizational culture",
            placeholder:
              "Example: Dynamic, direct culture focused on results and continuous improvement.",
          },
          values: {
            label: "Relevant values",
            placeholder:
              "Example: Responsibility, collaboration, transparency, customer orientation, and continuous learning.",
          },
          leadershipStyle: {
            label: "Leadership style",
            placeholder:
              "Example: Close and demanding leadership focused on autonomy, goal tracking, and direct communication.",
          },
          workStyle: {
            label: "Work style",
            placeholder:
              "Example: Agile work, high coordination load, frequent priority changes, and execution focus.",
          },
          expectations: {
            label: "Environment expectations",
            placeholder:
              "Example: An autonomous, flexible, proactive person who can communicate progress and risks in a timely manner is expected.",
          },
          additionalContext: {
            label: "Additional context",
            placeholder:
              "Add any additional information that may help interpret the candidate's fit.",
          },
        },
      },
      narrativesConfig: {
        loading: "Loading narratives...",
        title: "Report narratives",
        create: "Create narrative",
        description:
          "Narratives allow you to define the tone, style, and writing depth of the complete psycholabor report. The user will be able to select which one to use before generating the report.",
        info: "The narrative will be applied globally to the report. It is not configured per step.",
        noAvailable: "There are no narratives available for this project.",
        editTooltip: "Edit narrative",
        edit: "Edit",
        createTitle: "Create narrative",
        editTitle: "Edit narrative",
        cancel: "Cancel",
        saveNarrative: "Save narrative",
        messages: {
          requiredFields: "The narrative name and content are required",
          cannotSave: "Cannot save: organization or project are not available",
          updateSuccess: "Narrative updated successfully",
          updateError: "Error updating narrative",
          createSuccess: "Narrative created successfully",
          createError: "Error creating narrative",
          loadError: "Error loading narratives",
          saveError: "Error saving narrative",
        },
        fields: {
          name: {
            label: "Name",
            placeholder: "Example: Managerial, Technical, Brief executive",
          },
          description: {
            label: "Description",
            placeholder: "Briefly describe when this narrative should be used.",
          },
          content: {
            label: "Narrative content",
            placeholder:
              "Example: Write the report with an executive, clear, and decision-oriented style...",
          },
        },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "es", // idioma por defecto
  fallbackLng: "es",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
